// import { useEffect, useRef, useState, useCallback } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { selectUser, setUser, clearUser } from "../redux/authSlice";
// import { useWishlist } from "../hooks/useWishlist";
// import { useToast } from "../context/ToastContext";
// import { useSettings } from "../context/SettingsContext";
// import { apiJson } from "../api/apiClient";

// import { Viewer } from "@photo-sphere-viewer/core";
// import { MarkersPlugin } from "@photo-sphere-viewer/markers-plugin";
// import "@photo-sphere-viewer/core/index.css";
// import "@photo-sphere-viewer/markers-plugin/index.css";
// import "../styles/UnitPage.css";

// const toRad = (deg) => parseFloat((deg * (Math.PI / 180)).toFixed(6));

// const AMENITY_ICONS = {
//   "Swimming Pool": "🏊",
//   Gym: "🏋️",
//   Parking: "🚗",
//   "24/7 Security": "🔒",
//   "Club House": "🏛️",
//   "Children Play Area": "🛝",
//   "Jogging Track": "🏃",
//   Garden: "🌿",
//   Lift: "🛗",
//   "Power Backup": "⚡",
//   "CCTV Surveillance": "📹",
//   Intercom: "📞",
//   "Visitor Parking": "🅿️",
//   Terrace: "🏙️",
// };
// const amenityIcon = (name) => AMENITY_ICONS[name] || "✨";
// const toFt = (m) => (m * 3.28084).toFixed(1);

// const fmtExact = (n, sym = "₹") => {
//   if (n == null || n === "") return "—";
//   return (
//     sym +
//     parseFloat(n).toLocaleString("en-IN", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     })
//   );
// };

// const fmtRound = (n, sym = "₹") => {
//   if (n == null || n === "") return "—";
//   return (
//     sym + parseFloat(n).toLocaleString("en-IN", { maximumFractionDigits: 0 })
//   );
// };

// const computeMilestoneAmounts = (milestonePercent, feeBreakdown) => {
//   if (!feeBreakdown || !milestonePercent) return null;
//   const pct = parseFloat(milestonePercent) / 100;

//   const unitPrice = feeBreakdown.unit_price || 0;
//   const base = unitPrice * pct;
//   const tax = (feeBreakdown.tax_amount || 0) * pct;

//   const proc = (feeBreakdown.processing_fee || 0) * pct;
//   const stamp = (feeBreakdown.stamp_duty || 0) * pct;
//   const reg = (feeBreakdown.registration_fee || 0) * pct;
//   const maint = (feeBreakdown.maintenance_charge || 0) * pct;
//   const cf1 = (feeBreakdown.custom_fee1 || 0) * pct;
//   const cf2 = (feeBreakdown.custom_fee2 || 0) * pct;

//   const fees = proc + stamp + reg + maint + cf1 + cf2;
//   const total = base + tax + fees;

//   return {
//     base,
//     tax,
//     fees,
//     total,
//     breakdown: { proc, stamp, reg, maint, cf1, cf2 },
//     labels: feeBreakdown.fee_labels || {},
//     taxLabel: feeBreakdown.tax_label || "Tax",
//     taxRate: feeBreakdown.tax_rate || 0,
//     taxSystem: feeBreakdown.tax_system || "",
//     currencySymbol: feeBreakdown.currency_symbol || "₹",
//   };
// };

// /* ─────────────────────────────────────────────────────────────
//    TaxBreakdownBadge
// ───────────────────────────────────────────────────────────── */
// const TaxBreakdownBadge = ({ milestonePercent, feeBreakdown, sym = "₹" }) => {
//   const [open, setOpen] = useState(false);
//   const data = computeMilestoneAmounts(milestonePercent, feeBreakdown);
//   if (!data || (!data.tax && !data.fees)) return null;
//   const f = (n) => fmtExact(n, sym);
//   const extraFees = [
//     data.breakdown.proc > 0 && {
//       label: data.labels.processing || "Processing Fee",
//       val: data.breakdown.proc,
//     },
//     data.breakdown.stamp > 0 && {
//       label: data.labels.stamp_duty || "Stamp Duty",
//       val: data.breakdown.stamp,
//     },
//     data.breakdown.reg > 0 && {
//       label: data.labels.registration || "Registration Fee",
//       val: data.breakdown.reg,
//     },
//     data.breakdown.maint > 0 && {
//       label: data.labels.maintenance || "Maintenance",
//       val: data.breakdown.maint,
//     },
//     data.breakdown.cf1 > 0 && {
//       label: data.labels.custom1 || "Custom Fee 1",
//       val: data.breakdown.cf1,
//     },
//     data.breakdown.cf2 > 0 && {
//       label: data.labels.custom2 || "Custom Fee 2",
//       val: data.breakdown.cf2,
//     },
//   ].filter(Boolean);

//   return (
//     <span style={{ position: "relative", display: "inline-block" }}>
//       <button
//         type="button"
//         className="tax-badge-btn"
//         onClick={(e) => {
//           e.stopPropagation();
//           setOpen((o) => !o);
//         }}
//       >
//         +tax
//       </button>
//       {open && (
//         <div className="tax-popover" onClick={(e) => e.stopPropagation()}>
//           <div className="tax-popover-title">Charges for this instalment</div>
//           <div className="tax-row">
//             <span>Unit price portion</span>
//             <span>{f(data.base)}</span>
//           </div>
//           {extraFees.map((fee, i) => (
//             <div key={i} className="tax-row">
//               <span>{fee.label}</span>
//               <span>{f(fee.val)}</span>
//             </div>
//           ))}
//           {data.tax > 0 && (
//             <div className="tax-row highlight">
//               <span>
//                 {data.taxLabel}
//                 {data.taxRate > 0 && (
//                   <span style={{ opacity: 0.7, marginLeft: 4 }}>
//                     ({data.taxRate}%
//                     {data.taxSystem ? ` · ${data.taxSystem.toUpperCase()}` : ""}
//                     )
//                   </span>
//                 )}
//               </span>
//               <span>{f(data.tax)}</span>
//             </div>
//           )}
//           <div className="tax-row total">
//             <span>Instalment total</span>
//             <span>{f(data.total)}</span>
//           </div>
//           <button
//             type="button"
//             onClick={(e) => {
//               e.stopPropagation();
//               setOpen(false);
//             }}
//             style={{
//               position: "absolute",
//               top: 6,
//               right: 8,
//               background: "none",
//               border: "none",
//               color: "var(--text-muted)",
//               cursor: "pointer",
//               fontSize: 14,
//             }}
//           >
//             ×
//           </button>
//         </div>
//       )}
//     </span>
//   );
// };

// /* ─────────────────────────────────────────────────────────────
//    MilestoneTaxRow
// ───────────────────────────────────────────────────────────── */
// const MilestoneTaxRow = ({ milestone, feeBreakdown }) => {
//   if (!feeBreakdown || !milestone.percentage) return null;
//   const data = computeMilestoneAmounts(milestone.percentage, feeBreakdown);
//   if (!data || (!data.tax && !data.fees)) return null;
//   const sym = data.currencySymbol;
//   const f = (n) => fmtExact(n, sym);
//   const extraFees = [
//     data.breakdown.proc > 0 && {
//       label: data.labels.processing || "Processing Fee",
//       val: data.breakdown.proc,
//     },
//     data.breakdown.stamp > 0 && {
//       label: data.labels.stamp_duty || "Stamp Duty",
//       val: data.breakdown.stamp,
//     },
//     data.breakdown.reg > 0 && {
//       label: data.labels.registration || "Registration Fee",
//       val: data.breakdown.reg,
//     },
//     data.breakdown.maint > 0 && {
//       label: data.labels.maintenance || "Maintenance",
//       val: data.breakdown.maint,
//     },
//     data.breakdown.cf1 > 0 && {
//       label: data.labels.custom1 || "Custom Fee 1",
//       val: data.breakdown.cf1,
//     },
//     data.breakdown.cf2 > 0 && {
//       label: data.labels.custom2 || "Custom Fee 2",
//       val: data.breakdown.cf2,
//     },
//   ].filter(Boolean);

//   return (
//     <div
//       style={{
//         background: "#fef9ee",
//         border: "1px solid #fde68a",
//         borderRadius: 8,
//         padding: "10px 12px",
//         marginTop: 6,
//       }}
//     >
//       <div
//         style={{
//           fontSize: 10,
//           fontWeight: 700,
//           color: "#b45309",
//           textTransform: "uppercase",
//           letterSpacing: "0.5px",
//           marginBottom: 7,
//         }}
//       >
//         Tax &amp; fees for this instalment
//       </div>
//       <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
//         <div className="tax-row">
//           <span>Base ({milestone.percentage}% of unit price)</span>
//           <span>{f(data.base)}</span>
//         </div>
//         {extraFees.map((fee, i) => (
//           <div key={i} className="tax-row">
//             <span>{fee.label}</span>
//             <span>{f(fee.val)}</span>
//           </div>
//         ))}
//         {data.tax > 0 && (
//           <div className="tax-row highlight">
//             <span>
//               {data.taxLabel}
//               {data.taxRate > 0 ? ` (${data.taxRate}%)` : ""}
//             </span>
//             <span>{f(data.tax)}</span>
//           </div>
//         )}
//         <div className="tax-row total">
//           <span>Instalment total</span>
//           <span>{f(data.total)}</span>
//         </div>
//       </div>
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────────────────────
//    BookingSummaryTaxCard
// ───────────────────────────────────────────────────────────── */
// const BookingSummaryTaxCard = ({
//   feeBreakdown,
//   selectedPlan,
//   plans,
//   unit,
//   sym = "₹",
// }) => {
//   if (
//     !feeBreakdown?.tax_enabled &&
//     !feeBreakdown?.processing_fee &&
//     !feeBreakdown?.stamp_duty
//   )
//     return null;
//   const f = (n) => fmtExact(n, sym);
//   const labels = feeBreakdown.fee_labels || {};
//   const extraFees = [
//     feeBreakdown.processing_fee > 0 && {
//       label: labels.processing || "Processing Fee",
//       val: feeBreakdown.processing_fee,
//     },
//     feeBreakdown.stamp_duty > 0 && {
//       label: labels.stamp_duty || "Stamp Duty",
//       val: feeBreakdown.stamp_duty,
//     },
//     feeBreakdown.registration_fee > 0 && {
//       label: labels.registration || "Registration Fee",
//       val: feeBreakdown.registration_fee,
//     },
//     feeBreakdown.maintenance_charge > 0 && {
//       label: labels.maintenance || "Maintenance",
//       val: feeBreakdown.maintenance_charge,
//     },
//     feeBreakdown.custom_fee1 > 0 && {
//       label: labels.custom1 || "Custom Fee 1",
//       val: feeBreakdown.custom_fee1,
//     },
//     feeBreakdown.custom_fee2 > 0 && {
//       label: labels.custom2 || "Custom Fee 2",
//       val: feeBreakdown.custom_fee2,
//     },
//   ].filter(Boolean);

//   const plan = plans.find((p) => p.id === selectedPlan);
//   const firstMs = plan?.milestones?.[0];
//   const firstPct = firstMs?.percentage
//     ? parseFloat(firstMs.percentage) / 100
//     : 1;
//   const dueNow = feeBreakdown.total_amount * (plan ? firstPct : 1);

//   return (
//     <div className="grand-total-banner" style={{ marginBottom: 16 }}>
//       <div
//         style={{
//           fontSize: 11,
//           fontWeight: 700,
//           color: "#92400e",
//           textTransform: "uppercase",
//           letterSpacing: "0.5px",
//           marginBottom: 10,
//         }}
//       >
//         📄 Payment Breakdown
//       </div>
//       <div className="gtb-row">
//         <span className="gtb-label">Unit Price</span>
//         <span className="gtb-val">{f(feeBreakdown.unit_price)}</span>
//       </div>
//       {extraFees.map((fee, i) => (
//         <div key={i} className="gtb-row">
//           <span className="gtb-label">{fee.label}</span>
//           <span className="gtb-val">{f(fee.val)}</span>
//         </div>
//       ))}
//       {feeBreakdown.tax_amount > 0 && (
//         <div
//           className="gtb-row"
//           style={{
//             color: "#b45309",
//             fontWeight: 600,
//             borderTop: "1px solid #fde68a",
//             paddingTop: 6,
//             marginTop: 4,
//           }}
//         >
//           <span>
//             {feeBreakdown.tax_label || "Tax"}
//             {feeBreakdown.tax_rate > 0 && (
//               <span style={{ fontSize: 10, marginLeft: 5, opacity: 0.8 }}>
//                 ({feeBreakdown.tax_rate}%
//                 {feeBreakdown.tax_system
//                   ? ` · ${feeBreakdown.tax_system.toUpperCase()}`
//                   : ""}
//                 {feeBreakdown.tax_inclusive ? " · Incl." : ""})
//               </span>
//             )}
//           </span>
//           <span>{f(feeBreakdown.tax_amount)}</span>
//         </div>
//       )}
//       <div
//         className="gtb-row"
//         style={{
//           borderTop: "1.5px solid #fcd34d",
//           paddingTop: 8,
//           marginTop: 4,
//         }}
//       >
//         <span className="gtb-total-label">Grand Total</span>
//         <span className="gtb-total-val">{f(feeBreakdown.total_amount)}</span>
//       </div>
//       {plan && firstMs && (
//         <div className="due-now-box">
//           <div className="due-now-label">
//             Due Now — {firstMs.label} ({firstMs.percentage}%)
//           </div>
//           <div className="due-now-val">{f(dueNow)}</div>
//           <div className="due-now-note">
//             Includes proportional taxes &amp; fees
//           </div>
//         </div>
//       )}
//       <div
//         style={{
//           fontSize: 10,
//           color: "var(--text-muted)",
//           marginTop: 8,
//           textAlign: "center",
//         }}
//       >
//         Amounts are estimates. Final figures confirmed at booking.
//       </div>
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────────────────────
//    TYPE_COLORS / ICONS (payment milestone types)
// ───────────────────────────────────────────────────────────── */
// const TYPE_COLORS = {
//   down_payment: { bg: "#eff6ff", color: "#1d4ed8", border: "#bfdbfe" },
//   installment: { bg: "#faf5ff", color: "#7e22ce", border: "#e9d5ff" },
//   on_completion: { bg: "#f0fdf4", color: "#15803d", border: "#bbf7d0" },
//   on_handover: { bg: "#fff7ed", color: "#c2410c", border: "#fed7aa" },
//   rental_guarantee: { bg: "#fff1f2", color: "#be123c", border: "#fecdd3" },
//   custom: { bg: "#f9fafb", color: "#374151", border: "#e5e7eb" },
// };
// const TYPE_ICONS = {
//   down_payment: "💰",
//   installment: "🔄",
//   on_completion: "🏗️",
//   on_handover: "🔑",
//   rental_guarantee: "📈",
//   custom: "⭐",
// };

// /* ═════════════════════════════════════════════════════════════
//    MAIN COMPONENT
// ═════════════════════════════════════════════════════════════ */
// const UnitPage = () => {
//   const { tenant, plotId } = useParams();
//   const navigate = useNavigate();
//   const { settings, isLoaded: settingsLoaded } = useSettings();

//   const containerRef = useRef(null);
//   const viewerRef = useRef(null);
//   const markersRef = useRef(null);
//   const overlayRef = useRef(null);
//   const labelRef = useRef(null);
//   const allMarkerIdsRef = useRef([]);

//   const [unit, setUnit] = useState(null);
//   const [hotspots, setHotspots] = useState(null);
//   const [fetchError, setFetchError] = useState(null);
//   const [isFetching, setIsFetching] = useState(true);
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [loadProgress, setLoadProgress] = useState(0);
//   const [activeTab, setActiveTab] = useState("details");
//   const [galIdx, setGalIdx] = useState(0);

//   // Booking sidebar state
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [bookingStep, setBookingStep] = useState("details");
//   const [selectedPlan, setSelectedPlan] = useState(null);
//   const [loginForm, setLoginForm] = useState({ email: "", password: "" });
//   const [registerForm, setRegisterForm] = useState({
//     name: "",
//     email: "",
//     country_code: "+91",
//     phone: "",
//     password: "",
//     role: "broker",
//     broker_company: "",
//   });
//   const [bookingForm, setBookingForm] = useState({
//     name: "",
//     phone: "",
//     notes: "",
//     client_name: "",
//     client_phone: "",
//     client_email: "",
//     client_country_code: "+91",
//   });
//   const [authLoading, setAuthLoading] = useState(false);
//   const [authError, setAuthError] = useState("");
//   const [bookingDone, setBookingDone] = useState(false);
//   const [pendingUserId, setPendingUserId] = useState(null);
//   const [existingBookingId, setExistingBookingId] = useState(null);
//   const [currency, setCurrency] = useState("₹");
//   const [feeBreakdown, setFeeBreakdown] = useState(null);

//   // Login modal (shared by wishlist + book-now-when-logged-out flows)
//   const [loginModalOpen, setLoginModalOpen] = useState(false);
//   const [authIntent, setAuthIntent] = useState(null); // null | "wishlist" | "book"
//   const [modalStep, setModalStep] = useState("login");
//   const [modalPendingUserId, setModalPendingUserId] = useState(null);
//   const [modalAuthError, setModalAuthError] = useState("");

//   const dispatch = useDispatch();
//   const user = useSelector(selectUser);
//   const { wishedIds, toggle: toggleWish } = useWishlist(tenant, user?.token);
//   const { showToast } = useToast();

//   // ── Helper: build image URL with tenant ──────────────────────────────────
//   const getFullImageUrl = useCallback(
//     (path) => {
//       if (!path) return null;
//       if (path.startsWith("http://") || path.startsWith("https://")) {
//         return path;
//       }
//       const baseUrl = settings?.img_url || process.env.REACT_APP_IMG_URL || "";
//       const cleanPath = path.startsWith("/") ? path.substring(1) : path;
//       return baseUrl.endsWith("/")
//         ? `${baseUrl}${cleanPath}`
//         : `${baseUrl}/${cleanPath}`;
//     },
//     [settings],
//   );

//   const wishlistWithToken = useCallback(
//     (freshToken, pid, plotNumber) => {
//       apiJson(tenant, `/wishlist/toggle`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${freshToken}`,
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ plot_id: Number(pid) }),
//       })
//         .then((d) => {
//           showToast(
//             d.wishlisted
//               ? `❤️ Added to Wishlist — Unit ${plotNumber}`
//               : `🤍 Removed from Wishlist — Unit ${plotNumber}`,
//             d.wishlisted ? "wishlist_add" : "wishlist_remove",
//             2800,
//           );
//         })
//         .catch(() => {});
//     },
//     [tenant, showToast],
//   );

//   // ── Fetch unit + hotspots + currency ──────────────────────
//   useEffect(() => {
//     if (!tenant || !plotId) {
//       setFetchError("No tenant or plot ID provided");
//       setIsFetching(false);
//       return;
//     }

//     const fetchAll = async () => {
//       try {
//         const [unitData, hsData, currData] = await Promise.all([
//           apiJson(tenant, `/unit/${plotId}`),
//           apiJson(tenant, `/hotspots?plot_id=${plotId}`),
//           apiJson(tenant, `/currency`),
//         ]);

//         setUnit(unitData);
//         setHotspots(hsData || []);
//         setCurrency(
//           currData?.symbol ||
//             currData?.currency ||
//             currData?.data?.symbol ||
//             currData?.data?.currency ||
//             "₹",
//         );
//       } catch (err) {
//         console.error("Fetch error:", err);
//         setFetchError(err.message);
//       } finally {
//         setIsFetching(false);
//       }
//     };
//     fetchAll();
//   }, [tenant, plotId]);

//   // ── Fee preview ────────────────────────────────────────────
//   useEffect(() => {
//     if (!unit?.actual_price && !unit?.offer_price) return;
//     if (!tenant) return;

//     const price = unit.offer_price || unit.actual_price;
//     apiJson(tenant, `/payment/fee-preview?price=${encodeURIComponent(price)}`, {
//       headers: {
//         Accept: "application/json",
//         ...(user?.token ? { Authorization: `Bearer ${user.token}` } : {}),
//       },
//     })
//       .then((d) => {
//         if (d) setFeeBreakdown(d.fee_breakdown || d);
//       })
//       .catch(() => {});
//   }, [tenant, unit, user?.token]);

//   // ── Panorama viewer ────────────────────────────────────────
//   const destroyViewer = useCallback(() => {
//     if (!viewerRef.current) return;
//     try {
//       viewerRef.current._cleanup?.();
//     } catch (e) {}
//     try {
//       if (
//         containerRef.current?.isConnected &&
//         containerRef.current?.hasChildNodes()
//       )
//         viewerRef.current.destroy();
//     } catch (e) {}
//     viewerRef.current = null;
//     markersRef.current = null;
//   }, []);

//   const buildMarkers = useCallback((unitData, hsData) => {
//     const markers = [];
//     hsData.forEach((hs) => {
//       if (!hs.yaw || !hs.pitch) return;
//       if (hs.hotspot_type === "gallery") {
//         markers.push({
//           id: `hs-gallery-${hs.id}`,
//           position: {
//             yaw: toRad(parseFloat(hs.yaw)),
//             pitch: toRad(parseFloat(hs.pitch)),
//           },
//           html: `<div class="hs-marker hs-gallery">🖼 ${hs.title || hs.label}</div>`,
//           size: { width: 170, height: 42 },
//           data: {
//             type: "gallery",
//             galleryIndex: hs.gallery_index ?? 0,
//             name: hs.title || hs.label,
//             yawRad: toRad(parseFloat(hs.yaw)),
//             pitchRad: toRad(parseFloat(hs.pitch)),
//           },
//         });
//       } else {
//         const room = unitData.rooms?.find(
//           (r) =>
//             r.id === hs.room_panorama_id ||
//             r.room_label === (hs.title || hs.label),
//         );
//         markers.push({
//           id: `hs-room-${hs.id}`,
//           position: {
//             yaw: toRad(parseFloat(hs.yaw)),
//             pitch: toRad(parseFloat(hs.pitch)),
//           },
//           html: `<div class="hs-marker hs-room">🚪 ${hs.title || hs.label}</div>`,
//           size: { width: 160, height: 42 },
//           data: {
//             type: "room",
//             roomId: room?.id || hs.room_panorama_id,
//             name: hs.title || hs.label,
//             yawRad: toRad(parseFloat(hs.yaw)),
//             pitchRad: toRad(parseFloat(hs.pitch)),
//           },
//         });
//       }
//     });
//     if (markers.length === 0 && unitData.rooms?.length > 0) {
//       unitData.rooms.forEach((room, idx) => {
//         const yaw = (idx / unitData.rooms.length) * 360 - 180;
//         markers.push({
//           id: `fallback-room-${room.id}`,
//           position: { yaw: toRad(yaw), pitch: toRad(-10) },
//           html: `<div class="hs-marker hs-room">🚪 ${room.room_label}</div>`,
//           size: { width: 160, height: 42 },
//           data: {
//             type: "room",
//             roomId: room.id,
//             name: room.room_label,
//             yawRad: toRad(yaw),
//             pitchRad: toRad(-10),
//           },
//         });
//       });
//     }
//     return markers;
//   }, []);

//   useEffect(() => {
//     if (
//       !unit?.panorama_url ||
//       !hotspots ||
//       !containerRef.current ||
//       activeTab !== "panorama"
//     )
//       return;

//     destroyViewer();
//     setIsLoaded(false);
//     setLoadProgress(0);

//     let current = 0;
//     const interval = setInterval(() => {
//       current += Math.random() * 10;
//       if (current >= 90) {
//         current = 90;
//         clearInterval(interval);
//       }
//       setLoadProgress(Math.round(current));
//     }, 180);

//     const fullPanoramaUrl = getFullImageUrl(unit.panorama_url);
//     if (!fullPanoramaUrl) {
//       setFetchError("Failed to construct panorama URL");
//       return;
//     }

//     const psvMarkers = buildMarkers(unit, hotspots);
//     allMarkerIdsRef.current = psvMarkers.map((m) => m.id);

//     const initTimer = setTimeout(() => {
//       if (!containerRef.current) return;
//       try {
//         viewerRef.current = new Viewer({
//           container: containerRef.current,
//           panorama: fullPanoramaUrl,
//           defaultZoomLvl: 50,
//           mousewheelCtrlKey: false,
//           loadingImg: null,
//           loadingTxt: "",
//           useXmpData: false,
//           plugins: [[MarkersPlugin, { markers: psvMarkers }]],
//         });
//       } catch (e) {
//         console.error("PSV init error:", e);
//         return;
//       }

//       const handleResize = () => {
//         try {
//           viewerRef.current?.autoSize();
//         } catch (e) {}
//       };
//       window.addEventListener("resize", handleResize);
//       document.addEventListener("fullscreenchange", handleResize);
//       document.addEventListener("webkitfullscreenchange", handleResize);

//       markersRef.current = viewerRef.current.getPlugin(MarkersPlugin);
//       viewerRef.current.addEventListener("ready", () => {
//         clearInterval(interval);
//         setLoadProgress(100);
//         setTimeout(() => setIsLoaded(true), 400);

//         let angle = 0,
//           isInteracting = false,
//           resumeTimer = null;
//         const swing = () => {
//           if (!isInteracting) {
//             angle += 0.0015;
//             try {
//               viewerRef.current?.rotate({
//                 yaw: Math.sin(angle) * 0.06,
//                 pitch: 0,
//               });
//             } catch (e) {}
//           }
//           if (viewerRef.current)
//             viewerRef.current._rafId = requestAnimationFrame(swing);
//         };
//         viewerRef.current._rafId = requestAnimationFrame(swing);

//         const onStart = () => {
//           isInteracting = true;
//           clearTimeout(resumeTimer);
//         };
//         const onEnd = () => {
//           resumeTimer = setTimeout(() => {
//             isInteracting = false;
//           }, 2500);
//         };
//         const el = containerRef.current;
//         if (el) {
//           el.addEventListener("mousedown", onStart, { passive: true });
//           el.addEventListener("mouseup", onEnd, { passive: true });
//           el.addEventListener("touchstart", onStart, { passive: true });
//           el.addEventListener("touchend", onEnd, { passive: true });
//         }
//         viewerRef.current._cleanup = () => {
//           if (viewerRef.current?._rafId)
//             cancelAnimationFrame(viewerRef.current._rafId);
//           clearTimeout(resumeTimer);
//           window.removeEventListener("resize", handleResize);
//           document.removeEventListener("fullscreenchange", handleResize);
//           document.removeEventListener("webkitfullscreenchange", handleResize);
//           if (el) {
//             el.removeEventListener("mousedown", onStart);
//             el.removeEventListener("mouseup", onEnd);
//             el.removeEventListener("touchstart", onStart);
//             el.removeEventListener("touchend", onEnd);
//           }
//         };
//       });

//       markersRef.current?.addEventListener("select-marker", ({ marker }) => {
//         const { type, roomId, galleryIndex, name, yawRad, pitchRad } =
//           marker.data;
//         allMarkerIdsRef.current.forEach((id) => {
//           try {
//             markersRef.current?.updateMarker({ id, opacity: 0 });
//           } catch (e) {}
//         });
//         if (labelRef.current) {
//           labelRef.current.textContent = name;
//           labelRef.current.style.opacity = "1";
//         }
//         viewerRef.current
//           ?.animate({ yaw: yawRad, pitch: pitchRad, zoom: 60, speed: "4rpm" })
//           .then(() =>
//             viewerRef.current?.animate({
//               yaw: yawRad,
//               pitch: pitchRad,
//               zoom: 100,
//               speed: "20rpm",
//             }),
//           )
//           .then(() => {
//             if (overlayRef.current) {
//               overlayRef.current.style.transition = "opacity 0.4s ease-in";
//               overlayRef.current.style.opacity = "1";
//             }
//             setTimeout(() => {
//               if (type === "gallery")
//                 navigate(`/${tenant}/unit/${plotId}/gallery/${galleryIndex}`);
//               else navigate(`/${tenant}/unit/${plotId}/room/${roomId}`);
//             }, 450);
//           });
//       });
//     }, 50);

//     return () => {
//       clearInterval(interval);
//       clearTimeout(initTimer);
//       destroyViewer();
//     };
//   }, [
//     unit,
//     hotspots,
//     activeTab,
//     tenant,
//     plotId,
//     getFullImageUrl,
//     buildMarkers,
//     destroyViewer,
//     navigate,
//   ]);

//   useEffect(() => {
//     if (!overlayRef.current) return;
//     overlayRef.current.style.opacity = "1";
//     overlayRef.current.style.transition = "none";
//     const t = setTimeout(() => {
//       overlayRef.current.style.transition = "opacity 0.7s ease-out";
//       overlayRef.current.style.opacity = "0";
//     }, 50);
//     return () => clearTimeout(t);
//   }, []);

//   // ── Auth handlers (sidebar-embedded login/register/otp) ────
//   const handleLogin = async () => {
//     setAuthLoading(true);
//     setAuthError("");
//     try {
//       const data = await apiJson(tenant, `/user/login`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify(loginForm),
//       });

//       if (data.step === "verify_email") {
//         setPendingUserId(data.user_id);
//         setBookingStep("verify_email");
//         setAuthLoading(false);
//         return;
//       }
//       if (data.step === "verify_phone") {
//         setPendingUserId(data.user_id);
//         setBookingStep("verify_phone");
//         setAuthLoading(false);
//         return;
//       }

//       const userData = { ...data.user, token: data.token };
//       dispatch(setUser(userData));
//       setBookingForm((f) => ({
//         ...f,
//         name: userData.name || "",
//         phone: (userData.country_code || "") + (userData.phone || ""),
//       }));
//       afterAuth();
//     } catch (err) {
//       setAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleRegister = async () => {
//     setAuthLoading(true);
//     setAuthError("");
//     try {
//       const data = await apiJson(tenant, `/user/register`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify(registerForm),
//       });

//       setPendingUserId(data.user_id);
//       setBookingStep("verify_email");
//       setAuthError("");
//     } catch (err) {
//       setAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleVerifyEmail = async (otp) => {
//     setAuthLoading(true);
//     setAuthError("");
//     try {
//       const data = await apiJson(tenant, `/user/verify-email`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ user_id: pendingUserId, otp }),
//       });

//       setPendingUserId(data.user_id);
//       setBookingStep("verify_phone");
//       setAuthError("");
//     } catch (err) {
//       setAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleVerifyPhone = async (otp) => {
//     setAuthLoading(true);
//     setAuthError("");
//     try {
//       const data = await apiJson(tenant, `/user/verify-phone`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ user_id: pendingUserId, otp }),
//       });

//       const userData = { ...data.user, token: data.token };
//       dispatch(setUser(userData));
//       setBookingForm((f) => ({
//         ...f,
//         name: userData.name || "",
//         phone: (userData.country_code || "") + (userData.phone || ""),
//       }));
//       afterAuth();
//     } catch (err) {
//       setAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleResendOtp = async (type) => {
//     if (!pendingUserId) return;
//     setAuthLoading(true);
//     setAuthError("");
//     try {
//       const data = await apiJson(tenant, `/user/resend-otp`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ user_id: pendingUserId, type }),
//       });
//       setAuthError("✓ " + data.message);
//     } catch (err) {
//       setAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   // ── Modal auth handlers (login/register/otp inside the popup modal) ──
//   const handleModalLogin = async () => {
//     setAuthLoading(true);
//     setModalAuthError("");
//     try {
//       const data = await apiJson(tenant, `/user/login`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify(loginForm),
//       });

//       if (data.step === "verify_email") {
//         setModalPendingUserId(data.user_id);
//         setModalStep("verify_email");
//         setAuthLoading(false);
//         return;
//       }
//       if (data.step === "verify_phone") {
//         setModalPendingUserId(data.user_id);
//         setModalStep("verify_phone");
//         setAuthLoading(false);
//         return;
//       }

//       const userData = { ...data.user, token: data.token };
//       dispatch(setUser(userData));
//       setLoginModalOpen(false);

//       if (authIntent === "wishlist") {
//         wishlistWithToken(data.token, plotId, unit?.plot_number);
//       } else if (authIntent === "book") {
//         setBookingForm((f) => ({
//           ...f,
//           name: userData.name || "",
//           phone: (userData.country_code || "") + (userData.phone || ""),
//         }));
//         openBooking(userData);
//       }
//       setAuthIntent(null);
//     } catch (err) {
//       setModalAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleModalRegister = async () => {
//     setAuthLoading(true);
//     setModalAuthError("");
//     try {
//       const data = await apiJson(tenant, `/user/register`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify(registerForm),
//       });

//       setModalPendingUserId(data.user_id);
//       setModalStep("verify_email");
//       setModalAuthError("");
//     } catch (err) {
//       setModalAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleModalVerifyEmail = async (otp) => {
//     setAuthLoading(true);
//     setModalAuthError("");
//     try {
//       const data = await apiJson(tenant, `/user/verify-email`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ user_id: modalPendingUserId, otp }),
//       });

//       setModalPendingUserId(data.user_id);
//       setModalStep("verify_phone");
//       setModalAuthError("");
//     } catch (err) {
//       setModalAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleModalVerifyPhone = async (otp) => {
//     setAuthLoading(true);
//     setModalAuthError("");
//     try {
//       const data = await apiJson(tenant, `/user/verify-phone`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ user_id: modalPendingUserId, otp }),
//       });

//       const userData = { ...data.user, token: data.token };
//       dispatch(setUser(userData));
//       setLoginModalOpen(false);

//       if (authIntent === "wishlist") {
//         wishlistWithToken(data.token, plotId, unit?.plot_number);
//       } else if (authIntent === "book") {
//         setBookingForm((f) => ({
//           ...f,
//           name: userData.name || "",
//           phone: (userData.country_code || "") + (userData.phone || ""),
//         }));
//         openBooking(userData);
//       }
//       setAuthIntent(null);
//     } catch (err) {
//       setModalAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleModalResendOtp = async (type) => {
//     if (!modalPendingUserId) return;
//     setAuthLoading(true);
//     setModalAuthError("");
//     try {
//       const data = await apiJson(tenant, `/user/resend-otp`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ user_id: modalPendingUserId, type }),
//       });
//       setModalAuthError("✓ " + data.message);
//     } catch (err) {
//       setModalAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const closeModal = () => {
//     setLoginModalOpen(false);
//     setAuthIntent(null);
//     setModalStep("login");
//     setModalAuthError("");
//   };

//   // ── Booking submit ─────────────────────────────────────────
//   const handleBooking = async () => {
//     setAuthLoading(true);
//     setAuthError("");
//     const isAgent = user?.role === "broker" || user?.role === "sales";
//     if (isAgent && user?.status && user.status !== "active") {
//       setAuthError(
//         "Your account is currently inactive. Please contact the admin to activate your account before booking.",
//       );
//       setAuthLoading(false);
//       return;
//     }
//     try {
//       if (existingBookingId) {
//         const data = await apiJson(
//           tenant,
//           `/bookings/${existingBookingId}/plan`,
//           {
//             method: "PATCH",
//             headers: {
//               "Content-Type": "application/json",
//               Accept: "application/json",
//               Authorization: `Bearer ${user?.token}`,
//             },
//             body: JSON.stringify({ payment_plan_id: selectedPlan }),
//           },
//         );

//         if (data.booking?.fee_breakdown)
//           setFeeBreakdown(data.booking.fee_breakdown);
//         setTimeout(
//           () => navigate(`/${tenant}/payment/${existingBookingId}`),
//           400,
//         );
//         return;
//       }

//       const payload = {
//         plot_id: plotId,
//         plot_number: unit.plot_number,
//         plot_type: unit.plot_type,
//         block: unit.block,
//         section: unit.section,
//         direction: unit.direction,
//         area: unit.plot_size ? String(unit.plot_size) : "",
//         price: unit.offer_price
//           ? String(unit.offer_price)
//           : String(unit.actual_price || ""),
//         project_id: unit.project_id,
//         block_id: unit.block_id,
//         name: bookingForm.name,
//         phone: bookingForm.phone,
//         notes: bookingForm.notes,
//         payment_plan_id: selectedPlan,
//         client_name: isAgent ? bookingForm.client_name : undefined,
//         client_phone: isAgent
//           ? bookingForm.client_country_code + bookingForm.client_phone
//           : undefined,
//         client_email: isAgent ? bookingForm.client_email : undefined,
//       };

//       const data = await apiJson(tenant, `/bookings`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//           Authorization: `Bearer ${user?.token}`,
//         },
//         body: JSON.stringify(payload),
//       });

//       if (data.booking?.fee_breakdown)
//         setFeeBreakdown(data.booking.fee_breakdown);

//       const bookingId = data.booking?.id;
//       if (bookingId) {
//         showToast(
//           `🎉 Booking confirmed! Redirecting to payment…`,
//           "success",
//           2500,
//         );
//         setTimeout(() => navigate(`/${tenant}/payment/${bookingId}`), 400);
//       } else {
//         setBookingDone(true);
//         showToast(
//           `✅ Booking received! We'll contact you shortly.`,
//           "success",
//           4000,
//         );
//       }
//     } catch (err) {
//       setAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleBack = () => {
//     if (overlayRef.current) {
//       overlayRef.current.style.transition = "opacity 0.4s ease-in";
//       overlayRef.current.style.opacity = "1";
//     }
//     const dest = unit?.block_id
//       ? `/${tenant}/floor/${unit.block_id}`
//       : unit?.floor_id
//         ? `/${tenant}/floor/${unit.floor_id}`
//         : null;
//     setTimeout(() => (dest ? navigate(dest) : navigate(`/${tenant}`)), 450);
//   };

//   const switchToGallery = () => {
//     destroyViewer();
//     setActiveTab("gallery");
//     setIsLoaded(false);
//   };
//   const switchToPanorama = () => setActiveTab("panorama");
//   const switchToDetails = () => {
//     destroyViewer();
//     setActiveTab("details");
//   };

//   const hasPlans = (unit?.payment_plans?.length || 0) > 0;
//   const afterAuth = () => setBookingStep(hasPlans ? "plan" : "form");

//   // Accepts an optional user override so it can run immediately after a
//   // fresh login/registration (before the Redux `user` selector re-renders).
//   const openBooking = async (authedUser = user) => {
//     setSidebarOpen(true);
//     setBookingDone(false);
//     setAuthError("");
//     if (authedUser) {
//       if (
//         (authedUser.role === "broker" || authedUser.role === "sales") &&
//         authedUser.status &&
//         authedUser.status !== "active"
//       ) {
//         setBookingStep("broker_inactive");
//         return;
//       }
//       try {
//         const data = await apiJson(tenant, `/bookings`, {
//           headers: {
//             Authorization: `Bearer ${authedUser.token}`,
//             Accept: "application/json",
//           },
//         });

//         const bookings = Array.isArray(data) ? data : data.data || [];
//         const existing = bookings.find(
//           (b) =>
//             String(b.plot_id) === String(plotId) &&
//             b.booking_status !== "cancelled",
//         );
//         if (existing) {
//           setExistingBookingId(existing.id);
//           setSelectedPlan(existing.payment_plan_id || null);
//           try {
//             const d = await apiJson(tenant, `/bookings/${existing.id}`, {
//               headers: {
//                 Authorization: `Bearer ${authedUser.token}`,
//                 Accept: "application/json",
//               },
//             });
//             if (d?.booking?.fee_breakdown)
//               setFeeBreakdown(d.booking.fee_breakdown);
//           } catch (e) {}

//           if (existing.booking_status === "confirmed") {
//             setBookingDone(true);
//             setBookingStep("details");
//             return;
//           }
//           setBookingStep(hasPlans ? "plan" : "form");
//           return;
//         }
//       } catch (e) {}
//       setExistingBookingId(null);
//       setBookingStep(hasPlans ? "plan" : "form");
//     } else {
//       setExistingBookingId(null);
//       setBookingStep("details");
//     }
//   };

//   const logout = () => {
//     dispatch(clearUser());
//     setBookingStep("details");
//     setSelectedPlan(null);
//     setExistingBookingId(null);
//   };

//   useEffect(() => {
//     if (user)
//       setBookingForm((f) => ({
//         ...f,
//         name: f.name || user.name || "",
//         phone: f.phone || (user.country_code || "") + (user.phone || ""),
//       }));
//   }, [user?.id]);

//   // ── Helpers ────────────────────────────────────────────────
//   const fmtPrice = (val) =>
//     val ? `${currency} ${Number(val).toLocaleString("en-IN")}` : null;
//   const getStatusColor = (s) => {
//     const v = s?.toLowerCase();
//     return v === "available"
//       ? "#16a34a"
//       : v === "pre-booked"
//         ? "#d97706"
//         : "#dc2626";
//   };

//   // ── Guards ─────────────────────────────────────────────────
//   if (isFetching || !settingsLoaded)
//     return (
//       <div className="unit-loading-screen">
//         <div style={{ fontSize: 48 }}>🏠</div>
//         <div
//           style={{ color: "var(--text-dark)", fontSize: 16, fontWeight: 600 }}
//         >
//           {!settingsLoaded ? "Loading settings..." : "Loading unit…"}
//         </div>
//         <div className="loading-bar-track">
//           <div className="loading-bar-fill" />
//         </div>
//       </div>
//     );
//   if (fetchError || !unit)
//     return (
//       <div className="unit-loading-screen">
//         <div style={{ fontSize: 48 }}>⚠️</div>
//         <h2 style={{ color: "var(--text-dark)" }}>Unit Unavailable</h2>
//         <p style={{ color: "var(--text-muted)" }}>
//           {fetchError || "Unit not found."}
//         </p>
//         <button
//           onClick={() => navigate(`/${tenant}`)}
//           style={{
//             padding: "10px 24px",
//             background: "var(--primary-color)",
//             color: "#fff",
//             border: "none",
//             borderRadius: 8,
//             cursor: "pointer",
//             fontWeight: 700,
//           }}
//         >
//           ← Go Back
//         </button>
//       </div>
//     );

//   const gallery = unit.gallery_images || [];
//   const hasPano = !!unit.panorama_url;
//   const hasGal = gallery.length > 0;
//   const hasRooms = unit.rooms?.length > 0;
//   const isAvail = unit.status?.toLowerCase() === "available";
//   const statusColor = getStatusColor(unit.status);
//   const isWished =
//     wishedIds instanceof Set ? wishedIds.has(Number(plotId)) : false;
//   const sym = feeBreakdown?.currency_symbol || currency;

//   // ── Render panorama / gallery as full-screen ───────────────
//   const isFullView =
//     activeTab === "panorama" || (activeTab === "gallery" && hasGal);

//   return (
//     <div className="unit-page">
//       {/* ── Auth modal (wishlist + book-now-when-logged-out) ── */}
//       {loginModalOpen && (
//         <>
//           <div className="up-modal-backdrop" onClick={closeModal} />
//           <div className="up-modal">
//             <div className="up-modal-head">
//               <div className="up-modal-title">
//                 {modalStep === "verify_email"
//                   ? "📧 Verify Email"
//                   : modalStep === "verify_phone"
//                     ? "📱 Verify Phone"
//                     : authIntent === "book"
//                       ? "🏠 Login to Book"
//                       : authIntent === "wishlist"
//                         ? "❤️ Save to Wishlist"
//                         : "👤 Login to your account"}
//               </div>
//               <button className="up-modal-close" onClick={closeModal}>
//                 ×
//               </button>
//             </div>
//             {modalStep === "verify_email" ? (
//               <StepOtp
//                 key="modal-otp-email"
//                 type="email"
//                 onVerify={handleModalVerifyEmail}
//                 onResend={() => handleModalResendOtp("email")}
//                 loading={authLoading}
//                 error={modalAuthError}
//                 setError={setModalAuthError}
//               />
//             ) : modalStep === "verify_phone" ? (
//               <StepOtp
//                 key="modal-otp-phone"
//                 type="phone"
//                 onVerify={handleModalVerifyPhone}
//                 onResend={() => handleModalResendOtp("phone")}
//                 loading={authLoading}
//                 error={modalAuthError}
//                 setError={setModalAuthError}
//               />
//             ) : (
//               <>
//                 <div className="up-modal-tabs">
//                   {["login", "register"].map((tab) => (
//                     <button
//                       key={tab}
//                       className={`up-modal-tab${modalStep === tab ? " active" : ""}`}
//                       onClick={() => {
//                         setModalStep(tab);
//                         setModalAuthError("");
//                       }}
//                     >
//                       {tab === "login" ? "Log In" : "Register"}
//                     </button>
//                   ))}
//                 </div>
//                 <p
//                   style={{
//                     color: "var(--text-muted)",
//                     fontSize: 13,
//                     marginBottom: 16,
//                     lineHeight: 1.6,
//                   }}
//                 >
//                   {authIntent === "book"
//                     ? modalStep === "login"
//                       ? "Log in to continue booking this unit."
//                       : "Create an account to book this unit."
//                     : authIntent === "wishlist"
//                       ? modalStep === "login"
//                         ? "Log in to save this unit to your wishlist."
//                         : "Create an account to save this unit."
//                       : modalStep === "login"
//                         ? "Log in to access your account."
//                         : "Create an account to get started."}
//                 </p>
//                 {modalStep === "login" ? (
//                   <StepLogin
//                     form={loginForm}
//                     setForm={setLoginForm}
//                     onLogin={handleModalLogin}
//                     onSwitch={() => {
//                       setModalStep("register");
//                       setModalAuthError("");
//                     }}
//                     loading={authLoading}
//                     error={modalAuthError}
//                   />
//                 ) : (
//                   <StepRegister
//                     form={registerForm}
//                     setForm={setRegisterForm}
//                     onRegister={handleModalRegister}
//                     onSwitch={() => {
//                       setModalStep("login");
//                       setModalAuthError("");
//                     }}
//                     loading={authLoading}
//                     error={modalAuthError}
//                   />
//                 )}
//               </>
//             )}
//           </div>
//         </>
//       )}

//       {/* ── Sticky header ── */}
//       <div className="unit-header">
//         <button className="unit-back-btn" onClick={handleBack}>
//           ← Floor
//         </button>

//         <div className="unit-info">
//           <div className="unit-title-row">
//             <span className="unit-name">Unit {unit.plot_number}</span>
//             <span
//               className="unit-status-badge"
//               style={{
//                 background: statusColor + "18",
//                 color: statusColor,
//                 border: `1px solid ${statusColor}44`,
//               }}
//             >
//               {unit.status}
//             </span>
//           </div>
//           <div className="unit-subtitle">
//             {unit.plot_type}
//             {unit.plot_size ? ` · ${unit.plot_size} sqft` : ""}
//             {unit.direction ? ` · ${unit.direction}` : ""}
//           </div>
//         </div>

//         <div className="unit-tabs">
//           <button
//             className={`unit-tab${activeTab === "details" ? " active" : ""}`}
//             onClick={switchToDetails}
//           >
//             📋 Details
//           </button>
//           {hasPlans && (
//             <button
//               className={`unit-tab${activeTab === "payment" ? " active" : ""}`}
//               onClick={() => {
//                 destroyViewer();
//                 setActiveTab("payment");
//               }}
//             >
//               💳 Payment Plans
//             </button>
//           )}
//           {hasPano && (
//             <button
//               className={`unit-tab${activeTab === "panorama" ? " active" : ""}`}
//               onClick={switchToPanorama}
//             >
//               🌐 360°
//             </button>
//           )}
//           {hasGal && (
//             <button
//               className={`unit-tab${activeTab === "gallery" ? " active" : ""}`}
//               onClick={switchToGallery}
//             >
//               🖼 Gallery ({gallery.length})
//             </button>
//           )}
//         </div>

//         <div className="unit-price-wrap">
//           {user && (
//             <button
//               onClick={() => navigate(`/${tenant}/dashboard`)}
//               title={`${user.name} — My Dashboard`}
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 7,
//                 background: "var(--page-bg)",
//                 border: "1.5px solid var(--card-border)",
//                 borderRadius: 20,
//                 padding: "5px 14px 5px 6px",
//                 cursor: "pointer",
//                 color: "var(--text-dark)",
//                 fontSize: 12,
//                 fontWeight: 700,
//                 flexShrink: 0,
//                 fontFamily: "var(--font-body)",
//                 transition: "border-color 0.2s",
//               }}
//               onMouseEnter={(e) =>
//                 (e.currentTarget.style.borderColor = "var(--primary-color)")
//               }
//               onMouseLeave={(e) =>
//                 (e.currentTarget.style.borderColor = "var(--card-border)")
//               }
//             >
//               <span
//                 style={{
//                   width: 24,
//                   height: 24,
//                   borderRadius: "50%",
//                   background: "var(--primary-color)",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   fontSize: 11,
//                   fontWeight: 800,
//                   color: "#fff",
//                   flexShrink: 0,
//                 }}
//               >
//                 {user.name?.[0]?.toUpperCase()}
//               </span>
//               <span style={{ whiteSpace: "nowrap" }}>Dashboard</span>
//             </button>
//           )}

//           {!user && (
//             <button
//               onClick={() => {
//                 setAuthIntent(null);
//                 setModalStep("login");
//                 setModalAuthError("");
//                 setLoginModalOpen(true);
//               }}
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 7,
//                 background: "var(--page-bg)",
//                 border: "1.5px solid var(--card-border)",
//                 borderRadius: 20,
//                 padding: "6px 16px",
//                 cursor: "pointer",
//                 color: "var(--text-dark)",
//                 fontSize: 12,
//                 fontWeight: 700,
//                 flexShrink: 0,
//                 fontFamily: "var(--font-body)",
//                 transition: "border-color 0.2s",
//               }}
//               onMouseEnter={(e) =>
//                 (e.currentTarget.style.borderColor = "var(--primary-color)")
//               }
//               onMouseLeave={(e) =>
//                 (e.currentTarget.style.borderColor = "var(--card-border)")
//               }
//             >
//               👤 Login
//             </button>
//           )}

//           <div className="unit-price-box">
//             {unit.offer_price && (
//               <div className="unit-offer-price">
//                 {fmtPrice(unit.offer_price)}
//               </div>
//             )}
//             <div
//               className="unit-actual-price"
//               style={{
//                 color: unit.offer_price
//                   ? "var(--text-muted)"
//                   : "var(--text-dark)",
//                 textDecoration: unit.offer_price ? "line-through" : "none",
//                 fontSize: unit.offer_price ? 11 : 14,
//               }}
//             >
//               {fmtPrice(unit.actual_price)}
//             </div>
//             {feeBreakdown?.tax_enabled && feeBreakdown?.tax_rate > 0 && (
//               <div
//                 style={{
//                   fontSize: 10,
//                   color: "#b45309",
//                   marginTop: 2,
//                   fontWeight: 600,
//                 }}
//               >
//                 +{feeBreakdown.tax_rate}% {feeBreakdown.tax_label || "Tax"}
//               </div>
//             )}
//           </div>

//           {isAvail && (
//             <button
//               className="book-now-btn"
//               onClick={() => {
//                 if (user) {
//                   openBooking();
//                 } else {
//                   setAuthIntent("book");
//                   setModalStep("login");
//                   setModalAuthError("");
//                   setLoginModalOpen(true);
//                 }
//               }}
//             >
//               Book Now
//             </button>
//           )}

//           {unit && (
//             <button
//               onClick={() => {
//                 if (!user?.token) {
//                   setAuthIntent("wishlist");
//                   setModalStep("login");
//                   setModalAuthError("");
//                   setLoginModalOpen(true);
//                 } else {
//                   const willAdd = !isWished;
//                   toggleWish(Number(plotId))
//                     .then(() => {
//                       showToast(
//                         willAdd
//                           ? `❤️ Added to Wishlist — Unit ${unit.plot_number}`
//                           : `🤍 Removed from Wishlist — Unit ${unit.plot_number}`,
//                         willAdd ? "wishlist_add" : "wishlist_remove",
//                         2800,
//                       );
//                     })
//                     .catch(() => {
//                       showToast(
//                         "Failed to update wishlist. Please try again.",
//                         "error",
//                         3000,
//                       );
//                     });
//                 }
//               }}
//               title={isWished ? "Remove from Wishlist" : "Save to Wishlist"}
//               style={{
//                 background: isWished ? "#fff5f5" : "var(--page-bg)",
//                 border: `1.5px solid ${isWished ? "#fecaca" : "var(--card-border)"}`,
//                 borderRadius: 8,
//                 cursor: "pointer",
//                 padding: "6px 10px",
//                 fontSize: 18,
//                 lineHeight: 1,
//                 transition: "all 0.2s",
//                 color: isWished ? "#ef4444" : "var(--text-muted)",
//               }}
//             >
//               {isWished ? "❤️" : "🤍"}
//             </button>
//           )}
//         </div>
//       </div>

//       {/* ── Content ── */}
//       <div className="unit-content-area">
//         {/* Full-screen panorama */}
//         {activeTab === "panorama" && (
//           <div className="unit-fullview">
//             <div ref={containerRef} className="psv-container-div" />
//             <div className={`pano-loader${isLoaded ? " gone" : ""}`}>
//               <div className="pano-loader-card">
//                 <div className="pano-loader-emoji">🏠</div>
//                 <div className="pano-loader-percent">{loadProgress}%</div>
//                 <div className="pano-loader-bar-track">
//                   <div
//                     className="pano-loader-bar-fill"
//                     style={{ width: `${loadProgress}%` }}
//                   />
//                 </div>
//                 <div className="pano-loader-text">
//                   {loadProgress < 40
//                     ? "Preparing panorama..."
//                     : loadProgress < 80
//                       ? "Loading image data..."
//                       : loadProgress < 100
//                         ? "Almost ready..."
//                         : "✓ Ready"}
//                 </div>
//               </div>
//             </div>
//             {isLoaded && hasRooms && (
//               <div className="room-nav-strip">
//                 <span className="room-nav-label">Rooms</span>
//                 {unit.rooms.map((room) => (
//                   <button
//                     key={room.id}
//                     className="room-thumb-btn"
//                     onClick={() =>
//                       navigate(`/${tenant}/unit/${plotId}/room/${room.id}`)
//                     }
//                   >
//                     {room.thumb_url ? (
//                       <img
//                         src={getFullImageUrl(room.thumb_url)}
//                         alt={room.room_label}
//                       />
//                     ) : (
//                       <div className="room-thumb-placeholder">🚪</div>
//                     )}
//                     <span>{room.room_label}</span>
//                   </button>
//                 ))}
//               </div>
//             )}
//             <div ref={labelRef} className="marker-label" />
//           </div>
//         )}

//         {/* Two-column layout for details / payment / gallery */}
//         {activeTab !== "panorama" && (
//           <div className="unit-detail-layout">
//             {/* ── LEFT ── */}
//             <div className="unit-detail-left">
//               {(activeTab === "details" ||
//                 activeTab === "gallery" ||
//                 activeTab === "payment") &&
//                 (hasGal || hasPano) && (
//                   <GalleryStrip
//                     gallery={gallery}
//                     hasPano={hasPano}
//                     plotId={plotId}
//                     tenant={tenant}
//                     navigate={navigate}
//                     galIdx={galIdx}
//                     setGalIdx={setGalIdx}
//                     onOpenPano={switchToPanorama}
//                   />
//                 )}

//               {activeTab === "details" && (
//                 <UnitDetailsContent
//                   unit={unit}
//                   fmtPrice={fmtPrice}
//                   statusColor={statusColor}
//                   currency={currency}
//                   sym={sym}
//                   feeBreakdown={feeBreakdown}
//                   getFullImageUrl={getFullImageUrl}
//                 />
//               )}

//               {activeTab === "payment" && (
//                 <PaymentPlansContent
//                   plans={unit.payment_plans || []}
//                   fmtPrice={fmtPrice}
//                   currency={currency}
//                   unitPrice={unit.offer_price || unit.actual_price}
//                   feeBreakdown={feeBreakdown}
//                   sym={sym}
//                 />
//               )}

//               {activeTab === "gallery" && hasGal && (
//                 <div style={{ marginTop: 16 }}>
//                   <div className="up-section">
//                     <div className="up-section-head">
//                       🖼 All Photos ({gallery.length})
//                     </div>
//                     <div className="up-section-body">
//                       <div
//                         style={{
//                           display: "grid",
//                           gridTemplateColumns:
//                             "repeat(auto-fill, minmax(200px, 1fr))",
//                           gap: 10,
//                         }}
//                       >
//                         {gallery.map((img, i) => {
//                           const imgUrl = getFullImageUrl(img);
//                           return imgUrl ? (
//                             <img
//                               key={i}
//                               src={imgUrl}
//                               alt={`Gallery ${i + 1}`}
//                               onClick={() => {
//                                 setGalIdx(i);
//                                 navigate(
//                                   `/${tenant}/unit/${plotId}/gallery/${i}`,
//                                 );
//                               }}
//                               style={{
//                                 width: "100%",
//                                 aspectRatio: "4/3",
//                                 objectFit: "cover",
//                                 borderRadius: 8,
//                                 cursor: "pointer",
//                                 border: `2px solid ${i === galIdx ? "var(--primary-color)" : "transparent"}`,
//                                 transition: "all 0.2s",
//                               }}
//                             />
//                           ) : null;
//                         })}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* ── RIGHT — booking widget ── */}
//             <div
//               className={`unit-detail-right${sidebarOpen ? " sidebar-open" : ""}`}
//             >
//               <div className="right-panel-header">
//                 <div className="right-panel-price">
//                   {unit.offer_price
//                     ? fmtPrice(unit.offer_price)
//                     : fmtPrice(unit.actual_price)}
//                 </div>
//                 {unit.offer_price && (
//                   <div className="right-panel-price-orig">
//                     {fmtPrice(unit.actual_price)}
//                   </div>
//                 )}
//                 {feeBreakdown?.tax_enabled &&
//                   feeBreakdown?.total_amount > 0 && (
//                     <div
//                       style={{
//                         fontSize: 12,
//                         color: "#b45309",
//                         fontWeight: 600,
//                         marginTop: 3,
//                       }}
//                     >
//                       Grand Total: {fmtExact(feeBreakdown.total_amount, sym)}{" "}
//                       (incl. tax)
//                     </div>
//                   )}
//                 <div className="right-panel-title">Unit {unit.plot_number}</div>
//                 <div className="right-panel-sub">
//                   {unit.plot_type}
//                   {unit.plot_size ? ` · ${unit.plot_size} sqft` : ""}
//                   {unit.direction ? ` · ${unit.direction}` : ""}
//                 </div>
//                 <div
//                   style={{
//                     marginTop: 8,
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: 5,
//                     padding: "3px 12px",
//                     borderRadius: 20,
//                     fontSize: 12,
//                     fontWeight: 700,
//                     background: statusColor + "18",
//                     color: statusColor,
//                     border: `1px solid ${statusColor}44`,
//                   }}
//                 >
//                   ● {unit.status}
//                 </div>
//               </div>

//               {/* Quick stat pills */}
//               <div style={{ padding: "14px 22px 0" }}>
//                 <div className="rp-stats">
//                   {unit.bedrooms != null && (
//                     <div className="rp-stat">
//                       <span className="rp-stat-icon">🛏</span>
//                       <div className="rp-stat-val">{unit.bedrooms}</div>
//                       <div className="rp-stat-lbl">Beds</div>
//                     </div>
//                   )}
//                   {unit.bathrooms != null && (
//                     <div className="rp-stat">
//                       <span className="rp-stat-icon">🚿</span>
//                       <div className="rp-stat-val">{unit.bathrooms}</div>
//                       <div className="rp-stat-lbl">Baths</div>
//                     </div>
//                   )}
//                   {unit.plot_size && (
//                     <div className="rp-stat">
//                       <span className="rp-stat-icon">📐</span>
//                       <div className="rp-stat-val">{unit.plot_size}</div>
//                       <div className="rp-stat-lbl">sqft</div>
//                     </div>
//                   )}
//                   {!unit.bedrooms && !unit.bathrooms && !unit.plot_size && (
//                     <>
//                       <div className="rp-stat">
//                         <span className="rp-stat-icon">🏢</span>
//                         <div className="rp-stat-val">
//                           {unit.plot_type || "—"}
//                         </div>
//                         <div className="rp-stat-lbl">Type</div>
//                       </div>
//                       <div className="rp-stat">
//                         <span className="rp-stat-icon">🧭</span>
//                         <div className="rp-stat-val">
//                           {unit.direction || "—"}
//                         </div>
//                         <div className="rp-stat-lbl">Facing</div>
//                       </div>
//                       <div className="rp-stat">
//                         <span className="rp-stat-icon">🚪</span>
//                         <div className="rp-stat-val">
//                           {unit.rooms?.length || 0}
//                         </div>
//                         <div className="rp-stat-lbl">Rooms</div>
//                       </div>
//                     </>
//                   )}
//                 </div>
//               </div>

//               <div className="right-panel-scroll">
//                 {bookingStep === "broker_inactive" ? (
//                   <BrokerInactiveScreen onClose={() => setSidebarOpen(false)} />
//                 ) : bookingDone ? (
//                   <BookingDone
//                     unit={unit}
//                     onClose={() => setSidebarOpen(false)}
//                   />
//                 ) : bookingStep === "details" ? (
//                   <StepDetails
//                     user={user}
//                     onBook={() =>
//                       user
//                         ? hasPlans
//                           ? setBookingStep("plan")
//                           : setBookingStep("form")
//                         : setBookingStep("login")
//                     }
//                     onLogout={logout}
//                     isAvail={isAvail}
//                   />
//                 ) : bookingStep === "login" ? (
//                   <StepLogin
//                     form={loginForm}
//                     setForm={setLoginForm}
//                     onLogin={handleLogin}
//                     onSwitch={() => {
//                       setBookingStep("register");
//                       setAuthError("");
//                     }}
//                     loading={authLoading}
//                     error={authError}
//                   />
//                 ) : bookingStep === "register" ? (
//                   <StepRegister
//                     form={registerForm}
//                     setForm={setRegisterForm}
//                     onRegister={handleRegister}
//                     onSwitch={() => {
//                       setBookingStep("login");
//                       setAuthError("");
//                     }}
//                     loading={authLoading}
//                     error={authError}
//                   />
//                 ) : bookingStep === "verify_email" ? (
//                   <StepOtp
//                     key="otp-email"
//                     type="email"
//                     onVerify={handleVerifyEmail}
//                     onResend={() => handleResendOtp("email")}
//                     loading={authLoading}
//                     error={authError}
//                     setError={setAuthError}
//                   />
//                 ) : bookingStep === "verify_phone" ? (
//                   <StepOtp
//                     key="otp-phone"
//                     type="phone"
//                     onVerify={handleVerifyPhone}
//                     onResend={() => handleResendOtp("phone")}
//                     loading={authLoading}
//                     error={authError}
//                     setError={setAuthError}
//                   />
//                 ) : bookingStep === "plan" ? (
//                   <StepPlanSelect
//                     plans={unit.payment_plans || []}
//                     selected={selectedPlan}
//                     onSelect={setSelectedPlan}
//                     fmtPrice={fmtPrice}
//                     unitPrice={unit.actual_price}
//                     onNext={() => setBookingStep("form")}
//                     onBack={() => setBookingStep("details")}
//                     existingBookingId={existingBookingId}
//                     feeBreakdown={feeBreakdown}
//                     sym={sym}
//                   />
//                 ) : bookingStep === "form" ? (
//                   <StepBookingForm
//                     user={user}
//                     form={bookingForm}
//                     setForm={setBookingForm}
//                     onSubmit={handleBooking}
//                     loading={authLoading}
//                     error={authError}
//                     selectedPlan={selectedPlan}
//                     plans={unit.payment_plans || []}
//                     onBack={() =>
//                       hasPlans
//                         ? setBookingStep("plan")
//                         : setBookingStep("details")
//                     }
//                     unit={unit}
//                     existingBookingId={existingBookingId}
//                     feeBreakdown={feeBreakdown}
//                     sym={sym}
//                   />
//                 ) : null}
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// /* ═════════════════════════════════════════════════════════════
//    GalleryStrip — Dubizzle-style image strip
// ═════════════════════════════════════════════════════════════ */
// const GalleryStrip = ({
//   gallery,
//   hasPano,
//   plotId,
//   tenant,
//   navigate,
//   galIdx,
//   setGalIdx,
//   onOpenPano,
// }) => {
//   if (!gallery.length && !hasPano) return null;
//   const total = gallery.length;
//   return (
//     <div className="up-gallery">
//       <div
//         className="up-gallery-main"
//         onClick={() =>
//           total > 0 && navigate(`/${tenant}/unit/${plotId}/gallery/${galIdx}`)
//         }
//       >
//         {total > 0 ? (
//           <img src={gallery[galIdx]} alt={`View ${galIdx + 1}`} />
//         ) : (
//           <div
//             style={{
//               width: "100%",
//               height: "100%",
//               background: "#1a1a1a",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               color: "rgba(255,255,255,0.3)",
//               fontSize: 40,
//               aspectRatio: "16/9",
//             }}
//           >
//             🏠
//           </div>
//         )}

//         <div className="up-gallery-badges">
//           {hasPano && (
//             <button
//               className="up-gallery-badge pano"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 onOpenPano();
//               }}
//             >
//               🌐 360° View
//             </button>
//           )}
//         </div>

//         {total > 1 && (
//           <>
//             <button
//               className="up-gallery-nav prev"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 setGalIdx((i) => (i - 1 + total) % total);
//               }}
//             >
//               ‹
//             </button>
//             <button
//               className="up-gallery-nav next"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 setGalIdx((i) => (i + 1) % total);
//               }}
//             >
//               ›
//             </button>
//             <div className="up-gallery-counter">
//               📷 {galIdx + 1} / {total}
//             </div>
//           </>
//         )}
//       </div>
//       {total > 1 && (
//         <div className="up-gallery-thumbs">
//           {gallery.map((img, i) => (
//             <img
//               key={i}
//               src={img}
//               alt=""
//               className={i === galIdx ? "active" : ""}
//               onClick={() => setGalIdx(i)}
//             />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// /* ═════════════════════════════════════════════════════════════
//    UnitDetailsContent — Dubizzle-style detail sections
// ═════════════════════════════════════════════════════════════ */
// const UnitDetailsContent = ({
//   unit,
//   fmtPrice,
//   statusColor,
//   currency,
//   sym,
//   feeBreakdown,
//   getFullImageUrl,
// }) => {
//   const hasDims = unit.room_dimensions?.length > 0;
//   const hasAmenities = unit.amenities?.length > 0;
//   const hasAreaData =
//     unit.internal_area_sqft ||
//     unit.internal_area_sqm ||
//     unit.external_area_sqft;

//   return (
//     <>
//       {/* Headline */}
//       <div className="up-headline">
//         <div>
//           <h1 className="up-title">
//             Unit {unit.plot_number} — {unit.plot_type}
//           </h1>
//           <div className="up-meta-chips">
//             {unit.bedrooms != null && (
//               <span className="up-meta-chip">
//                 <span className="chip-icon">🛏</span>
//                 {unit.bedrooms} Bed{unit.bedrooms !== 1 ? "s" : ""}
//               </span>
//             )}
//             {unit.bathrooms != null && (
//               <span className="up-meta-chip">
//                 <span className="chip-icon">🚿</span>
//                 {unit.bathrooms} Bath{unit.bathrooms !== 1 ? "s" : ""}
//               </span>
//             )}
//             {unit.plot_size && (
//               <span className="up-meta-chip">
//                 <span className="chip-icon">📐</span>
//                 {unit.plot_size} sqft
//               </span>
//             )}
//             {unit.direction && (
//               <span className="up-meta-chip">
//                 <span className="chip-icon">🧭</span>
//                 {unit.direction}
//               </span>
//             )}
//           </div>
//         </div>
//         <div className="up-price-block">
//           {unit.offer_price && (
//             <div className="up-price-main">{fmtPrice(unit.offer_price)}</div>
//           )}
//           {unit.offer_price && (
//             <div className="up-price-original">
//               {fmtPrice(unit.actual_price)}
//             </div>
//           )}
//           {!unit.offer_price && unit.actual_price && (
//             <div className="up-price-main">{fmtPrice(unit.actual_price)}</div>
//           )}
//           {feeBreakdown?.tax_enabled && feeBreakdown?.tax_rate > 0 && (
//             <div className="up-price-tax-note">
//               +{feeBreakdown.tax_rate}% {feeBreakdown.tax_label || "Tax"}
//             </div>
//           )}
//           <div
//             className="up-price-status"
//             style={{
//               background: statusColor + "18",
//               color: statusColor,
//               border: `1px solid ${statusColor}44`,
//             }}
//           >
//             ● {unit.status}
//           </div>
//         </div>
//       </div>

//       {/* Overview facts */}
//       <div className="up-section">
//         <div className="up-section-head">🏠 Overview</div>
//         <div className="up-section-body">
//           <div className="up-facts-grid">
//             {[
//               ["Unit No", unit.plot_number],
//               ["Type", unit.plot_type],
//               ["Size", unit.plot_size ? `${unit.plot_size} sqft` : "—"],
//               ["Direction", unit.direction || "—"],
//               ["Project", unit.project_name || "—"],
//               ["Floor", unit.block || "—"],
//               ["Rooms", unit.rooms?.length || "—"],
//               ["Status", unit.status],
//             ].map(([lbl, val]) => (
//               <div key={lbl} className="up-fact">
//                 <div className="up-fact-label">{lbl}</div>
//                 <div className="up-fact-value">{val}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Area breakdown */}
//       {hasAreaData && (
//         <div className="up-section">
//           <div className="up-section-head">📐 Floor Areas</div>
//           <div className="up-section-body">
//             <div className="up-area-grid">
//               {unit.internal_area_sqft && (
//                 <div
//                   className="up-area-card"
//                   style={{ borderColor: "var(--primary-color)33" }}
//                 >
//                   <div className="up-area-label">Internal Area</div>
//                   <div
//                     className="up-area-sqft"
//                     style={{ color: "var(--primary-color)" }}
//                   >
//                     {Number(unit.internal_area_sqft).toLocaleString()}{" "}
//                     <span>sq ft</span>
//                   </div>
//                   <div className="up-area-sqm">
//                     {unit.internal_area_sqm
//                       ? Number(unit.internal_area_sqm).toLocaleString()
//                       : (unit.internal_area_sqft / 10.764).toFixed(1)}{" "}
//                     sq m
//                   </div>
//                 </div>
//               )}
//               {unit.external_area_sqft && (
//                 <div className="up-area-card">
//                   <div className="up-area-label">External Area</div>
//                   <div className="up-area-sqft">
//                     {Number(unit.external_area_sqft).toLocaleString()}{" "}
//                     <span>sq ft</span>
//                   </div>
//                   <div className="up-area-sqm">
//                     {unit.external_area_sqm
//                       ? Number(unit.external_area_sqm).toLocaleString()
//                       : (unit.external_area_sqft / 10.764).toFixed(1)}{" "}
//                     sq m
//                   </div>
//                 </div>
//               )}
//               {unit.internal_area_sqft && unit.external_area_sqft && (
//                 <div
//                   className="up-area-card"
//                   style={{ borderColor: "#86efac" }}
//                 >
//                   <div className="up-area-label">Total Area</div>
//                   <div className="up-area-sqft" style={{ color: "#16a34a" }}>
//                     {(
//                       parseFloat(unit.internal_area_sqft) +
//                       parseFloat(unit.external_area_sqft)
//                     ).toFixed(2)}{" "}
//                     <span>sq ft</span>
//                   </div>
//                   {unit.internal_area_sqm && unit.external_area_sqm && (
//                     <div className="up-area-sqm">
//                       {(
//                         parseFloat(unit.internal_area_sqm) +
//                         parseFloat(unit.external_area_sqm)
//                       ).toFixed(2)}{" "}
//                       sq m
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Room dimensions */}
//       {hasDims && (
//         <div className="up-section">
//           <div className="up-section-head">📏 Room Dimensions</div>
//           <div className="up-section-body">
//             {unit.room_dimensions.map((dim, i) => {
//               const u = dim.unit || "m",
//                 w = parseFloat(dim.width),
//                 l = parseFloat(dim.length);
//               const wFt = u === "m" ? toFt(w) : w.toFixed(1),
//                 lFt = u === "m" ? toFt(l) : l.toFixed(1);
//               const wM = u === "ft" ? (w / 3.28084).toFixed(1) : w.toFixed(1),
//                 lM = u === "ft" ? (l / 3.28084).toFixed(1) : l.toFixed(1);
//               const sqm = dim.area_sqm
//                 ? parseFloat(dim.area_sqm)
//                 : w && l
//                   ? u === "m"
//                     ? w * l
//                     : (w * l) / 10.7639
//                   : null;
//               const sqft = dim.area_sqft
//                 ? parseFloat(dim.area_sqft)
//                 : sqm
//                   ? sqm * 10.7639
//                   : null;
//               return (
//                 <div key={i} className="up-dim-row">
//                   <div className="up-dim-name">{dim.label}</div>
//                   <div className="up-dim-vals">
//                     <span className="up-dim-primary">
//                       {wM} × {lM} m
//                     </span>
//                     <span className="up-dim-secondary">
//                       {wFt}' × {lFt}'
//                     </span>
//                     {sqm != null && (
//                       <span className="up-dim-area">
//                         {sqm.toFixed(1)} m² / {sqft.toFixed(1)} ft²
//                       </span>
//                     )}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       )}

//       {/* Amenities */}
//       {hasAmenities && (
//         <div className="up-section">
//           <div className="up-section-head">✨ Amenities</div>
//           <div className="up-section-body">
//             <div className="up-amenities">
//               {unit.amenities.map((a, i) => (
//                 <div key={i} className="up-amenity">
//                   <span>{amenityIcon(a)}</span>
//                   <span>{a}</span>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Floor plan */}
//       {unit.floor_plan_image && (
//         <div className="up-section">
//           <div className="up-section-head">🗺️ Floor Plan</div>
//           <div className="up-section-body up-floor-plan">
//             <img
//               src={getFullImageUrl(unit.floor_plan_image)}
//               alt="Floor Plan"
//             />
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// /* ═════════════════════════════════════════════════════════════
//    PaymentPlansContent - with proper tax display
// ═════════════════════════════════════════════════════════════ */
// const PaymentPlansContent = ({
//   plans,
//   fmtPrice,
//   currency,
//   unitPrice,
//   feeBreakdown,
//   sym = "₹",
// }) => {
//   const [activePlan, setActivePlan] = useState(0);
//   if (!plans?.length)
//     return (
//       <div className="up-section">
//         <div
//           className="up-section-body"
//           style={{ textAlign: "center", padding: "40px 20px" }}
//         >
//           <div style={{ fontSize: 40, marginBottom: 12 }}>💳</div>
//           <div
//             style={{
//               fontSize: 15,
//               fontWeight: 600,
//               color: "var(--text-muted)",
//             }}
//           >
//             No payment plans available
//           </div>
//         </div>
//       </div>
//     );

//   const basePrice =
//     parseFloat(String(unitPrice || "0").replace(/[^0-9.]/g, "")) || 0;
//   const calcAmtLabel = (pct) =>
//     basePrice > 0 ? fmtExact((basePrice * parseFloat(pct)) / 100, sym) : null;
//   const plan = plans[activePlan];
//   const totalPct = plan.milestones.reduce(
//     (s, m) => s + (parseFloat(m.percentage) || 0),
//     0,
//   );

//   const calculateMilestoneTotal = (milestone) => {
//     if (!feeBreakdown || !milestone.percentage) {
//       return null;
//     }
//     const pct = parseFloat(milestone.percentage) / 100;
//     const base = (feeBreakdown.unit_price || basePrice) * pct;
//     const tax = (feeBreakdown.tax_amount || 0) * pct;
//     const fees =
//       ((feeBreakdown.processing_fee || 0) +
//         (feeBreakdown.stamp_duty || 0) +
//         (feeBreakdown.registration_fee || 0) +
//         (feeBreakdown.maintenance_charge || 0) +
//         (feeBreakdown.custom_fee1 || 0) +
//         (feeBreakdown.custom_fee2 || 0)) *
//       pct;
//     return {
//       base,
//       tax,
//       fees,
//       total: base + tax + fees,
//     };
//   };

//   return (
//     <div className="up-plans-wrap">
//       {plans.length > 1 && (
//         <div className="up-plan-tabs">
//           {plans.map((p, i) => (
//             <button
//               key={p.id}
//               className={`up-plan-tab${i === activePlan ? " active" : ""}`}
//               onClick={() => setActivePlan(i)}
//             >
//               {p.name}
//             </button>
//           ))}
//         </div>
//       )}

//       {/* Grand total banner */}
//       {feeBreakdown?.tax_enabled && feeBreakdown?.total_amount > 0 && (
//         <div className="grand-total-banner" style={{ marginBottom: 16 }}>
//           <div className="gtb-row">
//             <span className="gtb-label">Unit {fmtExact(basePrice, sym)}</span>
//             <span className="gtb-val">
//               {fmtExact(feeBreakdown.unit_price || basePrice, sym)}
//             </span>
//           </div>
//           {(feeBreakdown.processing_fee || 0) > 0 && (
//             <div className="gtb-row">
//               <span className="gtb-label">
//                 {feeBreakdown.fee_labels?.processing || "Processing Fee"}
//               </span>
//               <span className="gtb-val">
//                 {fmtExact(feeBreakdown.processing_fee, sym)}
//               </span>
//             </div>
//           )}
//           {(feeBreakdown.stamp_duty || 0) > 0 && (
//             <div className="gtb-row">
//               <span className="gtb-label">
//                 {feeBreakdown.fee_labels?.stamp_duty || "Stamp Duty"}
//               </span>
//               <span className="gtb-val">
//                 {fmtExact(feeBreakdown.stamp_duty, sym)}
//               </span>
//             </div>
//           )}
//           {(feeBreakdown.registration_fee || 0) > 0 && (
//             <div className="gtb-row">
//               <span className="gtb-label">
//                 {feeBreakdown.fee_labels?.registration || "Registration Fee"}
//               </span>
//               <span className="gtb-val">
//                 {fmtExact(feeBreakdown.registration_fee, sym)}
//               </span>
//             </div>
//           )}
//           {(feeBreakdown.maintenance_charge || 0) > 0 && (
//             <div className="gtb-row">
//               <span className="gtb-label">
//                 {feeBreakdown.fee_labels?.maintenance || "Maintenance"}
//               </span>
//               <span className="gtb-val">
//                 {fmtExact(feeBreakdown.maintenance_charge, sym)}
//               </span>
//             </div>
//           )}
//           {(feeBreakdown.custom_fee1 || 0) > 0 && (
//             <div className="gtb-row">
//               <span className="gtb-label">
//                 {feeBreakdown.fee_labels?.custom1 || "Custom Fee 1"}
//               </span>
//               <span className="gtb-val">
//                 {fmtExact(feeBreakdown.custom_fee1, sym)}
//               </span>
//             </div>
//           )}
//           {(feeBreakdown.custom_fee2 || 0) > 0 && (
//             <div className="gtb-row">
//               <span className="gtb-label">
//                 {feeBreakdown.fee_labels?.custom2 || "Custom Fee 2"}
//               </span>
//               <span className="gtb-val">
//                 {fmtExact(feeBreakdown.custom_fee2, sym)}
//               </span>
//             </div>
//           )}
//           {feeBreakdown.tax_amount > 0 && (
//             <div className="gtb-row" style={{ color: "#b45309" }}>
//               <span>
//                 {feeBreakdown.tax_label || "Tax"} ({feeBreakdown.tax_rate}%
//                 {feeBreakdown.tax_system
//                   ? ` · ${feeBreakdown.tax_system.toUpperCase()}`
//                   : ""}
//                 )
//               </span>
//               <span style={{ fontWeight: 700 }}>
//                 {fmtExact(feeBreakdown.tax_amount, sym)}
//               </span>
//             </div>
//           )}
//           <div
//             className="gtb-row"
//             style={{
//               borderTop: "1px solid #fde68a",
//               paddingTop: 5,
//               marginTop: 3,
//             }}
//           >
//             <span className="gtb-total-label">
//               Grand Total (incl. tax & fees)
//             </span>
//             <span className="gtb-total-val">
//               {fmtExact(feeBreakdown.total_amount, sym)}
//             </span>
//           </div>
//         </div>
//       )}

//       <div className="ms-card">
//         <div className="ms-header">
//           <div>
//             <div
//               style={{
//                 fontFamily: "var(--font-heading)",
//                 fontSize: 17,
//                 fontWeight: 700,
//                 color: "var(--text-dark)",
//               }}
//             >
//               {plan.name}
//             </div>
//             {plan.description && (
//               <div
//                 style={{
//                   fontSize: 13,
//                   color: "var(--text-muted)",
//                   marginTop: 2,
//                 }}
//               >
//                 {plan.description}
//               </div>
//             )}
//           </div>
//           {totalPct === 100 && (
//             <span
//               style={{
//                 padding: "3px 12px",
//                 borderRadius: 20,
//                 background: "#f0fdf4",
//                 border: "1px solid #bbf7d0",
//                 color: "#16a34a",
//                 fontSize: 12,
//                 fontWeight: 700,
//               }}
//             >
//               ✓ 100%
//             </span>
//           )}
//         </div>

//         {plan.milestones.map((m, i) => {
//           const c = TYPE_COLORS[m.type] || TYPE_COLORS.custom;
//           const icon = TYPE_ICONS[m.type] || "⭐";
//           const displayAmt = m.calculated_amount
//             ? fmtExact(m.calculated_amount, sym)
//             : m.percentage
//               ? calcAmtLabel(m.percentage)
//               : m.fixed_amount
//                 ? fmtExact(m.fixed_amount, sym)
//                 : null;

//           const milestoneTotals = calculateMilestoneTotal(m);
//           const msTaxData =
//             feeBreakdown && m.percentage
//               ? computeMilestoneAmounts(m.percentage, feeBreakdown)
//               : null;

//           return (
//             <div key={m.id || i} className="ms-row">
//               <div
//                 className="ms-num"
//                 style={{ borderColor: c.border, color: c.color }}
//               >
//                 {i + 1}
//               </div>
//               <div className="ms-body">
//                 <div
//                   className="ms-type-chip"
//                   style={{ background: c.bg, color: c.color }}
//                 >
//                   {icon} {m.type_label || m.type?.replace(/_/g, " ")}
//                 </div>
//                 <div className="ms-label">{m.label}</div>
//                 {(m.due_date || m.due_after_days) && (
//                   <div className="ms-due">
//                     📅{" "}
//                     {m.due_date
//                       ? `Due by ${m.due_date}`
//                       : `Due ${m.due_after_days} days after booking`}
//                   </div>
//                 )}
//                 {m.note && <div className="ms-note">{m.note}</div>}

//                 {feeBreakdown && m.percentage && (
//                   <div
//                     style={{
//                       marginTop: 6,
//                       padding: "8px 12px",
//                       background: "#fef9ee",
//                       border: "1px solid #fde68a",
//                       borderRadius: 6,
//                       fontSize: 12,
//                     }}
//                   >
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         marginBottom: 2,
//                       }}
//                     >
//                       <span style={{ color: "var(--text-muted)" }}>
//                         Base amount
//                       </span>
//                       <span>{fmtExact(milestoneTotals?.base || 0, sym)}</span>
//                     </div>
//                     {(milestoneTotals?.fees || 0) > 0 && (
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                           marginBottom: 2,
//                         }}
//                       >
//                         <span style={{ color: "var(--text-muted)" }}>Fees</span>
//                         <span>{fmtExact(milestoneTotals?.fees || 0, sym)}</span>
//                       </div>
//                     )}
//                     {(milestoneTotals?.tax || 0) > 0 && (
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                           marginBottom: 2,
//                           color: "#b45309",
//                         }}
//                       >
//                         <span>
//                           {feeBreakdown.tax_label || "Tax"} (
//                           {feeBreakdown.tax_rate}%)
//                         </span>
//                         <span style={{ fontWeight: 600 }}>
//                           {fmtExact(milestoneTotals?.tax || 0, sym)}
//                         </span>
//                       </div>
//                     )}
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         borderTop: "1px solid #fde68a",
//                         paddingTop: 4,
//                         marginTop: 4,
//                         fontWeight: 700,
//                         color: "var(--primary-color)",
//                       }}
//                     >
//                       <span>Total incl. tax & fees</span>
//                       <span>{fmtExact(milestoneTotals?.total || 0, sym)}</span>
//                     </div>
//                   </div>
//                 )}
//               </div>
//               <div className="ms-amounts">
//                 {m.percentage > 0 && (
//                   <div className="ms-pct">{m.percentage}%</div>
//                 )}
//                 {displayAmt && (
//                   <div
//                     className="ms-amt"
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "flex-end",
//                     }}
//                   >
//                     ≈ {displayAmt}
//                     {msTaxData && (msTaxData.tax > 0 || msTaxData.fees > 0) && (
//                       <TaxBreakdownBadge
//                         milestonePercent={m.percentage}
//                         feeBreakdown={feeBreakdown}
//                         sym={sym}
//                       />
//                     )}
//                   </div>
//                 )}
//                 {milestoneTotals && milestoneTotals.total > 0 && (
//                   <div
//                     style={{
//                       fontSize: 13,
//                       fontWeight: 700,
//                       color: "var(--primary-color)",
//                       marginTop: 2,
//                     }}
//                   >
//                     Total: {fmtExact(milestoneTotals.total, sym)}
//                   </div>
//                 )}
//               </div>
//             </div>
//           );
//         })}

//         <div className="ms-footer">
//           <span
//             style={{
//               fontSize: 13,
//               color: "var(--text-muted)",
//               fontWeight: 600,
//             }}
//           >
//             Total payment mapped
//           </span>
//           <div style={{ textAlign: "right" }}>
//             <span
//               style={{
//                 fontSize: 18,
//                 fontWeight: 800,
//                 color:
//                   totalPct === 100
//                     ? "#16a34a"
//                     : totalPct > 100
//                       ? "#dc2626"
//                       : "var(--primary-color)",
//               }}
//             >
//               {totalPct.toFixed(0)}%{totalPct === 100 ? " ✓" : ""}
//             </span>
//             {feeBreakdown?.total_amount > 0 && (
//               <div style={{ fontSize: 11, color: "#b45309", marginTop: 2 }}>
//                 Grand Total: {fmtExact(feeBreakdown.total_amount, sym)} (incl.
//                 all taxes &amp; fees)
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <div
//         style={{
//           textAlign: "center",
//           fontSize: 12,
//           color: "var(--text-muted)",
//           marginTop: 10,
//         }}
//       >
//         Amounts shown are estimates. Final figures confirmed at booking.
//       </div>
//     </div>
//   );
// };

// /* ═════════════════════════════════════════════════════════════
//    BOOKING STEP COMPONENTS
// ═════════════════════════════════════════════════════════════ */

// const BrokerInactiveScreen = ({ onClose }) => (
//   <div className="broker-inactive">
//     <div className="broker-inactive-icon">🔒</div>
//     <div className="broker-inactive-title">Account Inactive</div>
//     <p
//       style={{
//         color: "var(--text-muted)",
//         fontSize: 13,
//         lineHeight: 1.7,
//         marginBottom: 20,
//       }}
//     >
//       Your account is currently{" "}
//       <strong style={{ color: "#dc2626" }}>inactive</strong>. Please contact the
//       admin to activate your account.
//     </p>
//     <div
//       style={{
//         background: "#fff5f5",
//         border: "1.5px solid #fecaca",
//         borderRadius: 10,
//         padding: "12px 16px",
//         marginBottom: 20,
//         fontSize: 12,
//         color: "#dc2626",
//         textAlign: "left",
//       }}
//     >
//       <div style={{ fontWeight: 700, marginBottom: 4 }}>What to do next:</div>
//       <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.8 }}>
//         <li>Contact your project administrator</li>
//         <li>Ask them to activate your account</li>
//         <li>You can book once your status is active</li>
//       </ul>
//     </div>
//     <button
//       onClick={onClose}
//       className="book-btn"
//       style={{
//         background: "var(--page-bg)",
//         color: "var(--text-muted)",
//         border: "1.5px solid var(--card-border)",
//       }}
//     >
//       Close
//     </button>
//   </div>
// );

// const StepDetails = ({ user, onBook, onLogout, isAvail }) => (
//   <div>
//     {user ? (
//       <div className="logged-in-card">
//         <div>
//           <div className="logged-in-label">✓ Logged in as</div>
//           <div className="logged-in-name">{user.name}</div>
//           <div
//             style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 2 }}
//           >
//             {user.email}
//           </div>
//         </div>
//         <button className="logout-btn" onClick={onLogout}>
//           Logout
//         </button>
//       </div>
//     ) : (
//       <p
//         style={{
//           color: "var(--text-muted)",
//           fontSize: 13,
//           lineHeight: 1.6,
//           marginBottom: 16,
//         }}
//       >
//         To book this unit, please log in or create an account. Both email and
//         phone will be verified.
//       </p>
//     )}
//     {isAvail !== false && (
//       <button className="book-btn" onClick={onBook}>
//         {user ? "Continue to Booking →" : "Login / Register to Book →"}
//       </button>
//     )}
//   </div>
// );

// const StepLogin = ({ form, setForm, onLogin, onSwitch, loading, error }) => (
//   <div>
//     <div
//       style={{
//         color: "var(--text-dark)",
//         fontWeight: 700,
//         fontSize: 15,
//         marginBottom: 16,
//       }}
//     >
//       Login to your account
//     </div>
//     {error && <div className="error-box">⚠️ {error}</div>}
//     <input
//       className="sidebar-input"
//       type="email"
//       placeholder="Email address"
//       value={form.email}
//       onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
//     />
//     <input
//       className="sidebar-input"
//       type="password"
//       placeholder="Password"
//       value={form.password}
//       onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
//       onKeyDown={(e) => e.key === "Enter" && onLogin()}
//       style={{ marginBottom: 16 }}
//     />
//     <button
//       className="book-btn"
//       onClick={onLogin}
//       disabled={loading || !form.email || !form.password}
//     >
//       {loading ? "Logging in…" : "Login →"}
//     </button>
//     {onSwitch && (
//       <p
//         style={{
//           textAlign: "center",
//           marginTop: 14,
//           color: "var(--text-muted)",
//           fontSize: 13,
//         }}
//       >
//         Don't have an account?{" "}
//         <button className="auth-link" onClick={onSwitch}>
//           Register
//         </button>
//       </p>
//     )}
//   </div>
// );

// const StepRegister = ({
//   form,
//   setForm,
//   onRegister,
//   onSwitch,
//   loading,
//   error,
// }) => {
//   const [showPass, setShowPass] = useState(false);
//   const strength = !form.password
//     ? 0
//     : [
//         form.password.length >= 8,
//         /[A-Z]/.test(form.password),
//         /[0-9]/.test(form.password),
//         /[^A-Za-z0-9]/.test(form.password),
//       ].filter(Boolean).length;
//   const strengthColor = ["#ef4444", "#f59e0b", "#f59e0b", "#16a34a", "#16a34a"][
//     strength
//   ];
//   return (
//     <div>
//       <div
//         style={{
//           color: "var(--text-dark)",
//           fontWeight: 700,
//           fontSize: 15,
//           marginBottom: 4,
//         }}
//       >
//         Create an account
//       </div>
//       <div
//         style={{ color: "var(--text-muted)", fontSize: 12, marginBottom: 14 }}
//       >
//         We'll verify your email and phone number. A Company Admin will need to
//         approve your account before you can book on behalf of a client.
//       </div>
//       {error && <div className="error-box">⚠️ {error}</div>}
//       <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
//         {[
//           { v: "broker", label: "🤝 Broker" },
//           { v: "sales", label: "📈 Sales" },
//         ].map(({ v, label }) => (
//           <button
//             key={v}
//             type="button"
//             onClick={() => setForm((f) => ({ ...f, role: v }))}
//             style={{
//               flex: 1,
//               padding: 8,
//               borderRadius: 8,
//               cursor: "pointer",
//               fontSize: 13,
//               border: `1.5px solid ${form.role === v ? "var(--primary-color)" : "var(--card-border)"}`,
//               background: form.role === v ? "var(--page-bg)" : "transparent",
//               color:
//                 form.role === v ? "var(--primary-color)" : "var(--text-muted)",
//               fontWeight: form.role === v ? 700 : 400,
//               fontFamily: "var(--font-body)",
//             }}
//           >
//             {label}
//           </button>
//         ))}
//       </div>
//       <input
//         className="sidebar-input"
//         type="text"
//         placeholder="Full Name *"
//         value={form.name}
//         onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
//       />
//       {(form.role === "broker" || form.role === "sales") && (
//         <input
//           className="sidebar-input"
//           type="text"
//           placeholder={
//             form.role === "sales"
//               ? "Sales Team / Department (optional)"
//               : "Company / Agency Name"
//           }
//           value={form.broker_company}
//           onChange={(e) =>
//             setForm((f) => ({ ...f, broker_company: e.target.value }))
//           }
//         />
//       )}
//       <input
//         className="sidebar-input"
//         type="email"
//         placeholder="Email Address *"
//         value={form.email}
//         onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
//       />
//       <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
//         <CountryCodePicker
//           value={form.country_code}
//           onChange={(v) => setForm((f) => ({ ...f, country_code: v }))}
//         />
//         <input
//           style={{
//             flex: 1,
//             padding: "10px 12px",
//             background: "var(--page-bg)",
//             border: "1.5px solid var(--card-border)",
//             borderRadius: 8,
//             color: "var(--text-dark)",
//             fontSize: 13,
//             fontFamily: "var(--font-body)",
//             outline: "none",
//           }}
//           type="tel"
//           placeholder="Phone number *"
//           value={form.phone}
//           onChange={(e) =>
//             setForm((f) => ({ ...f, phone: e.target.value.replace(/\D/g, "") }))
//           }
//         />
//       </div>
//       <div style={{ position: "relative", marginBottom: 4 }}>
//         <input
//           style={{
//             width: "100%",
//             padding: "10px 40px 10px 12px",
//             background: "var(--page-bg)",
//             border: "1.5px solid var(--card-border)",
//             borderRadius: 8,
//             color: "var(--text-dark)",
//             fontSize: 13,
//             boxSizing: "border-box",
//             fontFamily: "var(--font-body)",
//             outline: "none",
//           }}
//           type={showPass ? "text" : "password"}
//           placeholder="Password (min 8 chars) *"
//           value={form.password}
//           onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
//         />
//         <button
//           type="button"
//           onClick={() => setShowPass((s) => !s)}
//           style={{
//             position: "absolute",
//             right: 10,
//             top: "50%",
//             transform: "translateY(-50%)",
//             background: "none",
//             border: "none",
//             color: "var(--text-muted)",
//             cursor: "pointer",
//             fontSize: 14,
//           }}
//         >
//           {showPass ? "🙈" : "👁"}
//         </button>
//       </div>
//       {form.password && (
//         <div style={{ marginBottom: 12 }}>
//           <div className="pw-strength">
//             {[1, 2, 3, 4].map((i) => (
//               <div
//                 key={i}
//                 className="pw-bar"
//                 style={{
//                   background:
//                     i <= strength ? strengthColor : "var(--card-border)",
//                 }}
//               />
//             ))}
//           </div>
//           <div style={{ fontSize: 11, color: strengthColor }}>
//             {["", "Weak", "Fair", "Good", "Strong"][strength]}
//           </div>
//         </div>
//       )}
//       <button
//         className="book-btn"
//         style={{ marginTop: 6 }}
//         onClick={onRegister}
//         disabled={
//           loading ||
//           !form.name ||
//           !form.email ||
//           !form.phone ||
//           !form.password ||
//           form.password.length < 8
//         }
//       >
//         {loading ? "Creating account…" : "Register & Verify →"}
//       </button>
//       <p
//         style={{
//           textAlign: "center",
//           marginTop: 14,
//           color: "var(--text-muted)",
//           fontSize: 13,
//         }}
//       >
//         Already have an account?{" "}
//         <button className="auth-link" onClick={onSwitch}>
//           Login
//         </button>
//       </p>
//     </div>
//   );
// };

// const StepOtp = ({ type, onVerify, onResend, loading, error, setError }) => {
//   const [otp, setOtp] = useState(["", "", "", "", "", ""]);
//   const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];
//   const isEmail = type === "email";
//   const handleKey = (i, e) => {
//     if (e.key === "Backspace") {
//       if (otp[i]) {
//         const n = [...otp];
//         n[i] = "";
//         setOtp(n);
//       } else if (i > 0) refs[i - 1].current?.focus();
//     }
//   };
//   const handleChange = (i, val) => {
//     const digit = val.replace(/\D/g, "").slice(-1),
//       n = [...otp];
//     n[i] = digit;
//     setOtp(n);
//     if (digit && i < 5) refs[i + 1].current?.focus();
//     if (digit && i === 5) {
//       const full = [...n].join("");
//       if (full.length === 6) {
//         setError("");
//         onVerify(full);
//       }
//     }
//   };
//   const handlePaste = (e) => {
//     const p = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
//     if (p.length === 6) {
//       setOtp(p.split(""));
//       refs[5].current?.focus();
//       setError("");
//       onVerify(p);
//     }
//   };
//   const fullOtp = otp.join("");
//   return (
//     <div>
//       <div style={{ textAlign: "center", marginBottom: 20 }}>
//         <div style={{ fontSize: 36, marginBottom: 8 }}>
//           {isEmail ? "📧" : "📱"}
//         </div>
//         <div
//           style={{ color: "var(--text-dark)", fontWeight: 700, fontSize: 15 }}
//         >
//           Verify your {isEmail ? "email" : "phone"}
//         </div>
//         <div style={{ color: "var(--text-muted)", fontSize: 12, marginTop: 6 }}>
//           Enter the 6-digit code sent to your {isEmail ? "email" : "phone"}.
//         </div>
//       </div>
//       {error && (
//         <div
//           style={{
//             padding: "8px 12px",
//             borderRadius: 8,
//             marginBottom: 12,
//             fontSize: 12,
//             background: error.startsWith("✓") ? "#f0fdf4" : "#fff5f5",
//             border: `1px solid ${error.startsWith("✓") ? "#bbf7d0" : "#fecaca"}`,
//             color: error.startsWith("✓") ? "#16a34a" : "#dc2626",
//           }}
//         >
//           {error}
//         </div>
//       )}
//       <div className="otp-grid" onPaste={handlePaste}>
//         {otp.map((digit, i) => (
//           <input
//             key={i}
//             ref={refs[i]}
//             type="text"
//             inputMode="numeric"
//             maxLength={1}
//             value={digit}
//             onChange={(e) => handleChange(i, e.target.value)}
//             onKeyDown={(e) => handleKey(i, e)}
//             className={`otp-cell${digit ? " filled" : ""}`}
//           />
//         ))}
//       </div>
//       <button
//         className="book-btn"
//         onClick={() => {
//           if (fullOtp.length === 6) onVerify(fullOtp);
//         }}
//         disabled={loading || fullOtp.length < 6}
//       >
//         {loading ? "Verifying…" : "Verify Code →"}
//       </button>
//       <div style={{ textAlign: "center", marginTop: 16 }}>
//         <span style={{ color: "var(--text-muted)", fontSize: 13 }}>
//           Didn't receive the code?{" "}
//         </span>
//         <button
//           className="auth-link"
//           onClick={() => {
//             setOtp(["", "", "", "", "", ""]);
//             onResend();
//           }}
//           disabled={loading}
//         >
//           Resend
//         </button>
//       </div>
//     </div>
//   );
// };

// const StepPlanSelect = ({
//   plans,
//   selected,
//   onSelect,
//   fmtPrice,
//   unitPrice,
//   onNext,
//   onBack,
//   existingBookingId,
//   feeBreakdown,
//   sym = "₹",
// }) => {
//   const [expanded, setExpanded] = useState(null);
//   const price = parseFloat(String(unitPrice || "0").replace(/,/g, "")) || 0;
//   const calcAmtLabel = (pct) =>
//     price > 0 ? fmtExact((price * parseFloat(pct)) / 100, sym) : null;

//   return (
//     <div>
//       <div
//         style={{
//           color: "var(--text-dark)",
//           fontWeight: 700,
//           fontSize: 15,
//           marginBottom: 4,
//         }}
//       >
//         Choose a Payment Plan
//       </div>
//       <div
//         style={{ color: "var(--text-muted)", fontSize: 12, marginBottom: 14 }}
//       >
//         Select how you'd like to pay for this unit
//       </div>

//       {feeBreakdown?.tax_enabled && feeBreakdown?.total_amount > 0 && (
//         <div className="grand-total-banner" style={{ marginBottom: 14 }}>
//           <div className="gtb-row">
//             <span className="gtb-label">Unit Price</span>
//             <span className="gtb-val">
//               {fmtExact(feeBreakdown.unit_price || price, sym)}
//             </span>
//           </div>
//           {feeBreakdown.tax_amount > 0 && (
//             <div className="gtb-row">
//               <span style={{ color: "#b45309" }}>
//                 {feeBreakdown.tax_label || "Tax"} ({feeBreakdown.tax_rate}%)
//               </span>
//               <span style={{ color: "#b45309", fontWeight: 700 }}>
//                 {fmtExact(feeBreakdown.tax_amount, sym)}
//               </span>
//             </div>
//           )}
//           <div
//             className="gtb-row"
//             style={{
//               borderTop: "1px solid #fde68a",
//               paddingTop: 5,
//               marginTop: 3,
//             }}
//           >
//             <span className="gtb-total-label">Grand Total</span>
//             <span className="gtb-total-val">
//               {fmtExact(feeBreakdown.total_amount, sym)}
//             </span>
//           </div>
//         </div>
//       )}

//       {/* Full payment option */}
//       <div
//         className={`plan-option${selected === null ? " selected" : ""}`}
//         onClick={() => onSelect(null)}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div>
//             <div
//               style={{
//                 color: "var(--text-dark)",
//                 fontWeight: 600,
//                 fontSize: 13,
//               }}
//             >
//               Full Payment
//             </div>
//             <div
//               style={{ color: "var(--text-muted)", fontSize: 11, marginTop: 2 }}
//             >
//               Pay{" "}
//               {feeBreakdown?.total_amount
//                 ? `${fmtExact(feeBreakdown.total_amount, sym)} (incl. taxes)`
//                 : "the full amount"}{" "}
//               upfront
//             </div>
//           </div>
//           <div
//             className={`plan-radio${selected === null ? " selected" : ""}`}
//           />
//         </div>
//       </div>

//       {plans.map((plan) => {
//         const isSelected = selected === plan.id,
//           isExpanded = expanded === plan.id;
//         const totalPct = plan.milestones.reduce(
//           (s, m) => s + (parseFloat(m.percentage) || 0),
//           0,
//         );
//         return (
//           <div key={plan.id} style={{ marginBottom: 8 }}>
//             <div
//               className={`plan-option${isSelected ? " selected" : ""}`}
//               style={{ borderRadius: isExpanded ? "8px 8px 0 0" : 8 }}
//               onClick={() => {
//                 onSelect(plan.id);
//                 setExpanded(isExpanded ? null : plan.id);
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "flex-start",
//                   justifyContent: "space-between",
//                   gap: 10,
//                 }}
//               >
//                 <div style={{ flex: 1, minWidth: 0 }}>
//                   <div
//                     style={{
//                       color: "var(--text-dark)",
//                       fontWeight: 700,
//                       fontSize: 13,
//                     }}
//                   >
//                     {plan.name}
//                   </div>
//                   {plan.description && (
//                     <div
//                       style={{
//                         color: "var(--text-muted)",
//                         fontSize: 11,
//                         marginTop: 2,
//                       }}
//                     >
//                       {plan.description}
//                     </div>
//                   )}
//                   {!isExpanded && (
//                     <div
//                       style={{
//                         marginTop: 6,
//                         display: "flex",
//                         flexWrap: "wrap",
//                         gap: 4,
//                       }}
//                     >
//                       {plan.milestones.slice(0, 2).map((m, i) => (
//                         <span
//                           key={i}
//                           style={{
//                             fontSize: 10,
//                             padding: "2px 8px",
//                             borderRadius: 8,
//                             background: "var(--page-bg)",
//                             color: "var(--primary-color)",
//                             fontWeight: 600,
//                             border: "1px solid var(--card-border)",
//                           }}
//                         >
//                           {m.label}
//                           {m.percentage ? ` · ${m.percentage}%` : ""}
//                         </span>
//                       ))}
//                       {plan.milestones.length > 2 && (
//                         <span
//                           style={{ fontSize: 10, color: "var(--text-muted)" }}
//                         >
//                           +{plan.milestones.length - 2} more
//                         </span>
//                       )}
//                     </div>
//                   )}
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "flex-end",
//                     gap: 6,
//                     flexShrink: 0,
//                   }}
//                 >
//                   <div
//                     className={`plan-radio${isSelected ? " selected" : ""}`}
//                   />
//                   <button
//                     type="button"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setExpanded(isExpanded ? null : plan.id);
//                     }}
//                     style={{
//                       background: "none",
//                       border: "none",
//                       color: "var(--text-muted)",
//                       fontSize: 11,
//                       cursor: "pointer",
//                       padding: 0,
//                       fontFamily: "var(--font-body)",
//                     }}
//                   >
//                     {isExpanded ? "▲ Less" : "▼ Details"}
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {isExpanded && (
//               <div
//                 style={{
//                   background: "var(--page-bg)",
//                   borderRadius: "0 0 8px 8px",
//                   border: "1.5px solid var(--primary-color)44",
//                   borderTop: "none",
//                 }}
//               >
//                 {plan.milestones.map((m, i) => {
//                   const c = TYPE_COLORS[m.type] || TYPE_COLORS.custom;
//                   const icon = TYPE_ICONS[m.type] || "⭐";
//                   const amt = m.calculated_amount
//                     ? fmtExact(m.calculated_amount, sym)
//                     : m.percentage
//                       ? calcAmtLabel(m.percentage)
//                       : null;
//                   return (
//                     <div
//                       key={i}
//                       style={{
//                         padding: "10px 14px",
//                         borderBottom:
//                           i < plan.milestones.length - 1
//                             ? "1px solid var(--card-border)"
//                             : "none",
//                       }}
//                     >
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "space-between",
//                           gap: 8,
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 8,
//                             flex: 1,
//                           }}
//                         >
//                           <span style={{ fontSize: 16 }}>{icon}</span>
//                           <div>
//                             <span
//                               style={{
//                                 fontSize: 10,
//                                 padding: "1px 7px",
//                                 borderRadius: 8,
//                                 background: c.bg,
//                                 color: c.color,
//                                 fontWeight: 700,
//                               }}
//                             >
//                               {m.type_label}
//                             </span>
//                             <span
//                               style={{
//                                 color: "var(--text-dark)",
//                                 fontSize: 12,
//                                 fontWeight: 600,
//                                 marginLeft: 6,
//                               }}
//                             >
//                               {m.label}
//                             </span>
//                           </div>
//                         </div>
//                         <div style={{ textAlign: "right" }}>
//                           {m.percentage > 0 && (
//                             <div
//                               style={{
//                                 color: "var(--primary-color)",
//                                 fontWeight: 800,
//                                 fontSize: 15,
//                               }}
//                             >
//                               {m.percentage}%
//                             </div>
//                           )}
//                           {amt && (
//                             <div
//                               style={{
//                                 color: "var(--text-muted)",
//                                 fontSize: 11,
//                               }}
//                             >
//                               ≈ {amt}
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                       {feeBreakdown && m.percentage && (
//                         <MilestoneTaxRow
//                           milestone={m}
//                           feeBreakdown={feeBreakdown}
//                         />
//                       )}
//                     </div>
//                   );
//                 })}
//                 <div
//                   style={{
//                     padding: "8px 14px",
//                     display: "flex",
//                     justifyContent: "space-between",
//                     borderTop: "1px solid var(--card-border)",
//                     background: "var(--card-bg)",
//                   }}
//                 >
//                   <span style={{ color: "var(--text-muted)", fontSize: 12 }}>
//                     Total
//                   </span>
//                   <div style={{ textAlign: "right" }}>
//                     <span
//                       style={{
//                         color:
//                           totalPct === 100 ? "#16a34a" : "var(--primary-color)",
//                         fontWeight: 700,
//                         fontSize: 13,
//                       }}
//                     >
//                       {totalPct.toFixed(0)}%{totalPct === 100 ? " ✓" : ""}
//                     </span>
//                     {feeBreakdown?.total_amount > 0 && (
//                       <div
//                         style={{ fontSize: 10, color: "#b45309", marginTop: 2 }}
//                       >
//                         = {fmtExact(feeBreakdown.total_amount, sym)} incl. taxes
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         );
//       })}

//       <button className="book-btn" onClick={onNext} style={{ marginTop: 12 }}>
//         {existingBookingId ? "Update Plan & Pay →" : "Continue →"}
//       </button>
//       <button
//         type="button"
//         onClick={onBack}
//         style={{
//           display: "block",
//           width: "100%",
//           marginTop: 8,
//           background: "none",
//           border: "1.5px solid var(--card-border)",
//           borderRadius: 8,
//           color: "var(--text-muted)",
//           padding: 10,
//           cursor: "pointer",
//           fontSize: 13,
//           fontFamily: "var(--font-body)",
//         }}
//       >
//         ← Back
//       </button>
//     </div>
//   );
// };

// const StepBookingForm = ({
//   user,
//   form,
//   setForm,
//   onSubmit,
//   loading,
//   error,
//   selectedPlan,
//   plans,
//   onBack,
//   unit,
//   existingBookingId,
//   feeBreakdown,
//   sym = "₹",
// }) => {
//   const plan = plans.find((p) => p.id === selectedPlan);
//   const isAgent = user?.role === "broker" || user?.role === "sales";
//   const price =
//     parseFloat(
//       (unit?.offer_price || unit?.actual_price || "")
//         .toString()
//         .replace(/[^0-9.]/g, ""),
//     ) || 0;
//   const commissionRate = parseFloat(user?.commission_rate || 2);
//   const commissionAmt =
//     price > 0 ? ((price * commissionRate) / 100).toFixed(2) : null;
//   const canSubmit = isAgent
//     ? form.name && form.phone && form.client_name && form.client_phone
//     : form.name && form.phone;

//   return (
//     <div>
//       <div
//         style={{
//           color: "var(--text-dark)",
//           fontWeight: 700,
//           fontSize: 15,
//           marginBottom: 4,
//         }}
//       >
//         {existingBookingId ? "Update Payment Plan" : "Confirm Booking"}
//       </div>
//       <div
//         style={{ color: "var(--text-muted)", fontSize: 12, marginBottom: 12 }}
//       >
//         {existingBookingId ? (
//           <span>
//             Updating plan for booking{" "}
//             <span style={{ color: "var(--primary-color)" }}>
//               #{existingBookingId}
//             </span>
//           </span>
//         ) : isAgent ? (
//           <>
//             Booking as {user?.role === "sales" ? "sales" : "broker"}{" "}
//             <span style={{ color: "var(--primary-color)" }}>{user?.name}</span>
//           </>
//         ) : (
//           <>
//             Booking as{" "}
//             <span style={{ color: "var(--primary-color)" }}>{user?.name}</span>
//           </>
//         )}
//       </div>

//       {plan && (
//         <div
//           style={{
//             background: "var(--page-bg)",
//             border: "1.5px solid var(--card-border)",
//             borderRadius: 8,
//             padding: "10px 12px",
//             marginBottom: 14,
//             fontSize: 12,
//           }}
//         >
//           <div
//             style={{
//               color: "var(--primary-color)",
//               fontWeight: 700,
//               marginBottom: 2,
//             }}
//           >
//             💳 {plan.name}
//           </div>
//           <div style={{ color: "var(--text-muted)" }}>
//             Selected payment plan
//           </div>
//           <button
//             type="button"
//             onClick={onBack}
//             style={{
//               background: "none",
//               border: "none",
//               color: "var(--text-muted)",
//               fontSize: 11,
//               padding: 0,
//               marginTop: 4,
//               cursor: "pointer",
//               textDecoration: "underline",
//               fontFamily: "var(--font-body)",
//             }}
//           >
//             Change plan
//           </button>
//         </div>
//       )}

//       <BookingSummaryTaxCard
//         feeBreakdown={feeBreakdown}
//         selectedPlan={selectedPlan}
//         plans={plans}
//         unit={unit}
//         sym={sym}
//       />

//       {error && <div className="error-box">⚠️ {error}</div>}

//       {isAgent ? (
//         <>
//           {commissionAmt && (
//             <div className="commission-box">
//               <div className="commission-label">Your Commission</div>
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                 }}
//               >
//                 <div className="commission-amt">
//                   {fmtExact(commissionAmt, sym)}
//                 </div>
//                 <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
//                   {commissionRate}% of price
//                 </div>
//               </div>
//             </div>
//           )}
//           <div
//             style={{
//               fontSize: 11,
//               color: "var(--text-muted)",
//               marginBottom: 8,
//               textTransform: "uppercase",
//               fontWeight: 600,
//               letterSpacing: "0.8px",
//             }}
//           >
//             Your Contact Info
//           </div>
//           <input
//             className="sidebar-input"
//             type="text"
//             placeholder="Your Name *"
//             value={form.name}
//             onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
//           />
//           <input
//             className="sidebar-input"
//             type="tel"
//             placeholder="Your Phone *"
//             value={form.phone}
//             onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
//           />
//           <div
//             style={{
//               fontSize: 11,
//               color: "var(--text-muted)",
//               marginBottom: 8,
//               marginTop: 8,
//               textTransform: "uppercase",
//               fontWeight: 600,
//               letterSpacing: "0.8px",
//             }}
//           >
//             Client Details
//           </div>
//           <input
//             className="sidebar-input"
//             type="text"
//             placeholder="Client Full Name *"
//             value={form.client_name}
//             onChange={(e) =>
//               setForm((f) => ({ ...f, client_name: e.target.value }))
//             }
//           />
//           <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
//             <CountryCodePicker
//               value={form.client_country_code}
//               onChange={(v) =>
//                 setForm((f) => ({ ...f, client_country_code: v }))
//               }
//             />
//             <input
//               style={{
//                 flex: 1,
//                 padding: "10px 12px",
//                 background: "var(--page-bg)",
//                 border: "1.5px solid var(--card-border)",
//                 borderRadius: 8,
//                 color: "var(--text-dark)",
//                 fontSize: 13,
//                 fontFamily: "var(--font-body)",
//                 outline: "none",
//               }}
//               type="tel"
//               placeholder="Client Phone *"
//               value={form.client_phone}
//               onChange={(e) =>
//                 setForm((f) => ({
//                   ...f,
//                   client_phone: e.target.value.replace(/\D/g, ""),
//                 }))
//               }
//             />
//           </div>
//           <input
//             className="sidebar-input"
//             type="email"
//             placeholder="Client Email (optional)"
//             value={form.client_email}
//             onChange={(e) =>
//               setForm((f) => ({ ...f, client_email: e.target.value }))
//             }
//           />
//           <textarea
//             className="sidebar-input"
//             placeholder="Notes (optional)"
//             rows={2}
//             value={form.notes}
//             onChange={(e) => setForm((f) => ({ ...f, notes: e.target.value }))}
//             style={{ resize: "none", marginBottom: 16 }}
//           />
//         </>
//       ) : (
//         <>
//           <input
//             className="sidebar-input"
//             type="text"
//             placeholder="Your Name *"
//             value={form.name}
//             onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
//           />
//           <input
//             className="sidebar-input"
//             type="tel"
//             placeholder="Phone Number *"
//             value={form.phone}
//             onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
//           />
//           <textarea
//             className="sidebar-input"
//             placeholder="Message / Notes (optional)"
//             rows={3}
//             value={form.notes}
//             onChange={(e) => setForm((f) => ({ ...f, notes: e.target.value }))}
//             style={{ resize: "none", marginBottom: 16 }}
//           />
//         </>
//       )}

//       <button
//         className="book-btn"
//         onClick={onSubmit}
//         disabled={loading || !canSubmit}
//       >
//         {loading
//           ? "Submitting…"
//           : existingBookingId
//             ? "✓ Update Plan & Proceed to Payment"
//             : isAgent
//               ? "✓ Submit Booking for Client"
//               : "✓ Confirm Booking"}
//       </button>
//       <button
//         type="button"
//         onClick={onBack}
//         style={{
//           display: "block",
//           width: "100%",
//           marginTop: 8,
//           background: "none",
//           border: "1.5px solid var(--card-border)",
//           borderRadius: 8,
//           color: "var(--text-muted)",
//           padding: 10,
//           cursor: "pointer",
//           fontSize: 13,
//           fontFamily: "var(--font-body)",
//         }}
//       >
//         ← Back
//       </button>
//     </div>
//   );
// };

// const BookingDone = ({ unit, onClose }) => (
//   <div className="booking-done">
//     <div className="booking-done-emoji">🎉</div>
//     <div className="booking-done-title">Booking Received!</div>
//     <div className="booking-done-text">
//       Your enquiry for Unit {unit.plot_number} has been submitted.
//       <br />
//       Our team will contact you shortly.
//     </div>
//     <button className="book-btn" onClick={onClose}>
//       Close
//     </button>
//   </div>
// );

// /* ═════════════════════════════════════════════════════════════
//    CountryCodePicker
// ═════════════════════════════════════════════════════════════ */
// const COUNTRY_CODES = [
//   { code: "+91", flag: "🇮🇳", name: "India" },
//   { code: "+971", flag: "🇦🇪", name: "UAE" },
//   { code: "+966", flag: "🇸🇦", name: "Saudi Arabia" },
//   { code: "+974", flag: "🇶🇦", name: "Qatar" },
//   { code: "+965", flag: "🇰🇼", name: "Kuwait" },
//   { code: "+973", flag: "🇧🇭", name: "Bahrain" },
//   { code: "+968", flag: "🇴🇲", name: "Oman" },
//   { code: "+1", flag: "🇺🇸", name: "USA / Canada" },
//   { code: "+44", flag: "🇬🇧", name: "UK" },
//   { code: "+61", flag: "🇦🇺", name: "Australia" },
//   { code: "+65", flag: "🇸🇬", name: "Singapore" },
//   { code: "+60", flag: "🇲🇾", name: "Malaysia" },
//   { code: "+86", flag: "🇨🇳", name: "China" },
//   { code: "+81", flag: "🇯🇵", name: "Japan" },
//   { code: "+49", flag: "🇩🇪", name: "Germany" },
//   { code: "+33", flag: "🇫🇷", name: "France" },
//   { code: "+39", flag: "🇮🇹", name: "Italy" },
//   { code: "+34", flag: "🇪🇸", name: "Spain" },
//   { code: "+7", flag: "🇷🇺", name: "Russia" },
//   { code: "+55", flag: "🇧🇷", name: "Brazil" },
//   { code: "+92", flag: "🇵🇰", name: "Pakistan" },
//   { code: "+880", flag: "🇧🇩", name: "Bangladesh" },
//   { code: "+94", flag: "🇱🇰", name: "Sri Lanka" },
//   { code: "+977", flag: "🇳🇵", name: "Nepal" },
//   { code: "+20", flag: "🇪🇬", name: "Egypt" },
//   { code: "+234", flag: "🇳🇬", name: "Nigeria" },
//   { code: "+27", flag: "🇿🇦", name: "South Africa" },
//   { code: "+254", flag: "🇰🇪", name: "Kenya" },
//   { code: "+62", flag: "🇮🇩", name: "Indonesia" },
//   { code: "+63", flag: "🇵🇭", name: "Philippines" },
//   { code: "+66", flag: "🇹🇭", name: "Thailand" },
//   { code: "+84", flag: "🇻🇳", name: "Vietnam" },
//   { code: "+82", flag: "🇰🇷", name: "South Korea" },
//   { code: "+90", flag: "🇹🇷", name: "Turkey" },
//   { code: "+98", flag: "🇮🇷", name: "Iran" },
//   { code: "+964", flag: "🇮🇶", name: "Iraq" },
//   { code: "+961", flag: "🇱🇧", name: "Lebanon" },
//   { code: "+962", flag: "🇯🇴", name: "Jordan" },
// ];

// const CountryCodePicker = ({ value, onChange }) => {
//   const [open, setOpen] = useState(false),
//     [search, setSearch] = useState("");
//   const selected =
//     COUNTRY_CODES.find((c) => c.code === value) || COUNTRY_CODES[0];
//   const filtered = search.trim()
//     ? COUNTRY_CODES.filter(
//         (c) =>
//           c.name.toLowerCase().includes(search.toLowerCase()) ||
//           c.code.includes(search),
//       )
//     : COUNTRY_CODES;
//   return (
//     <div style={{ position: "relative" }}>
//       <button
//         type="button"
//         onClick={() => {
//           setOpen((o) => !o);
//           setSearch("");
//         }}
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: 6,
//           padding: 10,
//           background: "var(--page-bg)",
//           border: "1.5px solid var(--card-border)",
//           borderRadius: 8,
//           color: "var(--text-dark)",
//           cursor: "pointer",
//           fontSize: 13,
//           whiteSpace: "nowrap",
//           minWidth: 82,
//           fontFamily: "var(--font-body)",
//         }}
//       >
//         <span style={{ fontSize: 16 }}>{selected.flag}</span>
//         <span>{selected.code}</span>
//         <span style={{ fontSize: 10, opacity: 0.5 }}>▼</span>
//       </button>
//       {open && (
//         <div
//           style={{
//             position: "absolute",
//             top: "calc(100% + 4px)",
//             left: 0,
//             zIndex: 999,
//             background: "var(--card-bg)",
//             border: "1px solid var(--card-border)",
//             borderRadius: 10,
//             overflow: "hidden",
//             minWidth: 220,
//             boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
//           }}
//         >
//           <div
//             style={{
//               padding: "8px 10px",
//               borderBottom: "1px solid var(--card-border)",
//             }}
//           >
//             <input
//               autoFocus
//               type="text"
//               placeholder="Search country…"
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               style={{
//                 width: "100%",
//                 padding: "7px 10px",
//                 background: "var(--page-bg)",
//                 border: "1px solid var(--card-border)",
//                 borderRadius: 6,
//                 color: "var(--text-dark)",
//                 fontSize: 12,
//                 outline: "none",
//                 boxSizing: "border-box",
//                 fontFamily: "var(--font-body)",
//               }}
//             />
//           </div>
//           <div style={{ maxHeight: 240, overflowY: "auto" }}>
//             {filtered.map((c) => (
//               <div
//                 key={c.code + c.name}
//                 onClick={() => {
//                   onChange(c.code);
//                   setOpen(false);
//                   setSearch("");
//                 }}
//                 style={{
//                   padding: "9px 14px",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 10,
//                   cursor: "pointer",
//                   fontSize: 13,
//                   background:
//                     c.code === value ? "var(--page-bg)" : "transparent",
//                   color:
//                     c.code === value
//                       ? "var(--primary-color)"
//                       : "var(--text-dark)",
//                   fontWeight: c.code === value ? 700 : 400,
//                 }}
//                 onMouseOver={(e) =>
//                   (e.currentTarget.style.background = "var(--page-bg)")
//                 }
//                 onMouseOut={(e) =>
//                   (e.currentTarget.style.background =
//                     c.code === value ? "var(--page-bg)" : "transparent")
//                 }
//               >
//                 <span style={{ fontSize: 16, flexShrink: 0 }}>{c.flag}</span>
//                 <span
//                   style={{
//                     flex: 1,
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   {c.name}
//                 </span>
//                 <span style={{ opacity: 0.45, fontSize: 12, flexShrink: 0 }}>
//                   {c.code}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UnitPage;


// import { useEffect, useRef, useState, useCallback } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";
// import { useWishlist } from "../hooks/useWishlist";
// import { useToast } from "../context/ToastContext";
// import { useSettings } from "../context/SettingsContext";
// import { apiJson } from "../api/apiClient";

// import { Viewer } from "@photo-sphere-viewer/core";
// import { MarkersPlugin } from "@photo-sphere-viewer/markers-plugin";
// import "@photo-sphere-viewer/core/index.css";
// import "@photo-sphere-viewer/markers-plugin/index.css";
// import "../styles/UnitPage.css";

// const toRad = (deg) => parseFloat((deg * (Math.PI / 180)).toFixed(6));

// const AMENITY_ICONS = {
//   "Swimming Pool": "🏊",
//   Gym: "🏋️",
//   Parking: "🚗",
//   "24/7 Security": "🔒",
//   "Club House": "🏛️",
//   "Children Play Area": "🛝",
//   "Jogging Track": "🏃",
//   Garden: "🌿",
//   Lift: "🛗",
//   "Power Backup": "⚡",
//   "CCTV Surveillance": "📹",
//   Intercom: "📞",
//   "Visitor Parking": "🅿️",
//   Terrace: "🏙️",
// };
// const amenityIcon = (name) => AMENITY_ICONS[name] || "✨";
// const toFt = (m) => (m * 3.28084).toFixed(1);

// const fmtExact = (n, sym = "₹") => {
//   if (n == null || n === "") return "—";
//   return (
//     sym +
//     parseFloat(n).toLocaleString("en-IN", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     })
//   );
// };

// const fmtRound = (n, sym = "₹") => {
//   if (n == null || n === "") return "—";
//   return (
//     sym + parseFloat(n).toLocaleString("en-IN", { maximumFractionDigits: 0 })
//   );
// };

// const computeMilestoneAmounts = (milestonePercent, feeBreakdown) => {
//   if (!feeBreakdown || !milestonePercent) return null;
//   const pct = parseFloat(milestonePercent) / 100;

//   const unitPrice = feeBreakdown.unit_price || 0;
//   const base = unitPrice * pct;
//   const tax = (feeBreakdown.tax_amount || 0) * pct;

//   const proc = (feeBreakdown.processing_fee || 0) * pct;
//   const stamp = (feeBreakdown.stamp_duty || 0) * pct;
//   const reg = (feeBreakdown.registration_fee || 0) * pct;
//   const maint = (feeBreakdown.maintenance_charge || 0) * pct;
//   const cf1 = (feeBreakdown.custom_fee1 || 0) * pct;
//   const cf2 = (feeBreakdown.custom_fee2 || 0) * pct;

//   const fees = proc + stamp + reg + maint + cf1 + cf2;
//   const total = base + tax + fees;

//   return {
//     base,
//     tax,
//     fees,
//     total,
//     breakdown: { proc, stamp, reg, maint, cf1, cf2 },
//     labels: feeBreakdown.fee_labels || {},
//     taxLabel: feeBreakdown.tax_label || "Tax",
//     taxRate: feeBreakdown.tax_rate || 0,
//     taxSystem: feeBreakdown.tax_system || "",
//     currencySymbol: feeBreakdown.currency_symbol || "₹",
//   };
// };

// /* ─────────────────────────────────────────────────────────────
//    TaxBreakdownBadge
// ───────────────────────────────────────────────────────────── */
// const TaxBreakdownBadge = ({ milestonePercent, feeBreakdown, sym = "₹" }) => {
//   const [open, setOpen] = useState(false);
//   const data = computeMilestoneAmounts(milestonePercent, feeBreakdown);
//   if (!data || (!data.tax && !data.fees)) return null;
//   const f = (n) => fmtExact(n, sym);
//   const extraFees = [
//     data.breakdown.proc > 0 && {
//       label: data.labels.processing || "Processing Fee",
//       val: data.breakdown.proc,
//     },
//     data.breakdown.stamp > 0 && {
//       label: data.labels.stamp_duty || "Stamp Duty",
//       val: data.breakdown.stamp,
//     },
//     data.breakdown.reg > 0 && {
//       label: data.labels.registration || "Registration Fee",
//       val: data.breakdown.reg,
//     },
//     data.breakdown.maint > 0 && {
//       label: data.labels.maintenance || "Maintenance",
//       val: data.breakdown.maint,
//     },
//     data.breakdown.cf1 > 0 && {
//       label: data.labels.custom1 || "Custom Fee 1",
//       val: data.breakdown.cf1,
//     },
//     data.breakdown.cf2 > 0 && {
//       label: data.labels.custom2 || "Custom Fee 2",
//       val: data.breakdown.cf2,
//     },
//   ].filter(Boolean);

//   return (
//     <span style={{ position: "relative", display: "inline-block" }}>
//       <button
//         type="button"
//         className="tax-badge-btn"
//         onClick={(e) => {
//           e.stopPropagation();
//           setOpen((o) => !o);
//         }}
//       >
//         +tax
//       </button>
//       {open && (
//         <div className="tax-popover" onClick={(e) => e.stopPropagation()}>
//           <div className="tax-popover-title">Charges for this instalment</div>
//           <div className="tax-row">
//             <span>Unit price portion</span>
//             <span>{f(data.base)}</span>
//           </div>
//           {extraFees.map((fee, i) => (
//             <div key={i} className="tax-row">
//               <span>{fee.label}</span>
//               <span>{f(fee.val)}</span>
//             </div>
//           ))}
//           {data.tax > 0 && (
//             <div className="tax-row highlight">
//               <span>
//                 {data.taxLabel}
//                 {data.taxRate > 0 && (
//                   <span style={{ opacity: 0.7, marginLeft: 4 }}>
//                     ({data.taxRate}%
//                     {data.taxSystem ? ` · ${data.taxSystem.toUpperCase()}` : ""}
//                     )
//                   </span>
//                 )}
//               </span>
//               <span>{f(data.tax)}</span>
//             </div>
//           )}
//           <div className="tax-row total">
//             <span>Instalment total</span>
//             <span>{f(data.total)}</span>
//           </div>
//           <button
//             type="button"
//             onClick={(e) => {
//               e.stopPropagation();
//               setOpen(false);
//             }}
//             style={{
//               position: "absolute",
//               top: 6,
//               right: 8,
//               background: "none",
//               border: "none",
//               color: "var(--text-muted)",
//               cursor: "pointer",
//               fontSize: 14,
//             }}
//           >
//             ×
//           </button>
//         </div>
//       )}
//     </span>
//   );
// };

// /* ─────────────────────────────────────────────────────────────
//    MilestoneTaxRow
// ───────────────────────────────────────────────────────────── */
// const MilestoneTaxRow = ({ milestone, feeBreakdown }) => {
//   if (!feeBreakdown || !milestone.percentage) return null;
//   const data = computeMilestoneAmounts(milestone.percentage, feeBreakdown);
//   if (!data || (!data.tax && !data.fees)) return null;
//   const sym = data.currencySymbol;
//   const f = (n) => fmtExact(n, sym);
//   const extraFees = [
//     data.breakdown.proc > 0 && {
//       label: data.labels.processing || "Processing Fee",
//       val: data.breakdown.proc,
//     },
//     data.breakdown.stamp > 0 && {
//       label: data.labels.stamp_duty || "Stamp Duty",
//       val: data.breakdown.stamp,
//     },
//     data.breakdown.reg > 0 && {
//       label: data.labels.registration || "Registration Fee",
//       val: data.breakdown.reg,
//     },
//     data.breakdown.maint > 0 && {
//       label: data.labels.maintenance || "Maintenance",
//       val: data.breakdown.maint,
//     },
//     data.breakdown.cf1 > 0 && {
//       label: data.labels.custom1 || "Custom Fee 1",
//       val: data.breakdown.cf1,
//     },
//     data.breakdown.cf2 > 0 && {
//       label: data.labels.custom2 || "Custom Fee 2",
//       val: data.breakdown.cf2,
//     },
//   ].filter(Boolean);

//   return (
//     <div
//       style={{
//         background: "#fef9ee",
//         border: "1px solid #fde68a",
//         borderRadius: 8,
//         padding: "10px 12px",
//         marginTop: 6,
//       }}
//     >
//       <div
//         style={{
//           fontSize: 10,
//           fontWeight: 700,
//           color: "#b45309",
//           textTransform: "uppercase",
//           letterSpacing: "0.5px",
//           marginBottom: 7,
//         }}
//       >
//         Tax &amp; fees for this instalment
//       </div>
//       <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
//         <div className="tax-row">
//           <span>Base ({milestone.percentage}% of unit price)</span>
//           <span>{f(data.base)}</span>
//         </div>
//         {extraFees.map((fee, i) => (
//           <div key={i} className="tax-row">
//             <span>{fee.label}</span>
//             <span>{f(fee.val)}</span>
//           </div>
//         ))}
//         {data.tax > 0 && (
//           <div className="tax-row highlight">
//             <span>
//               {data.taxLabel}
//               {data.taxRate > 0 ? ` (${data.taxRate}%)` : ""}
//             </span>
//             <span>{f(data.tax)}</span>
//           </div>
//         )}
//         <div className="tax-row total">
//           <span>Instalment total</span>
//           <span>{f(data.total)}</span>
//         </div>
//       </div>
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────────────────────
//    BookingSummaryTaxCard
// ───────────────────────────────────────────────────────────── */
// const BookingSummaryTaxCard = ({
//   feeBreakdown,
//   selectedPlan,
//   plans,
//   unit,
//   sym = "₹",
// }) => {
//   if (
//     !feeBreakdown?.tax_enabled &&
//     !feeBreakdown?.processing_fee &&
//     !feeBreakdown?.stamp_duty
//   )
//     return null;
//   const f = (n) => fmtExact(n, sym);
//   const labels = feeBreakdown.fee_labels || {};
//   const extraFees = [
//     feeBreakdown.processing_fee > 0 && {
//       label: labels.processing || "Processing Fee",
//       val: feeBreakdown.processing_fee,
//     },
//     feeBreakdown.stamp_duty > 0 && {
//       label: labels.stamp_duty || "Stamp Duty",
//       val: feeBreakdown.stamp_duty,
//     },
//     feeBreakdown.registration_fee > 0 && {
//       label: labels.registration || "Registration Fee",
//       val: feeBreakdown.registration_fee,
//     },
//     feeBreakdown.maintenance_charge > 0 && {
//       label: labels.maintenance || "Maintenance",
//       val: feeBreakdown.maintenance_charge,
//     },
//     feeBreakdown.custom_fee1 > 0 && {
//       label: labels.custom1 || "Custom Fee 1",
//       val: feeBreakdown.custom_fee1,
//     },
//     feeBreakdown.custom_fee2 > 0 && {
//       label: labels.custom2 || "Custom Fee 2",
//       val: feeBreakdown.custom_fee2,
//     },
//   ].filter(Boolean);

//   const plan = plans.find((p) => p.id === selectedPlan);
//   const firstMs = plan?.milestones?.[0];
//   const firstPct = firstMs?.percentage
//     ? parseFloat(firstMs.percentage) / 100
//     : 1;
//   const dueNow = feeBreakdown.total_amount * (plan ? firstPct : 1);

//   return (
//     <div className="grand-total-banner" style={{ marginBottom: 16 }}>
//       <div
//         style={{
//           fontSize: 11,
//           fontWeight: 700,
//           color: "#92400e",
//           textTransform: "uppercase",
//           letterSpacing: "0.5px",
//           marginBottom: 10,
//         }}
//       >
//         📄 Payment Breakdown
//       </div>
//       <div className="gtb-row">
//         <span className="gtb-label">Unit Price</span>
//         <span className="gtb-val">{f(feeBreakdown.unit_price)}</span>
//       </div>
//       {extraFees.map((fee, i) => (
//         <div key={i} className="gtb-row">
//           <span className="gtb-label">{fee.label}</span>
//           <span className="gtb-val">{f(fee.val)}</span>
//         </div>
//       ))}
//       {feeBreakdown.tax_amount > 0 && (
//         <div
//           className="gtb-row"
//           style={{
//             color: "#b45309",
//             fontWeight: 600,
//             borderTop: "1px solid #fde68a",
//             paddingTop: 6,
//             marginTop: 4,
//           }}
//         >
//           <span>
//             {feeBreakdown.tax_label || "Tax"}
//             {feeBreakdown.tax_rate > 0 && (
//               <span style={{ fontSize: 10, marginLeft: 5, opacity: 0.8 }}>
//                 ({feeBreakdown.tax_rate}%
//                 {feeBreakdown.tax_system
//                   ? ` · ${feeBreakdown.tax_system.toUpperCase()}`
//                   : ""}
//                 {feeBreakdown.tax_inclusive ? " · Incl." : ""})
//               </span>
//             )}
//           </span>
//           <span>{f(feeBreakdown.tax_amount)}</span>
//         </div>
//       )}
//       <div
//         className="gtb-row"
//         style={{
//           borderTop: "1.5px solid #fcd34d",
//           paddingTop: 8,
//           marginTop: 4,
//         }}
//       >
//         <span className="gtb-total-label">Grand Total</span>
//         <span className="gtb-total-val">{f(feeBreakdown.total_amount)}</span>
//       </div>
//       {plan && firstMs && (
//         <div className="due-now-box">
//           <div className="due-now-label">
//             Due Now — {firstMs.label} ({firstMs.percentage}%)
//           </div>
//           <div className="due-now-val">{f(dueNow)}</div>
//           <div className="due-now-note">
//             Includes proportional taxes &amp; fees
//           </div>
//         </div>
//       )}
//       <div
//         style={{
//           fontSize: 10,
//           color: "var(--text-muted)",
//           marginTop: 8,
//           textAlign: "center",
//         }}
//       >
//         Amounts are estimates. Final figures confirmed at booking.
//       </div>
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────────────────────
//    TYPE_COLORS / ICONS (payment milestone types)
// ───────────────────────────────────────────────────────────── */
// const TYPE_COLORS = {
//   down_payment: { bg: "#eff6ff", color: "#1d4ed8", border: "#bfdbfe" },
//   installment: { bg: "#faf5ff", color: "#7e22ce", border: "#e9d5ff" },
//   on_completion: { bg: "#f0fdf4", color: "#15803d", border: "#bbf7d0" },
//   on_handover: { bg: "#fff7ed", color: "#c2410c", border: "#fed7aa" },
//   rental_guarantee: { bg: "#fff1f2", color: "#be123c", border: "#fecdd3" },
//   custom: { bg: "#f9fafb", color: "#374151", border: "#e5e7eb" },
// };
// const TYPE_ICONS = {
//   down_payment: "💰",
//   installment: "🔄",
//   on_completion: "🏗️",
//   on_handover: "🔑",
//   rental_guarantee: "📈",
//   custom: "⭐",
// };

// /* ═════════════════════════════════════════════════════════════
//    MAIN COMPONENT
// ═════════════════════════════════════════════════════════════ */
// const UnitPage = () => {
//   const { tenant, plotId } = useParams();
//   const navigate = useNavigate();
//   const { settings, isLoaded: settingsLoaded } = useSettings();

//   const containerRef = useRef(null);
//   const viewerRef = useRef(null);
//   const markersRef = useRef(null);
//   const overlayRef = useRef(null);
//   const labelRef = useRef(null);
//   const allMarkerIdsRef = useRef([]);

//   const [unit, setUnit] = useState(null);
//   const [hotspots, setHotspots] = useState(null);
//   const [fetchError, setFetchError] = useState(null);
//   const [isFetching, setIsFetching] = useState(true);
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [loadProgress, setLoadProgress] = useState(0);
//   const [activeTab, setActiveTab] = useState("details");
//   const [galIdx, setGalIdx] = useState(0);

//   // Booking sidebar state
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [bookingStep, setBookingStep] = useState("details");
//   const [selectedPlan, setSelectedPlan] = useState(null);
//   const [loginForm, setLoginForm] = useState({ email: "", password: "" });
//   const [registerForm, setRegisterForm] = useState({
//     name: "",
//     email: "",
//     country_code: "+91",
//     phone: "",
//     password: "",
//     role: "broker",
//     broker_company: "",
//   });
//   const [bookingForm, setBookingForm] = useState({
//     name: "",
//     phone: "",
//     notes: "",
//     client_name: "",
//     client_phone: "",
//     client_email: "",
//     client_country_code: "+91",
//   });
//   const [authLoading, setAuthLoading] = useState(false);
//   const [authError, setAuthError] = useState("");
//   const [bookingDone, setBookingDone] = useState(false);
//   const [pendingUserId, setPendingUserId] = useState(null);
//   const [existingBookingId, setExistingBookingId] = useState(null);
//   const [currency, setCurrency] = useState("₹");
//   const [feeBreakdown, setFeeBreakdown] = useState(null);

//   // Login modal (shared by wishlist + book-now-when-logged-out flows)
//   const [loginModalOpen, setLoginModalOpen] = useState(false);
//   const [authIntent, setAuthIntent] = useState(null); // null | "wishlist" | "book"
//   const [modalStep, setModalStep] = useState("login");
//   const [modalPendingUserId, setModalPendingUserId] = useState(null);
//   const [modalAuthError, setModalAuthError] = useState("");

//   // ── Auth — via AuthContext, tenant-scoped (see components/AuthContext.jsx).
//   // AuthProvider already knows its own `tenant` (passed as a prop from
//   // TenantLayout in App.js), so none of these calls need to pass tenant
//   // themselves — that's handled internally by the provider.
//   const { user, login, register, verifyEmail, verifyPhone, resendOtp, signOut } =
//     useAuth();
//   const { wishedIds, toggle: toggleWish } = useWishlist(tenant, user?.token);
//   const { showToast } = useToast();

//   // ── Helper: build image URL with tenant ──────────────────────────────────
//   const getFullImageUrl = useCallback(
//     (path) => {
//       if (!path) return null;
//       if (path.startsWith("http://") || path.startsWith("https://")) {
//         return path;
//       }
//       const baseUrl = settings?.img_url || process.env.REACT_APP_IMG_URL || "";
//       const cleanPath = path.startsWith("/") ? path.substring(1) : path;
//       return baseUrl.endsWith("/")
//         ? `${baseUrl}${cleanPath}`
//         : `${baseUrl}/${cleanPath}`;
//     },
//     [settings],
//   );

//   const wishlistWithToken = useCallback(
//     (freshToken, pid, plotNumber) => {
//       apiJson(tenant, `/wishlist/toggle`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${freshToken}`,
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ plot_id: Number(pid) }),
//       })
//         .then((d) => {
//           showToast(
//             d.wishlisted
//               ? `❤️ Added to Wishlist — Unit ${plotNumber}`
//               : `🤍 Removed from Wishlist — Unit ${plotNumber}`,
//             d.wishlisted ? "wishlist_add" : "wishlist_remove",
//             2800,
//           );
//         })
//         .catch(() => {});
//     },
//     [tenant, showToast],
//   );

//   // ── Fetch unit + hotspots + currency ──────────────────────
//   useEffect(() => {
//     if (!tenant || !plotId) {
//       setFetchError("No tenant or plot ID provided");
//       setIsFetching(false);
//       return;
//     }

//     const fetchAll = async () => {
//       try {
//         const [unitData, hsData, currData] = await Promise.all([
//           apiJson(tenant, `/unit/${plotId}`),
//           apiJson(tenant, `/hotspots?plot_id=${plotId}`),
//           apiJson(tenant, `/currency`),
//         ]);

//         setUnit(unitData);
//         setHotspots(hsData || []);
//         setCurrency(
//           currData?.symbol ||
//             currData?.currency ||
//             currData?.data?.symbol ||
//             currData?.data?.currency ||
//             "₹",
//         );
//       } catch (err) {
//         console.error("Fetch error:", err);
//         setFetchError(err.message);
//       } finally {
//         setIsFetching(false);
//       }
//     };
//     fetchAll();
//   }, [tenant, plotId]);

//   // ── Fee preview ────────────────────────────────────────────
//   useEffect(() => {
//     if (!unit?.actual_price && !unit?.offer_price) return;
//     if (!tenant) return;

//     const price = unit.offer_price || unit.actual_price;
//     apiJson(tenant, `/payment/fee-preview?price=${encodeURIComponent(price)}`, {
//       headers: {
//         Accept: "application/json",
//         ...(user?.token ? { Authorization: `Bearer ${user.token}` } : {}),
//       },
//     })
//       .then((d) => {
//         if (d) setFeeBreakdown(d.fee_breakdown || d);
//       })
//       .catch(() => {});
//   }, [tenant, unit, user?.token]);

//   // ── Panorama viewer ────────────────────────────────────────
//   const destroyViewer = useCallback(() => {
//     if (!viewerRef.current) return;
//     try {
//       viewerRef.current._cleanup?.();
//     } catch (e) {}
//     try {
//       if (
//         containerRef.current?.isConnected &&
//         containerRef.current?.hasChildNodes()
//       )
//         viewerRef.current.destroy();
//     } catch (e) {}
//     viewerRef.current = null;
//     markersRef.current = null;
//   }, []);

//   const buildMarkers = useCallback((unitData, hsData) => {
//     const markers = [];
//     hsData.forEach((hs) => {
//       if (!hs.yaw || !hs.pitch) return;
//       if (hs.hotspot_type === "gallery") {
//         markers.push({
//           id: `hs-gallery-${hs.id}`,
//           position: {
//             yaw: toRad(parseFloat(hs.yaw)),
//             pitch: toRad(parseFloat(hs.pitch)),
//           },
//           html: `<div class="hs-marker hs-gallery">🖼 ${hs.title || hs.label}</div>`,
//           size: { width: 170, height: 42 },
//           data: {
//             type: "gallery",
//             galleryIndex: hs.gallery_index ?? 0,
//             name: hs.title || hs.label,
//             yawRad: toRad(parseFloat(hs.yaw)),
//             pitchRad: toRad(parseFloat(hs.pitch)),
//           },
//         });
//       } else {
//         const room = unitData.rooms?.find(
//           (r) =>
//             r.id === hs.room_panorama_id ||
//             r.room_label === (hs.title || hs.label),
//         );
//         markers.push({
//           id: `hs-room-${hs.id}`,
//           position: {
//             yaw: toRad(parseFloat(hs.yaw)),
//             pitch: toRad(parseFloat(hs.pitch)),
//           },
//           html: `<div class="hs-marker hs-room">🚪 ${hs.title || hs.label}</div>`,
//           size: { width: 160, height: 42 },
//           data: {
//             type: "room",
//             roomId: room?.id || hs.room_panorama_id,
//             name: hs.title || hs.label,
//             yawRad: toRad(parseFloat(hs.yaw)),
//             pitchRad: toRad(parseFloat(hs.pitch)),
//           },
//         });
//       }
//     });
//     if (markers.length === 0 && unitData.rooms?.length > 0) {
//       unitData.rooms.forEach((room, idx) => {
//         const yaw = (idx / unitData.rooms.length) * 360 - 180;
//         markers.push({
//           id: `fallback-room-${room.id}`,
//           position: { yaw: toRad(yaw), pitch: toRad(-10) },
//           html: `<div class="hs-marker hs-room">🚪 ${room.room_label}</div>`,
//           size: { width: 160, height: 42 },
//           data: {
//             type: "room",
//             roomId: room.id,
//             name: room.room_label,
//             yawRad: toRad(yaw),
//             pitchRad: toRad(-10),
//           },
//         });
//       });
//     }
//     return markers;
//   }, []);

//   useEffect(() => {
//     if (
//       !unit?.panorama_url ||
//       !hotspots ||
//       !containerRef.current ||
//       activeTab !== "panorama"
//     )
//       return;

//     destroyViewer();
//     setIsLoaded(false);
//     setLoadProgress(0);

//     let current = 0;
//     const interval = setInterval(() => {
//       current += Math.random() * 10;
//       if (current >= 90) {
//         current = 90;
//         clearInterval(interval);
//       }
//       setLoadProgress(Math.round(current));
//     }, 180);

//     const fullPanoramaUrl = getFullImageUrl(unit.panorama_url);
//     if (!fullPanoramaUrl) {
//       setFetchError("Failed to construct panorama URL");
//       return;
//     }

//     const psvMarkers = buildMarkers(unit, hotspots);
//     allMarkerIdsRef.current = psvMarkers.map((m) => m.id);

//     const initTimer = setTimeout(() => {
//       if (!containerRef.current) return;
//       try {
//         viewerRef.current = new Viewer({
//           container: containerRef.current,
//           panorama: fullPanoramaUrl,
//           defaultZoomLvl: 50,
//           mousewheelCtrlKey: false,
//           loadingImg: null,
//           loadingTxt: "",
//           useXmpData: false,
//           plugins: [[MarkersPlugin, { markers: psvMarkers }]],
//         });
//       } catch (e) {
//         console.error("PSV init error:", e);
//         return;
//       }

//       const handleResize = () => {
//         try {
//           viewerRef.current?.autoSize();
//         } catch (e) {}
//       };
//       window.addEventListener("resize", handleResize);
//       document.addEventListener("fullscreenchange", handleResize);
//       document.addEventListener("webkitfullscreenchange", handleResize);

//       markersRef.current = viewerRef.current.getPlugin(MarkersPlugin);
//       viewerRef.current.addEventListener("ready", () => {
//         clearInterval(interval);
//         setLoadProgress(100);
//         setTimeout(() => setIsLoaded(true), 400);

//         let angle = 0,
//           isInteracting = false,
//           resumeTimer = null;
//         const swing = () => {
//           if (!isInteracting) {
//             angle += 0.0015;
//             try {
//               viewerRef.current?.rotate({
//                 yaw: Math.sin(angle) * 0.06,
//                 pitch: 0,
//               });
//             } catch (e) {}
//           }
//           if (viewerRef.current)
//             viewerRef.current._rafId = requestAnimationFrame(swing);
//         };
//         viewerRef.current._rafId = requestAnimationFrame(swing);

//         const onStart = () => {
//           isInteracting = true;
//           clearTimeout(resumeTimer);
//         };
//         const onEnd = () => {
//           resumeTimer = setTimeout(() => {
//             isInteracting = false;
//           }, 2500);
//         };
//         const el = containerRef.current;
//         if (el) {
//           el.addEventListener("mousedown", onStart, { passive: true });
//           el.addEventListener("mouseup", onEnd, { passive: true });
//           el.addEventListener("touchstart", onStart, { passive: true });
//           el.addEventListener("touchend", onEnd, { passive: true });
//         }
//         viewerRef.current._cleanup = () => {
//           if (viewerRef.current?._rafId)
//             cancelAnimationFrame(viewerRef.current._rafId);
//           clearTimeout(resumeTimer);
//           window.removeEventListener("resize", handleResize);
//           document.removeEventListener("fullscreenchange", handleResize);
//           document.removeEventListener("webkitfullscreenchange", handleResize);
//           if (el) {
//             el.removeEventListener("mousedown", onStart);
//             el.removeEventListener("mouseup", onEnd);
//             el.removeEventListener("touchstart", onStart);
//             el.removeEventListener("touchend", onEnd);
//           }
//         };
//       });

//       // Handle error event
//       viewerRef.current.addEventListener("error", (e) => {
//         console.error("PSV viewer error:", e);
//       });

//       markersRef.current?.addEventListener("select-marker", ({ marker }) => {
//         const { type, roomId, galleryIndex, name, yawRad, pitchRad } =
//           marker.data;
//         allMarkerIdsRef.current.forEach((id) => {
//           try {
//             markersRef.current?.updateMarker({ id, opacity: 0 });
//           } catch (e) {}
//         });
//         if (labelRef.current) {
//           labelRef.current.textContent = name;
//           labelRef.current.style.opacity = "1";
//         }
//         viewerRef.current
//           ?.animate({ yaw: yawRad, pitch: pitchRad, zoom: 60, speed: "4rpm" })
//           .then(() =>
//             viewerRef.current?.animate({
//               yaw: yawRad,
//               pitch: pitchRad,
//               zoom: 100,
//               speed: "20rpm",
//             }),
//           )
//           .then(() => {
//             if (overlayRef.current) {
//               overlayRef.current.style.transition = "opacity 0.4s ease-in";
//               overlayRef.current.style.opacity = "1";
//             }
//             setTimeout(() => {
//               if (type === "gallery")
//                 navigate(`/${tenant}/unit/${plotId}/gallery/${galleryIndex}`);
//               else navigate(`/${tenant}/unit/${plotId}/room/${roomId}`);
//             }, 450);
//           });
//       });
//     }, 50);

//     return () => {
//       clearInterval(interval);
//       clearTimeout(initTimer);
//       destroyViewer();
//     };
//   }, [
//     unit,
//     hotspots,
//     activeTab,
//     tenant,
//     plotId,
//     getFullImageUrl,
//     buildMarkers,
//     destroyViewer,
//     navigate,
//   ]);

//   useEffect(() => {
//     if (!overlayRef.current) return;
//     overlayRef.current.style.opacity = "1";
//     overlayRef.current.style.transition = "none";
//     const t = setTimeout(() => {
//       overlayRef.current.style.transition = "opacity 0.7s ease-out";
//       overlayRef.current.style.opacity = "0";
//     }, 50);
//     return () => clearTimeout(t);
//   }, []);

//   // ── Auth handlers (sidebar-embedded login/register/otp) ────
//   // All go through AuthContext's tenant-scoped login/register/verifyEmail/
//   // verifyPhone/resendOtp — the provider already knows its own tenant, so
//   // none of these need to pass it in. See components/AuthContext.jsx.
//   const handleLogin = async () => {
//     setAuthLoading(true);
//     setAuthError("");
//     try {
//       const data = await login(loginForm);

//       if (data.step === "verify_email") {
//         setPendingUserId(data.user_id);
//         setBookingStep("verify_email");
//         setAuthLoading(false);
//         return;
//       }
//       if (data.step === "verify_phone") {
//         setPendingUserId(data.user_id);
//         setBookingStep("verify_phone");
//         setAuthLoading(false);
//         return;
//       }

//       setBookingForm((f) => ({
//         ...f,
//         name: data.user.name || "",
//         phone: (data.user.country_code || "") + (data.user.phone || ""),
//       }));
//       afterAuth();
//     } catch (err) {
//       setAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleRegister = async () => {
//     setAuthLoading(true);
//     setAuthError("");
//     try {
//       const data = await register(registerForm);

//       setPendingUserId(data.user_id);
//       setBookingStep("verify_email");
//       setAuthError("");
//     } catch (err) {
//       setAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleVerifyEmail = async (otp) => {
//     setAuthLoading(true);
//     setAuthError("");
//     try {
//       const data = await verifyEmail(pendingUserId, otp);

//       setPendingUserId(data.user_id);
//       setBookingStep("verify_phone");
//       setAuthError("");
//     } catch (err) {
//       setAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleVerifyPhone = async (otp) => {
//     setAuthLoading(true);
//     setAuthError("");
//     try {
//       const data = await verifyPhone(pendingUserId, otp);

//       setBookingForm((f) => ({
//         ...f,
//         name: data.user.name || "",
//         phone: (data.user.country_code || "") + (data.user.phone || ""),
//       }));
//       afterAuth();
//     } catch (err) {
//       setAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleResendOtp = async (type) => {
//     if (!pendingUserId) return;
//     setAuthLoading(true);
//     setAuthError("");
//     try {
//       const data = await resendOtp(pendingUserId, type);
//       setAuthError("✓ " + data.message);
//     } catch (err) {
//       setAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   // ── Modal auth handlers (login/register/otp inside the popup modal) ──
//   const handleModalLogin = async () => {
//     setAuthLoading(true);
//     setModalAuthError("");
//     try {
//       const data = await login(loginForm);

//       if (data.step === "verify_email") {
//         setModalPendingUserId(data.user_id);
//         setModalStep("verify_email");
//         setAuthLoading(false);
//         return;
//       }
//       if (data.step === "verify_phone") {
//         setModalPendingUserId(data.user_id);
//         setModalStep("verify_phone");
//         setAuthLoading(false);
//         return;
//       }

//       setLoginModalOpen(false);

//       if (authIntent === "wishlist") {
//         wishlistWithToken(data.user.token, plotId, unit?.plot_number);
//       } else if (authIntent === "book") {
//         setBookingForm((f) => ({
//           ...f,
//           name: data.user.name || "",
//           phone: (data.user.country_code || "") + (data.user.phone || ""),
//         }));
//         openBooking(data.user);
//       }
//       setAuthIntent(null);
//     } catch (err) {
//       setModalAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleModalRegister = async () => {
//     setAuthLoading(true);
//     setModalAuthError("");
//     try {
//       const data = await register(registerForm);

//       setModalPendingUserId(data.user_id);
//       setModalStep("verify_email");
//       setModalAuthError("");
//     } catch (err) {
//       setModalAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleModalVerifyEmail = async (otp) => {
//     setAuthLoading(true);
//     setModalAuthError("");
//     try {
//       const data = await verifyEmail(modalPendingUserId, otp);

//       setModalPendingUserId(data.user_id);
//       setModalStep("verify_phone");
//       setModalAuthError("");
//     } catch (err) {
//       setModalAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleModalVerifyPhone = async (otp) => {
//     setAuthLoading(true);
//     setModalAuthError("");
//     try {
//       const data = await verifyPhone(modalPendingUserId, otp);

//       setLoginModalOpen(false);

//       if (authIntent === "wishlist") {
//         wishlistWithToken(data.user.token, plotId, unit?.plot_number);
//       } else if (authIntent === "book") {
//         setBookingForm((f) => ({
//           ...f,
//           name: data.user.name || "",
//           phone: (data.user.country_code || "") + (data.user.phone || ""),
//         }));
//         openBooking(data.user);
//       }
//       setAuthIntent(null);
//     } catch (err) {
//       setModalAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleModalResendOtp = async (type) => {
//     if (!modalPendingUserId) return;
//     setAuthLoading(true);
//     setModalAuthError("");
//     try {
//       const data = await resendOtp(modalPendingUserId, type);
//       setModalAuthError("✓ " + data.message);
//     } catch (err) {
//       setModalAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const closeModal = () => {
//     setLoginModalOpen(false);
//     setAuthIntent(null);
//     setModalStep("login");
//     setModalAuthError("");
//   };

//   // ── Booking submit ─────────────────────────────────────────
//   const handleBooking = async () => {
//     setAuthLoading(true);
//     setAuthError("");
//     const isAgent = user?.role === "broker" || user?.role === "sales";
//     if (isAgent && user?.status && user.status !== "active") {
//       setAuthError(
//         "Your account is currently inactive. Please contact the admin to activate your account before booking.",
//       );
//       setAuthLoading(false);
//       return;
//     }
//     try {
//       if (existingBookingId) {
//         const data = await apiJson(
//           tenant,
//           `/bookings/${existingBookingId}/plan`,
//           {
//             method: "PATCH",
//             headers: {
//               "Content-Type": "application/json",
//               Accept: "application/json",
//               Authorization: `Bearer ${user?.token}`,
//             },
//             body: JSON.stringify({ payment_plan_id: selectedPlan }),
//           },
//         );

//         if (data.booking?.fee_breakdown)
//           setFeeBreakdown(data.booking.fee_breakdown);
//         setTimeout(
//           () => navigate(`/${tenant}/payment/${existingBookingId}`),
//           400,
//         );
//         return;
//       }

//       const payload = {
//         plot_id: plotId,
//         plot_number: unit.plot_number,
//         plot_type: unit.plot_type,
//         block: unit.block,
//         section: unit.section,
//         direction: unit.direction,
//         area: unit.plot_size ? String(unit.plot_size) : "",
//         price: unit.offer_price
//           ? String(unit.offer_price)
//           : String(unit.actual_price || ""),
//         project_id: unit.project_id,
//         block_id: unit.block_id,
//         name: bookingForm.name,
//         phone: bookingForm.phone,
//         notes: bookingForm.notes,
//         payment_plan_id: selectedPlan,
//         client_name: isAgent ? bookingForm.client_name : undefined,
//         client_phone: isAgent
//           ? bookingForm.client_country_code + bookingForm.client_phone
//           : undefined,
//         client_email: isAgent ? bookingForm.client_email : undefined,
//       };

//       const data = await apiJson(tenant, `/bookings`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//           Authorization: `Bearer ${user?.token}`,
//         },
//         body: JSON.stringify(payload),
//       });

//       if (data.booking?.fee_breakdown)
//         setFeeBreakdown(data.booking.fee_breakdown);

//       const bookingId = data.booking?.id;
//       if (bookingId) {
//         showToast(
//           `🎉 Booking confirmed! Redirecting to payment…`,
//           "success",
//           2500,
//         );
//         setTimeout(() => navigate(`/${tenant}/payment/${bookingId}`), 400);
//       } else {
//         setBookingDone(true);
//         showToast(
//           `✅ Booking received! We'll contact you shortly.`,
//           "success",
//           4000,
//         );
//       }
//     } catch (err) {
//       setAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleBack = () => {
//     if (overlayRef.current) {
//       overlayRef.current.style.transition = "opacity 0.4s ease-in";
//       overlayRef.current.style.opacity = "1";
//     }
//     const dest = unit?.block_id
//       ? `/${tenant}/floor/${unit.block_id}`
//       : unit?.floor_id
//         ? `/${tenant}/floor/${unit.floor_id}`
//         : null;
//     setTimeout(() => (dest ? navigate(dest) : navigate(`/${tenant}`)), 450);
//   };

//   const switchToGallery = () => {
//     destroyViewer();
//     setActiveTab("gallery");
//     setIsLoaded(false);
//   };
//   const switchToPanorama = () => setActiveTab("panorama");
//   const switchToDetails = () => {
//     destroyViewer();
//     setActiveTab("details");
//   };

//   const hasPlans = (unit?.payment_plans?.length || 0) > 0;
//   const afterAuth = () => setBookingStep(hasPlans ? "plan" : "form");

//   // Accepts an optional user override so it can run immediately after a
//   // fresh login/registration (before AuthContext's `user` re-renders).
//   const openBooking = async (authedUser = user) => {
//     setSidebarOpen(true);
//     setBookingDone(false);
//     setAuthError("");
//     if (authedUser) {
//       if (
//         (authedUser.role === "broker" || authedUser.role === "sales") &&
//         authedUser.status &&
//         authedUser.status !== "active"
//       ) {
//         setBookingStep("broker_inactive");
//         return;
//       }
//       try {
//         const data = await apiJson(tenant, `/bookings`, {
//           headers: {
//             Authorization: `Bearer ${authedUser.token}`,
//             Accept: "application/json",
//           },
//         });

//         const bookings = Array.isArray(data) ? data : data.data || [];
//         const existing = bookings.find(
//           (b) =>
//             String(b.plot_id) === String(plotId) &&
//             b.booking_status !== "cancelled",
//         );
//         if (existing) {
//           setExistingBookingId(existing.id);
//           setSelectedPlan(existing.payment_plan_id || null);
//           try {
//             const d = await apiJson(tenant, `/bookings/${existing.id}`, {
//               headers: {
//                 Authorization: `Bearer ${authedUser.token}`,
//                 Accept: "application/json",
//               },
//             });
//             if (d?.booking?.fee_breakdown)
//               setFeeBreakdown(d.booking.fee_breakdown);
//           } catch (e) {}

//           if (existing.booking_status === "confirmed") {
//             setBookingDone(true);
//             setBookingStep("details");
//             return;
//           }
//           setBookingStep(hasPlans ? "plan" : "form");
//           return;
//         }
//       } catch (e) {}
//       setExistingBookingId(null);
//       setBookingStep(hasPlans ? "plan" : "form");
//     } else {
//       setExistingBookingId(null);
//       setBookingStep("details");
//     }
//   };

//   const logout = () => {
//     signOut();
//     setBookingStep("details");
//     setSelectedPlan(null);
//     setExistingBookingId(null);
//   };

//   useEffect(() => {
//     if (user)
//       setBookingForm((f) => ({
//         ...f,
//         name: f.name || user.name || "",
//         phone: f.phone || (user.country_code || "") + (user.phone || ""),
//       }));
//   }, [user?.id]);

//   // ── Helpers ────────────────────────────────────────────────
//   const fmtPrice = (val) =>
//     val ? `${currency} ${Number(val).toLocaleString("en-IN")}` : null;
//   const getStatusColor = (s) => {
//     const v = s?.toLowerCase();
//     return v === "available"
//       ? "#16a34a"
//       : v === "pre-booked"
//         ? "#d97706"
//         : "#dc2626";
//   };

//   // ── Guards ─────────────────────────────────────────────────
//   if (isFetching || !settingsLoaded)
//     return (
//       <div className="unit-loading-screen">
//         <div style={{ fontSize: 48 }}>🏠</div>
//         <div
//           style={{ color: "var(--text-dark)", fontSize: 16, fontWeight: 600 }}
//         >
//           {!settingsLoaded ? "Loading settings..." : "Loading unit…"}
//         </div>
//         <div className="loading-bar-track">
//           <div className="loading-bar-fill" />
//         </div>
//       </div>
//     );
//   if (fetchError || !unit)
//     return (
//       <div className="unit-loading-screen">
//         <div style={{ fontSize: 48 }}>⚠️</div>
//         <h2 style={{ color: "var(--text-dark)" }}>Unit Unavailable</h2>
//         <p style={{ color: "var(--text-muted)" }}>
//           {fetchError || "Unit not found."}
//         </p>
//         <button
//           onClick={() => navigate(`/${tenant}`)}
//           style={{
//             padding: "10px 24px",
//             background: "var(--primary-color)",
//             color: "#fff",
//             border: "none",
//             borderRadius: 8,
//             cursor: "pointer",
//             fontWeight: 700,
//           }}
//         >
//           ← Go Back
//         </button>
//       </div>
//     );

//   const gallery = unit.gallery_images || [];
//   const hasPano = !!unit.panorama_url;
//   const hasGal = gallery.length > 0;
//   const hasRooms = unit.rooms?.length > 0;
//   const isAvail = unit.status?.toLowerCase() === "available";
//   const statusColor = getStatusColor(unit.status);
//   const isWished =
//     wishedIds instanceof Set ? wishedIds.has(Number(plotId)) : false;
//   const sym = feeBreakdown?.currency_symbol || currency;

//   // ── Render panorama / gallery as full-screen ───────────────
//   const isFullView =
//     activeTab === "panorama" || (activeTab === "gallery" && hasGal);

//   return (
//     <div className="unit-page">
//       {/* ── Auth modal (wishlist + book-now-when-logged-out) ── */}
//       {loginModalOpen && (
//         <>
//           <div className="up-modal-backdrop" onClick={closeModal} />
//           <div className="up-modal">
//             <div className="up-modal-head">
//               <div className="up-modal-title">
//                 {modalStep === "verify_email"
//                   ? "📧 Verify Email"
//                   : modalStep === "verify_phone"
//                     ? "📱 Verify Phone"
//                     : authIntent === "book"
//                       ? "🏠 Login to Book"
//                       : authIntent === "wishlist"
//                         ? "❤️ Save to Wishlist"
//                         : "👤 Login to your account"}
//               </div>
//               <button className="up-modal-close" onClick={closeModal}>
//                 ×
//               </button>
//             </div>
//             {modalStep === "verify_email" ? (
//               <StepOtp
//                 key="modal-otp-email"
//                 type="email"
//                 onVerify={handleModalVerifyEmail}
//                 onResend={() => handleModalResendOtp("email")}
//                 loading={authLoading}
//                 error={modalAuthError}
//                 setError={setModalAuthError}
//               />
//             ) : modalStep === "verify_phone" ? (
//               <StepOtp
//                 key="modal-otp-phone"
//                 type="phone"
//                 onVerify={handleModalVerifyPhone}
//                 onResend={() => handleModalResendOtp("phone")}
//                 loading={authLoading}
//                 error={modalAuthError}
//                 setError={setModalAuthError}
//               />
//             ) : (
//               <>
//                 <div className="up-modal-tabs">
//                   {["login", "register"].map((tab) => (
//                     <button
//                       key={tab}
//                       className={`up-modal-tab${modalStep === tab ? " active" : ""}`}
//                       onClick={() => {
//                         setModalStep(tab);
//                         setModalAuthError("");
//                       }}
//                     >
//                       {tab === "login" ? "Log In" : "Register"}
//                     </button>
//                   ))}
//                 </div>
//                 <p
//                   style={{
//                     color: "var(--text-muted)",
//                     fontSize: 13,
//                     marginBottom: 16,
//                     lineHeight: 1.6,
//                   }}
//                 >
//                   {authIntent === "book"
//                     ? modalStep === "login"
//                       ? "Log in to continue booking this unit."
//                       : "Create an account to book this unit."
//                     : authIntent === "wishlist"
//                       ? modalStep === "login"
//                         ? "Log in to save this unit to your wishlist."
//                         : "Create an account to save this unit."
//                       : modalStep === "login"
//                         ? "Log in to access your account."
//                         : "Create an account to get started."}
//                 </p>
//                 {modalStep === "login" ? (
//                   <StepLogin
//                     form={loginForm}
//                     setForm={setLoginForm}
//                     onLogin={handleModalLogin}
//                     onSwitch={() => {
//                       setModalStep("register");
//                       setModalAuthError("");
//                     }}
//                     loading={authLoading}
//                     error={modalAuthError}
//                   />
//                 ) : (
//                   <StepRegister
//                     form={registerForm}
//                     setForm={setRegisterForm}
//                     onRegister={handleModalRegister}
//                     onSwitch={() => {
//                       setModalStep("login");
//                       setModalAuthError("");
//                     }}
//                     loading={authLoading}
//                     error={modalAuthError}
//                   />
//                 )}
//               </>
//             )}
//           </div>
//         </>
//       )}

//       {/* ── Sticky header ── */}
//       <div className="unit-header">
//         <button className="unit-back-btn" onClick={handleBack}>
//           ← Floor
//         </button>

//         <div className="unit-info">
//           <div className="unit-title-row">
//             <span className="unit-name">Unit {unit.plot_number}</span>
//             <span
//               className="unit-status-badge"
//               style={{
//                 background: statusColor + "18",
//                 color: statusColor,
//                 border: `1px solid ${statusColor}44`,
//               }}
//             >
//               {unit.status}
//             </span>
//           </div>
//           <div className="unit-subtitle">
//             {unit.plot_type}
//             {unit.plot_size ? ` · ${unit.plot_size} sqft` : ""}
//             {unit.direction ? ` · ${unit.direction}` : ""}
//           </div>
//         </div>

//         <div className="unit-tabs">
//           <button
//             className={`unit-tab${activeTab === "details" ? " active" : ""}`}
//             onClick={switchToDetails}
//           >
//             📋 Details
//           </button>
//           {hasPlans && (
//             <button
//               className={`unit-tab${activeTab === "payment" ? " active" : ""}`}
//               onClick={() => {
//                 destroyViewer();
//                 setActiveTab("payment");
//               }}
//             >
//               💳 Payment Plans
//             </button>
//           )}
//           {hasPano && (
//             <button
//               className={`unit-tab${activeTab === "panorama" ? " active" : ""}`}
//               onClick={switchToPanorama}
//             >
//               🌐 360°
//             </button>
//           )}
//           {hasGal && (
//             <button
//               className={`unit-tab${activeTab === "gallery" ? " active" : ""}`}
//               onClick={switchToGallery}
//             >
//               🖼 Gallery ({gallery.length})
//             </button>
//           )}
//         </div>

//         <div className="unit-price-wrap">
//           {user && (
//             <button
//               onClick={() => navigate(`/${tenant}/dashboard`)}
//               title={`${user.name} — My Dashboard`}
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 7,
//                 background: "var(--page-bg)",
//                 border: "1.5px solid var(--card-border)",
//                 borderRadius: 20,
//                 padding: "5px 14px 5px 6px",
//                 cursor: "pointer",
//                 color: "var(--text-dark)",
//                 fontSize: 12,
//                 fontWeight: 700,
//                 flexShrink: 0,
//                 fontFamily: "var(--font-body)",
//                 transition: "border-color 0.2s",
//               }}
//               onMouseEnter={(e) =>
//                 (e.currentTarget.style.borderColor = "var(--primary-color)")
//               }
//               onMouseLeave={(e) =>
//                 (e.currentTarget.style.borderColor = "var(--card-border)")
//               }
//             >
//               <span
//                 style={{
//                   width: 24,
//                   height: 24,
//                   borderRadius: "50%",
//                   background: "var(--primary-color)",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   fontSize: 11,
//                   fontWeight: 800,
//                   color: "#fff",
//                   flexShrink: 0,
//                 }}
//               >
//                 {user.name?.[0]?.toUpperCase()}
//               </span>
//               <span style={{ whiteSpace: "nowrap" }}>Dashboard</span>
//             </button>
//           )}

//           {!user && (
//             <button
//               onClick={() => {
//                 setAuthIntent(null);
//                 setModalStep("login");
//                 setModalAuthError("");
//                 setLoginModalOpen(true);
//               }}
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 7,
//                 background: "var(--page-bg)",
//                 border: "1.5px solid var(--card-border)",
//                 borderRadius: 20,
//                 padding: "6px 16px",
//                 cursor: "pointer",
//                 color: "var(--text-dark)",
//                 fontSize: 12,
//                 fontWeight: 700,
//                 flexShrink: 0,
//                 fontFamily: "var(--font-body)",
//                 transition: "border-color 0.2s",
//               }}
//               onMouseEnter={(e) =>
//                 (e.currentTarget.style.borderColor = "var(--primary-color)")
//               }
//               onMouseLeave={(e) =>
//                 (e.currentTarget.style.borderColor = "var(--card-border)")
//               }
//             >
//               👤 Login
//             </button>
//           )}

//           <div className="unit-price-box">
//             {unit.offer_price && (
//               <div className="unit-offer-price">
//                 {fmtPrice(unit.offer_price)}
//               </div>
//             )}
//             <div
//               className="unit-actual-price"
//               style={{
//                 color: unit.offer_price
//                   ? "var(--text-muted)"
//                   : "var(--text-dark)",
//                 textDecoration: unit.offer_price ? "line-through" : "none",
//                 fontSize: unit.offer_price ? 11 : 14,
//               }}
//             >
//               {fmtPrice(unit.actual_price)}
//             </div>
//             {feeBreakdown?.tax_enabled && feeBreakdown?.tax_rate > 0 && (
//               <div
//                 style={{
//                   fontSize: 10,
//                   color: "#b45309",
//                   marginTop: 2,
//                   fontWeight: 600,
//                 }}
//               >
//                 +{feeBreakdown.tax_rate}% {feeBreakdown.tax_label || "Tax"}
//               </div>
//             )}
//           </div>

//           {isAvail && (
//             <button
//               className="book-now-btn"
//               onClick={() => {
//                 if (user) {
//                   openBooking();
//                 } else {
//                   setAuthIntent("book");
//                   setModalStep("login");
//                   setModalAuthError("");
//                   setLoginModalOpen(true);
//                 }
//               }}
//             >
//               Book Now
//             </button>
//           )}

//           {unit && (
//             <button
//               onClick={() => {
//                 if (!user?.token) {
//                   setAuthIntent("wishlist");
//                   setModalStep("login");
//                   setModalAuthError("");
//                   setLoginModalOpen(true);
//                 } else {
//                   const willAdd = !isWished;
//                   toggleWish(Number(plotId))
//                     .then(() => {
//                       showToast(
//                         willAdd
//                           ? `❤️ Added to Wishlist — Unit ${unit.plot_number}`
//                           : `🤍 Removed from Wishlist — Unit ${unit.plot_number}`,
//                         willAdd ? "wishlist_add" : "wishlist_remove",
//                         2800,
//                       );
//                     })
//                     .catch(() => {
//                       showToast(
//                         "Failed to update wishlist. Please try again.",
//                         "error",
//                         3000,
//                       );
//                     });
//                 }
//               }}
//               title={isWished ? "Remove from Wishlist" : "Save to Wishlist"}
//               style={{
//                 background: isWished ? "#fff5f5" : "var(--page-bg)",
//                 border: `1.5px solid ${isWished ? "#fecaca" : "var(--card-border)"}`,
//                 borderRadius: 8,
//                 cursor: "pointer",
//                 padding: "6px 10px",
//                 fontSize: 18,
//                 lineHeight: 1,
//                 transition: "all 0.2s",
//                 color: isWished ? "#ef4444" : "var(--text-muted)",
//               }}
//             >
//               {isWished ? "❤️" : "🤍"}
//             </button>
//           )}
//         </div>
//       </div>

//       {/* ── Content ── */}
//       <div className="unit-content-area">
//         {/* Full-screen panorama */}
//         {activeTab === "panorama" && (
//           <div className="unit-fullview">
//             <div ref={containerRef} className="psv-container-div" />
//             <div className={`pano-loader${isLoaded ? " gone" : ""}`}>
//               <div className="pano-loader-card">
//                 <div className="pano-loader-emoji">🏠</div>
//                 <div className="pano-loader-percent">{loadProgress}%</div>
//                 <div className="pano-loader-bar-track">
//                   <div
//                     className="pano-loader-bar-fill"
//                     style={{ width: `${loadProgress}%` }}
//                   />
//                 </div>
//                 <div className="pano-loader-text">
//                   {loadProgress < 40
//                     ? "Preparing panorama..."
//                     : loadProgress < 80
//                       ? "Loading image data..."
//                       : loadProgress < 100
//                         ? "Almost ready..."
//                         : "✓ Ready"}
//                 </div>
//               </div>
//             </div>
//             {isLoaded && hasRooms && (
//               <div className="room-nav-strip">
//                 <span className="room-nav-label">Rooms</span>
//                 {unit.rooms.map((room) => (
//                   <button
//                     key={room.id}
//                     className="room-thumb-btn"
//                     onClick={() =>
//                       navigate(`/${tenant}/unit/${plotId}/room/${room.id}`)
//                     }
//                   >
//                     {room.thumb_url ? (
//                       <img
//                         src={getFullImageUrl(room.thumb_url)}
//                         alt={room.room_label}
//                       />
//                     ) : (
//                       <div className="room-thumb-placeholder">🚪</div>
//                     )}
//                     <span>{room.room_label}</span>
//                   </button>
//                 ))}
//               </div>
//             )}
//             <div ref={labelRef} className="marker-label" />
//           </div>
//         )}

//         {/* Two-column layout for details / payment / gallery */}
//         {activeTab !== "panorama" && (
//           <div className="unit-detail-layout">
//             {/* ── LEFT ── */}
//             <div className="unit-detail-left">
//               {(activeTab === "details" ||
//                 activeTab === "gallery" ||
//                 activeTab === "payment") &&
//                 (hasGal || hasPano) && (
//                   <GalleryStrip
//                     gallery={gallery}
//                     hasPano={hasPano}
//                     plotId={plotId}
//                     tenant={tenant}
//                     navigate={navigate}
//                     galIdx={galIdx}
//                     setGalIdx={setGalIdx}
//                     onOpenPano={switchToPanorama}
//                   />
//                 )}

//               {activeTab === "details" && (
//                 <UnitDetailsContent
//                   unit={unit}
//                   fmtPrice={fmtPrice}
//                   statusColor={statusColor}
//                   currency={currency}
//                   sym={sym}
//                   feeBreakdown={feeBreakdown}
//                   getFullImageUrl={getFullImageUrl}
//                 />
//               )}

//               {activeTab === "payment" && (
//                 <PaymentPlansContent
//                   plans={unit.payment_plans || []}
//                   fmtPrice={fmtPrice}
//                   currency={currency}
//                   unitPrice={unit.offer_price || unit.actual_price}
//                   feeBreakdown={feeBreakdown}
//                   sym={sym}
//                 />
//               )}

//               {activeTab === "gallery" && hasGal && (
//                 <div style={{ marginTop: 16 }}>
//                   <div className="up-section">
//                     <div className="up-section-head">
//                       🖼 All Photos ({gallery.length})
//                     </div>
//                     <div className="up-section-body">
//                       <div
//                         style={{
//                           display: "grid",
//                           gridTemplateColumns:
//                             "repeat(auto-fill, minmax(200px, 1fr))",
//                           gap: 10,
//                         }}
//                       >
//                         {gallery.map((img, i) => {
//                           const imgUrl = getFullImageUrl(img);
//                           return imgUrl ? (
//                             <img
//                               key={i}
//                               src={imgUrl}
//                               alt={`Gallery ${i + 1}`}
//                               onClick={() => {
//                                 setGalIdx(i);
//                                 navigate(
//                                   `/${tenant}/unit/${plotId}/gallery/${i}`,
//                                 );
//                               }}
//                               style={{
//                                 width: "100%",
//                                 aspectRatio: "4/3",
//                                 objectFit: "cover",
//                                 borderRadius: 8,
//                                 cursor: "pointer",
//                                 border: `2px solid ${i === galIdx ? "var(--primary-color)" : "transparent"}`,
//                                 transition: "all 0.2s",
//                               }}
//                             />
//                           ) : null;
//                         })}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* ── RIGHT — booking widget ── */}
//             <div
//               className={`unit-detail-right${sidebarOpen ? " sidebar-open" : ""}`}
//             >
//               <div className="right-panel-header">
//                 <div className="right-panel-price">
//                   {unit.offer_price
//                     ? fmtPrice(unit.offer_price)
//                     : fmtPrice(unit.actual_price)}
//                 </div>
//                 {unit.offer_price && (
//                   <div className="right-panel-price-orig">
//                     {fmtPrice(unit.actual_price)}
//                   </div>
//                 )}
//                 {feeBreakdown?.tax_enabled &&
//                   feeBreakdown?.total_amount > 0 && (
//                     <div
//                       style={{
//                         fontSize: 12,
//                         color: "#b45309",
//                         fontWeight: 600,
//                         marginTop: 3,
//                       }}
//                     >
//                       Grand Total: {fmtExact(feeBreakdown.total_amount, sym)}{" "}
//                       (incl. tax)
//                     </div>
//                   )}
//                 <div className="right-panel-title">Unit {unit.plot_number}</div>
//                 <div className="right-panel-sub">
//                   {unit.plot_type}
//                   {unit.plot_size ? ` · ${unit.plot_size} sqft` : ""}
//                   {unit.direction ? ` · ${unit.direction}` : ""}
//                 </div>
//                 <div
//                   style={{
//                     marginTop: 8,
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: 5,
//                     padding: "3px 12px",
//                     borderRadius: 20,
//                     fontSize: 12,
//                     fontWeight: 700,
//                     background: statusColor + "18",
//                     color: statusColor,
//                     border: `1px solid ${statusColor}44`,
//                   }}
//                 >
//                   ● {unit.status}
//                 </div>
//               </div>

//               {/* Quick stat pills */}
//               <div style={{ padding: "14px 22px 0" }}>
//                 <div className="rp-stats">
//                   {unit.bedrooms != null && (
//                     <div className="rp-stat">
//                       <span className="rp-stat-icon">🛏</span>
//                       <div className="rp-stat-val">{unit.bedrooms}</div>
//                       <div className="rp-stat-lbl">Beds</div>
//                     </div>
//                   )}
//                   {unit.bathrooms != null && (
//                     <div className="rp-stat">
//                       <span className="rp-stat-icon">🚿</span>
//                       <div className="rp-stat-val">{unit.bathrooms}</div>
//                       <div className="rp-stat-lbl">Baths</div>
//                     </div>
//                   )}
//                   {unit.plot_size && (
//                     <div className="rp-stat">
//                       <span className="rp-stat-icon">📐</span>
//                       <div className="rp-stat-val">{unit.plot_size}</div>
//                       <div className="rp-stat-lbl">sqft</div>
//                     </div>
//                   )}
//                   {!unit.bedrooms && !unit.bathrooms && !unit.plot_size && (
//                     <>
//                       <div className="rp-stat">
//                         <span className="rp-stat-icon">🏢</span>
//                         <div className="rp-stat-val">
//                           {unit.plot_type || "—"}
//                         </div>
//                         <div className="rp-stat-lbl">Type</div>
//                       </div>
//                       <div className="rp-stat">
//                         <span className="rp-stat-icon">🧭</span>
//                         <div className="rp-stat-val">
//                           {unit.direction || "—"}
//                         </div>
//                         <div className="rp-stat-lbl">Facing</div>
//                       </div>
//                       <div className="rp-stat">
//                         <span className="rp-stat-icon">🚪</span>
//                         <div className="rp-stat-val">
//                           {unit.rooms?.length || 0}
//                         </div>
//                         <div className="rp-stat-lbl">Rooms</div>
//                       </div>
//                     </>
//                   )}
//                 </div>
//               </div>

//               <div className="right-panel-scroll">
//                 {bookingStep === "broker_inactive" ? (
//                   <BrokerInactiveScreen onClose={() => setSidebarOpen(false)} />
//                 ) : bookingDone ? (
//                   <BookingDone
//                     unit={unit}
//                     onClose={() => setSidebarOpen(false)}
//                   />
//                 ) : bookingStep === "details" ? (
//                   <StepDetails
//                     user={user}
//                     onBook={() =>
//                       user
//                         ? hasPlans
//                           ? setBookingStep("plan")
//                           : setBookingStep("form")
//                         : setBookingStep("login")
//                     }
//                     onLogout={logout}
//                     isAvail={isAvail}
//                   />
//                 ) : bookingStep === "login" ? (
//                   <StepLogin
//                     form={loginForm}
//                     setForm={setLoginForm}
//                     onLogin={handleLogin}
//                     onSwitch={() => {
//                       setBookingStep("register");
//                       setAuthError("");
//                     }}
//                     loading={authLoading}
//                     error={authError}
//                   />
//                 ) : bookingStep === "register" ? (
//                   <StepRegister
//                     form={registerForm}
//                     setForm={setRegisterForm}
//                     onRegister={handleRegister}
//                     onSwitch={() => {
//                       setBookingStep("login");
//                       setAuthError("");
//                     }}
//                     loading={authLoading}
//                     error={authError}
//                   />
//                 ) : bookingStep === "verify_email" ? (
//                   <StepOtp
//                     key="otp-email"
//                     type="email"
//                     onVerify={handleVerifyEmail}
//                     onResend={() => handleResendOtp("email")}
//                     loading={authLoading}
//                     error={authError}
//                     setError={setAuthError}
//                   />
//                 ) : bookingStep === "verify_phone" ? (
//                   <StepOtp
//                     key="otp-phone"
//                     type="phone"
//                     onVerify={handleVerifyPhone}
//                     onResend={() => handleResendOtp("phone")}
//                     loading={authLoading}
//                     error={authError}
//                     setError={setAuthError}
//                   />
//                 ) : bookingStep === "plan" ? (
//                   <StepPlanSelect
//                     plans={unit.payment_plans || []}
//                     selected={selectedPlan}
//                     onSelect={setSelectedPlan}
//                     fmtPrice={fmtPrice}
//                     unitPrice={unit.actual_price}
//                     onNext={() => setBookingStep("form")}
//                     onBack={() => setBookingStep("details")}
//                     existingBookingId={existingBookingId}
//                     feeBreakdown={feeBreakdown}
//                     sym={sym}
//                   />
//                 ) : bookingStep === "form" ? (
//                   <StepBookingForm
//                     user={user}
//                     form={bookingForm}
//                     setForm={setBookingForm}
//                     onSubmit={handleBooking}
//                     loading={authLoading}
//                     error={authError}
//                     selectedPlan={selectedPlan}
//                     plans={unit.payment_plans || []}
//                     onBack={() =>
//                       hasPlans
//                         ? setBookingStep("plan")
//                         : setBookingStep("details")
//                     }
//                     unit={unit}
//                     existingBookingId={existingBookingId}
//                     feeBreakdown={feeBreakdown}
//                     sym={sym}
//                   />
//                 ) : null}
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// /* ═════════════════════════════════════════════════════════════
//    GalleryStrip — Dubizzle-style image strip
// ═════════════════════════════════════════════════════════════ */
// const GalleryStrip = ({
//   gallery,
//   hasPano,
//   plotId,
//   tenant,
//   navigate,
//   galIdx,
//   setGalIdx,
//   onOpenPano,
// }) => {
//   if (!gallery.length && !hasPano) return null;
//   const total = gallery.length;
//   return (
//     <div className="up-gallery">
//       <div
//         className="up-gallery-main"
//         onClick={() =>
//           total > 0 && navigate(`/${tenant}/unit/${plotId}/gallery/${galIdx}`)
//         }
//       >
//         {total > 0 ? (
//           <img src={gallery[galIdx]} alt={`View ${galIdx + 1}`} />
//         ) : (
//           <div
//             style={{
//               width: "100%",
//               height: "100%",
//               background: "#1a1a1a",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               color: "rgba(255,255,255,0.3)",
//               fontSize: 40,
//               aspectRatio: "16/9",
//             }}
//           >
//             🏠
//           </div>
//         )}

//         <div className="up-gallery-badges">
//           {hasPano && (
//             <button
//               className="up-gallery-badge pano"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 onOpenPano();
//               }}
//             >
//               🌐 360° View
//             </button>
//           )}
//         </div>

//         {total > 1 && (
//           <>
//             <button
//               className="up-gallery-nav prev"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 setGalIdx((i) => (i - 1 + total) % total);
//               }}
//             >
//               ‹
//             </button>
//             <button
//               className="up-gallery-nav next"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 setGalIdx((i) => (i + 1) % total);
//               }}
//             >
//               ›
//             </button>
//             <div className="up-gallery-counter">
//               📷 {galIdx + 1} / {total}
//             </div>
//           </>
//         )}
//       </div>
//       {total > 1 && (
//         <div className="up-gallery-thumbs">
//           {gallery.map((img, i) => (
//             <img
//               key={i}
//               src={img}
//               alt=""
//               className={i === galIdx ? "active" : ""}
//               onClick={() => setGalIdx(i)}
//             />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// /* ═════════════════════════════════════════════════════════════
//    UnitDetailsContent — Dubizzle-style detail sections
// ═════════════════════════════════════════════════════════════ */
// const UnitDetailsContent = ({
//   unit,
//   fmtPrice,
//   statusColor,
//   currency,
//   sym,
//   feeBreakdown,
//   getFullImageUrl,
// }) => {
//   const hasDims = unit.room_dimensions?.length > 0;
//   const hasAmenities = unit.amenities?.length > 0;
//   const hasAreaData =
//     unit.internal_area_sqft ||
//     unit.internal_area_sqm ||
//     unit.external_area_sqft;

//   return (
//     <>
//       {/* Headline */}
//       <div className="up-headline">
//         <div>
//           <h1 className="up-title">
//             Unit {unit.plot_number} — {unit.plot_type}
//           </h1>
//           <div className="up-meta-chips">
//             {unit.bedrooms != null && (
//               <span className="up-meta-chip">
//                 <span className="chip-icon">🛏</span>
//                 {unit.bedrooms} Bed{unit.bedrooms !== 1 ? "s" : ""}
//               </span>
//             )}
//             {unit.bathrooms != null && (
//               <span className="up-meta-chip">
//                 <span className="chip-icon">🚿</span>
//                 {unit.bathrooms} Bath{unit.bathrooms !== 1 ? "s" : ""}
//               </span>
//             )}
//             {unit.plot_size && (
//               <span className="up-meta-chip">
//                 <span className="chip-icon">📐</span>
//                 {unit.plot_size} sqft
//               </span>
//             )}
//             {unit.direction && (
//               <span className="up-meta-chip">
//                 <span className="chip-icon">🧭</span>
//                 {unit.direction}
//               </span>
//             )}
//           </div>
//         </div>
//         <div className="up-price-block">
//           {unit.offer_price && (
//             <div className="up-price-main">{fmtPrice(unit.offer_price)}</div>
//           )}
//           {unit.offer_price && (
//             <div className="up-price-original">
//               {fmtPrice(unit.actual_price)}
//             </div>
//           )}
//           {!unit.offer_price && unit.actual_price && (
//             <div className="up-price-main">{fmtPrice(unit.actual_price)}</div>
//           )}
//           {feeBreakdown?.tax_enabled && feeBreakdown?.tax_rate > 0 && (
//             <div className="up-price-tax-note">
//               +{feeBreakdown.tax_rate}% {feeBreakdown.tax_label || "Tax"}
//             </div>
//           )}
//           <div
//             className="up-price-status"
//             style={{
//               background: statusColor + "18",
//               color: statusColor,
//               border: `1px solid ${statusColor}44`,
//             }}
//           >
//             ● {unit.status}
//           </div>
//         </div>
//       </div>

//       {/* Overview facts */}
//       <div className="up-section">
//         <div className="up-section-head">🏠 Overview</div>
//         <div className="up-section-body">
//           <div className="up-facts-grid">
//             {[
//               ["Unit No", unit.plot_number],
//               ["Type", unit.plot_type],
//               ["Size", unit.plot_size ? `${unit.plot_size} sqft` : "—"],
//               ["Direction", unit.direction || "—"],
//               ["Project", unit.project_name || "—"],
//               ["Floor", unit.block || "—"],
//               ["Rooms", unit.rooms?.length || "—"],
//               ["Status", unit.status],
//             ].map(([lbl, val]) => (
//               <div key={lbl} className="up-fact">
//                 <div className="up-fact-label">{lbl}</div>
//                 <div className="up-fact-value">{val}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Area breakdown */}
//       {hasAreaData && (
//         <div className="up-section">
//           <div className="up-section-head">📐 Floor Areas</div>
//           <div className="up-section-body">
//             <div className="up-area-grid">
//               {unit.internal_area_sqft && (
//                 <div
//                   className="up-area-card"
//                   style={{ borderColor: "var(--primary-color)33" }}
//                 >
//                   <div className="up-area-label">Internal Area</div>
//                   <div
//                     className="up-area-sqft"
//                     style={{ color: "var(--primary-color)" }}
//                   >
//                     {Number(unit.internal_area_sqft).toLocaleString()}{" "}
//                     <span>sq ft</span>
//                   </div>
//                   <div className="up-area-sqm">
//                     {unit.internal_area_sqm
//                       ? Number(unit.internal_area_sqm).toLocaleString()
//                       : (unit.internal_area_sqft / 10.764).toFixed(1)}{" "}
//                     sq m
//                   </div>
//                 </div>
//               )}
//               {unit.external_area_sqft && (
//                 <div className="up-area-card">
//                   <div className="up-area-label">External Area</div>
//                   <div className="up-area-sqft">
//                     {Number(unit.external_area_sqft).toLocaleString()}{" "}
//                     <span>sq ft</span>
//                   </div>
//                   <div className="up-area-sqm">
//                     {unit.external_area_sqm
//                       ? Number(unit.external_area_sqm).toLocaleString()
//                       : (unit.external_area_sqft / 10.764).toFixed(1)}{" "}
//                     sq m
//                   </div>
//                 </div>
//               )}
//               {unit.internal_area_sqft && unit.external_area_sqft && (
//                 <div
//                   className="up-area-card"
//                   style={{ borderColor: "#86efac" }}
//                 >
//                   <div className="up-area-label">Total Area</div>
//                   <div className="up-area-sqft" style={{ color: "#16a34a" }}>
//                     {(
//                       parseFloat(unit.internal_area_sqft) +
//                       parseFloat(unit.external_area_sqft)
//                     ).toFixed(2)}{" "}
//                     <span>sq ft</span>
//                   </div>
//                   {unit.internal_area_sqm && unit.external_area_sqm && (
//                     <div className="up-area-sqm">
//                       {(
//                         parseFloat(unit.internal_area_sqm) +
//                         parseFloat(unit.external_area_sqm)
//                       ).toFixed(2)}{" "}
//                       sq m
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Room dimensions */}
//       {hasDims && (
//         <div className="up-section">
//           <div className="up-section-head">📏 Room Dimensions</div>
//           <div className="up-section-body">
//             {unit.room_dimensions.map((dim, i) => {
//               const u = dim.unit || "m",
//                 w = parseFloat(dim.width),
//                 l = parseFloat(dim.length);
//               const wFt = u === "m" ? toFt(w) : w.toFixed(1),
//                 lFt = u === "m" ? toFt(l) : l.toFixed(1);
//               const wM = u === "ft" ? (w / 3.28084).toFixed(1) : w.toFixed(1),
//                 lM = u === "ft" ? (l / 3.28084).toFixed(1) : l.toFixed(1);
//               const sqm = dim.area_sqm
//                 ? parseFloat(dim.area_sqm)
//                 : w && l
//                   ? u === "m"
//                     ? w * l
//                     : (w * l) / 10.7639
//                   : null;
//               const sqft = dim.area_sqft
//                 ? parseFloat(dim.area_sqft)
//                 : sqm
//                   ? sqm * 10.7639
//                   : null;
//               return (
//                 <div key={i} className="up-dim-row">
//                   <div className="up-dim-name">{dim.label}</div>
//                   <div className="up-dim-vals">
//                     <span className="up-dim-primary">
//                       {wM} × {lM} m
//                     </span>
//                     <span className="up-dim-secondary">
//                       {wFt}' × {lFt}'
//                     </span>
//                     {sqm != null && (
//                       <span className="up-dim-area">
//                         {sqm.toFixed(1)} m² / {sqft.toFixed(1)} ft²
//                       </span>
//                     )}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       )}

//       {/* Amenities */}
//       {hasAmenities && (
//         <div className="up-section">
//           <div className="up-section-head">✨ Amenities</div>
//           <div className="up-section-body">
//             <div className="up-amenities">
//               {unit.amenities.map((a, i) => (
//                 <div key={i} className="up-amenity">
//                   <span>{amenityIcon(a)}</span>
//                   <span>{a}</span>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Floor plan */}
//       {unit.floor_plan_image && (
//         <div className="up-section">
//           <div className="up-section-head">🗺️ Floor Plan</div>
//           <div className="up-section-body up-floor-plan">
//             <img
//               src={getFullImageUrl(unit.floor_plan_image)}
//               alt="Floor Plan"
//             />
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// /* ═════════════════════════════════════════════════════════════
//    PaymentPlansContent - with proper tax display
// ═════════════════════════════════════════════════════════════ */
// const PaymentPlansContent = ({
//   plans,
//   fmtPrice,
//   currency,
//   unitPrice,
//   feeBreakdown,
//   sym = "₹",
// }) => {
//   const [activePlan, setActivePlan] = useState(0);
//   if (!plans?.length)
//     return (
//       <div className="up-section">
//         <div
//           className="up-section-body"
//           style={{ textAlign: "center", padding: "40px 20px" }}
//         >
//           <div style={{ fontSize: 40, marginBottom: 12 }}>💳</div>
//           <div
//             style={{
//               fontSize: 15,
//               fontWeight: 600,
//               color: "var(--text-muted)",
//             }}
//           >
//             No payment plans available
//           </div>
//         </div>
//       </div>
//     );

//   const basePrice =
//     parseFloat(String(unitPrice || "0").replace(/[^0-9.]/g, "")) || 0;
//   const calcAmtLabel = (pct) =>
//     basePrice > 0 ? fmtExact((basePrice * parseFloat(pct)) / 100, sym) : null;
//   const plan = plans[activePlan];
//   const totalPct = plan.milestones.reduce(
//     (s, m) => s + (parseFloat(m.percentage) || 0),
//     0,
//   );

//   const calculateMilestoneTotal = (milestone) => {
//     if (!feeBreakdown || !milestone.percentage) {
//       return null;
//     }
//     const pct = parseFloat(milestone.percentage) / 100;
//     const base = (feeBreakdown.unit_price || basePrice) * pct;
//     const tax = (feeBreakdown.tax_amount || 0) * pct;
//     const fees =
//       ((feeBreakdown.processing_fee || 0) +
//         (feeBreakdown.stamp_duty || 0) +
//         (feeBreakdown.registration_fee || 0) +
//         (feeBreakdown.maintenance_charge || 0) +
//         (feeBreakdown.custom_fee1 || 0) +
//         (feeBreakdown.custom_fee2 || 0)) *
//       pct;
//     return {
//       base,
//       tax,
//       fees,
//       total: base + tax + fees,
//     };
//   };

//   return (
//     <div className="up-plans-wrap">
//       {plans.length > 1 && (
//         <div className="up-plan-tabs">
//           {plans.map((p, i) => (
//             <button
//               key={p.id}
//               className={`up-plan-tab${i === activePlan ? " active" : ""}`}
//               onClick={() => setActivePlan(i)}
//             >
//               {p.name}
//             </button>
//           ))}
//         </div>
//       )}

//       {/* Grand total banner */}
//       {feeBreakdown?.tax_enabled && feeBreakdown?.total_amount > 0 && (
//         <div className="grand-total-banner" style={{ marginBottom: 16 }}>
//           <div className="gtb-row">
//             <span className="gtb-label">Unit {fmtExact(basePrice, sym)}</span>
//             <span className="gtb-val">
//               {fmtExact(feeBreakdown.unit_price || basePrice, sym)}
//             </span>
//           </div>
//           {(feeBreakdown.processing_fee || 0) > 0 && (
//             <div className="gtb-row">
//               <span className="gtb-label">
//                 {feeBreakdown.fee_labels?.processing || "Processing Fee"}
//               </span>
//               <span className="gtb-val">
//                 {fmtExact(feeBreakdown.processing_fee, sym)}
//               </span>
//             </div>
//           )}
//           {(feeBreakdown.stamp_duty || 0) > 0 && (
//             <div className="gtb-row">
//               <span className="gtb-label">
//                 {feeBreakdown.fee_labels?.stamp_duty || "Stamp Duty"}
//               </span>
//               <span className="gtb-val">
//                 {fmtExact(feeBreakdown.stamp_duty, sym)}
//               </span>
//             </div>
//           )}
//           {(feeBreakdown.registration_fee || 0) > 0 && (
//             <div className="gtb-row">
//               <span className="gtb-label">
//                 {feeBreakdown.fee_labels?.registration || "Registration Fee"}
//               </span>
//               <span className="gtb-val">
//                 {fmtExact(feeBreakdown.registration_fee, sym)}
//               </span>
//             </div>
//           )}
//           {(feeBreakdown.maintenance_charge || 0) > 0 && (
//             <div className="gtb-row">
//               <span className="gtb-label">
//                 {feeBreakdown.fee_labels?.maintenance || "Maintenance"}
//               </span>
//               <span className="gtb-val">
//                 {fmtExact(feeBreakdown.maintenance_charge, sym)}
//               </span>
//             </div>
//           )}
//           {(feeBreakdown.custom_fee1 || 0) > 0 && (
//             <div className="gtb-row">
//               <span className="gtb-label">
//                 {feeBreakdown.fee_labels?.custom1 || "Custom Fee 1"}
//               </span>
//               <span className="gtb-val">
//                 {fmtExact(feeBreakdown.custom_fee1, sym)}
//               </span>
//             </div>
//           )}
//           {(feeBreakdown.custom_fee2 || 0) > 0 && (
//             <div className="gtb-row">
//               <span className="gtb-label">
//                 {feeBreakdown.fee_labels?.custom2 || "Custom Fee 2"}
//               </span>
//               <span className="gtb-val">
//                 {fmtExact(feeBreakdown.custom_fee2, sym)}
//               </span>
//             </div>
//           )}
//           {feeBreakdown.tax_amount > 0 && (
//             <div className="gtb-row" style={{ color: "#b45309" }}>
//               <span>
//                 {feeBreakdown.tax_label || "Tax"} ({feeBreakdown.tax_rate}%
//                 {feeBreakdown.tax_system
//                   ? ` · ${feeBreakdown.tax_system.toUpperCase()}`
//                   : ""}
//                 )
//               </span>
//               <span style={{ fontWeight: 700 }}>
//                 {fmtExact(feeBreakdown.tax_amount, sym)}
//               </span>
//             </div>
//           )}
//           <div
//             className="gtb-row"
//             style={{
//               borderTop: "1px solid #fde68a",
//               paddingTop: 5,
//               marginTop: 3,
//             }}
//           >
//             <span className="gtb-total-label">
//               Grand Total (incl. tax & fees)
//             </span>
//             <span className="gtb-total-val">
//               {fmtExact(feeBreakdown.total_amount, sym)}
//             </span>
//           </div>
//         </div>
//       )}

//       <div className="ms-card">
//         <div className="ms-header">
//           <div>
//             <div
//               style={{
//                 fontFamily: "var(--font-heading)",
//                 fontSize: 17,
//                 fontWeight: 700,
//                 color: "var(--text-dark)",
//               }}
//             >
//               {plan.name}
//             </div>
//             {plan.description && (
//               <div
//                 style={{
//                   fontSize: 13,
//                   color: "var(--text-muted)",
//                   marginTop: 2,
//                 }}
//               >
//                 {plan.description}
//               </div>
//             )}
//           </div>
//           {totalPct === 100 && (
//             <span
//               style={{
//                 padding: "3px 12px",
//                 borderRadius: 20,
//                 background: "#f0fdf4",
//                 border: "1px solid #bbf7d0",
//                 color: "#16a34a",
//                 fontSize: 12,
//                 fontWeight: 700,
//               }}
//             >
//               ✓ 100%
//             </span>
//           )}
//         </div>

//         {plan.milestones.map((m, i) => {
//           const c = TYPE_COLORS[m.type] || TYPE_COLORS.custom;
//           const icon = TYPE_ICONS[m.type] || "⭐";
//           const displayAmt = m.calculated_amount
//             ? fmtExact(m.calculated_amount, sym)
//             : m.percentage
//               ? calcAmtLabel(m.percentage)
//               : m.fixed_amount
//                 ? fmtExact(m.fixed_amount, sym)
//                 : null;

//           const milestoneTotals = calculateMilestoneTotal(m);
//           const msTaxData =
//             feeBreakdown && m.percentage
//               ? computeMilestoneAmounts(m.percentage, feeBreakdown)
//               : null;

//           return (
//             <div key={m.id || i} className="ms-row">
//               <div
//                 className="ms-num"
//                 style={{ borderColor: c.border, color: c.color }}
//               >
//                 {i + 1}
//               </div>
//               <div className="ms-body">
//                 <div
//                   className="ms-type-chip"
//                   style={{ background: c.bg, color: c.color }}
//                 >
//                   {icon} {m.type_label || m.type?.replace(/_/g, " ")}
//                 </div>
//                 <div className="ms-label">{m.label}</div>
//                 {(m.due_date || m.due_after_days) && (
//                   <div className="ms-due">
//                     📅{" "}
//                     {m.due_date
//                       ? `Due by ${m.due_date}`
//                       : `Due ${m.due_after_days} days after booking`}
//                   </div>
//                 )}
//                 {m.note && <div className="ms-note">{m.note}</div>}

//                 {feeBreakdown && m.percentage && (
//                   <div
//                     style={{
//                       marginTop: 6,
//                       padding: "8px 12px",
//                       background: "#fef9ee",
//                       border: "1px solid #fde68a",
//                       borderRadius: 6,
//                       fontSize: 12,
//                     }}
//                   >
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         marginBottom: 2,
//                       }}
//                     >
//                       <span style={{ color: "var(--text-muted)" }}>
//                         Base amount
//                       </span>
//                       <span>{fmtExact(milestoneTotals?.base || 0, sym)}</span>
//                     </div>
//                     {(milestoneTotals?.fees || 0) > 0 && (
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                           marginBottom: 2,
//                         }}
//                       >
//                         <span style={{ color: "var(--text-muted)" }}>Fees</span>
//                         <span>{fmtExact(milestoneTotals?.fees || 0, sym)}</span>
//                       </div>
//                     )}
//                     {(milestoneTotals?.tax || 0) > 0 && (
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                           marginBottom: 2,
//                           color: "#b45309",
//                         }}
//                       >
//                         <span>
//                           {feeBreakdown.tax_label || "Tax"} (
//                           {feeBreakdown.tax_rate}%)
//                         </span>
//                         <span style={{ fontWeight: 600 }}>
//                           {fmtExact(milestoneTotals?.tax || 0, sym)}
//                         </span>
//                       </div>
//                     )}
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         borderTop: "1px solid #fde68a",
//                         paddingTop: 4,
//                         marginTop: 4,
//                         fontWeight: 700,
//                         color: "var(--primary-color)",
//                       }}
//                     >
//                       <span>Total incl. tax & fees</span>
//                       <span>{fmtExact(milestoneTotals?.total || 0, sym)}</span>
//                     </div>
//                   </div>
//                 )}
//               </div>
//               <div className="ms-amounts">
//                 {m.percentage > 0 && (
//                   <div className="ms-pct">{m.percentage}%</div>
//                 )}
//                 {displayAmt && (
//                   <div
//                     className="ms-amt"
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "flex-end",
//                     }}
//                   >
//                     ≈ {displayAmt}
//                     {msTaxData && (msTaxData.tax > 0 || msTaxData.fees > 0) && (
//                       <TaxBreakdownBadge
//                         milestonePercent={m.percentage}
//                         feeBreakdown={feeBreakdown}
//                         sym={sym}
//                       />
//                     )}
//                   </div>
//                 )}
//                 {milestoneTotals && milestoneTotals.total > 0 && (
//                   <div
//                     style={{
//                       fontSize: 13,
//                       fontWeight: 700,
//                       color: "var(--primary-color)",
//                       marginTop: 2,
//                     }}
//                   >
//                     Total: {fmtExact(milestoneTotals.total, sym)}
//                   </div>
//                 )}
//               </div>
//             </div>
//           );
//         })}

//         <div className="ms-footer">
//           <span
//             style={{
//               fontSize: 13,
//               color: "var(--text-muted)",
//               fontWeight: 600,
//             }}
//           >
//             Total payment mapped
//           </span>
//           <div style={{ textAlign: "right" }}>
//             <span
//               style={{
//                 fontSize: 18,
//                 fontWeight: 800,
//                 color:
//                   totalPct === 100
//                     ? "#16a34a"
//                     : totalPct > 100
//                       ? "#dc2626"
//                       : "var(--primary-color)",
//               }}
//             >
//               {totalPct.toFixed(0)}%{totalPct === 100 ? " ✓" : ""}
//             </span>
//             {feeBreakdown?.total_amount > 0 && (
//               <div style={{ fontSize: 11, color: "#b45309", marginTop: 2 }}>
//                 Grand Total: {fmtExact(feeBreakdown.total_amount, sym)} (incl.
//                 all taxes &amp; fees)
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <div
//         style={{
//           textAlign: "center",
//           fontSize: 12,
//           color: "var(--text-muted)",
//           marginTop: 10,
//         }}
//       >
//         Amounts shown are estimates. Final figures confirmed at booking.
//       </div>
//     </div>
//   );
// };

// /* ═════════════════════════════════════════════════════════════
//    BOOKING STEP COMPONENTS
// ═════════════════════════════════════════════════════════════ */

// const BrokerInactiveScreen = ({ onClose }) => (
//   <div className="broker-inactive">
//     <div className="broker-inactive-icon">🔒</div>
//     <div className="broker-inactive-title">Account Inactive</div>
//     <p
//       style={{
//         color: "var(--text-muted)",
//         fontSize: 13,
//         lineHeight: 1.7,
//         marginBottom: 20,
//       }}
//     >
//       Your account is currently{" "}
//       <strong style={{ color: "#dc2626" }}>inactive</strong>. Please contact the
//       admin to activate your account.
//     </p>
//     <div
//       style={{
//         background: "#fff5f5",
//         border: "1.5px solid #fecaca",
//         borderRadius: 10,
//         padding: "12px 16px",
//         marginBottom: 20,
//         fontSize: 12,
//         color: "#dc2626",
//         textAlign: "left",
//       }}
//     >
//       <div style={{ fontWeight: 700, marginBottom: 4 }}>What to do next:</div>
//       <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.8 }}>
//         <li>Contact your project administrator</li>
//         <li>Ask them to activate your account</li>
//         <li>You can book once your status is active</li>
//       </ul>
//     </div>
//     <button
//       onClick={onClose}
//       className="book-btn"
//       style={{
//         background: "var(--page-bg)",
//         color: "var(--text-muted)",
//         border: "1.5px solid var(--card-border)",
//       }}
//     >
//       Close
//     </button>
//   </div>
// );

// const StepDetails = ({ user, onBook, onLogout, isAvail }) => (
//   <div>
//     {user ? (
//       <div className="logged-in-card">
//         <div>
//           <div className="logged-in-label">✓ Logged in as</div>
//           <div className="logged-in-name">{user.name}</div>
//           <div
//             style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 2 }}
//           >
//             {user.email}
//           </div>
//         </div>
//         <button className="logout-btn" onClick={onLogout}>
//           Logout
//         </button>
//       </div>
//     ) : (
//       <p
//         style={{
//           color: "var(--text-muted)",
//           fontSize: 13,
//           lineHeight: 1.6,
//           marginBottom: 16,
//         }}
//       >
//         To book this unit, please log in or create an account. Both email and
//         phone will be verified.
//       </p>
//     )}
//     {isAvail !== false && (
//       <button className="book-btn" onClick={onBook}>
//         {user ? "Continue to Booking →" : "Login / Register to Book →"}
//       </button>
//     )}
//   </div>
// );

// const StepLogin = ({ form, setForm, onLogin, onSwitch, loading, error }) => (
//   <div>
//     <div
//       style={{
//         color: "var(--text-dark)",
//         fontWeight: 700,
//         fontSize: 15,
//         marginBottom: 16,
//       }}
//     >
//       Login to your account
//     </div>
//     {error && <div className="error-box">⚠️ {error}</div>}
//     <input
//       className="sidebar-input"
//       type="email"
//       placeholder="Email address"
//       value={form.email}
//       onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
//     />
//     <input
//       className="sidebar-input"
//       type="password"
//       placeholder="Password"
//       value={form.password}
//       onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
//       onKeyDown={(e) => e.key === "Enter" && onLogin()}
//       style={{ marginBottom: 16 }}
//     />
//     <button
//       className="book-btn"
//       onClick={onLogin}
//       disabled={loading || !form.email || !form.password}
//     >
//       {loading ? "Logging in…" : "Login →"}
//     </button>
//     {onSwitch && (
//       <p
//         style={{
//           textAlign: "center",
//           marginTop: 14,
//           color: "var(--text-muted)",
//           fontSize: 13,
//         }}
//       >
//         Don't have an account?{" "}
//         <button className="auth-link" onClick={onSwitch}>
//           Register
//         </button>
//       </p>
//     )}
//   </div>
// );

// const StepRegister = ({
//   form,
//   setForm,
//   onRegister,
//   onSwitch,
//   loading,
//   error,
// }) => {
//   const [showPass, setShowPass] = useState(false);
//   const strength = !form.password
//     ? 0
//     : [
//         form.password.length >= 8,
//         /[A-Z]/.test(form.password),
//         /[0-9]/.test(form.password),
//         /[^A-Za-z0-9]/.test(form.password),
//       ].filter(Boolean).length;
//   const strengthColor = ["#ef4444", "#f59e0b", "#f59e0b", "#16a34a", "#16a34a"][
//     strength
//   ];
//   return (
//     <div>
//       <div
//         style={{
//           color: "var(--text-dark)",
//           fontWeight: 700,
//           fontSize: 15,
//           marginBottom: 4,
//         }}
//       >
//         Create an account
//       </div>
//       <div
//         style={{ color: "var(--text-muted)", fontSize: 12, marginBottom: 14 }}
//       >
//         We'll verify your email and phone number. A Company Admin will need to
//         approve your account before you can book on behalf of a client.
//       </div>
//       {error && <div className="error-box">⚠️ {error}</div>}
//       <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
//         {[
//           { v: "broker", label: "🤝 Broker" },
//           { v: "sales", label: "📈 Sales" },
//         ].map(({ v, label }) => (
//           <button
//             key={v}
//             type="button"
//             onClick={() => setForm((f) => ({ ...f, role: v }))}
//             style={{
//               flex: 1,
//               padding: 8,
//               borderRadius: 8,
//               cursor: "pointer",
//               fontSize: 13,
//               border: `1.5px solid ${form.role === v ? "var(--primary-color)" : "var(--card-border)"}`,
//               background: form.role === v ? "var(--page-bg)" : "transparent",
//               color:
//                 form.role === v ? "var(--primary-color)" : "var(--text-muted)",
//               fontWeight: form.role === v ? 700 : 400,
//               fontFamily: "var(--font-body)",
//             }}
//           >
//             {label}
//           </button>
//         ))}
//       </div>
//       <input
//         className="sidebar-input"
//         type="text"
//         placeholder="Full Name *"
//         value={form.name}
//         onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
//       />
//       {(form.role === "broker" || form.role === "sales") && (
//         <input
//           className="sidebar-input"
//           type="text"
//           placeholder={
//             form.role === "sales"
//               ? "Sales Team / Department (optional)"
//               : "Company / Agency Name"
//           }
//           value={form.broker_company}
//           onChange={(e) =>
//             setForm((f) => ({ ...f, broker_company: e.target.value }))
//           }
//         />
//       )}
//       <input
//         className="sidebar-input"
//         type="email"
//         placeholder="Email Address *"
//         value={form.email}
//         onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
//       />
//       <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
//         <CountryCodePicker
//           value={form.country_code}
//           onChange={(v) => setForm((f) => ({ ...f, country_code: v }))}
//         />
//         <input
//           style={{
//             flex: 1,
//             padding: "10px 12px",
//             background: "var(--page-bg)",
//             border: "1.5px solid var(--card-border)",
//             borderRadius: 8,
//             color: "var(--text-dark)",
//             fontSize: 13,
//             fontFamily: "var(--font-body)",
//             outline: "none",
//           }}
//           type="tel"
//           placeholder="Phone number *"
//           value={form.phone}
//           onChange={(e) =>
//             setForm((f) => ({ ...f, phone: e.target.value.replace(/\D/g, "") }))
//           }
//         />
//       </div>
//       <div style={{ position: "relative", marginBottom: 4 }}>
//         <input
//           style={{
//             width: "100%",
//             padding: "10px 40px 10px 12px",
//             background: "var(--page-bg)",
//             border: "1.5px solid var(--card-border)",
//             borderRadius: 8,
//             color: "var(--text-dark)",
//             fontSize: 13,
//             boxSizing: "border-box",
//             fontFamily: "var(--font-body)",
//             outline: "none",
//           }}
//           type={showPass ? "text" : "password"}
//           placeholder="Password (min 8 chars) *"
//           value={form.password}
//           onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
//         />
//         <button
//           type="button"
//           onClick={() => setShowPass((s) => !s)}
//           style={{
//             position: "absolute",
//             right: 10,
//             top: "50%",
//             transform: "translateY(-50%)",
//             background: "none",
//             border: "none",
//             color: "var(--text-muted)",
//             cursor: "pointer",
//             fontSize: 14,
//           }}
//         >
//           {showPass ? "🙈" : "👁"}
//         </button>
//       </div>
//       {form.password && (
//         <div style={{ marginBottom: 12 }}>
//           <div className="pw-strength">
//             {[1, 2, 3, 4].map((i) => (
//               <div
//                 key={i}
//                 className="pw-bar"
//                 style={{
//                   background:
//                     i <= strength ? strengthColor : "var(--card-border)",
//                 }}
//               />
//             ))}
//           </div>
//           <div style={{ fontSize: 11, color: strengthColor }}>
//             {["", "Weak", "Fair", "Good", "Strong"][strength]}
//           </div>
//         </div>
//       )}
//       <button
//         className="book-btn"
//         style={{ marginTop: 6 }}
//         onClick={onRegister}
//         disabled={
//           loading ||
//           !form.name ||
//           !form.email ||
//           !form.phone ||
//           !form.password ||
//           form.password.length < 8
//         }
//       >
//         {loading ? "Creating account…" : "Register & Verify →"}
//       </button>
//       <p
//         style={{
//           textAlign: "center",
//           marginTop: 14,
//           color: "var(--text-muted)",
//           fontSize: 13,
//         }}
//       >
//         Already have an account?{" "}
//         <button className="auth-link" onClick={onSwitch}>
//           Login
//         </button>
//       </p>
//     </div>
//   );
// };

// const StepOtp = ({ type, onVerify, onResend, loading, error, setError }) => {
//   const [otp, setOtp] = useState(["", "", "", "", "", ""]);
//   const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];
//   const isEmail = type === "email";
//   const handleKey = (i, e) => {
//     if (e.key === "Backspace") {
//       if (otp[i]) {
//         const n = [...otp];
//         n[i] = "";
//         setOtp(n);
//       } else if (i > 0) refs[i - 1].current?.focus();
//     }
//   };
//   const handleChange = (i, val) => {
//     const digit = val.replace(/\D/g, "").slice(-1),
//       n = [...otp];
//     n[i] = digit;
//     setOtp(n);
//     if (digit && i < 5) refs[i + 1].current?.focus();
//     if (digit && i === 5) {
//       const full = [...n].join("");
//       if (full.length === 6) {
//         setError("");
//         onVerify(full);
//       }
//     }
//   };
//   const handlePaste = (e) => {
//     const p = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
//     if (p.length === 6) {
//       setOtp(p.split(""));
//       refs[5].current?.focus();
//       setError("");
//       onVerify(p);
//     }
//   };
//   const fullOtp = otp.join("");
//   return (
//     <div>
//       <div style={{ textAlign: "center", marginBottom: 20 }}>
//         <div style={{ fontSize: 36, marginBottom: 8 }}>
//           {isEmail ? "📧" : "📱"}
//         </div>
//         <div
//           style={{ color: "var(--text-dark)", fontWeight: 700, fontSize: 15 }}
//         >
//           Verify your {isEmail ? "email" : "phone"}
//         </div>
//         <div style={{ color: "var(--text-muted)", fontSize: 12, marginTop: 6 }}>
//           Enter the 6-digit code sent to your {isEmail ? "email" : "phone"}.
//         </div>
//       </div>
//       {error && (
//         <div
//           style={{
//             padding: "8px 12px",
//             borderRadius: 8,
//             marginBottom: 12,
//             fontSize: 12,
//             background: error.startsWith("✓") ? "#f0fdf4" : "#fff5f5",
//             border: `1px solid ${error.startsWith("✓") ? "#bbf7d0" : "#fecaca"}`,
//             color: error.startsWith("✓") ? "#16a34a" : "#dc2626",
//           }}
//         >
//           {error}
//         </div>
//       )}
//       <div className="otp-grid" onPaste={handlePaste}>
//         {otp.map((digit, i) => (
//           <input
//             key={i}
//             ref={refs[i]}
//             type="text"
//             inputMode="numeric"
//             maxLength={1}
//             value={digit}
//             onChange={(e) => handleChange(i, e.target.value)}
//             onKeyDown={(e) => handleKey(i, e)}
//             className={`otp-cell${digit ? " filled" : ""}`}
//           />
//         ))}
//       </div>
//       <button
//         className="book-btn"
//         onClick={() => {
//           if (fullOtp.length === 6) onVerify(fullOtp);
//         }}
//         disabled={loading || fullOtp.length < 6}
//       >
//         {loading ? "Verifying…" : "Verify Code →"}
//       </button>
//       <div style={{ textAlign: "center", marginTop: 16 }}>
//         <span style={{ color: "var(--text-muted)", fontSize: 13 }}>
//           Didn't receive the code?{" "}
//         </span>
//         <button
//           className="auth-link"
//           onClick={() => {
//             setOtp(["", "", "", "", "", ""]);
//             onResend();
//           }}
//           disabled={loading}
//         >
//           Resend
//         </button>
//       </div>
//     </div>
//   );
// };

// const StepPlanSelect = ({
//   plans,
//   selected,
//   onSelect,
//   fmtPrice,
//   unitPrice,
//   onNext,
//   onBack,
//   existingBookingId,
//   feeBreakdown,
//   sym = "₹",
// }) => {
//   const [expanded, setExpanded] = useState(null);
//   const price = parseFloat(String(unitPrice || "0").replace(/,/g, "")) || 0;
//   const calcAmtLabel = (pct) =>
//     price > 0 ? fmtExact((price * parseFloat(pct)) / 100, sym) : null;

//   return (
//     <div>
//       <div
//         style={{
//           color: "var(--text-dark)",
//           fontWeight: 700,
//           fontSize: 15,
//           marginBottom: 4,
//         }}
//       >
//         Choose a Payment Plan
//       </div>
//       <div
//         style={{ color: "var(--text-muted)", fontSize: 12, marginBottom: 14 }}
//       >
//         Select how you'd like to pay for this unit
//       </div>

//       {feeBreakdown?.tax_enabled && feeBreakdown?.total_amount > 0 && (
//         <div className="grand-total-banner" style={{ marginBottom: 14 }}>
//           <div className="gtb-row">
//             <span className="gtb-label">Unit Price</span>
//             <span className="gtb-val">
//               {fmtExact(feeBreakdown.unit_price || price, sym)}
//             </span>
//           </div>
//           {feeBreakdown.tax_amount > 0 && (
//             <div className="gtb-row">
//               <span style={{ color: "#b45309" }}>
//                 {feeBreakdown.tax_label || "Tax"} ({feeBreakdown.tax_rate}%)
//               </span>
//               <span style={{ color: "#b45309", fontWeight: 700 }}>
//                 {fmtExact(feeBreakdown.tax_amount, sym)}
//               </span>
//             </div>
//           )}
//           <div
//             className="gtb-row"
//             style={{
//               borderTop: "1px solid #fde68a",
//               paddingTop: 5,
//               marginTop: 3,
//             }}
//           >
//             <span className="gtb-total-label">Grand Total</span>
//             <span className="gtb-total-val">
//               {fmtExact(feeBreakdown.total_amount, sym)}
//             </span>
//           </div>
//         </div>
//       )}

//       {/* Full payment option */}
//       <div
//         className={`plan-option${selected === null ? " selected" : ""}`}
//         onClick={() => onSelect(null)}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div>
//             <div
//               style={{
//                 color: "var(--text-dark)",
//                 fontWeight: 600,
//                 fontSize: 13,
//               }}
//             >
//               Full Payment
//             </div>
//             <div
//               style={{ color: "var(--text-muted)", fontSize: 11, marginTop: 2 }}
//             >
//               Pay{" "}
//               {feeBreakdown?.total_amount
//                 ? `${fmtExact(feeBreakdown.total_amount, sym)} (incl. taxes)`
//                 : "the full amount"}{" "}
//               upfront
//             </div>
//           </div>
//           <div
//             className={`plan-radio${selected === null ? " selected" : ""}`}
//           />
//         </div>
//       </div>

//       {plans.map((plan) => {
//         const isSelected = selected === plan.id,
//           isExpanded = expanded === plan.id;
//         const totalPct = plan.milestones.reduce(
//           (s, m) => s + (parseFloat(m.percentage) || 0),
//           0,
//         );
//         return (
//           <div key={plan.id} style={{ marginBottom: 8 }}>
//             <div
//               className={`plan-option${isSelected ? " selected" : ""}`}
//               style={{ borderRadius: isExpanded ? "8px 8px 0 0" : 8 }}
//               onClick={() => {
//                 onSelect(plan.id);
//                 setExpanded(isExpanded ? null : plan.id);
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "flex-start",
//                   justifyContent: "space-between",
//                   gap: 10,
//                 }}
//               >
//                 <div style={{ flex: 1, minWidth: 0 }}>
//                   <div
//                     style={{
//                       color: "var(--text-dark)",
//                       fontWeight: 700,
//                       fontSize: 13,
//                     }}
//                   >
//                     {plan.name}
//                   </div>
//                   {plan.description && (
//                     <div
//                       style={{
//                         color: "var(--text-muted)",
//                         fontSize: 11,
//                         marginTop: 2,
//                       }}
//                     >
//                       {plan.description}
//                     </div>
//                   )}
//                   {!isExpanded && (
//                     <div
//                       style={{
//                         marginTop: 6,
//                         display: "flex",
//                         flexWrap: "wrap",
//                         gap: 4,
//                       }}
//                     >
//                       {plan.milestones.slice(0, 2).map((m, i) => (
//                         <span
//                           key={i}
//                           style={{
//                             fontSize: 10,
//                             padding: "2px 8px",
//                             borderRadius: 8,
//                             background: "var(--page-bg)",
//                             color: "var(--primary-color)",
//                             fontWeight: 600,
//                             border: "1px solid var(--card-border)",
//                           }}
//                         >
//                           {m.label}
//                           {m.percentage ? ` · ${m.percentage}%` : ""}
//                         </span>
//                       ))}
//                       {plan.milestones.length > 2 && (
//                         <span
//                           style={{ fontSize: 10, color: "var(--text-muted)" }}
//                         >
//                           +{plan.milestones.length - 2} more
//                         </span>
//                       )}
//                     </div>
//                   )}
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "flex-end",
//                     gap: 6,
//                     flexShrink: 0,
//                   }}
//                 >
//                   <div
//                     className={`plan-radio${isSelected ? " selected" : ""}`}
//                   />
//                   <button
//                     type="button"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setExpanded(isExpanded ? null : plan.id);
//                     }}
//                     style={{
//                       background: "none",
//                       border: "none",
//                       color: "var(--text-muted)",
//                       fontSize: 11,
//                       cursor: "pointer",
//                       padding: 0,
//                       fontFamily: "var(--font-body)",
//                     }}
//                   >
//                     {isExpanded ? "▲ Less" : "▼ Details"}
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {isExpanded && (
//               <div
//                 style={{
//                   background: "var(--page-bg)",
//                   borderRadius: "0 0 8px 8px",
//                   border: "1.5px solid var(--primary-color)44",
//                   borderTop: "none",
//                 }}
//               >
//                 {plan.milestones.map((m, i) => {
//                   const c = TYPE_COLORS[m.type] || TYPE_COLORS.custom;
//                   const icon = TYPE_ICONS[m.type] || "⭐";
//                   const amt = m.calculated_amount
//                     ? fmtExact(m.calculated_amount, sym)
//                     : m.percentage
//                       ? calcAmtLabel(m.percentage)
//                       : null;
//                   return (
//                     <div
//                       key={i}
//                       style={{
//                         padding: "10px 14px",
//                         borderBottom:
//                           i < plan.milestones.length - 1
//                             ? "1px solid var(--card-border)"
//                             : "none",
//                       }}
//                     >
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "space-between",
//                           gap: 8,
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 8,
//                             flex: 1,
//                           }}
//                         >
//                           <span style={{ fontSize: 16 }}>{icon}</span>
//                           <div>
//                             <span
//                               style={{
//                                 fontSize: 10,
//                                 padding: "1px 7px",
//                                 borderRadius: 8,
//                                 background: c.bg,
//                                 color: c.color,
//                                 fontWeight: 700,
//                               }}
//                             >
//                               {m.type_label}
//                             </span>
//                             <span
//                               style={{
//                                 color: "var(--text-dark)",
//                                 fontSize: 12,
//                                 fontWeight: 600,
//                                 marginLeft: 6,
//                               }}
//                             >
//                               {m.label}
//                             </span>
//                           </div>
//                         </div>
//                         <div style={{ textAlign: "right" }}>
//                           {m.percentage > 0 && (
//                             <div
//                               style={{
//                                 color: "var(--primary-color)",
//                                 fontWeight: 800,
//                                 fontSize: 15,
//                               }}
//                             >
//                               {m.percentage}%
//                             </div>
//                           )}
//                           {amt && (
//                             <div
//                               style={{
//                                 color: "var(--text-muted)",
//                                 fontSize: 11,
//                               }}
//                             >
//                               ≈ {amt}
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                       {feeBreakdown && m.percentage && (
//                         <MilestoneTaxRow
//                           milestone={m}
//                           feeBreakdown={feeBreakdown}
//                         />
//                       )}
//                     </div>
//                   );
//                 })}
//                 <div
//                   style={{
//                     padding: "8px 14px",
//                     display: "flex",
//                     justifyContent: "space-between",
//                     borderTop: "1px solid var(--card-border)",
//                     background: "var(--card-bg)",
//                   }}
//                 >
//                   <span style={{ color: "var(--text-muted)", fontSize: 12 }}>
//                     Total
//                   </span>
//                   <div style={{ textAlign: "right" }}>
//                     <span
//                       style={{
//                         color:
//                           totalPct === 100 ? "#16a34a" : "var(--primary-color)",
//                         fontWeight: 700,
//                         fontSize: 13,
//                       }}
//                     >
//                       {totalPct.toFixed(0)}%{totalPct === 100 ? " ✓" : ""}
//                     </span>
//                     {feeBreakdown?.total_amount > 0 && (
//                       <div
//                         style={{ fontSize: 10, color: "#b45309", marginTop: 2 }}
//                       >
//                         = {fmtExact(feeBreakdown.total_amount, sym)} incl. taxes
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         );
//       })}

//       <button className="book-btn" onClick={onNext} style={{ marginTop: 12 }}>
//         {existingBookingId ? "Update Plan & Pay →" : "Continue →"}
//       </button>
//       <button
//         type="button"
//         onClick={onBack}
//         style={{
//           display: "block",
//           width: "100%",
//           marginTop: 8,
//           background: "none",
//           border: "1.5px solid var(--card-border)",
//           borderRadius: 8,
//           color: "var(--text-muted)",
//           padding: 10,
//           cursor: "pointer",
//           fontSize: 13,
//           fontFamily: "var(--font-body)",
//         }}
//       >
//         ← Back
//       </button>
//     </div>
//   );
// };

// const StepBookingForm = ({
//   user,
//   form,
//   setForm,
//   onSubmit,
//   loading,
//   error,
//   selectedPlan,
//   plans,
//   onBack,
//   unit,
//   existingBookingId,
//   feeBreakdown,
//   sym = "₹",
// }) => {
//   const plan = plans.find((p) => p.id === selectedPlan);
//   const isAgent = user?.role === "broker" || user?.role === "sales";
//   const price =
//     parseFloat(
//       (unit?.offer_price || unit?.actual_price || "")
//         .toString()
//         .replace(/[^0-9.]/g, ""),
//     ) || 0;
//   const commissionRate = parseFloat(user?.commission_rate || 2);
//   const commissionAmt =
//     price > 0 ? ((price * commissionRate) / 100).toFixed(2) : null;
//   const canSubmit = isAgent
//     ? form.name && form.phone && form.client_name && form.client_phone
//     : form.name && form.phone;

//   return (
//     <div>
//       <div
//         style={{
//           color: "var(--text-dark)",
//           fontWeight: 700,
//           fontSize: 15,
//           marginBottom: 4,
//         }}
//       >
//         {existingBookingId ? "Update Payment Plan" : "Confirm Booking"}
//       </div>
//       <div
//         style={{ color: "var(--text-muted)", fontSize: 12, marginBottom: 12 }}
//       >
//         {existingBookingId ? (
//           <span>
//             Updating plan for booking{" "}
//             <span style={{ color: "var(--primary-color)" }}>
//               #{existingBookingId}
//             </span>
//           </span>
//         ) : isAgent ? (
//           <>
//             Booking as {user?.role === "sales" ? "sales" : "broker"}{" "}
//             <span style={{ color: "var(--primary-color)" }}>{user?.name}</span>
//           </>
//         ) : (
//           <>
//             Booking as{" "}
//             <span style={{ color: "var(--primary-color)" }}>{user?.name}</span>
//           </>
//         )}
//       </div>

//       {plan && (
//         <div
//           style={{
//             background: "var(--page-bg)",
//             border: "1.5px solid var(--card-border)",
//             borderRadius: 8,
//             padding: "10px 12px",
//             marginBottom: 14,
//             fontSize: 12,
//           }}
//         >
//           <div
//             style={{
//               color: "var(--primary-color)",
//               fontWeight: 700,
//               marginBottom: 2,
//             }}
//           >
//             💳 {plan.name}
//           </div>
//           <div style={{ color: "var(--text-muted)" }}>
//             Selected payment plan
//           </div>
//           <button
//             type="button"
//             onClick={onBack}
//             style={{
//               background: "none",
//               border: "none",
//               color: "var(--text-muted)",
//               fontSize: 11,
//               padding: 0,
//               marginTop: 4,
//               cursor: "pointer",
//               textDecoration: "underline",
//               fontFamily: "var(--font-body)",
//             }}
//           >
//             Change plan
//           </button>
//         </div>
//       )}

//       <BookingSummaryTaxCard
//         feeBreakdown={feeBreakdown}
//         selectedPlan={selectedPlan}
//         plans={plans}
//         unit={unit}
//         sym={sym}
//       />

//       {error && <div className="error-box">⚠️ {error}</div>}

//       {isAgent ? (
//         <>
//           {commissionAmt && (
//             <div className="commission-box">
//               <div className="commission-label">Your Commission</div>
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                 }}
//               >
//                 <div className="commission-amt">
//                   {fmtExact(commissionAmt, sym)}
//                 </div>
//                 <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
//                   {commissionRate}% of price
//                 </div>
//               </div>
//             </div>
//           )}
//           <div
//             style={{
//               fontSize: 11,
//               color: "var(--text-muted)",
//               marginBottom: 8,
//               textTransform: "uppercase",
//               fontWeight: 600,
//               letterSpacing: "0.8px",
//             }}
//           >
//             Your Contact Info
//           </div>
//           <input
//             className="sidebar-input"
//             type="text"
//             placeholder="Your Name *"
//             value={form.name}
//             onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
//           />
//           <input
//             className="sidebar-input"
//             type="tel"
//             placeholder="Your Phone *"
//             value={form.phone}
//             onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
//           />
//           <div
//             style={{
//               fontSize: 11,
//               color: "var(--text-muted)",
//               marginBottom: 8,
//               marginTop: 8,
//               textTransform: "uppercase",
//               fontWeight: 600,
//               letterSpacing: "0.8px",
//             }}
//           >
//             Client Details
//           </div>
//           <input
//             className="sidebar-input"
//             type="text"
//             placeholder="Client Full Name *"
//             value={form.client_name}
//             onChange={(e) =>
//               setForm((f) => ({ ...f, client_name: e.target.value }))
//             }
//           />
//           <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
//             <CountryCodePicker
//               value={form.client_country_code}
//               onChange={(v) =>
//                 setForm((f) => ({ ...f, client_country_code: v }))
//               }
//             />
//             <input
//               style={{
//                 flex: 1,
//                 padding: "10px 12px",
//                 background: "var(--page-bg)",
//                 border: "1.5px solid var(--card-border)",
//                 borderRadius: 8,
//                 color: "var(--text-dark)",
//                 fontSize: 13,
//                 fontFamily: "var(--font-body)",
//                 outline: "none",
//               }}
//               type="tel"
//               placeholder="Client Phone *"
//               value={form.client_phone}
//               onChange={(e) =>
//                 setForm((f) => ({
//                   ...f,
//                   client_phone: e.target.value.replace(/\D/g, ""),
//                 }))
//               }
//             />
//           </div>
//           <input
//             className="sidebar-input"
//             type="email"
//             placeholder="Client Email (optional)"
//             value={form.client_email}
//             onChange={(e) =>
//               setForm((f) => ({ ...f, client_email: e.target.value }))
//             }
//           />
//           <textarea
//             className="sidebar-input"
//             placeholder="Notes (optional)"
//             rows={2}
//             value={form.notes}
//             onChange={(e) => setForm((f) => ({ ...f, notes: e.target.value }))}
//             style={{ resize: "none", marginBottom: 16 }}
//           />
//         </>
//       ) : (
//         <>
//           <input
//             className="sidebar-input"
//             type="text"
//             placeholder="Your Name *"
//             value={form.name}
//             onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
//           />
//           <input
//             className="sidebar-input"
//             type="tel"
//             placeholder="Phone Number *"
//             value={form.phone}
//             onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
//           />
//           <textarea
//             className="sidebar-input"
//             placeholder="Message / Notes (optional)"
//             rows={3}
//             value={form.notes}
//             onChange={(e) => setForm((f) => ({ ...f, notes: e.target.value }))}
//             style={{ resize: "none", marginBottom: 16 }}
//           />
//         </>
//       )}

//       <button
//         className="book-btn"
//         onClick={onSubmit}
//         disabled={loading || !canSubmit}
//       >
//         {loading
//           ? "Submitting…"
//           : existingBookingId
//             ? "✓ Update Plan & Proceed to Payment"
//             : isAgent
//               ? "✓ Submit Booking for Client"
//               : "✓ Confirm Booking"}
//       </button>
//       <button
//         type="button"
//         onClick={onBack}
//         style={{
//           display: "block",
//           width: "100%",
//           marginTop: 8,
//           background: "none",
//           border: "1.5px solid var(--card-border)",
//           borderRadius: 8,
//           color: "var(--text-muted)",
//           padding: 10,
//           cursor: "pointer",
//           fontSize: 13,
//           fontFamily: "var(--font-body)",
//         }}
//       >
//         ← Back
//       </button>
//     </div>
//   );
// };

// const BookingDone = ({ unit, onClose }) => (
//   <div className="booking-done">
//     <div className="booking-done-emoji">🎉</div>
//     <div className="booking-done-title">Booking Received!</div>
//     <div className="booking-done-text">
//       Your enquiry for Unit {unit.plot_number} has been submitted.
//       <br />
//       Our team will contact you shortly.
//     </div>
//     <button className="book-btn" onClick={onClose}>
//       Close
//     </button>
//   </div>
// );

// /* ═════════════════════════════════════════════════════════════
//    CountryCodePicker
// ═════════════════════════════════════════════════════════════ */
// const COUNTRY_CODES = [
//   { code: "+91", flag: "🇮🇳", name: "India" },
//   { code: "+971", flag: "🇦🇪", name: "UAE" },
//   { code: "+966", flag: "🇸🇦", name: "Saudi Arabia" },
//   { code: "+974", flag: "🇶🇦", name: "Qatar" },
//   { code: "+965", flag: "🇰🇼", name: "Kuwait" },
//   { code: "+973", flag: "🇧🇭", name: "Bahrain" },
//   { code: "+968", flag: "🇴🇲", name: "Oman" },
//   { code: "+1", flag: "🇺🇸", name: "USA / Canada" },
//   { code: "+44", flag: "🇬🇧", name: "UK" },
//   { code: "+61", flag: "🇦🇺", name: "Australia" },
//   { code: "+65", flag: "🇸🇬", name: "Singapore" },
//   { code: "+60", flag: "🇲🇾", name: "Malaysia" },
//   { code: "+86", flag: "🇨🇳", name: "China" },
//   { code: "+81", flag: "🇯🇵", name: "Japan" },
//   { code: "+49", flag: "🇩🇪", name: "Germany" },
//   { code: "+33", flag: "🇫🇷", name: "France" },
//   { code: "+39", flag: "🇮🇹", name: "Italy" },
//   { code: "+34", flag: "🇪🇸", name: "Spain" },
//   { code: "+7", flag: "🇷🇺", name: "Russia" },
//   { code: "+55", flag: "🇧🇷", name: "Brazil" },
//   { code: "+92", flag: "🇵🇰", name: "Pakistan" },
//   { code: "+880", flag: "🇧🇩", name: "Bangladesh" },
//   { code: "+94", flag: "🇱🇰", name: "Sri Lanka" },
//   { code: "+977", flag: "🇳🇵", name: "Nepal" },
//   { code: "+20", flag: "🇪🇬", name: "Egypt" },
//   { code: "+234", flag: "🇳🇬", name: "Nigeria" },
//   { code: "+27", flag: "🇿🇦", name: "South Africa" },
//   { code: "+254", flag: "🇰🇪", name: "Kenya" },
//   { code: "+62", flag: "🇮🇩", name: "Indonesia" },
//   { code: "+63", flag: "🇵🇭", name: "Philippines" },
//   { code: "+66", flag: "🇹🇭", name: "Thailand" },
//   { code: "+84", flag: "🇻🇳", name: "Vietnam" },
//   { code: "+82", flag: "🇰🇷", name: "South Korea" },
//   { code: "+90", flag: "🇹🇷", name: "Turkey" },
//   { code: "+98", flag: "🇮🇷", name: "Iran" },
//   { code: "+964", flag: "🇮🇶", name: "Iraq" },
//   { code: "+961", flag: "🇱🇧", name: "Lebanon" },
//   { code: "+962", flag: "🇯🇴", name: "Jordan" },
// ];

// const CountryCodePicker = ({ value, onChange }) => {
//   const [open, setOpen] = useState(false),
//     [search, setSearch] = useState("");
//   const selected =
//     COUNTRY_CODES.find((c) => c.code === value) || COUNTRY_CODES[0];
//   const filtered = search.trim()
//     ? COUNTRY_CODES.filter(
//         (c) =>
//           c.name.toLowerCase().includes(search.toLowerCase()) ||
//           c.code.includes(search),
//       )
//     : COUNTRY_CODES;
//   return (
//     <div style={{ position: "relative" }}>
//       <button
//         type="button"
//         onClick={() => {
//           setOpen((o) => !o);
//           setSearch("");
//         }}
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: 6,
//           padding: 10,
//           background: "var(--page-bg)",
//           border: "1.5px solid var(--card-border)",
//           borderRadius: 8,
//           color: "var(--text-dark)",
//           cursor: "pointer",
//           fontSize: 13,
//           whiteSpace: "nowrap",
//           minWidth: 82,
//           fontFamily: "var(--font-body)",
//         }}
//       >
//         <span style={{ fontSize: 16 }}>{selected.flag}</span>
//         <span>{selected.code}</span>
//         <span style={{ fontSize: 10, opacity: 0.5 }}>▼</span>
//       </button>
//       {open && (
//         <div
//           style={{
//             position: "absolute",
//             top: "calc(100% + 4px)",
//             left: 0,
//             zIndex: 999,
//             background: "var(--card-bg)",
//             border: "1px solid var(--card-border)",
//             borderRadius: 10,
//             overflow: "hidden",
//             minWidth: 220,
//             boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
//           }}
//         >
//           <div
//             style={{
//               padding: "8px 10px",
//               borderBottom: "1px solid var(--card-border)",
//             }}
//           >
//             <input
//               autoFocus
//               type="text"
//               placeholder="Search country…"
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               style={{
//                 width: "100%",
//                 padding: "7px 10px",
//                 background: "var(--page-bg)",
//                 border: "1px solid var(--card-border)",
//                 borderRadius: 6,
//                 color: "var(--text-dark)",
//                 fontSize: 12,
//                 outline: "none",
//                 boxSizing: "border-box",
//                 fontFamily: "var(--font-body)",
//               }}
//             />
//           </div>
//           <div style={{ maxHeight: 240, overflowY: "auto" }}>
//             {filtered.map((c) => (
//               <div
//                 key={c.code + c.name}
//                 onClick={() => {
//                   onChange(c.code);
//                   setOpen(false);
//                   setSearch("");
//                 }}
//                 style={{
//                   padding: "9px 14px",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 10,
//                   cursor: "pointer",
//                   fontSize: 13,
//                   background:
//                     c.code === value ? "var(--page-bg)" : "transparent",
//                   color:
//                     c.code === value
//                       ? "var(--primary-color)"
//                       : "var(--text-dark)",
//                   fontWeight: c.code === value ? 700 : 400,
//                 }}
//                 onMouseOver={(e) =>
//                   (e.currentTarget.style.background = "var(--page-bg)")
//                 }
//                 onMouseOut={(e) =>
//                   (e.currentTarget.style.background =
//                     c.code === value ? "var(--page-bg)" : "transparent")
//                 }
//               >
//                 <span style={{ fontSize: 16, flexShrink: 0 }}>{c.flag}</span>
//                 <span
//                   style={{
//                     flex: 1,
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   {c.name}
//                 </span>
//                 <span style={{ opacity: 0.45, fontSize: 12, flexShrink: 0 }}>
//                   {c.code}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UnitPage;


// import { useEffect, useRef, useState, useCallback } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";
// import { useWishlist } from "../hooks/useWishlist";
// import { useToast } from "../context/ToastContext";
// import { useSettings } from "../context/SettingsContext";
// import { apiJson } from "../api/apiClient";

// import { Viewer } from "@photo-sphere-viewer/core";
// import { MarkersPlugin } from "@photo-sphere-viewer/markers-plugin";
// import "@photo-sphere-viewer/core/index.css";
// import "@photo-sphere-viewer/markers-plugin/index.css";
// import "../styles/UnitPage.css";

// /* ═════════════════════════════════════════════════════════════
//    Reveal — wraps a section so it fades/slides in the first time it
//    scrolls into view (matches the reference site's scroll animation).
//    Pure CSS transition driven by IntersectionObserver; no layout
//    logic, so it's safe to drop around any block.
// ═════════════════════════════════════════════════════════════ */
// const Reveal = ({ children, delay = 0 }) => {
//   const ref = useRef(null);
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     const el = ref.current;
//     if (!el) return;
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setVisible(true);
//           observer.disconnect();
//         }
//       },
//       { threshold: 0.15 },
//     );
//     observer.observe(el);
//     return () => observer.disconnect();
//   }, []);

//   return (
//     <div
//       ref={ref}
//       className={`era-reveal${visible ? " era-reveal-visible" : ""}`}
//       style={{ transitionDelay: `${delay}ms` }}
//     >
//       {children}
//     </div>
//   );
// };

// const toRad = (deg) => parseFloat((deg * (Math.PI / 180)).toFixed(6));

// const AMENITY_ICONS = {
//   "Swimming Pool": "🏊",
//   Gym: "🏋️",
//   Parking: "🚗",
//   "24/7 Security": "🔒",
//   "Club House": "🏛️",
//   "Children Play Area": "🛝",
//   "Jogging Track": "🏃",
//   Garden: "🌿",
//   Lift: "🛗",
//   "Power Backup": "⚡",
//   "CCTV Surveillance": "📹",
//   Intercom: "📞",
//   "Visitor Parking": "🅿️",
//   Terrace: "🏙️",
// };
// const amenityIcon = (name) => AMENITY_ICONS[name] || "✨";
// const toFt = (m) => (m * 3.28084).toFixed(1);

// const fmtExact = (n, sym = "₹") => {
//   if (n == null || n === "") return "—";
//   return (
//     sym +
//     parseFloat(n).toLocaleString("en-IN", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     })
//   );
// };

// const fmtRound = (n, sym = "₹") => {
//   if (n == null || n === "") return "—";
//   return (
//     sym + parseFloat(n).toLocaleString("en-IN", { maximumFractionDigits: 0 })
//   );
// };

// const computeMilestoneAmounts = (milestonePercent, feeBreakdown) => {
//   if (!feeBreakdown || !milestonePercent) return null;
//   const pct = parseFloat(milestonePercent) / 100;

//   const unitPrice = feeBreakdown.unit_price || 0;
//   const base = unitPrice * pct;
//   const tax = (feeBreakdown.tax_amount || 0) * pct;

//   const proc = (feeBreakdown.processing_fee || 0) * pct;
//   const stamp = (feeBreakdown.stamp_duty || 0) * pct;
//   const reg = (feeBreakdown.registration_fee || 0) * pct;
//   const maint = (feeBreakdown.maintenance_charge || 0) * pct;
//   const cf1 = (feeBreakdown.custom_fee1 || 0) * pct;
//   const cf2 = (feeBreakdown.custom_fee2 || 0) * pct;

//   const fees = proc + stamp + reg + maint + cf1 + cf2;
//   const total = base + tax + fees;

//   return {
//     base,
//     tax,
//     fees,
//     total,
//     breakdown: { proc, stamp, reg, maint, cf1, cf2 },
//     labels: feeBreakdown.fee_labels || {},
//     taxLabel: feeBreakdown.tax_label || "Tax",
//     taxRate: feeBreakdown.tax_rate || 0,
//     taxSystem: feeBreakdown.tax_system || "",
//     currencySymbol: feeBreakdown.currency_symbol || "₹",
//   };
// };

// /* ─────────────────────────────────────────────────────────────
//    TaxBreakdownBadge
// ───────────────────────────────────────────────────────────── */
// const TaxBreakdownBadge = ({ milestonePercent, feeBreakdown, sym = "₹" }) => {
//   const [open, setOpen] = useState(false);
//   const data = computeMilestoneAmounts(milestonePercent, feeBreakdown);
//   if (!data || (!data.tax && !data.fees)) return null;
//   const f = (n) => fmtExact(n, sym);
//   const extraFees = [
//     data.breakdown.proc > 0 && {
//       label: data.labels.processing || "Processing Fee",
//       val: data.breakdown.proc,
//     },
//     data.breakdown.stamp > 0 && {
//       label: data.labels.stamp_duty || "Stamp Duty",
//       val: data.breakdown.stamp,
//     },
//     data.breakdown.reg > 0 && {
//       label: data.labels.registration || "Registration Fee",
//       val: data.breakdown.reg,
//     },
//     data.breakdown.maint > 0 && {
//       label: data.labels.maintenance || "Maintenance",
//       val: data.breakdown.maint,
//     },
//     data.breakdown.cf1 > 0 && {
//       label: data.labels.custom1 || "Custom Fee 1",
//       val: data.breakdown.cf1,
//     },
//     data.breakdown.cf2 > 0 && {
//       label: data.labels.custom2 || "Custom Fee 2",
//       val: data.breakdown.cf2,
//     },
//   ].filter(Boolean);

//   return (
//     <span style={{ position: "relative", display: "inline-block" }}>
//       <button
//         type="button"
//         className="tax-badge-btn"
//         onClick={(e) => {
//           e.stopPropagation();
//           setOpen((o) => !o);
//         }}
//       >
//         +tax
//       </button>
//       {open && (
//         <div className="tax-popover" onClick={(e) => e.stopPropagation()}>
//           <div className="tax-popover-title">Charges for this instalment</div>
//           <div className="tax-row">
//             <span>Unit price portion</span>
//             <span>{f(data.base)}</span>
//           </div>
//           {extraFees.map((fee, i) => (
//             <div key={i} className="tax-row">
//               <span>{fee.label}</span>
//               <span>{f(fee.val)}</span>
//             </div>
//           ))}
//           {data.tax > 0 && (
//             <div className="tax-row highlight">
//               <span>
//                 {data.taxLabel}
//                 {data.taxRate > 0 && (
//                   <span style={{ opacity: 0.7, marginLeft: 4 }}>
//                     ({data.taxRate}%
//                     {data.taxSystem ? ` · ${data.taxSystem.toUpperCase()}` : ""}
//                     )
//                   </span>
//                 )}
//               </span>
//               <span>{f(data.tax)}</span>
//             </div>
//           )}
//           <div className="tax-row total">
//             <span>Instalment total</span>
//             <span>{f(data.total)}</span>
//           </div>
//           <button
//             type="button"
//             onClick={(e) => {
//               e.stopPropagation();
//               setOpen(false);
//             }}
//             style={{
//               position: "absolute",
//               top: 6,
//               right: 8,
//               background: "none",
//               border: "none",
//               color: "var(--text-muted)",
//               cursor: "pointer",
//               fontSize: 14,
//             }}
//           >
//             ×
//           </button>
//         </div>
//       )}
//     </span>
//   );
// };

// /* ─────────────────────────────────────────────────────────────
//    MilestoneTaxRow
// ───────────────────────────────────────────────────────────── */
// const MilestoneTaxRow = ({ milestone, feeBreakdown }) => {
//   if (!feeBreakdown || !milestone.percentage) return null;
//   const data = computeMilestoneAmounts(milestone.percentage, feeBreakdown);
//   if (!data || (!data.tax && !data.fees)) return null;
//   const sym = data.currencySymbol;
//   const f = (n) => fmtExact(n, sym);
//   const extraFees = [
//     data.breakdown.proc > 0 && {
//       label: data.labels.processing || "Processing Fee",
//       val: data.breakdown.proc,
//     },
//     data.breakdown.stamp > 0 && {
//       label: data.labels.stamp_duty || "Stamp Duty",
//       val: data.breakdown.stamp,
//     },
//     data.breakdown.reg > 0 && {
//       label: data.labels.registration || "Registration Fee",
//       val: data.breakdown.reg,
//     },
//     data.breakdown.maint > 0 && {
//       label: data.labels.maintenance || "Maintenance",
//       val: data.breakdown.maint,
//     },
//     data.breakdown.cf1 > 0 && {
//       label: data.labels.custom1 || "Custom Fee 1",
//       val: data.breakdown.cf1,
//     },
//     data.breakdown.cf2 > 0 && {
//       label: data.labels.custom2 || "Custom Fee 2",
//       val: data.breakdown.cf2,
//     },
//   ].filter(Boolean);

//   return (
//     <div
//       style={{
//         background: "#fef9ee",
//         border: "1px solid #fde68a",
//         borderRadius: 8,
//         padding: "10px 12px",
//         marginTop: 6,
//       }}
//     >
//       <div
//         style={{
//           fontSize: 10,
//           fontWeight: 700,
//           color: "#b45309",
//           textTransform: "uppercase",
//           letterSpacing: "0.5px",
//           marginBottom: 7,
//         }}
//       >
//         Tax &amp; fees for this instalment
//       </div>
//       <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
//         <div className="tax-row">
//           <span>Base ({milestone.percentage}% of unit price)</span>
//           <span>{f(data.base)}</span>
//         </div>
//         {extraFees.map((fee, i) => (
//           <div key={i} className="tax-row">
//             <span>{fee.label}</span>
//             <span>{f(fee.val)}</span>
//           </div>
//         ))}
//         {data.tax > 0 && (
//           <div className="tax-row highlight">
//             <span>
//               {data.taxLabel}
//               {data.taxRate > 0 ? ` (${data.taxRate}%)` : ""}
//             </span>
//             <span>{f(data.tax)}</span>
//           </div>
//         )}
//         <div className="tax-row total">
//           <span>Instalment total</span>
//           <span>{f(data.total)}</span>
//         </div>
//       </div>
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────────────────────
//    BookingSummaryTaxCard
// ───────────────────────────────────────────────────────────── */
// const BookingSummaryTaxCard = ({
//   feeBreakdown,
//   selectedPlan,
//   plans,
//   unit,
//   sym = "₹",
// }) => {
//   if (
//     !feeBreakdown?.tax_enabled &&
//     !feeBreakdown?.processing_fee &&
//     !feeBreakdown?.stamp_duty
//   )
//     return null;
//   const f = (n) => fmtExact(n, sym);
//   const labels = feeBreakdown.fee_labels || {};
//   const extraFees = [
//     feeBreakdown.processing_fee > 0 && {
//       label: labels.processing || "Processing Fee",
//       val: feeBreakdown.processing_fee,
//     },
//     feeBreakdown.stamp_duty > 0 && {
//       label: labels.stamp_duty || "Stamp Duty",
//       val: feeBreakdown.stamp_duty,
//     },
//     feeBreakdown.registration_fee > 0 && {
//       label: labels.registration || "Registration Fee",
//       val: feeBreakdown.registration_fee,
//     },
//     feeBreakdown.maintenance_charge > 0 && {
//       label: labels.maintenance || "Maintenance",
//       val: feeBreakdown.maintenance_charge,
//     },
//     feeBreakdown.custom_fee1 > 0 && {
//       label: labels.custom1 || "Custom Fee 1",
//       val: feeBreakdown.custom_fee1,
//     },
//     feeBreakdown.custom_fee2 > 0 && {
//       label: labels.custom2 || "Custom Fee 2",
//       val: feeBreakdown.custom_fee2,
//     },
//   ].filter(Boolean);

//   const plan = plans.find((p) => p.id === selectedPlan);
//   const firstMs = plan?.milestones?.[0];
//   const firstPct = firstMs?.percentage
//     ? parseFloat(firstMs.percentage) / 100
//     : 1;
//   const dueNow = feeBreakdown.total_amount * (plan ? firstPct : 1);

//   return (
//     <div className="grand-total-banner" style={{ marginBottom: 16 }}>
//       <div
//         style={{
//           fontSize: 11,
//           fontWeight: 700,
//           color: "#92400e",
//           textTransform: "uppercase",
//           letterSpacing: "0.5px",
//           marginBottom: 10,
//         }}
//       >
//         📄 Payment Breakdown
//       </div>
//       <div className="gtb-row">
//         <span className="gtb-label">Unit Price</span>
//         <span className="gtb-val">{f(feeBreakdown.unit_price)}</span>
//       </div>
//       {extraFees.map((fee, i) => (
//         <div key={i} className="gtb-row">
//           <span className="gtb-label">{fee.label}</span>
//           <span className="gtb-val">{f(fee.val)}</span>
//         </div>
//       ))}
//       {feeBreakdown.tax_amount > 0 && (
//         <div
//           className="gtb-row"
//           style={{
//             color: "#b45309",
//             fontWeight: 600,
//             borderTop: "1px solid #fde68a",
//             paddingTop: 6,
//             marginTop: 4,
//           }}
//         >
//           <span>
//             {feeBreakdown.tax_label || "Tax"}
//             {feeBreakdown.tax_rate > 0 && (
//               <span style={{ fontSize: 10, marginLeft: 5, opacity: 0.8 }}>
//                 ({feeBreakdown.tax_rate}%
//                 {feeBreakdown.tax_system
//                   ? ` · ${feeBreakdown.tax_system.toUpperCase()}`
//                   : ""}
//                 {feeBreakdown.tax_inclusive ? " · Incl." : ""})
//               </span>
//             )}
//           </span>
//           <span>{f(feeBreakdown.tax_amount)}</span>
//         </div>
//       )}
//       <div
//         className="gtb-row"
//         style={{
//           borderTop: "1.5px solid #fcd34d",
//           paddingTop: 8,
//           marginTop: 4,
//         }}
//       >
//         <span className="gtb-total-label">Grand Total</span>
//         <span className="gtb-total-val">{f(feeBreakdown.total_amount)}</span>
//       </div>
//       {plan && firstMs && (
//         <div className="due-now-box">
//           <div className="due-now-label">
//             Due Now — {firstMs.label} ({firstMs.percentage}%)
//           </div>
//           <div className="due-now-val">{f(dueNow)}</div>
//           <div className="due-now-note">
//             Includes proportional taxes &amp; fees
//           </div>
//         </div>
//       )}
//       <div
//         style={{
//           fontSize: 10,
//           color: "var(--text-muted)",
//           marginTop: 8,
//           textAlign: "center",
//         }}
//       >
//         Amounts are estimates. Final figures confirmed at booking.
//       </div>
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────────────────────
//    TYPE_COLORS / ICONS (payment milestone types)
// ───────────────────────────────────────────────────────────── */
// const TYPE_COLORS = {
//   down_payment: { bg: "#eff6ff", color: "#1d4ed8", border: "#bfdbfe" },
//   installment: { bg: "#faf5ff", color: "#7e22ce", border: "#e9d5ff" },
//   on_completion: { bg: "#f0fdf4", color: "#15803d", border: "#bbf7d0" },
//   on_handover: { bg: "#fff7ed", color: "#c2410c", border: "#fed7aa" },
//   rental_guarantee: { bg: "#fff1f2", color: "#be123c", border: "#fecdd3" },
//   custom: { bg: "#f9fafb", color: "#374151", border: "#e5e7eb" },
// };
// const TYPE_ICONS = {
//   down_payment: "💰",
//   installment: "🔄",
//   on_completion: "🏗️",
//   on_handover: "🔑",
//   rental_guarantee: "📈",
//   custom: "⭐",
// };

// /* ═════════════════════════════════════════════════════════════
//    ERA-STYLE GALLERY — large stacked hero photos + 3-up thumbs
// ═════════════════════════════════════════════════════════════ */
// const EraGallery = ({
//   gallery,
//   hasPano,
//   plotId,
//   tenant,
//   navigate,
//   galIdx,
//   setGalIdx,
//   onOpenPano,
// }) => {
//   if (!gallery.length && !hasPano) return null;
//   const total = gallery.length;

//   return (
//     <div className="era-gallery">
//       <div
//         className="era-gallery-main"
//         onClick={() =>
//           total > 0 && navigate(`/${tenant}/unit/${plotId}/gallery/${galIdx}`)
//         }
//       >
//         {total > 0 ? (
//           <img src={gallery[galIdx]} alt={`View ${galIdx + 1}`} />
//         ) : (
//           <div
//             style={{
//               width: "100%",
//               height: "100%",
//               background: "var(--page-bg)",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               color: "var(--text-muted)",
//               fontSize: 40,
//             }}
//           >
//             🏠
//           </div>
//         )}

//         <div className="era-gallery-badges">
//           {hasPano && (
//             <button
//               className="era-gallery-badge"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 onOpenPano();
//               }}
//             >
//               360° View
//             </button>
//           )}
//         </div>

//         {total > 1 && (
//           <>
//             <button
//               className="era-gallery-nav prev"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 setGalIdx((i) => (i - 1 + total) % total);
//               }}
//             >
//               ‹
//             </button>
//             <button
//               className="era-gallery-nav next"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 setGalIdx((i) => (i + 1) % total);
//               }}
//             >
//               ›
//             </button>
//             <div className="era-gallery-counter">
//               {galIdx + 1} / {total}
//             </div>
//           </>
//         )}
//       </div>

//       {total > 1 && (
//         <div className="era-gallery-thumbs">
//           {gallery.slice(0, 3).map((img, i) => (
//             <img
//               key={i}
//               src={img}
//               alt=""
//               className={i === galIdx ? "active" : ""}
//               onClick={() => setGalIdx(i)}
//             />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// /* ═════════════════════════════════════════════════════════════
//    ERA-STYLE UNIT DETAILS — hero, stats, gallery, info/benefits,
//    payment plans (inline, not a tab), amenity showcases — all one
//    continuous scroll, matching the reference site's flow.
// ═════════════════════════════════════════════════════════════ */
// const EraUnitDetails = ({
//   unit,
//   fmtPrice,
//   statusColor,
//   currency,
//   sym,
//   feeBreakdown,
//   getFullImageUrl,
//   gallery,
//   hasPano,
//   plotId,
//   tenant,
//   navigate,
//   galIdx,
//   setGalIdx,
//   onOpenPano,
//   PaymentPlansContent,
// }) => {
//   const [infoTab, setInfoTab] = useState("info"); // "info" | "benefits"
//   const hasDims = unit.room_dimensions?.length > 0;
//   const hasAmenities = unit.amenities?.length > 0;
//   const hasAreaData =
//     unit.internal_area_sqft || unit.internal_area_sqm || unit.external_area_sqft;

//   return (
//     <>
//       {/* ── Hero — "No. XXX" ── */}
//       <Reveal>
//         <div className="era-hero">
//           <div className="era-hero-eyebrow">
//             {unit.status}
//             {unit.project_name ? ` · ${unit.project_name}` : ""}
//           </div>
//           <h1 className="era-hero-title">No. {unit.plot_number}</h1>
//           <div className="era-hero-meta">
//             {unit.block && (
//               <div className="era-hero-meta-item">
//                 Block <strong>{unit.block}</strong>
//               </div>
//             )}
//             <div className="era-hero-meta-item">
//               Type <strong>{unit.plot_type}</strong>
//             </div>
//             {unit.direction && (
//               <div className="era-hero-meta-item">
//                 Facing <strong>{unit.direction}</strong>
//               </div>
//             )}
//           </div>
//         </div>
//       </Reveal>

//       {/* ── Stat row — big borderless numbers ── */}
//       <Reveal delay={80}>
//         <div className="era-stats-row">
//           {unit.bedrooms != null && (
//             <div className="era-stat">
//               <div className="era-stat-label">Bedrooms</div>
//               <div className="era-stat-value">{unit.bedrooms}</div>
//             </div>
//           )}
//           {unit.bathrooms != null && (
//             <div className="era-stat">
//               <div className="era-stat-label">Bathrooms</div>
//               <div className="era-stat-value">{unit.bathrooms}</div>
//             </div>
//           )}
//           {(unit.internal_area_sqft || unit.plot_size) && (
//             <div className="era-stat">
//               <div className="era-stat-label">Interior Area</div>
//               <div className="era-stat-value">
//                 {unit.internal_area_sqft || unit.plot_size}
//                 <small>sqft</small>
//               </div>
//             </div>
//           )}
//           {unit.external_area_sqft && (
//             <div className="era-stat">
//               <div className="era-stat-label">Terrace</div>
//               <div className="era-stat-value">
//                 {unit.external_area_sqft}
//                 <small>sqft</small>
//               </div>
//             </div>
//           )}
//         </div>
//       </Reveal>

//       {/* ── Gallery ── */}
//       <Reveal delay={140}>
//         <EraGallery
//           gallery={gallery}
//           hasPano={hasPano}
//           plotId={plotId}
//           tenant={tenant}
//           navigate={navigate}
//           galIdx={galIdx}
//           setGalIdx={setGalIdx}
//           onOpenPano={onOpenPano}
//         />
//       </Reveal>

//       {/* ── Info / Benefits tabs ── */}
//       <Reveal>
//         <div className="era-content-tabs">
//           <button
//             className={`era-content-tab${infoTab === "info" ? " active" : ""}`}
//             onClick={() => setInfoTab("info")}
//           >
//             Info
//           </button>
//           {(hasAmenities || unit.description) && (
//             <button
//               className={`era-content-tab${infoTab === "benefits" ? " active" : ""}`}
//               onClick={() => setInfoTab("benefits")}
//             >
//               Benefits
//             </button>
//           )}
//         </div>

//         {infoTab === "info" && (
//           <>
//             {/* Facts */}
//             <div className="era-facts">
//               <div className="era-facts-grid">
//                 {[
//                   ["Unit No", unit.plot_number],
//                   ["Type", unit.plot_type],
//                   ["Size", unit.plot_size ? `${unit.plot_size} sqft` : "—"],
//                   ["Direction", unit.direction || "—"],
//                   ["Project", unit.project_name || "—"],
//                   ["Floor", unit.block || "—"],
//                   ["Rooms", unit.rooms?.length || "—"],
//                   ["Status", unit.status],
//                 ].map(([lbl, val]) => (
//                   <div key={lbl} className="era-fact">
//                     <div className="era-fact-label">{lbl}</div>
//                     <div className="era-fact-value">{val}</div>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* Area breakdown, reusing the stat-row visual language */}
//             {hasAreaData && (
//               <div className="era-stats-row" style={{ marginTop: -24 }}>
//                 {unit.internal_area_sqft && (
//                   <div className="era-stat">
//                     <div className="era-stat-label">Internal Area</div>
//                     <div className="era-stat-value">
//                       {Number(unit.internal_area_sqft).toLocaleString()}
//                       <small>sqft</small>
//                     </div>
//                   </div>
//                 )}
//                 {unit.external_area_sqft && (
//                   <div className="era-stat">
//                     <div className="era-stat-label">External Area</div>
//                     <div className="era-stat-value">
//                       {Number(unit.external_area_sqft).toLocaleString()}
//                       <small>sqft</small>
//                     </div>
//                   </div>
//                 )}
//                 {unit.internal_area_sqft && unit.external_area_sqft && (
//                   <div className="era-stat">
//                     <div className="era-stat-label">Total Area</div>
//                     <div className="era-stat-value">
//                       {(
//                         parseFloat(unit.internal_area_sqft) +
//                         parseFloat(unit.external_area_sqft)
//                       ).toFixed(0)}
//                       <small>sqft</small>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             )}

//             {/* Room dimensions */}
//             {hasDims && (
//               <div className="era-dims">
//                 <div className="era-floor-plan-section-label">Room Dimensions</div>
//                 {unit.room_dimensions.map((dim, i) => {
//                   const u = dim.unit || "m",
//                     w = parseFloat(dim.width),
//                     l = parseFloat(dim.length);
//                   const wM = u === "ft" ? (w / 3.28084).toFixed(1) : w.toFixed(1);
//                   const lM = u === "ft" ? (l / 3.28084).toFixed(1) : l.toFixed(1);
//                   const wFt = u === "m" ? (w * 3.28084).toFixed(1) : w.toFixed(1);
//                   const lFt = u === "m" ? (l * 3.28084).toFixed(1) : l.toFixed(1);
//                   return (
//                     <div key={i} className="era-dim-row">
//                       <div className="era-dim-name">{dim.label}</div>
//                       <div className="era-dim-vals">
//                         <span className="era-dim-primary">
//                           {wM} × {lM} m
//                         </span>
//                         <span className="era-dim-secondary">
//                           {wFt}' × {lFt}'
//                         </span>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             )}

//             {/* Floor plan */}
//             {unit.floor_plan_image && (
//               <div className="era-floor-plan">
//                 <div className="era-floor-plan-section-label">Floor Plan</div>
//                 <img src={getFullImageUrl(unit.floor_plan_image)} alt="Floor Plan" />
//               </div>
//             )}
//           </>
//         )}

//         {infoTab === "benefits" && (
//           <div className="era-benefits">
//             {unit.description && (
//               <div className="era-benefits-text">{unit.description}</div>
//             )}
//             {hasAmenities && (
//               <div className="era-tags">
//                 {unit.amenities.map((a, i) => (
//                   <span key={i} className="era-tag">
//                     {a}
//                   </span>
//                 ))}
//               </div>
//             )}
//           </div>
//         )}
//       </Reveal>

//       {/* ── Payment Plans — inline, part of the same continuous scroll ──
//            No longer a separate header tab. Only rendered when the unit
//            actually has plans; otherwise this section is skipped entirely
//            and the page flows straight from Info/Benefits to amenities. */}
//       {unit.payment_plans?.length > 0 && PaymentPlansContent && (
//         <Reveal>
//           <div className="era-payment-section">
//             <div className="era-content-tabs" style={{ borderBottom: "1px solid var(--card-border)" }}>
//               <div className="era-content-tab active" style={{ cursor: "default" }}>
//                 Payment Plans
//               </div>
//             </div>
//             <div style={{ padding: "0 56px 44px" }}>
//               <PaymentPlansContent
//                 plans={unit.payment_plans || []}
//                 fmtPrice={fmtPrice}
//                 currency={currency}
//                 unitPrice={unit.offer_price || unit.actual_price}
//                 feeBreakdown={feeBreakdown}
//                 sym={sym}
//               />
//             </div>
//           </div>
//         </Reveal>
//       )}

//       {/* ── Full-bleed amenity showcase sections ──
//            Only rendered for amenities that have a dedicated image
//            (unit.amenity_showcases, if your API provides one) — falls
//            back to nothing if you don't have per-amenity imagery yet. */}
//       {unit.amenity_showcases?.map((a, i) => (
//         <Reveal key={i}>
//           <div className="era-amenities-section">
//             {i % 2 === 0 ? (
//               <>
//                 <img
//                   className="era-amenity-image"
//                   src={getFullImageUrl(a.image)}
//                   alt={a.title}
//                 />
//                 <div>
//                   <div className="era-amenity-title">{a.title}</div>
//                   <div className="era-amenity-desc">{a.description}</div>
//                 </div>
//               </>
//             ) : (
//               <>
//                 <div>
//                   <div className="era-amenity-title">{a.title}</div>
//                   <div className="era-amenity-desc">{a.description}</div>
//                 </div>
//                 <img
//                   className="era-amenity-image"
//                   src={getFullImageUrl(a.image)}
//                   alt={a.title}
//                 />
//               </>
//             )}
//           </div>
//         </Reveal>
//       ))}
//     </>
//   );
// };

// /* ═════════════════════════════════════════════════════════════
//    PaymentPlansContent - with proper tax display
//    (Unchanged logic — now rendered inline by EraUnitDetails instead
//    of behind a separate header tab.)
// ═════════════════════════════════════════════════════════════ */
// const PaymentPlansContent = ({
//   plans,
//   fmtPrice,
//   currency,
//   unitPrice,
//   feeBreakdown,
//   sym = "₹",
// }) => {
//   const [activePlan, setActivePlan] = useState(0);
//   if (!plans?.length)
//     return (
//       <div className="up-section">
//         <div
//           className="up-section-body"
//           style={{ textAlign: "center", padding: "40px 20px" }}
//         >
//           <div style={{ fontSize: 40, marginBottom: 12 }}>💳</div>
//           <div
//             style={{
//               fontSize: 15,
//               fontWeight: 600,
//               color: "var(--text-muted)",
//             }}
//           >
//             No payment plans available
//           </div>
//         </div>
//       </div>
//     );

//   const basePrice =
//     parseFloat(String(unitPrice || "0").replace(/[^0-9.]/g, "")) || 0;
//   const calcAmtLabel = (pct) =>
//     basePrice > 0 ? fmtExact((basePrice * parseFloat(pct)) / 100, sym) : null;
//   const plan = plans[activePlan];
//   const totalPct = plan.milestones.reduce(
//     (s, m) => s + (parseFloat(m.percentage) || 0),
//     0,
//   );

//   const calculateMilestoneTotal = (milestone) => {
//     if (!feeBreakdown || !milestone.percentage) {
//       return null;
//     }
//     const pct = parseFloat(milestone.percentage) / 100;
//     const base = (feeBreakdown.unit_price || basePrice) * pct;
//     const tax = (feeBreakdown.tax_amount || 0) * pct;
//     const fees =
//       ((feeBreakdown.processing_fee || 0) +
//         (feeBreakdown.stamp_duty || 0) +
//         (feeBreakdown.registration_fee || 0) +
//         (feeBreakdown.maintenance_charge || 0) +
//         (feeBreakdown.custom_fee1 || 0) +
//         (feeBreakdown.custom_fee2 || 0)) *
//       pct;
//     return {
//       base,
//       tax,
//       fees,
//       total: base + tax + fees,
//     };
//   };

//   return (
//     <div className="up-plans-wrap">
//       {plans.length > 1 && (
//         <div className="up-plan-tabs">
//           {plans.map((p, i) => (
//             <button
//               key={p.id}
//               className={`up-plan-tab${i === activePlan ? " active" : ""}`}
//               onClick={() => setActivePlan(i)}
//             >
//               {p.name}
//             </button>
//           ))}
//         </div>
//       )}

//       {/* Grand total banner */}
//       {feeBreakdown?.tax_enabled && feeBreakdown?.total_amount > 0 && (
//         <div className="grand-total-banner" style={{ marginBottom: 16 }}>
//           <div className="gtb-row">
//             <span className="gtb-label">Unit {fmtExact(basePrice, sym)}</span>
//             <span className="gtb-val">
//               {fmtExact(feeBreakdown.unit_price || basePrice, sym)}
//             </span>
//           </div>
//           {(feeBreakdown.processing_fee || 0) > 0 && (
//             <div className="gtb-row">
//               <span className="gtb-label">
//                 {feeBreakdown.fee_labels?.processing || "Processing Fee"}
//               </span>
//               <span className="gtb-val">
//                 {fmtExact(feeBreakdown.processing_fee, sym)}
//               </span>
//             </div>
//           )}
//           {(feeBreakdown.stamp_duty || 0) > 0 && (
//             <div className="gtb-row">
//               <span className="gtb-label">
//                 {feeBreakdown.fee_labels?.stamp_duty || "Stamp Duty"}
//               </span>
//               <span className="gtb-val">
//                 {fmtExact(feeBreakdown.stamp_duty, sym)}
//               </span>
//             </div>
//           )}
//           {(feeBreakdown.registration_fee || 0) > 0 && (
//             <div className="gtb-row">
//               <span className="gtb-label">
//                 {feeBreakdown.fee_labels?.registration || "Registration Fee"}
//               </span>
//               <span className="gtb-val">
//                 {fmtExact(feeBreakdown.registration_fee, sym)}
//               </span>
//             </div>
//           )}
//           {(feeBreakdown.maintenance_charge || 0) > 0 && (
//             <div className="gtb-row">
//               <span className="gtb-label">
//                 {feeBreakdown.fee_labels?.maintenance || "Maintenance"}
//               </span>
//               <span className="gtb-val">
//                 {fmtExact(feeBreakdown.maintenance_charge, sym)}
//               </span>
//             </div>
//           )}
//           {(feeBreakdown.custom_fee1 || 0) > 0 && (
//             <div className="gtb-row">
//               <span className="gtb-label">
//                 {feeBreakdown.fee_labels?.custom1 || "Custom Fee 1"}
//               </span>
//               <span className="gtb-val">
//                 {fmtExact(feeBreakdown.custom_fee1, sym)}
//               </span>
//             </div>
//           )}
//           {(feeBreakdown.custom_fee2 || 0) > 0 && (
//             <div className="gtb-row">
//               <span className="gtb-label">
//                 {feeBreakdown.fee_labels?.custom2 || "Custom Fee 2"}
//               </span>
//               <span className="gtb-val">
//                 {fmtExact(feeBreakdown.custom_fee2, sym)}
//               </span>
//             </div>
//           )}
//           {feeBreakdown.tax_amount > 0 && (
//             <div className="gtb-row" style={{ color: "#b45309" }}>
//               <span>
//                 {feeBreakdown.tax_label || "Tax"} ({feeBreakdown.tax_rate}%
//                 {feeBreakdown.tax_system
//                   ? ` · ${feeBreakdown.tax_system.toUpperCase()}`
//                   : ""}
//                 )
//               </span>
//               <span style={{ fontWeight: 700 }}>
//                 {fmtExact(feeBreakdown.tax_amount, sym)}
//               </span>
//             </div>
//           )}
//           <div
//             className="gtb-row"
//             style={{
//               borderTop: "1px solid #fde68a",
//               paddingTop: 5,
//               marginTop: 3,
//             }}
//           >
//             <span className="gtb-total-label">
//               Grand Total (incl. tax & fees)
//             </span>
//             <span className="gtb-total-val">
//               {fmtExact(feeBreakdown.total_amount, sym)}
//             </span>
//           </div>
//         </div>
//       )}

//       <div className="ms-card">
//         <div className="ms-header">
//           <div>
//             <div
//               style={{
//                 fontFamily: "var(--font-heading)",
//                 fontSize: 17,
//                 fontWeight: 700,
//                 color: "var(--text-dark)",
//               }}
//             >
//               {plan.name}
//             </div>
//             {plan.description && (
//               <div
//                 style={{
//                   fontSize: 13,
//                   color: "var(--text-muted)",
//                   marginTop: 2,
//                 }}
//               >
//                 {plan.description}
//               </div>
//             )}
//           </div>
//           {totalPct === 100 && (
//             <span
//               style={{
//                 padding: "3px 12px",
//                 borderRadius: 20,
//                 background: "#f0fdf4",
//                 border: "1px solid #bbf7d0",
//                 color: "#16a34a",
//                 fontSize: 12,
//                 fontWeight: 700,
//               }}
//             >
//               ✓ 100%
//             </span>
//           )}
//         </div>

//         {plan.milestones.map((m, i) => {
//           const c = TYPE_COLORS[m.type] || TYPE_COLORS.custom;
//           const icon = TYPE_ICONS[m.type] || "⭐";
//           const displayAmt = m.calculated_amount
//             ? fmtExact(m.calculated_amount, sym)
//             : m.percentage
//               ? calcAmtLabel(m.percentage)
//               : m.fixed_amount
//                 ? fmtExact(m.fixed_amount, sym)
//                 : null;

//           const milestoneTotals = calculateMilestoneTotal(m);
//           const msTaxData =
//             feeBreakdown && m.percentage
//               ? computeMilestoneAmounts(m.percentage, feeBreakdown)
//               : null;

//           return (
//             <div key={m.id || i} className="ms-row">
//               <div
//                 className="ms-num"
//                 style={{ borderColor: c.border, color: c.color }}
//               >
//                 {i + 1}
//               </div>
//               <div className="ms-body">
//                 <div
//                   className="ms-type-chip"
//                   style={{ background: c.bg, color: c.color }}
//                 >
//                   {icon} {m.type_label || m.type?.replace(/_/g, " ")}
//                 </div>
//                 <div className="ms-label">{m.label}</div>
//                 {(m.due_date || m.due_after_days) && (
//                   <div className="ms-due">
//                     📅{" "}
//                     {m.due_date
//                       ? `Due by ${m.due_date}`
//                       : `Due ${m.due_after_days} days after booking`}
//                   </div>
//                 )}
//                 {m.note && <div className="ms-note">{m.note}</div>}

//                 {feeBreakdown && m.percentage && (
//                   <div
//                     style={{
//                       marginTop: 6,
//                       padding: "8px 12px",
//                       background: "#fef9ee",
//                       border: "1px solid #fde68a",
//                       borderRadius: 6,
//                       fontSize: 12,
//                     }}
//                   >
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         marginBottom: 2,
//                       }}
//                     >
//                       <span style={{ color: "var(--text-muted)" }}>
//                         Base amount
//                       </span>
//                       <span>{fmtExact(milestoneTotals?.base || 0, sym)}</span>
//                     </div>
//                     {(milestoneTotals?.fees || 0) > 0 && (
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                           marginBottom: 2,
//                         }}
//                       >
//                         <span style={{ color: "var(--text-muted)" }}>Fees</span>
//                         <span>{fmtExact(milestoneTotals?.fees || 0, sym)}</span>
//                       </div>
//                     )}
//                     {(milestoneTotals?.tax || 0) > 0 && (
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                           marginBottom: 2,
//                           color: "#b45309",
//                         }}
//                       >
//                         <span>
//                           {feeBreakdown.tax_label || "Tax"} (
//                           {feeBreakdown.tax_rate}%)
//                         </span>
//                         <span style={{ fontWeight: 600 }}>
//                           {fmtExact(milestoneTotals?.tax || 0, sym)}
//                         </span>
//                       </div>
//                     )}
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         borderTop: "1px solid #fde68a",
//                         paddingTop: 4,
//                         marginTop: 4,
//                         fontWeight: 700,
//                         color: "var(--primary-color)",
//                       }}
//                     >
//                       <span>Total incl. tax & fees</span>
//                       <span>{fmtExact(milestoneTotals?.total || 0, sym)}</span>
//                     </div>
//                   </div>
//                 )}
//               </div>
//               <div className="ms-amounts">
//                 {m.percentage > 0 && (
//                   <div className="ms-pct">{m.percentage}%</div>
//                 )}
//                 {displayAmt && (
//                   <div
//                     className="ms-amt"
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "flex-end",
//                     }}
//                   >
//                     ≈ {displayAmt}
//                     {msTaxData && (msTaxData.tax > 0 || msTaxData.fees > 0) && (
//                       <TaxBreakdownBadge
//                         milestonePercent={m.percentage}
//                         feeBreakdown={feeBreakdown}
//                         sym={sym}
//                       />
//                     )}
//                   </div>
//                 )}
//                 {milestoneTotals && milestoneTotals.total > 0 && (
//                   <div
//                     style={{
//                       fontSize: 13,
//                       fontWeight: 700,
//                       color: "var(--primary-color)",
//                       marginTop: 2,
//                     }}
//                   >
//                     Total: {fmtExact(milestoneTotals.total, sym)}
//                   </div>
//                 )}
//               </div>
//             </div>
//           );
//         })}

//         <div className="ms-footer">
//           <span
//             style={{
//               fontSize: 13,
//               color: "var(--text-muted)",
//               fontWeight: 600,
//             }}
//           >
//             Total payment mapped
//           </span>
//           <div style={{ textAlign: "right" }}>
//             <span
//               style={{
//                 fontSize: 18,
//                 fontWeight: 800,
//                 color:
//                   totalPct === 100
//                     ? "#16a34a"
//                     : totalPct > 100
//                       ? "#dc2626"
//                       : "var(--primary-color)",
//               }}
//             >
//               {totalPct.toFixed(0)}%{totalPct === 100 ? " ✓" : ""}
//             </span>
//             {feeBreakdown?.total_amount > 0 && (
//               <div style={{ fontSize: 11, color: "#b45309", marginTop: 2 }}>
//                 Grand Total: {fmtExact(feeBreakdown.total_amount, sym)} (incl.
//                 all taxes &amp; fees)
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <div
//         style={{
//           textAlign: "center",
//           fontSize: 12,
//           color: "var(--text-muted)",
//           marginTop: 10,
//         }}
//       >
//         Amounts shown are estimates. Final figures confirmed at booking.
//       </div>
//     </div>
//   );
// };

// /* ═════════════════════════════════════════════════════════════
//    BOOKING STEP COMPONENTS
// ═════════════════════════════════════════════════════════════ */

// const BrokerInactiveScreen = ({ onClose }) => (
//   <div className="broker-inactive">
//     <div className="broker-inactive-icon">🔒</div>
//     <div className="broker-inactive-title">Account Inactive</div>
//     <p
//       style={{
//         color: "var(--text-muted)",
//         fontSize: 13,
//         lineHeight: 1.7,
//         marginBottom: 20,
//       }}
//     >
//       Your account is currently{" "}
//       <strong style={{ color: "#dc2626" }}>inactive</strong>. Please contact the
//       admin to activate your account.
//     </p>
//     <div
//       style={{
//         background: "#fff5f5",
//         border: "1.5px solid #fecaca",
//         borderRadius: 10,
//         padding: "12px 16px",
//         marginBottom: 20,
//         fontSize: 12,
//         color: "#dc2626",
//         textAlign: "left",
//       }}
//     >
//       <div style={{ fontWeight: 700, marginBottom: 4 }}>What to do next:</div>
//       <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.8 }}>
//         <li>Contact your project administrator</li>
//         <li>Ask them to activate your account</li>
//         <li>You can book once your status is active</li>
//       </ul>
//     </div>
//     <button
//       onClick={onClose}
//       className="book-btn"
//       style={{
//         background: "var(--page-bg)",
//         color: "var(--text-muted)",
//         border: "1.5px solid var(--card-border)",
//       }}
//     >
//       Close
//     </button>
//   </div>
// );

// const StepDetails = ({ user, onBook, onLogout, isAvail }) => (
//   <div>
//     {user ? (
//       <div className="logged-in-card">
//         <div>
//           <div className="logged-in-label">✓ Logged in as</div>
//           <div className="logged-in-name">{user.name}</div>
//           <div
//             style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 2 }}
//           >
//             {user.email}
//           </div>
//         </div>
//         <button className="logout-btn" onClick={onLogout}>
//           Logout
//         </button>
//       </div>
//     ) : (
//       <p
//         style={{
//           color: "var(--text-muted)",
//           fontSize: 13,
//           lineHeight: 1.6,
//           marginBottom: 16,
//         }}
//       >
//         To book this unit, please log in or create an account. Both email and
//         phone will be verified.
//       </p>
//     )}
//     {isAvail !== false && (
//       <button className="book-btn" onClick={onBook}>
//         {user ? "Continue to Booking →" : "Login / Register to Book →"}
//       </button>
//     )}
//   </div>
// );

// const StepLogin = ({ form, setForm, onLogin, onSwitch, loading, error }) => (
//   <div>
//     <div
//       style={{
//         color: "var(--text-dark)",
//         fontWeight: 700,
//         fontSize: 15,
//         marginBottom: 16,
//       }}
//     >
//       Login to your account
//     </div>
//     {error && <div className="error-box">⚠️ {error}</div>}
//     <input
//       className="sidebar-input"
//       type="email"
//       placeholder="Email address"
//       value={form.email}
//       onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
//     />
//     <input
//       className="sidebar-input"
//       type="password"
//       placeholder="Password"
//       value={form.password}
//       onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
//       onKeyDown={(e) => e.key === "Enter" && onLogin()}
//       style={{ marginBottom: 16 }}
//     />
//     <button
//       className="book-btn"
//       onClick={onLogin}
//       disabled={loading || !form.email || !form.password}
//     >
//       {loading ? "Logging in…" : "Login →"}
//     </button>
//     {onSwitch && (
//       <p
//         style={{
//           textAlign: "center",
//           marginTop: 14,
//           color: "var(--text-muted)",
//           fontSize: 13,
//         }}
//       >
//         Don't have an account?{" "}
//         <button className="auth-link" onClick={onSwitch}>
//           Register
//         </button>
//       </p>
//     )}
//   </div>
// );

// const StepRegister = ({
//   form,
//   setForm,
//   onRegister,
//   onSwitch,
//   loading,
//   error,
// }) => {
//   const [showPass, setShowPass] = useState(false);
//   const strength = !form.password
//     ? 0
//     : [
//         form.password.length >= 8,
//         /[A-Z]/.test(form.password),
//         /[0-9]/.test(form.password),
//         /[^A-Za-z0-9]/.test(form.password),
//       ].filter(Boolean).length;
//   const strengthColor = ["#ef4444", "#f59e0b", "#f59e0b", "#16a34a", "#16a34a"][
//     strength
//   ];
//   return (
//     <div>
//       <div
//         style={{
//           color: "var(--text-dark)",
//           fontWeight: 700,
//           fontSize: 15,
//           marginBottom: 4,
//         }}
//       >
//         Create an account
//       </div>
//       <div
//         style={{ color: "var(--text-muted)", fontSize: 12, marginBottom: 14 }}
//       >
//         We'll verify your email and phone number. A Company Admin will need to
//         approve your account before you can book on behalf of a client.
//       </div>
//       {error && <div className="error-box">⚠️ {error}</div>}
//       <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
//         {[
//           { v: "broker", label: "🤝 Broker" },
//           { v: "sales", label: "📈 Sales" },
//         ].map(({ v, label }) => (
//           <button
//             key={v}
//             type="button"
//             onClick={() => setForm((f) => ({ ...f, role: v }))}
//             style={{
//               flex: 1,
//               padding: 8,
//               borderRadius: 8,
//               cursor: "pointer",
//               fontSize: 13,
//               border: `1.5px solid ${form.role === v ? "var(--primary-color)" : "var(--card-border)"}`,
//               background: form.role === v ? "var(--page-bg)" : "transparent",
//               color:
//                 form.role === v ? "var(--primary-color)" : "var(--text-muted)",
//               fontWeight: form.role === v ? 700 : 400,
//               fontFamily: "var(--font-body)",
//             }}
//           >
//             {label}
//           </button>
//         ))}
//       </div>
//       <input
//         className="sidebar-input"
//         type="text"
//         placeholder="Full Name *"
//         value={form.name}
//         onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
//       />
//       {(form.role === "broker" || form.role === "sales") && (
//         <input
//           className="sidebar-input"
//           type="text"
//           placeholder={
//             form.role === "sales"
//               ? "Sales Team / Department (optional)"
//               : "Company / Agency Name"
//           }
//           value={form.broker_company}
//           onChange={(e) =>
//             setForm((f) => ({ ...f, broker_company: e.target.value }))
//           }
//         />
//       )}
//       <input
//         className="sidebar-input"
//         type="email"
//         placeholder="Email Address *"
//         value={form.email}
//         onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
//       />
//       <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
//         <CountryCodePicker
//           value={form.country_code}
//           onChange={(v) => setForm((f) => ({ ...f, country_code: v }))}
//         />
//         <input
//           style={{
//             flex: 1,
//             padding: "10px 12px",
//             background: "var(--page-bg)",
//             border: "1.5px solid var(--card-border)",
//             borderRadius: 8,
//             color: "var(--text-dark)",
//             fontSize: 13,
//             fontFamily: "var(--font-body)",
//             outline: "none",
//           }}
//           type="tel"
//           placeholder="Phone number *"
//           value={form.phone}
//           onChange={(e) =>
//             setForm((f) => ({ ...f, phone: e.target.value.replace(/\D/g, "") }))
//           }
//         />
//       </div>
//       <div style={{ position: "relative", marginBottom: 4 }}>
//         <input
//           style={{
//             width: "100%",
//             padding: "10px 40px 10px 12px",
//             background: "var(--page-bg)",
//             border: "1.5px solid var(--card-border)",
//             borderRadius: 8,
//             color: "var(--text-dark)",
//             fontSize: 13,
//             boxSizing: "border-box",
//             fontFamily: "var(--font-body)",
//             outline: "none",
//           }}
//           type={showPass ? "text" : "password"}
//           placeholder="Password (min 8 chars) *"
//           value={form.password}
//           onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
//         />
//         <button
//           type="button"
//           onClick={() => setShowPass((s) => !s)}
//           style={{
//             position: "absolute",
//             right: 10,
//             top: "50%",
//             transform: "translateY(-50%)",
//             background: "none",
//             border: "none",
//             color: "var(--text-muted)",
//             cursor: "pointer",
//             fontSize: 14,
//           }}
//         >
//           {showPass ? "🙈" : "👁"}
//         </button>
//       </div>
//       {form.password && (
//         <div style={{ marginBottom: 12 }}>
//           <div className="pw-strength">
//             {[1, 2, 3, 4].map((i) => (
//               <div
//                 key={i}
//                 className="pw-bar"
//                 style={{
//                   background:
//                     i <= strength ? strengthColor : "var(--card-border)",
//                 }}
//               />
//             ))}
//           </div>
//           <div style={{ fontSize: 11, color: strengthColor }}>
//             {["", "Weak", "Fair", "Good", "Strong"][strength]}
//           </div>
//         </div>
//       )}
//       <button
//         className="book-btn"
//         style={{ marginTop: 6 }}
//         onClick={onRegister}
//         disabled={
//           loading ||
//           !form.name ||
//           !form.email ||
//           !form.phone ||
//           !form.password ||
//           form.password.length < 8
//         }
//       >
//         {loading ? "Creating account…" : "Register & Verify →"}
//       </button>
//       <p
//         style={{
//           textAlign: "center",
//           marginTop: 14,
//           color: "var(--text-muted)",
//           fontSize: 13,
//         }}
//       >
//         Already have an account?{" "}
//         <button className="auth-link" onClick={onSwitch}>
//           Login
//         </button>
//       </p>
//     </div>
//   );
// };

// const StepOtp = ({ type, onVerify, onResend, loading, error, setError }) => {
//   const [otp, setOtp] = useState(["", "", "", "", "", ""]);
//   const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];
//   const isEmail = type === "email";
//   const handleKey = (i, e) => {
//     if (e.key === "Backspace") {
//       if (otp[i]) {
//         const n = [...otp];
//         n[i] = "";
//         setOtp(n);
//       } else if (i > 0) refs[i - 1].current?.focus();
//     }
//   };
//   const handleChange = (i, val) => {
//     const digit = val.replace(/\D/g, "").slice(-1),
//       n = [...otp];
//     n[i] = digit;
//     setOtp(n);
//     if (digit && i < 5) refs[i + 1].current?.focus();
//     if (digit && i === 5) {
//       const full = [...n].join("");
//       if (full.length === 6) {
//         setError("");
//         onVerify(full);
//       }
//     }
//   };
//   const handlePaste = (e) => {
//     const p = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
//     if (p.length === 6) {
//       setOtp(p.split(""));
//       refs[5].current?.focus();
//       setError("");
//       onVerify(p);
//     }
//   };
//   const fullOtp = otp.join("");
//   return (
//     <div>
//       <div style={{ textAlign: "center", marginBottom: 20 }}>
//         <div style={{ fontSize: 36, marginBottom: 8 }}>
//           {isEmail ? "📧" : "📱"}
//         </div>
//         <div
//           style={{ color: "var(--text-dark)", fontWeight: 700, fontSize: 15 }}
//         >
//           Verify your {isEmail ? "email" : "phone"}
//         </div>
//         <div style={{ color: "var(--text-muted)", fontSize: 12, marginTop: 6 }}>
//           Enter the 6-digit code sent to your {isEmail ? "email" : "phone"}.
//         </div>
//       </div>
//       {error && (
//         <div
//           style={{
//             padding: "8px 12px",
//             borderRadius: 8,
//             marginBottom: 12,
//             fontSize: 12,
//             background: error.startsWith("✓") ? "#f0fdf4" : "#fff5f5",
//             border: `1px solid ${error.startsWith("✓") ? "#bbf7d0" : "#fecaca"}`,
//             color: error.startsWith("✓") ? "#16a34a" : "#dc2626",
//           }}
//         >
//           {error}
//         </div>
//       )}
//       <div className="otp-grid" onPaste={handlePaste}>
//         {otp.map((digit, i) => (
//           <input
//             key={i}
//             ref={refs[i]}
//             type="text"
//             inputMode="numeric"
//             maxLength={1}
//             value={digit}
//             onChange={(e) => handleChange(i, e.target.value)}
//             onKeyDown={(e) => handleKey(i, e)}
//             className={`otp-cell${digit ? " filled" : ""}`}
//           />
//         ))}
//       </div>
//       <button
//         className="book-btn"
//         onClick={() => {
//           if (fullOtp.length === 6) onVerify(fullOtp);
//         }}
//         disabled={loading || fullOtp.length < 6}
//       >
//         {loading ? "Verifying…" : "Verify Code →"}
//       </button>
//       <div style={{ textAlign: "center", marginTop: 16 }}>
//         <span style={{ color: "var(--text-muted)", fontSize: 13 }}>
//           Didn't receive the code?{" "}
//         </span>
//         <button
//           className="auth-link"
//           onClick={() => {
//             setOtp(["", "", "", "", "", ""]);
//             onResend();
//           }}
//           disabled={loading}
//         >
//           Resend
//         </button>
//       </div>
//     </div>
//   );
// };

// const StepPlanSelect = ({
//   plans,
//   selected,
//   onSelect,
//   fmtPrice,
//   unitPrice,
//   onNext,
//   onBack,
//   existingBookingId,
//   feeBreakdown,
//   sym = "₹",
// }) => {
//   const [expanded, setExpanded] = useState(null);
//   const price = parseFloat(String(unitPrice || "0").replace(/,/g, "")) || 0;
//   const calcAmtLabel = (pct) =>
//     price > 0 ? fmtExact((price * parseFloat(pct)) / 100, sym) : null;

//   return (
//     <div>
//       <div
//         style={{
//           color: "var(--text-dark)",
//           fontWeight: 700,
//           fontSize: 15,
//           marginBottom: 4,
//         }}
//       >
//         Choose a Payment Plan
//       </div>
//       <div
//         style={{ color: "var(--text-muted)", fontSize: 12, marginBottom: 14 }}
//       >
//         Full plan details are shown above — pick one to continue.
//       </div>

//       {feeBreakdown?.tax_enabled && feeBreakdown?.total_amount > 0 && (
//         <div className="grand-total-banner" style={{ marginBottom: 14 }}>
//           <div className="gtb-row">
//             <span className="gtb-label">Unit Price</span>
//             <span className="gtb-val">
//               {fmtExact(feeBreakdown.unit_price || price, sym)}
//             </span>
//           </div>
//           {feeBreakdown.tax_amount > 0 && (
//             <div className="gtb-row">
//               <span style={{ color: "#b45309" }}>
//                 {feeBreakdown.tax_label || "Tax"} ({feeBreakdown.tax_rate}%)
//               </span>
//               <span style={{ color: "#b45309", fontWeight: 700 }}>
//                 {fmtExact(feeBreakdown.tax_amount, sym)}
//               </span>
//             </div>
//           )}
//           <div
//             className="gtb-row"
//             style={{
//               borderTop: "1px solid #fde68a",
//               paddingTop: 5,
//               marginTop: 3,
//             }}
//           >
//             <span className="gtb-total-label">Grand Total</span>
//             <span className="gtb-total-val">
//               {fmtExact(feeBreakdown.total_amount, sym)}
//             </span>
//           </div>
//         </div>
//       )}

//       {/* Full payment option */}
//       <div
//         className={`plan-option${selected === null ? " selected" : ""}`}
//         onClick={() => onSelect(null)}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div>
//             <div
//               style={{
//                 color: "var(--text-dark)",
//                 fontWeight: 600,
//                 fontSize: 13,
//               }}
//             >
//               Full Payment
//             </div>
//             <div
//               style={{ color: "var(--text-muted)", fontSize: 11, marginTop: 2 }}
//             >
//               Pay{" "}
//               {feeBreakdown?.total_amount
//                 ? `${fmtExact(feeBreakdown.total_amount, sym)} (incl. taxes)`
//                 : "the full amount"}{" "}
//               upfront
//             </div>
//           </div>
//           <div
//             className={`plan-radio${selected === null ? " selected" : ""}`}
//           />
//         </div>
//       </div>

//       {plans.map((plan) => {
//         const isSelected = selected === plan.id,
//           isExpanded = expanded === plan.id;
//         const totalPct = plan.milestones.reduce(
//           (s, m) => s + (parseFloat(m.percentage) || 0),
//           0,
//         );
//         return (
//           <div key={plan.id} style={{ marginBottom: 8 }}>
//             <div
//               className={`plan-option${isSelected ? " selected" : ""}`}
//               style={{ borderRadius: isExpanded ? "8px 8px 0 0" : 8 }}
//               onClick={() => {
//                 onSelect(plan.id);
//                 setExpanded(isExpanded ? null : plan.id);
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "flex-start",
//                   justifyContent: "space-between",
//                   gap: 10,
//                 }}
//               >
//                 <div style={{ flex: 1, minWidth: 0 }}>
//                   <div
//                     style={{
//                       color: "var(--text-dark)",
//                       fontWeight: 700,
//                       fontSize: 13,
//                     }}
//                   >
//                     {plan.name}
//                   </div>
//                   {plan.description && (
//                     <div
//                       style={{
//                         color: "var(--text-muted)",
//                         fontSize: 11,
//                         marginTop: 2,
//                       }}
//                     >
//                       {plan.description}
//                     </div>
//                   )}
//                   {!isExpanded && (
//                     <div
//                       style={{
//                         marginTop: 6,
//                         display: "flex",
//                         flexWrap: "wrap",
//                         gap: 4,
//                       }}
//                     >
//                       {plan.milestones.slice(0, 2).map((m, i) => (
//                         <span
//                           key={i}
//                           style={{
//                             fontSize: 10,
//                             padding: "2px 8px",
//                             borderRadius: 8,
//                             background: "var(--page-bg)",
//                             color: "var(--primary-color)",
//                             fontWeight: 600,
//                             border: "1px solid var(--card-border)",
//                           }}
//                         >
//                           {m.label}
//                           {m.percentage ? ` · ${m.percentage}%` : ""}
//                         </span>
//                       ))}
//                       {plan.milestones.length > 2 && (
//                         <span
//                           style={{ fontSize: 10, color: "var(--text-muted)" }}
//                         >
//                           +{plan.milestones.length - 2} more
//                         </span>
//                       )}
//                     </div>
//                   )}
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "flex-end",
//                     gap: 6,
//                     flexShrink: 0,
//                   }}
//                 >
//                   <div
//                     className={`plan-radio${isSelected ? " selected" : ""}`}
//                   />
//                   <button
//                     type="button"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setExpanded(isExpanded ? null : plan.id);
//                     }}
//                     style={{
//                       background: "none",
//                       border: "none",
//                       color: "var(--text-muted)",
//                       fontSize: 11,
//                       cursor: "pointer",
//                       padding: 0,
//                       fontFamily: "var(--font-body)",
//                     }}
//                   >
//                     {isExpanded ? "▲ Less" : "▼ Details"}
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {isExpanded && (
//               <div
//                 style={{
//                   background: "var(--page-bg)",
//                   borderRadius: "0 0 8px 8px",
//                   border: "1.5px solid var(--primary-color)44",
//                   borderTop: "none",
//                 }}
//               >
//                 {plan.milestones.map((m, i) => {
//                   const c = TYPE_COLORS[m.type] || TYPE_COLORS.custom;
//                   const icon = TYPE_ICONS[m.type] || "⭐";
//                   const amt = m.calculated_amount
//                     ? fmtExact(m.calculated_amount, sym)
//                     : m.percentage
//                       ? calcAmtLabel(m.percentage)
//                       : null;
//                   return (
//                     <div
//                       key={i}
//                       style={{
//                         padding: "10px 14px",
//                         borderBottom:
//                           i < plan.milestones.length - 1
//                             ? "1px solid var(--card-border)"
//                             : "none",
//                       }}
//                     >
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "space-between",
//                           gap: 8,
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 8,
//                             flex: 1,
//                           }}
//                         >
//                           <span style={{ fontSize: 16 }}>{icon}</span>
//                           <div>
//                             <span
//                               style={{
//                                 fontSize: 10,
//                                 padding: "1px 7px",
//                                 borderRadius: 8,
//                                 background: c.bg,
//                                 color: c.color,
//                                 fontWeight: 700,
//                               }}
//                             >
//                               {m.type_label}
//                             </span>
//                             <span
//                               style={{
//                                 color: "var(--text-dark)",
//                                 fontSize: 12,
//                                 fontWeight: 600,
//                                 marginLeft: 6,
//                               }}
//                             >
//                               {m.label}
//                             </span>
//                           </div>
//                         </div>
//                         <div style={{ textAlign: "right" }}>
//                           {m.percentage > 0 && (
//                             <div
//                               style={{
//                                 color: "var(--primary-color)",
//                                 fontWeight: 800,
//                                 fontSize: 15,
//                               }}
//                             >
//                               {m.percentage}%
//                             </div>
//                           )}
//                           {amt && (
//                             <div
//                               style={{
//                                 color: "var(--text-muted)",
//                                 fontSize: 11,
//                               }}
//                             >
//                               ≈ {amt}
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                       {feeBreakdown && m.percentage && (
//                         <MilestoneTaxRow
//                           milestone={m}
//                           feeBreakdown={feeBreakdown}
//                         />
//                       )}
//                     </div>
//                   );
//                 })}
//                 <div
//                   style={{
//                     padding: "8px 14px",
//                     display: "flex",
//                     justifyContent: "space-between",
//                     borderTop: "1px solid var(--card-border)",
//                     background: "var(--card-bg)",
//                   }}
//                 >
//                   <span style={{ color: "var(--text-muted)", fontSize: 12 }}>
//                     Total
//                   </span>
//                   <div style={{ textAlign: "right" }}>
//                     <span
//                       style={{
//                         color:
//                           totalPct === 100 ? "#16a34a" : "var(--primary-color)",
//                         fontWeight: 700,
//                         fontSize: 13,
//                       }}
//                     >
//                       {totalPct.toFixed(0)}%{totalPct === 100 ? " ✓" : ""}
//                     </span>
//                     {feeBreakdown?.total_amount > 0 && (
//                       <div
//                         style={{ fontSize: 10, color: "#b45309", marginTop: 2 }}
//                       >
//                         = {fmtExact(feeBreakdown.total_amount, sym)} incl. taxes
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         );
//       })}

//       <button className="book-btn" onClick={onNext} style={{ marginTop: 12 }}>
//         {existingBookingId ? "Update Plan & Pay →" : "Continue →"}
//       </button>
//       <button
//         type="button"
//         onClick={onBack}
//         style={{
//           display: "block",
//           width: "100%",
//           marginTop: 8,
//           background: "none",
//           border: "1.5px solid var(--card-border)",
//           borderRadius: 8,
//           color: "var(--text-muted)",
//           padding: 10,
//           cursor: "pointer",
//           fontSize: 13,
//           fontFamily: "var(--font-body)",
//         }}
//       >
//         ← Back
//       </button>
//     </div>
//   );
// };

// const StepBookingForm = ({
//   user,
//   form,
//   setForm,
//   onSubmit,
//   loading,
//   error,
//   selectedPlan,
//   plans,
//   onBack,
//   unit,
//   existingBookingId,
//   feeBreakdown,
//   sym = "₹",
// }) => {
//   const plan = plans.find((p) => p.id === selectedPlan);
//   const isAgent = user?.role === "broker" || user?.role === "sales";
//   const price =
//     parseFloat(
//       (unit?.offer_price || unit?.actual_price || "")
//         .toString()
//         .replace(/[^0-9.]/g, ""),
//     ) || 0;
//   const commissionRate = parseFloat(user?.commission_rate || 2);
//   const commissionAmt =
//     price > 0 ? ((price * commissionRate) / 100).toFixed(2) : null;
//   const canSubmit = isAgent
//     ? form.name && form.phone && form.client_name && form.client_phone
//     : form.name && form.phone;

//   return (
//     <div>
//       <div
//         style={{
//           color: "var(--text-dark)",
//           fontWeight: 700,
//           fontSize: 15,
//           marginBottom: 4,
//         }}
//       >
//         {existingBookingId ? "Update Payment Plan" : "Confirm Booking"}
//       </div>
//       <div
//         style={{ color: "var(--text-muted)", fontSize: 12, marginBottom: 12 }}
//       >
//         {existingBookingId ? (
//           <span>
//             Updating plan for booking{" "}
//             <span style={{ color: "var(--primary-color)" }}>
//               #{existingBookingId}
//             </span>
//           </span>
//         ) : isAgent ? (
//           <>
//             Booking as {user?.role === "sales" ? "sales" : "broker"}{" "}
//             <span style={{ color: "var(--primary-color)" }}>{user?.name}</span>
//           </>
//         ) : (
//           <>
//             Booking as{" "}
//             <span style={{ color: "var(--primary-color)" }}>{user?.name}</span>
//           </>
//         )}
//       </div>

//       {plan && (
//         <div
//           style={{
//             background: "var(--page-bg)",
//             border: "1.5px solid var(--card-border)",
//             borderRadius: 8,
//             padding: "10px 12px",
//             marginBottom: 14,
//             fontSize: 12,
//           }}
//         >
//           <div
//             style={{
//               color: "var(--primary-color)",
//               fontWeight: 700,
//               marginBottom: 2,
//             }}
//           >
//             💳 {plan.name}
//           </div>
//           <div style={{ color: "var(--text-muted)" }}>
//             Selected payment plan
//           </div>
//           <button
//             type="button"
//             onClick={onBack}
//             style={{
//               background: "none",
//               border: "none",
//               color: "var(--text-muted)",
//               fontSize: 11,
//               padding: 0,
//               marginTop: 4,
//               cursor: "pointer",
//               textDecoration: "underline",
//               fontFamily: "var(--font-body)",
//             }}
//           >
//             Change plan
//           </button>
//         </div>
//       )}

//       <BookingSummaryTaxCard
//         feeBreakdown={feeBreakdown}
//         selectedPlan={selectedPlan}
//         plans={plans}
//         unit={unit}
//         sym={sym}
//       />

//       {error && <div className="error-box">⚠️ {error}</div>}

//       {isAgent ? (
//         <>
//           {commissionAmt && (
//             <div className="commission-box">
//               <div className="commission-label">Your Commission</div>
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                 }}
//               >
//                 <div className="commission-amt">
//                   {fmtExact(commissionAmt, sym)}
//                 </div>
//                 <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
//                   {commissionRate}% of price
//                 </div>
//               </div>
//             </div>
//           )}
//           <div
//             style={{
//               fontSize: 11,
//               color: "var(--text-muted)",
//               marginBottom: 8,
//               textTransform: "uppercase",
//               fontWeight: 600,
//               letterSpacing: "0.8px",
//             }}
//           >
//             Your Contact Info
//           </div>
//           <input
//             className="sidebar-input"
//             type="text"
//             placeholder="Your Name *"
//             value={form.name}
//             onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
//           />
//           <input
//             className="sidebar-input"
//             type="tel"
//             placeholder="Your Phone *"
//             value={form.phone}
//             onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
//           />
//           <div
//             style={{
//               fontSize: 11,
//               color: "var(--text-muted)",
//               marginBottom: 8,
//               marginTop: 8,
//               textTransform: "uppercase",
//               fontWeight: 600,
//               letterSpacing: "0.8px",
//             }}
//           >
//             Client Details
//           </div>
//           <input
//             className="sidebar-input"
//             type="text"
//             placeholder="Client Full Name *"
//             value={form.client_name}
//             onChange={(e) =>
//               setForm((f) => ({ ...f, client_name: e.target.value }))
//             }
//           />
//           <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
//             <CountryCodePicker
//               value={form.client_country_code}
//               onChange={(v) =>
//                 setForm((f) => ({ ...f, client_country_code: v }))
//               }
//             />
//             <input
//               style={{
//                 flex: 1,
//                 padding: "10px 12px",
//                 background: "var(--page-bg)",
//                 border: "1.5px solid var(--card-border)",
//                 borderRadius: 8,
//                 color: "var(--text-dark)",
//                 fontSize: 13,
//                 fontFamily: "var(--font-body)",
//                 outline: "none",
//               }}
//               type="tel"
//               placeholder="Client Phone *"
//               value={form.client_phone}
//               onChange={(e) =>
//                 setForm((f) => ({
//                   ...f,
//                   client_phone: e.target.value.replace(/\D/g, ""),
//                 }))
//               }
//             />
//           </div>
//           <input
//             className="sidebar-input"
//             type="email"
//             placeholder="Client Email (optional)"
//             value={form.client_email}
//             onChange={(e) =>
//               setForm((f) => ({ ...f, client_email: e.target.value }))
//             }
//           />
//           <textarea
//             className="sidebar-input"
//             placeholder="Notes (optional)"
//             rows={2}
//             value={form.notes}
//             onChange={(e) => setForm((f) => ({ ...f, notes: e.target.value }))}
//             style={{ resize: "none", marginBottom: 16 }}
//           />
//         </>
//       ) : (
//         <>
//           <input
//             className="sidebar-input"
//             type="text"
//             placeholder="Your Name *"
//             value={form.name}
//             onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
//           />
//           <input
//             className="sidebar-input"
//             type="tel"
//             placeholder="Phone Number *"
//             value={form.phone}
//             onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
//           />
//           <textarea
//             className="sidebar-input"
//             placeholder="Message / Notes (optional)"
//             rows={3}
//             value={form.notes}
//             onChange={(e) => setForm((f) => ({ ...f, notes: e.target.value }))}
//             style={{ resize: "none", marginBottom: 16 }}
//           />
//         </>
//       )}

//       <button
//         className="book-btn"
//         onClick={onSubmit}
//         disabled={loading || !canSubmit}
//       >
//         {loading
//           ? "Submitting…"
//           : existingBookingId
//             ? "✓ Update Plan & Proceed to Payment"
//             : isAgent
//               ? "✓ Submit Booking for Client"
//               : "✓ Confirm Booking"}
//       </button>
//       <button
//         type="button"
//         onClick={onBack}
//         style={{
//           display: "block",
//           width: "100%",
//           marginTop: 8,
//           background: "none",
//           border: "1.5px solid var(--card-border)",
//           borderRadius: 8,
//           color: "var(--text-muted)",
//           padding: 10,
//           cursor: "pointer",
//           fontSize: 13,
//           fontFamily: "var(--font-body)",
//         }}
//       >
//         ← Back
//       </button>
//     </div>
//   );
// };

// const BookingDone = ({ unit, onClose }) => (
//   <div className="booking-done">
//     <div className="booking-done-emoji">🎉</div>
//     <div className="booking-done-title">Booking Received!</div>
//     <div className="booking-done-text">
//       Your enquiry for Unit {unit.plot_number} has been submitted.
//       <br />
//       Our team will contact you shortly.
//     </div>
//     <button className="book-btn" onClick={onClose}>
//       Close
//     </button>
//   </div>
// );

// /* ═════════════════════════════════════════════════════════════
//    CountryCodePicker
// ═════════════════════════════════════════════════════════════ */
// const COUNTRY_CODES = [
//   { code: "+91", flag: "🇮🇳", name: "India" },
//   { code: "+971", flag: "🇦🇪", name: "UAE" },
//   { code: "+966", flag: "🇸🇦", name: "Saudi Arabia" },
//   { code: "+974", flag: "🇶🇦", name: "Qatar" },
//   { code: "+965", flag: "🇰🇼", name: "Kuwait" },
//   { code: "+973", flag: "🇧🇭", name: "Bahrain" },
//   { code: "+968", flag: "🇴🇲", name: "Oman" },
//   { code: "+1", flag: "🇺🇸", name: "USA / Canada" },
//   { code: "+44", flag: "🇬🇧", name: "UK" },
//   { code: "+61", flag: "🇦🇺", name: "Australia" },
//   { code: "+65", flag: "🇸🇬", name: "Singapore" },
//   { code: "+60", flag: "🇲🇾", name: "Malaysia" },
//   { code: "+86", flag: "🇨🇳", name: "China" },
//   { code: "+81", flag: "🇯🇵", name: "Japan" },
//   { code: "+49", flag: "🇩🇪", name: "Germany" },
//   { code: "+33", flag: "🇫🇷", name: "France" },
//   { code: "+39", flag: "🇮🇹", name: "Italy" },
//   { code: "+34", flag: "🇪🇸", name: "Spain" },
//   { code: "+7", flag: "🇷🇺", name: "Russia" },
//   { code: "+55", flag: "🇧🇷", name: "Brazil" },
//   { code: "+92", flag: "🇵🇰", name: "Pakistan" },
//   { code: "+880", flag: "🇧🇩", name: "Bangladesh" },
//   { code: "+94", flag: "🇱🇰", name: "Sri Lanka" },
//   { code: "+977", flag: "🇳🇵", name: "Nepal" },
//   { code: "+20", flag: "🇪🇬", name: "Egypt" },
//   { code: "+234", flag: "🇳🇬", name: "Nigeria" },
//   { code: "+27", flag: "🇿🇦", name: "South Africa" },
//   { code: "+254", flag: "🇰🇪", name: "Kenya" },
//   { code: "+62", flag: "🇮🇩", name: "Indonesia" },
//   { code: "+63", flag: "🇵🇭", name: "Philippines" },
//   { code: "+66", flag: "🇹🇭", name: "Thailand" },
//   { code: "+84", flag: "🇻🇳", name: "Vietnam" },
//   { code: "+82", flag: "🇰🇷", name: "South Korea" },
//   { code: "+90", flag: "🇹🇷", name: "Turkey" },
//   { code: "+98", flag: "🇮🇷", name: "Iran" },
//   { code: "+964", flag: "🇮🇶", name: "Iraq" },
//   { code: "+961", flag: "🇱🇧", name: "Lebanon" },
//   { code: "+962", flag: "🇯🇴", name: "Jordan" },
// ];

// const CountryCodePicker = ({ value, onChange }) => {
//   const [open, setOpen] = useState(false),
//     [search, setSearch] = useState("");
//   const selected =
//     COUNTRY_CODES.find((c) => c.code === value) || COUNTRY_CODES[0];
//   const filtered = search.trim()
//     ? COUNTRY_CODES.filter(
//         (c) =>
//           c.name.toLowerCase().includes(search.toLowerCase()) ||
//           c.code.includes(search),
//       )
//     : COUNTRY_CODES;
//   return (
//     <div style={{ position: "relative" }}>
//       <button
//         type="button"
//         onClick={() => {
//           setOpen((o) => !o);
//           setSearch("");
//         }}
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: 6,
//           padding: 10,
//           background: "var(--page-bg)",
//           border: "1.5px solid var(--card-border)",
//           borderRadius: 8,
//           color: "var(--text-dark)",
//           cursor: "pointer",
//           fontSize: 13,
//           whiteSpace: "nowrap",
//           minWidth: 82,
//           fontFamily: "var(--font-body)",
//         }}
//       >
//         <span style={{ fontSize: 16 }}>{selected.flag}</span>
//         <span>{selected.code}</span>
//         <span style={{ fontSize: 10, opacity: 0.5 }}>▼</span>
//       </button>
//       {open && (
//         <div
//           style={{
//             position: "absolute",
//             top: "calc(100% + 4px)",
//             left: 0,
//             zIndex: 999,
//             background: "var(--card-bg)",
//             border: "1px solid var(--card-border)",
//             borderRadius: 10,
//             overflow: "hidden",
//             minWidth: 220,
//             boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
//           }}
//         >
//           <div
//             style={{
//               padding: "8px 10px",
//               borderBottom: "1px solid var(--card-border)",
//             }}
//           >
//             <input
//               autoFocus
//               type="text"
//               placeholder="Search country…"
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               style={{
//                 width: "100%",
//                 padding: "7px 10px",
//                 background: "var(--page-bg)",
//                 border: "1px solid var(--card-border)",
//                 borderRadius: 6,
//                 color: "var(--text-dark)",
//                 fontSize: 12,
//                 outline: "none",
//                 boxSizing: "border-box",
//                 fontFamily: "var(--font-body)",
//               }}
//             />
//           </div>
//           <div style={{ maxHeight: 240, overflowY: "auto" }}>
//             {filtered.map((c) => (
//               <div
//                 key={c.code + c.name}
//                 onClick={() => {
//                   onChange(c.code);
//                   setOpen(false);
//                   setSearch("");
//                 }}
//                 style={{
//                   padding: "9px 14px",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 10,
//                   cursor: "pointer",
//                   fontSize: 13,
//                   background:
//                     c.code === value ? "var(--page-bg)" : "transparent",
//                   color:
//                     c.code === value
//                       ? "var(--primary-color)"
//                       : "var(--text-dark)",
//                   fontWeight: c.code === value ? 700 : 400,
//                 }}
//                 onMouseOver={(e) =>
//                   (e.currentTarget.style.background = "var(--page-bg)")
//                 }
//                 onMouseOut={(e) =>
//                   (e.currentTarget.style.background =
//                     c.code === value ? "var(--page-bg)" : "transparent")
//                 }
//               >
//                 <span style={{ fontSize: 16, flexShrink: 0 }}>{c.flag}</span>
//                 <span
//                   style={{
//                     flex: 1,
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   {c.name}
//                 </span>
//                 <span style={{ opacity: 0.45, fontSize: 12, flexShrink: 0 }}>
//                   {c.code}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// /* ═════════════════════════════════════════════════════════════
//    MAIN COMPONENT
// ═════════════════════════════════════════════════════════════ */
// const UnitPage = () => {
//   const { tenant, plotId } = useParams();
//   const navigate = useNavigate();
//   const { settings, isLoaded: settingsLoaded } = useSettings();

//   const containerRef = useRef(null);
//   const viewerRef = useRef(null);
//   const markersRef = useRef(null);
//   const overlayRef = useRef(null);
//   const labelRef = useRef(null);
//   const allMarkerIdsRef = useRef([]);

//   const [unit, setUnit] = useState(null);
//   const [hotspots, setHotspots] = useState(null);
//   const [fetchError, setFetchError] = useState(null);
//   const [isFetching, setIsFetching] = useState(true);
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [loadProgress, setLoadProgress] = useState(0);
//   const [activeTab, setActiveTab] = useState("details");
//   const [galIdx, setGalIdx] = useState(0);

//   // Booking sidebar state
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [bookingStep, setBookingStep] = useState("details");
//   const [selectedPlan, setSelectedPlan] = useState(null);
//   const [loginForm, setLoginForm] = useState({ email: "", password: "" });
//   const [registerForm, setRegisterForm] = useState({
//     name: "",
//     email: "",
//     country_code: "+91",
//     phone: "",
//     password: "",
//     role: "broker",
//     broker_company: "",
//   });
//   const [bookingForm, setBookingForm] = useState({
//     name: "",
//     phone: "",
//     notes: "",
//     client_name: "",
//     client_phone: "",
//     client_email: "",
//     client_country_code: "+91",
//   });
//   const [authLoading, setAuthLoading] = useState(false);
//   const [authError, setAuthError] = useState("");
//   const [bookingDone, setBookingDone] = useState(false);
//   const [pendingUserId, setPendingUserId] = useState(null);
//   const [existingBookingId, setExistingBookingId] = useState(null);
//   const [currency, setCurrency] = useState("₹");
//   const [feeBreakdown, setFeeBreakdown] = useState(null);

//   // Login modal (shared by wishlist + book-now-when-logged-out flows)
//   const [loginModalOpen, setLoginModalOpen] = useState(false);
//   const [authIntent, setAuthIntent] = useState(null); // null | "wishlist" | "book"
//   const [modalStep, setModalStep] = useState("login");
//   const [modalPendingUserId, setModalPendingUserId] = useState(null);
//   const [modalAuthError, setModalAuthError] = useState("");

//   // ── Auth — via AuthContext, tenant-scoped (see components/AuthContext.jsx).
//   const { user, login, register, verifyEmail, verifyPhone, resendOtp, signOut } =
//     useAuth();
//   const { wishedIds, toggle: toggleWish } = useWishlist(tenant, user?.token);
//   const { showToast } = useToast();

//   // ── Helper: build image URL with tenant ──────────────────────────────────
//   const getFullImageUrl = useCallback(
//     (path) => {
//       if (!path) return null;
//       if (path.startsWith("http://") || path.startsWith("https://")) {
//         return path;
//       }
//       const baseUrl = settings?.img_url || process.env.REACT_APP_IMG_URL || "";
//       const cleanPath = path.startsWith("/") ? path.substring(1) : path;
//       return baseUrl.endsWith("/")
//         ? `${baseUrl}${cleanPath}`
//         : `${baseUrl}/${cleanPath}`;
//     },
//     [settings],
//   );

//   const wishlistWithToken = useCallback(
//     (freshToken, pid, plotNumber) => {
//       apiJson(tenant, `/wishlist/toggle`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${freshToken}`,
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ plot_id: Number(pid) }),
//       })
//         .then((d) => {
//           showToast(
//             d.wishlisted
//               ? `❤️ Added to Wishlist — Unit ${plotNumber}`
//               : `🤍 Removed from Wishlist — Unit ${plotNumber}`,
//             d.wishlisted ? "wishlist_add" : "wishlist_remove",
//             2800,
//           );
//         })
//         .catch(() => {});
//     },
//     [tenant, showToast],
//   );

//   // ── Fetch unit + hotspots + currency ──────────────────────
//   useEffect(() => {
//     if (!tenant || !plotId) {
//       setFetchError("No tenant or plot ID provided");
//       setIsFetching(false);
//       return;
//     }

//     const fetchAll = async () => {
//       try {
//         const [unitData, hsData, currData] = await Promise.all([
//           apiJson(tenant, `/unit/${plotId}`),
//           apiJson(tenant, `/hotspots?plot_id=${plotId}`),
//           apiJson(tenant, `/currency`),
//         ]);

//         setUnit(unitData);
//         setHotspots(hsData || []);
//         setCurrency(
//           currData?.symbol ||
//             currData?.currency ||
//             currData?.data?.symbol ||
//             currData?.data?.currency ||
//             "₹",
//         );
//       } catch (err) {
//         console.error("Fetch error:", err);
//         setFetchError(err.message);
//       } finally {
//         setIsFetching(false);
//       }
//     };
//     fetchAll();
//   }, [tenant, plotId]);

//   // ── Fee preview ────────────────────────────────────────────
//   useEffect(() => {
//     if (!unit?.actual_price && !unit?.offer_price) return;
//     if (!tenant) return;

//     const price = unit.offer_price || unit.actual_price;
//     apiJson(tenant, `/payment/fee-preview?price=${encodeURIComponent(price)}`, {
//       headers: {
//         Accept: "application/json",
//         ...(user?.token ? { Authorization: `Bearer ${user.token}` } : {}),
//       },
//     })
//       .then((d) => {
//         if (d) setFeeBreakdown(d.fee_breakdown || d);
//       })
//       .catch(() => {});
//   }, [tenant, unit, user?.token]);

//   // ── Panorama viewer ────────────────────────────────────────
//   const destroyViewer = useCallback(() => {
//     if (!viewerRef.current) return;
//     try {
//       viewerRef.current._cleanup?.();
//     } catch (e) {}
//     try {
//       if (
//         containerRef.current?.isConnected &&
//         containerRef.current?.hasChildNodes()
//       )
//         viewerRef.current.destroy();
//     } catch (e) {}
//     viewerRef.current = null;
//     markersRef.current = null;
//   }, []);

//   const buildMarkers = useCallback((unitData, hsData) => {
//     const markers = [];
//     hsData.forEach((hs) => {
//       if (!hs.yaw || !hs.pitch) return;
//       if (hs.hotspot_type === "gallery") {
//         markers.push({
//           id: `hs-gallery-${hs.id}`,
//           position: {
//             yaw: toRad(parseFloat(hs.yaw)),
//             pitch: toRad(parseFloat(hs.pitch)),
//           },
//           html: `<div class="hs-marker hs-gallery">🖼 ${hs.title || hs.label}</div>`,
//           size: { width: 170, height: 42 },
//           data: {
//             type: "gallery",
//             galleryIndex: hs.gallery_index ?? 0,
//             name: hs.title || hs.label,
//             yawRad: toRad(parseFloat(hs.yaw)),
//             pitchRad: toRad(parseFloat(hs.pitch)),
//           },
//         });
//       } else {
//         const room = unitData.rooms?.find(
//           (r) =>
//             r.id === hs.room_panorama_id ||
//             r.room_label === (hs.title || hs.label),
//         );
//         markers.push({
//           id: `hs-room-${hs.id}`,
//           position: {
//             yaw: toRad(parseFloat(hs.yaw)),
//             pitch: toRad(parseFloat(hs.pitch)),
//           },
//           html: `<div class="hs-marker hs-room">🚪 ${hs.title || hs.label}</div>`,
//           size: { width: 160, height: 42 },
//           data: {
//             type: "room",
//             roomId: room?.id || hs.room_panorama_id,
//             name: hs.title || hs.label,
//             yawRad: toRad(parseFloat(hs.yaw)),
//             pitchRad: toRad(parseFloat(hs.pitch)),
//           },
//         });
//       }
//     });
//     if (markers.length === 0 && unitData.rooms?.length > 0) {
//       unitData.rooms.forEach((room, idx) => {
//         const yaw = (idx / unitData.rooms.length) * 360 - 180;
//         markers.push({
//           id: `fallback-room-${room.id}`,
//           position: { yaw: toRad(yaw), pitch: toRad(-10) },
//           html: `<div class="hs-marker hs-room">🚪 ${room.room_label}</div>`,
//           size: { width: 160, height: 42 },
//           data: {
//             type: "room",
//             roomId: room.id,
//             name: room.room_label,
//             yawRad: toRad(yaw),
//             pitchRad: toRad(-10),
//           },
//         });
//       });
//     }
//     return markers;
//   }, []);

//   useEffect(() => {
//     if (
//       !unit?.panorama_url ||
//       !hotspots ||
//       !containerRef.current ||
//       activeTab !== "panorama"
//     )
//       return;

//     destroyViewer();
//     setIsLoaded(false);
//     setLoadProgress(0);

//     let current = 0;
//     const interval = setInterval(() => {
//       current += Math.random() * 10;
//       if (current >= 90) {
//         current = 90;
//         clearInterval(interval);
//       }
//       setLoadProgress(Math.round(current));
//     }, 180);

//     const fullPanoramaUrl = getFullImageUrl(unit.panorama_url);
//     if (!fullPanoramaUrl) {
//       setFetchError("Failed to construct panorama URL");
//       return;
//     }

//     const psvMarkers = buildMarkers(unit, hotspots);
//     allMarkerIdsRef.current = psvMarkers.map((m) => m.id);

//     const initTimer = setTimeout(() => {
//       if (!containerRef.current) return;
//       try {
//         viewerRef.current = new Viewer({
//           container: containerRef.current,
//           panorama: fullPanoramaUrl,
//           defaultZoomLvl: 50,
//           mousewheelCtrlKey: false,
//           loadingImg: null,
//           loadingTxt: "",
//           useXmpData: false,
//           plugins: [[MarkersPlugin, { markers: psvMarkers }]],
//         });
//       } catch (e) {
//         console.error("PSV init error:", e);
//         return;
//       }

//       const handleResize = () => {
//         try {
//           viewerRef.current?.autoSize();
//         } catch (e) {}
//       };
//       window.addEventListener("resize", handleResize);
//       document.addEventListener("fullscreenchange", handleResize);
//       document.addEventListener("webkitfullscreenchange", handleResize);

//       markersRef.current = viewerRef.current.getPlugin(MarkersPlugin);
//       viewerRef.current.addEventListener("ready", () => {
//         clearInterval(interval);
//         setLoadProgress(100);
//         setTimeout(() => setIsLoaded(true), 400);

//         let angle = 0,
//           isInteracting = false,
//           resumeTimer = null;
//         const swing = () => {
//           if (!isInteracting) {
//             angle += 0.0015;
//             try {
//               viewerRef.current?.rotate({
//                 yaw: Math.sin(angle) * 0.06,
//                 pitch: 0,
//               });
//             } catch (e) {}
//           }
//           if (viewerRef.current)
//             viewerRef.current._rafId = requestAnimationFrame(swing);
//         };
//         viewerRef.current._rafId = requestAnimationFrame(swing);

//         const onStart = () => {
//           isInteracting = true;
//           clearTimeout(resumeTimer);
//         };
//         const onEnd = () => {
//           resumeTimer = setTimeout(() => {
//             isInteracting = false;
//           }, 2500);
//         };
//         const el = containerRef.current;
//         if (el) {
//           el.addEventListener("mousedown", onStart, { passive: true });
//           el.addEventListener("mouseup", onEnd, { passive: true });
//           el.addEventListener("touchstart", onStart, { passive: true });
//           el.addEventListener("touchend", onEnd, { passive: true });
//         }
//         viewerRef.current._cleanup = () => {
//           if (viewerRef.current?._rafId)
//             cancelAnimationFrame(viewerRef.current._rafId);
//           clearTimeout(resumeTimer);
//           window.removeEventListener("resize", handleResize);
//           document.removeEventListener("fullscreenchange", handleResize);
//           document.removeEventListener("webkitfullscreenchange", handleResize);
//           if (el) {
//             el.removeEventListener("mousedown", onStart);
//             el.removeEventListener("mouseup", onEnd);
//             el.removeEventListener("touchstart", onStart);
//             el.removeEventListener("touchend", onEnd);
//           }
//         };
//       });

//       // Handle error event
//       viewerRef.current.addEventListener("error", (e) => {
//         console.error("PSV viewer error:", e);
//       });

//       markersRef.current?.addEventListener("select-marker", ({ marker }) => {
//         const { type, roomId, galleryIndex, name, yawRad, pitchRad } =
//           marker.data;
//         allMarkerIdsRef.current.forEach((id) => {
//           try {
//             markersRef.current?.updateMarker({ id, opacity: 0 });
//           } catch (e) {}
//         });
//         if (labelRef.current) {
//           labelRef.current.textContent = name;
//           labelRef.current.style.opacity = "1";
//         }
//         viewerRef.current
//           ?.animate({ yaw: yawRad, pitch: pitchRad, zoom: 60, speed: "4rpm" })
//           .then(() =>
//             viewerRef.current?.animate({
//               yaw: yawRad,
//               pitch: pitchRad,
//               zoom: 100,
//               speed: "20rpm",
//             }),
//           )
//           .then(() => {
//             if (overlayRef.current) {
//               overlayRef.current.style.transition = "opacity 0.4s ease-in";
//               overlayRef.current.style.opacity = "1";
//             }
//             setTimeout(() => {
//               if (type === "gallery")
//                 navigate(`/${tenant}/unit/${plotId}/gallery/${galleryIndex}`);
//               else navigate(`/${tenant}/unit/${plotId}/room/${roomId}`);
//             }, 450);
//           });
//       });
//     }, 50);

//     return () => {
//       clearInterval(interval);
//       clearTimeout(initTimer);
//       destroyViewer();
//     };
//   }, [
//     unit,
//     hotspots,
//     activeTab,
//     tenant,
//     plotId,
//     getFullImageUrl,
//     buildMarkers,
//     destroyViewer,
//     navigate,
//   ]);

//   useEffect(() => {
//     if (!overlayRef.current) return;
//     overlayRef.current.style.opacity = "1";
//     overlayRef.current.style.transition = "none";
//     const t = setTimeout(() => {
//       overlayRef.current.style.transition = "opacity 0.7s ease-out";
//       overlayRef.current.style.opacity = "0";
//     }, 50);
//     return () => clearTimeout(t);
//   }, []);

//   // ── Auth handlers (sidebar-embedded login/register/otp) ────
//   const handleLogin = async () => {
//     setAuthLoading(true);
//     setAuthError("");
//     try {
//       const data = await login(loginForm);

//       if (data.step === "verify_email") {
//         setPendingUserId(data.user_id);
//         setBookingStep("verify_email");
//         setAuthLoading(false);
//         return;
//       }
//       if (data.step === "verify_phone") {
//         setPendingUserId(data.user_id);
//         setBookingStep("verify_phone");
//         setAuthLoading(false);
//         return;
//       }

//       setBookingForm((f) => ({
//         ...f,
//         name: data.user.name || "",
//         phone: (data.user.country_code || "") + (data.user.phone || ""),
//       }));
//       afterAuth();
//     } catch (err) {
//       setAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleRegister = async () => {
//     setAuthLoading(true);
//     setAuthError("");
//     try {
//       const data = await register(registerForm);

//       setPendingUserId(data.user_id);
//       setBookingStep("verify_email");
//       setAuthError("");
//     } catch (err) {
//       setAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleVerifyEmail = async (otp) => {
//     setAuthLoading(true);
//     setAuthError("");
//     try {
//       const data = await verifyEmail(pendingUserId, otp);

//       setPendingUserId(data.user_id);
//       setBookingStep("verify_phone");
//       setAuthError("");
//     } catch (err) {
//       setAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleVerifyPhone = async (otp) => {
//     setAuthLoading(true);
//     setAuthError("");
//     try {
//       const data = await verifyPhone(pendingUserId, otp);

//       setBookingForm((f) => ({
//         ...f,
//         name: data.user.name || "",
//         phone: (data.user.country_code || "") + (data.user.phone || ""),
//       }));
//       afterAuth();
//     } catch (err) {
//       setAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleResendOtp = async (type) => {
//     if (!pendingUserId) return;
//     setAuthLoading(true);
//     setAuthError("");
//     try {
//       const data = await resendOtp(pendingUserId, type);
//       setAuthError("✓ " + data.message);
//     } catch (err) {
//       setAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   // ── Modal auth handlers (login/register/otp inside the popup modal) ──
//   const handleModalLogin = async () => {
//     setAuthLoading(true);
//     setModalAuthError("");
//     try {
//       const data = await login(loginForm);

//       if (data.step === "verify_email") {
//         setModalPendingUserId(data.user_id);
//         setModalStep("verify_email");
//         setAuthLoading(false);
//         return;
//       }
//       if (data.step === "verify_phone") {
//         setModalPendingUserId(data.user_id);
//         setModalStep("verify_phone");
//         setAuthLoading(false);
//         return;
//       }

//       setLoginModalOpen(false);

//       if (authIntent === "wishlist") {
//         wishlistWithToken(data.user.token, plotId, unit?.plot_number);
//       } else if (authIntent === "book") {
//         setBookingForm((f) => ({
//           ...f,
//           name: data.user.name || "",
//           phone: (data.user.country_code || "") + (data.user.phone || ""),
//         }));
//         openBooking(data.user);
//       }
//       setAuthIntent(null);
//     } catch (err) {
//       setModalAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleModalRegister = async () => {
//     setAuthLoading(true);
//     setModalAuthError("");
//     try {
//       const data = await register(registerForm);

//       setModalPendingUserId(data.user_id);
//       setModalStep("verify_email");
//       setModalAuthError("");
//     } catch (err) {
//       setModalAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleModalVerifyEmail = async (otp) => {
//     setAuthLoading(true);
//     setModalAuthError("");
//     try {
//       const data = await verifyEmail(modalPendingUserId, otp);

//       setModalPendingUserId(data.user_id);
//       setModalStep("verify_phone");
//       setModalAuthError("");
//     } catch (err) {
//       setModalAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleModalVerifyPhone = async (otp) => {
//     setAuthLoading(true);
//     setModalAuthError("");
//     try {
//       const data = await verifyPhone(modalPendingUserId, otp);

//       setLoginModalOpen(false);

//       if (authIntent === "wishlist") {
//         wishlistWithToken(data.user.token, plotId, unit?.plot_number);
//       } else if (authIntent === "book") {
//         setBookingForm((f) => ({
//           ...f,
//           name: data.user.name || "",
//           phone: (data.user.country_code || "") + (data.user.phone || ""),
//         }));
//         openBooking(data.user);
//       }
//       setAuthIntent(null);
//     } catch (err) {
//       setModalAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleModalResendOtp = async (type) => {
//     if (!modalPendingUserId) return;
//     setAuthLoading(true);
//     setModalAuthError("");
//     try {
//       const data = await resendOtp(modalPendingUserId, type);
//       setModalAuthError("✓ " + data.message);
//     } catch (err) {
//       setModalAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const closeModal = () => {
//     setLoginModalOpen(false);
//     setAuthIntent(null);
//     setModalStep("login");
//     setModalAuthError("");
//   };

//   // ── Booking submit ─────────────────────────────────────────
//   const handleBooking = async () => {
//     setAuthLoading(true);
//     setAuthError("");
//     const isAgent = user?.role === "broker" || user?.role === "sales";
//     if (isAgent && user?.status && user.status !== "active") {
//       setAuthError(
//         "Your account is currently inactive. Please contact the admin to activate your account before booking.",
//       );
//       setAuthLoading(false);
//       return;
//     }
//     try {
//       if (existingBookingId) {
//         const data = await apiJson(
//           tenant,
//           `/bookings/${existingBookingId}/plan`,
//           {
//             method: "PATCH",
//             headers: {
//               "Content-Type": "application/json",
//               Accept: "application/json",
//               Authorization: `Bearer ${user?.token}`,
//             },
//             body: JSON.stringify({ payment_plan_id: selectedPlan }),
//           },
//         );

//         if (data.booking?.fee_breakdown)
//           setFeeBreakdown(data.booking.fee_breakdown);
//         setTimeout(
//           () => navigate(`/${tenant}/payment/${existingBookingId}`),
//           400,
//         );
//         return;
//       }

//       const payload = {
//         plot_id: plotId,
//         plot_number: unit.plot_number,
//         plot_type: unit.plot_type,
//         block: unit.block,
//         section: unit.section,
//         direction: unit.direction,
//         area: unit.plot_size ? String(unit.plot_size) : "",
//         price: unit.offer_price
//           ? String(unit.offer_price)
//           : String(unit.actual_price || ""),
//         project_id: unit.project_id,
//         block_id: unit.block_id,
//         name: bookingForm.name,
//         phone: bookingForm.phone,
//         notes: bookingForm.notes,
//         payment_plan_id: selectedPlan,
//         client_name: isAgent ? bookingForm.client_name : undefined,
//         client_phone: isAgent
//           ? bookingForm.client_country_code + bookingForm.client_phone
//           : undefined,
//         client_email: isAgent ? bookingForm.client_email : undefined,
//       };

//       const data = await apiJson(tenant, `/bookings`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//           Authorization: `Bearer ${user?.token}`,
//         },
//         body: JSON.stringify(payload),
//       });

//       if (data.booking?.fee_breakdown)
//         setFeeBreakdown(data.booking.fee_breakdown);

//       const bookingId = data.booking?.id;
//       if (bookingId) {
//         showToast(
//           `🎉 Booking confirmed! Redirecting to payment…`,
//           "success",
//           2500,
//         );
//         setTimeout(() => navigate(`/${tenant}/payment/${bookingId}`), 400);
//       } else {
//         setBookingDone(true);
//         showToast(
//           `✅ Booking received! We'll contact you shortly.`,
//           "success",
//           4000,
//         );
//       }
//     } catch (err) {
//       setAuthError(err.message);
//     }
//     setAuthLoading(false);
//   };

//   const handleBack = () => {
//     if (overlayRef.current) {
//       overlayRef.current.style.transition = "opacity 0.4s ease-in";
//       overlayRef.current.style.opacity = "1";
//     }
//     const dest = unit?.block_id
//       ? `/${tenant}/floor/${unit.block_id}`
//       : unit?.floor_id
//         ? `/${tenant}/floor/${unit.floor_id}`
//         : null;
//     setTimeout(() => (dest ? navigate(dest) : navigate(`/${tenant}`)), 450);
//   };

//   const switchToGallery = () => {
//     destroyViewer();
//     setActiveTab("gallery");
//     setIsLoaded(false);
//   };
//   const switchToPanorama = () => setActiveTab("panorama");
//   const switchToDetails = () => {
//     destroyViewer();
//     setActiveTab("details");
//   };

//   const hasPlans = (unit?.payment_plans?.length || 0) > 0;
//   const afterAuth = () => setBookingStep(hasPlans ? "plan" : "form");

//   // Accepts an optional user override so it can run immediately after a
//   // fresh login/registration (before AuthContext's `user` re-renders).
//   const openBooking = async (authedUser = user) => {
//     setSidebarOpen(true);
//     setBookingDone(false);
//     setAuthError("");
//     if (authedUser) {
//       if (
//         (authedUser.role === "broker" || authedUser.role === "sales") &&
//         authedUser.status &&
//         authedUser.status !== "active"
//       ) {
//         setBookingStep("broker_inactive");
//         return;
//       }
//       try {
//         const data = await apiJson(tenant, `/bookings`, {
//           headers: {
//             Authorization: `Bearer ${authedUser.token}`,
//             Accept: "application/json",
//           },
//         });

//         const bookings = Array.isArray(data) ? data : data.data || [];
//         const existing = bookings.find(
//           (b) =>
//             String(b.plot_id) === String(plotId) &&
//             b.booking_status !== "cancelled",
//         );
//         if (existing) {
//           setExistingBookingId(existing.id);
//           setSelectedPlan(existing.payment_plan_id || null);
//           try {
//             const d = await apiJson(tenant, `/bookings/${existing.id}`, {
//               headers: {
//                 Authorization: `Bearer ${authedUser.token}`,
//                 Accept: "application/json",
//               },
//             });
//             if (d?.booking?.fee_breakdown)
//               setFeeBreakdown(d.booking.fee_breakdown);
//           } catch (e) {}

//           if (existing.booking_status === "confirmed") {
//             setBookingDone(true);
//             setBookingStep("details");
//             return;
//           }
//           setBookingStep(hasPlans ? "plan" : "form");
//           return;
//         }
//       } catch (e) {}
//       setExistingBookingId(null);
//       setBookingStep(hasPlans ? "plan" : "form");
//     } else {
//       setExistingBookingId(null);
//       setBookingStep("details");
//     }
//   };

//   const logout = () => {
//     signOut();
//     setBookingStep("details");
//     setSelectedPlan(null);
//     setExistingBookingId(null);
//   };

//   useEffect(() => {
//     if (user)
//       setBookingForm((f) => ({
//         ...f,
//         name: f.name || user.name || "",
//         phone: f.phone || (user.country_code || "") + (user.phone || ""),
//       }));
//   }, [user?.id]);

//   // ── Helpers ────────────────────────────────────────────────
//   const fmtPrice = (val) =>
//     val ? `${currency} ${Number(val).toLocaleString("en-IN")}` : null;
//   const getStatusColor = (s) => {
//     const v = s?.toLowerCase();
//     return v === "available"
//       ? "#16a34a"
//       : v === "pre-booked"
//         ? "#d97706"
//         : "#dc2626";
//   };

//   // ── Guards ─────────────────────────────────────────────────
//   if (isFetching || !settingsLoaded)
//     return (
//       <div className="unit-loading-screen">
//         <div style={{ fontSize: 48 }}>🏠</div>
//         <div
//           style={{ color: "var(--text-dark)", fontSize: 16, fontWeight: 600 }}
//         >
//           {!settingsLoaded ? "Loading settings..." : "Loading unit…"}
//         </div>
//         <div className="loading-bar-track">
//           <div className="loading-bar-fill" />
//         </div>
//       </div>
//     );
//   if (fetchError || !unit)
//     return (
//       <div className="unit-loading-screen">
//         <div style={{ fontSize: 48 }}>⚠️</div>
//         <h2 style={{ color: "var(--text-dark)" }}>Unit Unavailable</h2>
//         <p style={{ color: "var(--text-muted)" }}>
//           {fetchError || "Unit not found."}
//         </p>
//         <button
//           onClick={() => navigate(`/${tenant}`)}
//           style={{
//             padding: "10px 24px",
//             background: "var(--primary-color)",
//             color: "#fff",
//             border: "none",
//             borderRadius: 8,
//             cursor: "pointer",
//             fontWeight: 700,
//           }}
//         >
//           ← Go Back
//         </button>
//       </div>
//     );

//   const gallery = unit.gallery_images || [];
//   const hasPano = !!unit.panorama_url;
//   const hasGal = gallery.length > 0;
//   const hasRooms = unit.rooms?.length > 0;
//   const isAvail = unit.status?.toLowerCase() === "available";
//   const statusColor = getStatusColor(unit.status);
//   const isWished =
//     wishedIds instanceof Set ? wishedIds.has(Number(plotId)) : false;
//   const sym = feeBreakdown?.currency_symbol || currency;

//   // ── Theme — colors & fonts pulled from the tenant's own backend
//   // settings instead of the hardcoded ERA defaults, so each tenant's
//   // branding actually applies. Falls back to the CSS :root defaults
//   // in UnitPage.css whenever a given setting isn't present.
//   const themeVars = {
//     ...(settings?.primary_color && { "--primary-color": settings.primary_color }),
//     ...(settings?.primary_hover_color && { "--primary-hover": settings.primary_hover_color }),
//     ...(settings?.page_bg_color && { "--page-bg": settings.page_bg_color }),
//     ...(settings?.card_bg_color && { "--card-bg": settings.card_bg_color }),
//     ...(settings?.card_border_color && { "--card-border": settings.card_border_color }),
//     ...(settings?.text_dark_color && { "--text-dark": settings.text_dark_color }),
//     ...(settings?.text_muted_color && { "--text-muted": settings.text_muted_color }),
//     ...(settings?.header_bg_color && { "--header-bg": settings.header_bg_color }),
//     ...(settings?.font_heading && { "--font-heading": settings.font_heading }),
//     ...(settings?.font_body && { "--font-body": settings.font_body }),
//   };

//   return (
//     <div className="unit-page" style={themeVars}>
//       {/* ── Auth modal (wishlist + book-now-when-logged-out) ── */}
//       {loginModalOpen && (
//         <>
//           <div className="up-modal-backdrop" onClick={closeModal} />
//           <div className="up-modal">
//             <div className="up-modal-head">
//               <div className="up-modal-title">
//                 {modalStep === "verify_email"
//                   ? "📧 Verify Email"
//                   : modalStep === "verify_phone"
//                     ? "📱 Verify Phone"
//                     : authIntent === "book"
//                       ? "🏠 Login to Book"
//                       : authIntent === "wishlist"
//                         ? "❤️ Save to Wishlist"
//                         : "👤 Login to your account"}
//               </div>
//               <button className="up-modal-close" onClick={closeModal}>
//                 ×
//               </button>
//             </div>
//             {modalStep === "verify_email" ? (
//               <StepOtp
//                 key="modal-otp-email"
//                 type="email"
//                 onVerify={handleModalVerifyEmail}
//                 onResend={() => handleModalResendOtp("email")}
//                 loading={authLoading}
//                 error={modalAuthError}
//                 setError={setModalAuthError}
//               />
//             ) : modalStep === "verify_phone" ? (
//               <StepOtp
//                 key="modal-otp-phone"
//                 type="phone"
//                 onVerify={handleModalVerifyPhone}
//                 onResend={() => handleModalResendOtp("phone")}
//                 loading={authLoading}
//                 error={modalAuthError}
//                 setError={setModalAuthError}
//               />
//             ) : (
//               <>
//                 <div className="up-modal-tabs">
//                   {["login", "register"].map((tab) => (
//                     <button
//                       key={tab}
//                       className={`up-modal-tab${modalStep === tab ? " active" : ""}`}
//                       onClick={() => {
//                         setModalStep(tab);
//                         setModalAuthError("");
//                       }}
//                     >
//                       {tab === "login" ? "Log In" : "Register"}
//                     </button>
//                   ))}
//                 </div>
//                 <p
//                   style={{
//                     color: "var(--text-muted)",
//                     fontSize: 13,
//                     marginBottom: 16,
//                     lineHeight: 1.6,
//                   }}
//                 >
//                   {authIntent === "book"
//                     ? modalStep === "login"
//                       ? "Log in to continue booking this unit."
//                       : "Create an account to book this unit."
//                     : authIntent === "wishlist"
//                       ? modalStep === "login"
//                         ? "Log in to save this unit to your wishlist."
//                         : "Create an account to save this unit."
//                       : modalStep === "login"
//                         ? "Log in to access your account."
//                         : "Create an account to get started."}
//                 </p>
//                 {modalStep === "login" ? (
//                   <StepLogin
//                     form={loginForm}
//                     setForm={setLoginForm}
//                     onLogin={handleModalLogin}
//                     onSwitch={() => {
//                       setModalStep("register");
//                       setModalAuthError("");
//                     }}
//                     loading={authLoading}
//                     error={modalAuthError}
//                   />
//                 ) : (
//                   <StepRegister
//                     form={registerForm}
//                     setForm={setRegisterForm}
//                     onRegister={handleModalRegister}
//                     onSwitch={() => {
//                       setModalStep("login");
//                       setModalAuthError("");
//                     }}
//                     loading={authLoading}
//                     error={modalAuthError}
//                   />
//                 )}
//               </>
//             )}
//           </div>
//         </>
//       )}

//       {/* ── Vertical nav rail — replaces the old horizontal header.
//            Same handlers as before (handleBack, switchToDetails,
//            switchToPanorama, switchToGallery, openBooking, wishlist
//            toggle, dashboard/login navigation) — only the layout moved. ── */}
//       <div className="unit-nav-rail">
//         <button className="rail-back-btn" onClick={handleBack} title="Back to floor">
//           ←
//         </button>

//         <div
//           className="rail-status-dot"
//           style={{ background: statusColor }}
//           title={unit.status}
//         />

//         <div className="rail-nav">
//           <button
//             className={`rail-nav-btn${activeTab === "details" ? " active" : ""}`}
//             onClick={switchToDetails}
//             title="Details"
//           >
//             <span className="rail-icon">📋</span>
//             <span className="rail-label">Info</span>
//           </button>
//           {hasPano && (
//             <button
//               className={`rail-nav-btn${activeTab === "panorama" ? " active" : ""}`}
//               onClick={switchToPanorama}
//               title="360° View"
//             >
//               <span className="rail-icon">🌐</span>
//               <span className="rail-label">360°</span>
//             </button>
//           )}
//           {hasGal && (
//             <button
//               className={`rail-nav-btn${activeTab === "gallery" ? " active" : ""}`}
//               onClick={switchToGallery}
//               title={`Gallery (${gallery.length})`}
//             >
//               <span className="rail-icon">🖼</span>
//               <span className="rail-label">Gallery</span>
//             </button>
//           )}
//         </div>

//         <div className="rail-spacer" />

//         {isAvail && (
//           <button
//             className="rail-book-btn"
//             onClick={() => {
//               if (user) {
//                 openBooking();
//               } else {
//                 setAuthIntent("book");
//                 setModalStep("login");
//                 setModalAuthError("");
//                 setLoginModalOpen(true);
//               }
//             }}
//             title="Book Now"
//           >
//             <span className="rail-icon">✦</span>
//             <span className="rail-label">Book</span>
//           </button>
//         )}

//         {unit && (
//           <button
//             className={`rail-action-btn${isWished ? " wished" : ""}`}
//             onClick={() => {
//               if (!user?.token) {
//                 setAuthIntent("wishlist");
//                 setModalStep("login");
//                 setModalAuthError("");
//                 setLoginModalOpen(true);
//               } else {
//                 const willAdd = !isWished;
//                 toggleWish(Number(plotId))
//                   .then(() => {
//                     showToast(
//                       willAdd
//                         ? `❤️ Added to Wishlist — Unit ${unit.plot_number}`
//                         : `🤍 Removed from Wishlist — Unit ${unit.plot_number}`,
//                       willAdd ? "wishlist_add" : "wishlist_remove",
//                       2800,
//                     );
//                   })
//                   .catch(() => {
//                     showToast(
//                       "Failed to update wishlist. Please try again.",
//                       "error",
//                       3000,
//                     );
//                   });
//               }
//             }}
//             title={isWished ? "Remove from Wishlist" : "Save to Wishlist"}
//           >
//             {isWished ? "❤️" : "🤍"}
//           </button>
//         )}

//         {user ? (
//           <button
//             className="rail-avatar"
//             onClick={() => navigate(`/${tenant}/dashboard`)}
//             title={`${user.name} — My Dashboard`}
//           >
//             {user.name?.[0]?.toUpperCase()}
//           </button>
//         ) : (
//           <button
//             className="rail-action-btn"
//             onClick={() => {
//               setAuthIntent(null);
//               setModalStep("login");
//               setModalAuthError("");
//               setLoginModalOpen(true);
//             }}
//             title="Login"
//           >
//             👤
//           </button>
//         )}
//       </div>

//       {/* ── Main wrapper — everything to the right of the rail ── */}
//       <div className="unit-main-wrapper">
//         <div className="unit-content-area">
//         {/* Full-screen panorama */}
//         {activeTab === "panorama" && (
//           <div className="unit-fullview">
//             <div ref={containerRef} className="psv-container-div" />
//             <div className={`pano-loader${isLoaded ? " gone" : ""}`}>
//               <div className="pano-loader-card">
//                 <div className="pano-loader-emoji">🏠</div>
//                 <div className="pano-loader-percent">{loadProgress}%</div>
//                 <div className="pano-loader-bar-track">
//                   <div
//                     className="pano-loader-bar-fill"
//                     style={{ width: `${loadProgress}%` }}
//                   />
//                 </div>
//                 <div className="pano-loader-text">
//                   {loadProgress < 40
//                     ? "Preparing panorama..."
//                     : loadProgress < 80
//                       ? "Loading image data..."
//                       : loadProgress < 100
//                         ? "Almost ready..."
//                         : "✓ Ready"}
//                 </div>
//               </div>
//             </div>
//             {isLoaded && hasRooms && (
//               <div className="room-nav-strip">
//                 <span className="room-nav-label">Rooms</span>
//                 {unit.rooms.map((room) => (
//                   <button
//                     key={room.id}
//                     className="room-thumb-btn"
//                     onClick={() =>
//                       navigate(`/${tenant}/unit/${plotId}/room/${room.id}`)
//                     }
//                   >
//                     {room.thumb_url ? (
//                       <img
//                         src={getFullImageUrl(room.thumb_url)}
//                         alt={room.room_label}
//                       />
//                     ) : (
//                       <div className="room-thumb-placeholder">🚪</div>
//                     )}
//                     <span>{room.room_label}</span>
//                   </button>
//                 ))}
//               </div>
//             )}
//             <div ref={labelRef} className="marker-label" />
//           </div>
//         )}

//         {/* Two-column layout for details / gallery — sidebar on the
//             left (booking widget), main content flows on the right
//             as one continuous page (see .unit-detail-layout CSS
//             `order` swap). */}
//         {activeTab !== "panorama" && (
//           <div className="unit-detail-layout">
//             {/* ── MAIN CONTENT (renders on the right via CSS order) ── */}
//             <div className="unit-detail-left">
//               {activeTab === "details" && (
//                 <EraUnitDetails
//                   unit={unit}
//                   fmtPrice={fmtPrice}
//                   statusColor={statusColor}
//                   currency={currency}
//                   sym={sym}
//                   feeBreakdown={feeBreakdown}
//                   getFullImageUrl={getFullImageUrl}
//                   gallery={gallery}
//                   hasPano={hasPano}
//                   plotId={plotId}
//                   tenant={tenant}
//                   navigate={navigate}
//                   galIdx={galIdx}
//                   setGalIdx={setGalIdx}
//                   onOpenPano={switchToPanorama}
//                   PaymentPlansContent={PaymentPlansContent}
//                 />
//               )}

//               {activeTab === "gallery" && hasGal && (
//                 <>
//                   <EraGallery
//                     gallery={gallery}
//                     hasPano={hasPano}
//                     plotId={plotId}
//                     tenant={tenant}
//                     navigate={navigate}
//                     galIdx={galIdx}
//                     setGalIdx={setGalIdx}
//                     onOpenPano={switchToPanorama}
//                   />
//                   <div style={{ padding: "0 56px 44px" }}>
//                     <div className="era-floor-plan-section-label">
//                       All Photos ({gallery.length})
//                     </div>
//                     <div
//                       style={{
//                         display: "grid",
//                         gridTemplateColumns:
//                           "repeat(auto-fill, minmax(200px, 1fr))",
//                         gap: 10,
//                       }}
//                     >
//                       {gallery.map((img, i) => {
//                         const imgUrl = img;
//                         return imgUrl ? (
//                           <img
//                             key={i}
//                             src={imgUrl}
//                             alt={`Gallery ${i + 1}`}
//                             onClick={() => {
//                               setGalIdx(i);
//                               navigate(
//                                 `/${tenant}/unit/${plotId}/gallery/${i}`,
//                               );
//                             }}
//                             style={{
//                               width: "100%",
//                               aspectRatio: "4/3",
//                               objectFit: "cover",
//                               cursor: "pointer",
//                               border: `2px solid ${i === galIdx ? "var(--primary-color)" : "transparent"}`,
//                               transition: "all 0.2s",
//                             }}
//                           />
//                         ) : null;
//                       })}
//                     </div>
//                   </div>
//                 </>
//               )}
//             </div>

//             {/* ── SIDEBAR — booking widget (renders on the left via CSS order) ── */}
//             <div
//               className={`unit-detail-right${sidebarOpen ? " sidebar-open" : ""}`}
//             >
//               <div className="right-panel-header">
//                 <div className="right-panel-price">
//                   {unit.offer_price
//                     ? fmtPrice(unit.offer_price)
//                     : fmtPrice(unit.actual_price)}
//                 </div>
//                 {unit.offer_price && (
//                   <div className="right-panel-price-orig">
//                     {fmtPrice(unit.actual_price)}
//                   </div>
//                 )}
//                 {feeBreakdown?.tax_enabled &&
//                   feeBreakdown?.total_amount > 0 && (
//                     <div
//                       style={{
//                         fontSize: 12,
//                         color: "#b45309",
//                         fontWeight: 600,
//                         marginTop: 3,
//                       }}
//                     >
//                       Grand Total: {fmtExact(feeBreakdown.total_amount, sym)}{" "}
//                       (incl. tax)
//                     </div>
//                   )}
//                 <div className="right-panel-title">Unit {unit.plot_number}</div>
//                 <div className="right-panel-sub">
//                   {unit.plot_type}
//                   {unit.plot_size ? ` · ${unit.plot_size} sqft` : ""}
//                   {unit.direction ? ` · ${unit.direction}` : ""}
//                 </div>
//                 <div
//                   style={{
//                     marginTop: 8,
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: 5,
//                     padding: "3px 12px",
//                     borderRadius: 20,
//                     fontSize: 12,
//                     fontWeight: 700,
//                     background: statusColor + "18",
//                     color: statusColor,
//                     border: `1px solid ${statusColor}44`,
//                   }}
//                 >
//                   ● {unit.status}
//                 </div>
//               </div>

//               {/* Quick stat pills */}
//               <div style={{ padding: "14px 32px 0" }}>
//                 <div className="rp-stats">
//                   {unit.bedrooms != null && (
//                     <div className="rp-stat">
//                       <span className="rp-stat-icon">🛏</span>
//                       <div className="rp-stat-val">{unit.bedrooms}</div>
//                       <div className="rp-stat-lbl">Beds</div>
//                     </div>
//                   )}
//                   {unit.bathrooms != null && (
//                     <div className="rp-stat">
//                       <span className="rp-stat-icon">🚿</span>
//                       <div className="rp-stat-val">{unit.bathrooms}</div>
//                       <div className="rp-stat-lbl">Baths</div>
//                     </div>
//                   )}
//                   {unit.plot_size && (
//                     <div className="rp-stat">
//                       <span className="rp-stat-icon">📐</span>
//                       <div className="rp-stat-val">{unit.plot_size}</div>
//                       <div className="rp-stat-lbl">sqft</div>
//                     </div>
//                   )}
//                   {!unit.bedrooms && !unit.bathrooms && !unit.plot_size && (
//                     <>
//                       <div className="rp-stat">
//                         <span className="rp-stat-icon">🏢</span>
//                         <div className="rp-stat-val">
//                           {unit.plot_type || "—"}
//                         </div>
//                         <div className="rp-stat-lbl">Type</div>
//                       </div>
//                       <div className="rp-stat">
//                         <span className="rp-stat-icon">🧭</span>
//                         <div className="rp-stat-val">
//                           {unit.direction || "—"}
//                         </div>
//                         <div className="rp-stat-lbl">Facing</div>
//                       </div>
//                       <div className="rp-stat">
//                         <span className="rp-stat-icon">🚪</span>
//                         <div className="rp-stat-val">
//                           {unit.rooms?.length || 0}
//                         </div>
//                         <div className="rp-stat-lbl">Rooms</div>
//                       </div>
//                     </>
//                   )}
//                 </div>
//               </div>

//               <div className="right-panel-scroll">
//                 {bookingStep === "broker_inactive" ? (
//                   <BrokerInactiveScreen onClose={() => setSidebarOpen(false)} />
//                 ) : bookingDone ? (
//                   <BookingDone
//                     unit={unit}
//                     onClose={() => setSidebarOpen(false)}
//                   />
//                 ) : bookingStep === "details" ? (
//                   <StepDetails
//                     user={user}
//                     onBook={() =>
//                       user
//                         ? hasPlans
//                           ? setBookingStep("plan")
//                           : setBookingStep("form")
//                         : setBookingStep("login")
//                     }
//                     onLogout={logout}
//                     isAvail={isAvail}
//                   />
//                 ) : bookingStep === "login" ? (
//                   <StepLogin
//                     form={loginForm}
//                     setForm={setLoginForm}
//                     onLogin={handleLogin}
//                     onSwitch={() => {
//                       setBookingStep("register");
//                       setAuthError("");
//                     }}
//                     loading={authLoading}
//                     error={authError}
//                   />
//                 ) : bookingStep === "register" ? (
//                   <StepRegister
//                     form={registerForm}
//                     setForm={setRegisterForm}
//                     onRegister={handleRegister}
//                     onSwitch={() => {
//                       setBookingStep("login");
//                       setAuthError("");
//                     }}
//                     loading={authLoading}
//                     error={authError}
//                   />
//                 ) : bookingStep === "verify_email" ? (
//                   <StepOtp
//                     key="otp-email"
//                     type="email"
//                     onVerify={handleVerifyEmail}
//                     onResend={() => handleResendOtp("email")}
//                     loading={authLoading}
//                     error={authError}
//                     setError={setAuthError}
//                   />
//                 ) : bookingStep === "verify_phone" ? (
//                   <StepOtp
//                     key="otp-phone"
//                     type="phone"
//                     onVerify={handleVerifyPhone}
//                     onResend={() => handleResendOtp("phone")}
//                     loading={authLoading}
//                     error={authError}
//                     setError={setAuthError}
//                   />
//                 ) : bookingStep === "plan" ? (
//                   <StepPlanSelect
//                     plans={unit.payment_plans || []}
//                     selected={selectedPlan}
//                     onSelect={setSelectedPlan}
//                     fmtPrice={fmtPrice}
//                     unitPrice={unit.actual_price}
//                     onNext={() => setBookingStep("form")}
//                     onBack={() => setBookingStep("details")}
//                     existingBookingId={existingBookingId}
//                     feeBreakdown={feeBreakdown}
//                     sym={sym}
//                   />
//                 ) : bookingStep === "form" ? (
//                   <StepBookingForm
//                     user={user}
//                     form={bookingForm}
//                     setForm={setBookingForm}
//                     onSubmit={handleBooking}
//                     loading={authLoading}
//                     error={authError}
//                     selectedPlan={selectedPlan}
//                     plans={unit.payment_plans || []}
//                     onBack={() =>
//                       hasPlans
//                         ? setBookingStep("plan")
//                         : setBookingStep("details")
//                     }
//                     unit={unit}
//                     existingBookingId={existingBookingId}
//                     feeBreakdown={feeBreakdown}
//                     sym={sym}
//                   />
//                 ) : null}
//               </div>
//             </div>
//           </div>
//         )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UnitPage;

import { useEffect, useRef, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useWishlist } from "../hooks/useWishlist";
import { useToast } from "../context/ToastContext";
import { useSettings } from "../context/SettingsContext";
import { apiJson } from "../api/apiClient";

import { Viewer } from "@photo-sphere-viewer/core";
import { MarkersPlugin } from "@photo-sphere-viewer/markers-plugin";
import "@photo-sphere-viewer/core/index.css";
import "@photo-sphere-viewer/markers-plugin/index.css";
import "../styles/UnitPage.css";

/* ═════════════════════════════════════════════════════════════
   Reveal — wraps a section so it fades/slides in the first time it
   scrolls into view (matches the reference site's scroll animation).
   Pure CSS transition driven by IntersectionObserver; no layout
   logic, so it's safe to drop around any block.
═════════════════════════════════════════════════════════════ */
const Reveal = ({ children, delay = 0 }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`era-reveal${visible ? " era-reveal-visible" : ""}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

const toRad = (deg) => parseFloat((deg * (Math.PI / 180)).toFixed(6));

const AMENITY_ICONS = {
  "Swimming Pool": "🏊",
  Gym: "🏋️",
  Parking: "🚗",
  "24/7 Security": "🔒",
  "Club House": "🏛️",
  "Children Play Area": "🛝",
  "Jogging Track": "🏃",
  Garden: "🌿",
  Lift: "🛗",
  "Power Backup": "⚡",
  "CCTV Surveillance": "📹",
  Intercom: "📞",
  "Visitor Parking": "🅿️",
  Terrace: "🏙️",
};
const amenityIcon = (name) => AMENITY_ICONS[name] || "✨";
const toFt = (m) => (m * 3.28084).toFixed(1);

const fmtExact = (n, sym = "₹") => {
  if (n == null || n === "") return "—";
  return (
    sym +
    parseFloat(n).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
};

const fmtRound = (n, sym = "₹") => {
  if (n == null || n === "") return "—";
  return (
    sym + parseFloat(n).toLocaleString("en-IN", { maximumFractionDigits: 0 })
  );
};

const computeMilestoneAmounts = (milestonePercent, feeBreakdown) => {
  if (!feeBreakdown || !milestonePercent) return null;
  const pct = parseFloat(milestonePercent) / 100;

  const unitPrice = feeBreakdown.unit_price || 0;
  const base = unitPrice * pct;
  const tax = (feeBreakdown.tax_amount || 0) * pct;

  const proc = (feeBreakdown.processing_fee || 0) * pct;
  const stamp = (feeBreakdown.stamp_duty || 0) * pct;
  const reg = (feeBreakdown.registration_fee || 0) * pct;
  const maint = (feeBreakdown.maintenance_charge || 0) * pct;
  const cf1 = (feeBreakdown.custom_fee1 || 0) * pct;
  const cf2 = (feeBreakdown.custom_fee2 || 0) * pct;

  const fees = proc + stamp + reg + maint + cf1 + cf2;
  const total = base + tax + fees;

  return {
    base,
    tax,
    fees,
    total,
    breakdown: { proc, stamp, reg, maint, cf1, cf2 },
    labels: feeBreakdown.fee_labels || {},
    taxLabel: feeBreakdown.tax_label || "Tax",
    taxRate: feeBreakdown.tax_rate || 0,
    taxSystem: feeBreakdown.tax_system || "",
    currencySymbol: feeBreakdown.currency_symbol || "₹",
  };
};

/* ─────────────────────────────────────────────────────────────
   TaxBreakdownBadge
───────────────────────────────────────────────────────────── */
const TaxBreakdownBadge = ({ milestonePercent, feeBreakdown, sym = "₹" }) => {
  const [open, setOpen] = useState(false);
  const data = computeMilestoneAmounts(milestonePercent, feeBreakdown);
  if (!data || (!data.tax && !data.fees)) return null;
  const f = (n) => fmtExact(n, sym);
  const extraFees = [
    data.breakdown.proc > 0 && {
      label: data.labels.processing || "Processing Fee",
      val: data.breakdown.proc,
    },
    data.breakdown.stamp > 0 && {
      label: data.labels.stamp_duty || "Stamp Duty",
      val: data.breakdown.stamp,
    },
    data.breakdown.reg > 0 && {
      label: data.labels.registration || "Registration Fee",
      val: data.breakdown.reg,
    },
    data.breakdown.maint > 0 && {
      label: data.labels.maintenance || "Maintenance",
      val: data.breakdown.maint,
    },
    data.breakdown.cf1 > 0 && {
      label: data.labels.custom1 || "Custom Fee 1",
      val: data.breakdown.cf1,
    },
    data.breakdown.cf2 > 0 && {
      label: data.labels.custom2 || "Custom Fee 2",
      val: data.breakdown.cf2,
    },
  ].filter(Boolean);

  return (
    <span style={{ position: "relative", display: "inline-block" }}>
      <button
        type="button"
        className="tax-badge-btn"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((o) => !o);
        }}
      >
        +tax
      </button>
      {open && (
        <div className="tax-popover" onClick={(e) => e.stopPropagation()}>
          <div className="tax-popover-title">Charges for this instalment</div>
          <div className="tax-row">
            <span>Unit price portion</span>
            <span>{f(data.base)}</span>
          </div>
          {extraFees.map((fee, i) => (
            <div key={i} className="tax-row">
              <span>{fee.label}</span>
              <span>{f(fee.val)}</span>
            </div>
          ))}
          {data.tax > 0 && (
            <div className="tax-row highlight">
              <span>
                {data.taxLabel}
                {data.taxRate > 0 && (
                  <span style={{ opacity: 0.7, marginLeft: 4 }}>
                    ({data.taxRate}%
                    {data.taxSystem ? ` · ${data.taxSystem.toUpperCase()}` : ""}
                    )
                  </span>
                )}
              </span>
              <span>{f(data.tax)}</span>
            </div>
          )}
          <div className="tax-row total">
            <span>Instalment total</span>
            <span>{f(data.total)}</span>
          </div>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setOpen(false);
            }}
            style={{
              position: "absolute",
              top: 6,
              right: 8,
              background: "none",
              border: "none",
              color: "var(--text-muted)",
              cursor: "pointer",
              fontSize: 14,
            }}
          >
            ×
          </button>
        </div>
      )}
    </span>
  );
};

/* ─────────────────────────────────────────────────────────────
   MilestoneTaxRow
───────────────────────────────────────────────────────────── */
const MilestoneTaxRow = ({ milestone, feeBreakdown }) => {
  if (!feeBreakdown || !milestone.percentage) return null;
  const data = computeMilestoneAmounts(milestone.percentage, feeBreakdown);
  if (!data || (!data.tax && !data.fees)) return null;
  const sym = data.currencySymbol;
  const f = (n) => fmtExact(n, sym);
  const extraFees = [
    data.breakdown.proc > 0 && {
      label: data.labels.processing || "Processing Fee",
      val: data.breakdown.proc,
    },
    data.breakdown.stamp > 0 && {
      label: data.labels.stamp_duty || "Stamp Duty",
      val: data.breakdown.stamp,
    },
    data.breakdown.reg > 0 && {
      label: data.labels.registration || "Registration Fee",
      val: data.breakdown.reg,
    },
    data.breakdown.maint > 0 && {
      label: data.labels.maintenance || "Maintenance",
      val: data.breakdown.maint,
    },
    data.breakdown.cf1 > 0 && {
      label: data.labels.custom1 || "Custom Fee 1",
      val: data.breakdown.cf1,
    },
    data.breakdown.cf2 > 0 && {
      label: data.labels.custom2 || "Custom Fee 2",
      val: data.breakdown.cf2,
    },
  ].filter(Boolean);

  return (
    <div
      style={{
        background: "#fef9ee",
        border: "1px solid #fde68a",
        borderRadius: 8,
        padding: "10px 12px",
        marginTop: 6,
      }}
    >
      <div
        style={{
          fontSize: 10,
          fontWeight: 700,
          color: "#b45309",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          marginBottom: 7,
        }}
      >
        Tax &amp; fees for this instalment
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <div className="tax-row">
          <span>Base ({milestone.percentage}% of unit price)</span>
          <span>{f(data.base)}</span>
        </div>
        {extraFees.map((fee, i) => (
          <div key={i} className="tax-row">
            <span>{fee.label}</span>
            <span>{f(fee.val)}</span>
          </div>
        ))}
        {data.tax > 0 && (
          <div className="tax-row highlight">
            <span>
              {data.taxLabel}
              {data.taxRate > 0 ? ` (${data.taxRate}%)` : ""}
            </span>
            <span>{f(data.tax)}</span>
          </div>
        )}
        <div className="tax-row total">
          <span>Instalment total</span>
          <span>{f(data.total)}</span>
        </div>
      </div>
    </div>
  );
};

/* ─────────────────────────────────────────────────────────────
   BookingSummaryTaxCard
───────────────────────────────────────────────────────────── */
const BookingSummaryTaxCard = ({
  feeBreakdown,
  selectedPlan,
  plans,
  unit,
  sym = "₹",
}) => {
  if (
    !feeBreakdown?.tax_enabled &&
    !feeBreakdown?.processing_fee &&
    !feeBreakdown?.stamp_duty
  )
    return null;
  const f = (n) => fmtExact(n, sym);
  const labels = feeBreakdown.fee_labels || {};
  const extraFees = [
    feeBreakdown.processing_fee > 0 && {
      label: labels.processing || "Processing Fee",
      val: feeBreakdown.processing_fee,
    },
    feeBreakdown.stamp_duty > 0 && {
      label: labels.stamp_duty || "Stamp Duty",
      val: feeBreakdown.stamp_duty,
    },
    feeBreakdown.registration_fee > 0 && {
      label: labels.registration || "Registration Fee",
      val: feeBreakdown.registration_fee,
    },
    feeBreakdown.maintenance_charge > 0 && {
      label: labels.maintenance || "Maintenance",
      val: feeBreakdown.maintenance_charge,
    },
    feeBreakdown.custom_fee1 > 0 && {
      label: labels.custom1 || "Custom Fee 1",
      val: feeBreakdown.custom_fee1,
    },
    feeBreakdown.custom_fee2 > 0 && {
      label: labels.custom2 || "Custom Fee 2",
      val: feeBreakdown.custom_fee2,
    },
  ].filter(Boolean);

  const plan = plans.find((p) => p.id === selectedPlan);
  const firstMs = plan?.milestones?.[0];
  const firstPct = firstMs?.percentage
    ? parseFloat(firstMs.percentage) / 100
    : 1;
  const dueNow = feeBreakdown.total_amount * (plan ? firstPct : 1);

  return (
    <div className="grand-total-banner" style={{ marginBottom: 16 }}>
      <div
        style={{
          fontSize: 11,
          fontWeight: 700,
          color: "#92400e",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          marginBottom: 10,
        }}
      >
        📄 Payment Breakdown
      </div>
      <div className="gtb-row">
        <span className="gtb-label">Unit Price</span>
        <span className="gtb-val">{f(feeBreakdown.unit_price)}</span>
      </div>
      {extraFees.map((fee, i) => (
        <div key={i} className="gtb-row">
          <span className="gtb-label">{fee.label}</span>
          <span className="gtb-val">{f(fee.val)}</span>
        </div>
      ))}
      {feeBreakdown.tax_amount > 0 && (
        <div
          className="gtb-row"
          style={{
            color: "#b45309",
            fontWeight: 600,
            borderTop: "1px solid #fde68a",
            paddingTop: 6,
            marginTop: 4,
          }}
        >
          <span>
            {feeBreakdown.tax_label || "Tax"}
            {feeBreakdown.tax_rate > 0 && (
              <span style={{ fontSize: 10, marginLeft: 5, opacity: 0.8 }}>
                ({feeBreakdown.tax_rate}%
                {feeBreakdown.tax_system
                  ? ` · ${feeBreakdown.tax_system.toUpperCase()}`
                  : ""}
                {feeBreakdown.tax_inclusive ? " · Incl." : ""})
              </span>
            )}
          </span>
          <span>{f(feeBreakdown.tax_amount)}</span>
        </div>
      )}
      <div
        className="gtb-row"
        style={{
          borderTop: "1.5px solid #fcd34d",
          paddingTop: 8,
          marginTop: 4,
        }}
      >
        <span className="gtb-total-label">Grand Total</span>
        <span className="gtb-total-val">{f(feeBreakdown.total_amount)}</span>
      </div>
      {plan && firstMs && (
        <div className="due-now-box">
          <div className="due-now-label">
            Due Now — {firstMs.label} ({firstMs.percentage}%)
          </div>
          <div className="due-now-val">{f(dueNow)}</div>
          <div className="due-now-note">
            Includes proportional taxes &amp; fees
          </div>
        </div>
      )}
      <div
        style={{
          fontSize: 10,
          color: "var(--text-muted)",
          marginTop: 8,
          textAlign: "center",
        }}
      >
        Amounts are estimates. Final figures confirmed at booking.
      </div>
    </div>
  );
};

/* ─────────────────────────────────────────────────────────────
   TYPE_COLORS / ICONS (payment milestone types)
───────────────────────────────────────────────────────────── */
const TYPE_COLORS = {
  down_payment: { bg: "#eff6ff", color: "#1d4ed8", border: "#bfdbfe" },
  installment: { bg: "#faf5ff", color: "#7e22ce", border: "#e9d5ff" },
  on_completion: { bg: "#f0fdf4", color: "#15803d", border: "#bbf7d0" },
  on_handover: { bg: "#fff7ed", color: "#c2410c", border: "#fed7aa" },
  rental_guarantee: { bg: "#fff1f2", color: "#be123c", border: "#fecdd3" },
  custom: { bg: "#f9fafb", color: "#374151", border: "#e5e7eb" },
};
const TYPE_ICONS = {
  down_payment: "💰",
  installment: "🔄",
  on_completion: "🏗️",
  on_handover: "🔑",
  rental_guarantee: "📈",
  custom: "⭐",
};

/* ═════════════════════════════════════════════════════════════
   ERA-STYLE GALLERY — large stacked hero photos + 3-up thumbs
═════════════════════════════════════════════════════════════ */
const EraGallery = ({
  gallery,
  hasPano,
  plotId,
  tenant,
  navigate,
  galIdx,
  setGalIdx,
  onOpenPano,
}) => {
  if (!gallery.length && !hasPano) return null;
  const total = gallery.length;

  return (
    <div className="era-gallery">
      <div
        className="era-gallery-main"
        onClick={() =>
          total > 0 && navigate(`/${tenant}/unit/${plotId}/gallery/${galIdx}`)
        }
      >
        {total > 0 ? (
          <img src={gallery[galIdx]} alt={`View ${galIdx + 1}`} />
        ) : (
          <div
            style={{
              width: "100%",
              height: "100%",
              background: "var(--page-bg)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "var(--text-muted)",
              fontSize: 40,
            }}
          >
            🏠
          </div>
        )}

        <div className="era-gallery-badges">
          {hasPano && (
            <button
              className="era-gallery-badge"
              onClick={(e) => {
                e.stopPropagation();
                onOpenPano();
              }}
            >
              360° View
            </button>
          )}
        </div>

        {total > 1 && (
          <>
            <button
              className="era-gallery-nav prev"
              onClick={(e) => {
                e.stopPropagation();
                setGalIdx((i) => (i - 1 + total) % total);
              }}
            >
              ‹
            </button>
            <button
              className="era-gallery-nav next"
              onClick={(e) => {
                e.stopPropagation();
                setGalIdx((i) => (i + 1) % total);
              }}
            >
              ›
            </button>
            <div className="era-gallery-counter">
              {galIdx + 1} / {total}
            </div>
          </>
        )}
      </div>

      {total > 1 && (
        <div className="era-gallery-thumbs">
          {gallery.slice(0, 3).map((img, i) => (
            <img
              key={i}
              src={img}
              alt=""
              className={i === galIdx ? "active" : ""}
              onClick={() => setGalIdx(i)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

/* ═════════════════════════════════════════════════════════════
   ERA-STYLE UNIT DETAILS — hero, stats, gallery, info/benefits,
   payment plans (inline, not a tab), amenity showcases — all one
   continuous scroll, matching the reference site's flow.
═════════════════════════════════════════════════════════════ */
const EraUnitDetails = ({
  unit,
  fmtPrice,
  statusColor,
  currency,
  sym,
  feeBreakdown,
  getFullImageUrl,
  gallery,
  hasPano,
  plotId,
  tenant,
  navigate,
  galIdx,
  setGalIdx,
  onOpenPano,
  PaymentPlansContent,
}) => {
  const [infoTab, setInfoTab] = useState("info"); // "info" | "benefits"
  const hasDims = unit.room_dimensions?.length > 0;
  const hasAmenities = unit.amenities?.length > 0;
  const hasAreaData =
    unit.internal_area_sqft || unit.internal_area_sqm || unit.external_area_sqft;

  return (
    <>
      {/* ── Hero — "No. XXX" ── */}
      <Reveal>
        <div className="era-hero">
          <div className="era-hero-eyebrow">
            {unit.status}
            {unit.project_name ? ` · ${unit.project_name}` : ""}
          </div>
          <h1 className="era-hero-title">No. {unit.plot_number}</h1>
          <div className="era-hero-meta">
            {unit.block && (
              <div className="era-hero-meta-item">
                Block <strong>{unit.block}</strong>
              </div>
            )}
            <div className="era-hero-meta-item">
              Type <strong>{unit.plot_type}</strong>
            </div>
            {unit.direction && (
              <div className="era-hero-meta-item">
                Facing <strong>{unit.direction}</strong>
              </div>
            )}
          </div>
        </div>
      </Reveal>

      {/* ── Stat row — big borderless numbers ── */}
      <Reveal delay={80}>
        <div className="era-stats-row">
          {unit.bedrooms != null && (
            <div className="era-stat">
              <div className="era-stat-label">Bedrooms</div>
              <div className="era-stat-value">{unit.bedrooms}</div>
            </div>
          )}
          {unit.bathrooms != null && (
            <div className="era-stat">
              <div className="era-stat-label">Bathrooms</div>
              <div className="era-stat-value">{unit.bathrooms}</div>
            </div>
          )}
          {(unit.internal_area_sqft || unit.plot_size) && (
            <div className="era-stat">
              <div className="era-stat-label">Interior Area</div>
              <div className="era-stat-value">
                {unit.internal_area_sqft || unit.plot_size}
                <small>sqft</small>
              </div>
            </div>
          )}
          {unit.external_area_sqft && (
            <div className="era-stat">
              <div className="era-stat-label">Terrace</div>
              <div className="era-stat-value">
                {unit.external_area_sqft}
                <small>sqft</small>
              </div>
            </div>
          )}
        </div>
      </Reveal>

      {/* ── Gallery ── */}
      <Reveal delay={140}>
        <EraGallery
          gallery={gallery}
          hasPano={hasPano}
          plotId={plotId}
          tenant={tenant}
          navigate={navigate}
          galIdx={galIdx}
          setGalIdx={setGalIdx}
          onOpenPano={onOpenPano}
        />
      </Reveal>

      {/* ── Info / Benefits tabs ── */}
      <Reveal>
        <div className="era-content-tabs">
          <button
            className={`era-content-tab${infoTab === "info" ? " active" : ""}`}
            onClick={() => setInfoTab("info")}
          >
            Info
          </button>
          {(hasAmenities || unit.description) && (
            <button
              className={`era-content-tab${infoTab === "benefits" ? " active" : ""}`}
              onClick={() => setInfoTab("benefits")}
            >
              Benefits
            </button>
          )}
        </div>

        {infoTab === "info" && (
          <>
            {/* Facts */}
            <div className="era-facts">
              <div className="era-facts-grid">
                {[
                  ["Unit No", unit.plot_number],
                  ["Type", unit.plot_type],
                  ["Size", unit.plot_size ? `${unit.plot_size} sqft` : "—"],
                  ["Direction", unit.direction || "—"],
                  ["Project", unit.project_name || "—"],
                  ["Floor", unit.block || "—"],
                  ["Rooms", unit.rooms?.length || "—"],
                  ["Status", unit.status],
                ].map(([lbl, val]) => (
                  <div key={lbl} className="era-fact">
                    <div className="era-fact-label">{lbl}</div>
                    <div className="era-fact-value">{val}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Area breakdown, reusing the stat-row visual language */}
            {hasAreaData && (
              <div className="era-stats-row" style={{ marginTop: -24 }}>
                {unit.internal_area_sqft && (
                  <div className="era-stat">
                    <div className="era-stat-label">Internal Area</div>
                    <div className="era-stat-value">
                      {Number(unit.internal_area_sqft).toLocaleString()}
                      <small>sqft</small>
                    </div>
                  </div>
                )}
                {unit.external_area_sqft && (
                  <div className="era-stat">
                    <div className="era-stat-label">External Area</div>
                    <div className="era-stat-value">
                      {Number(unit.external_area_sqft).toLocaleString()}
                      <small>sqft</small>
                    </div>
                  </div>
                )}
                {unit.internal_area_sqft && unit.external_area_sqft && (
                  <div className="era-stat">
                    <div className="era-stat-label">Total Area</div>
                    <div className="era-stat-value">
                      {(
                        parseFloat(unit.internal_area_sqft) +
                        parseFloat(unit.external_area_sqft)
                      ).toFixed(0)}
                      <small>sqft</small>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Room dimensions */}
            {hasDims && (
              <div className="era-dims">
                <div className="era-floor-plan-section-label">Room Dimensions</div>
                {unit.room_dimensions.map((dim, i) => {
                  const u = dim.unit || "m",
                    w = parseFloat(dim.width),
                    l = parseFloat(dim.length);
                  const wM = u === "ft" ? (w / 3.28084).toFixed(1) : w.toFixed(1);
                  const lM = u === "ft" ? (l / 3.28084).toFixed(1) : l.toFixed(1);
                  const wFt = u === "m" ? (w * 3.28084).toFixed(1) : w.toFixed(1);
                  const lFt = u === "m" ? (l * 3.28084).toFixed(1) : l.toFixed(1);
                  return (
                    <div key={i} className="era-dim-row">
                      <div className="era-dim-name">{dim.label}</div>
                      <div className="era-dim-vals">
                        <span className="era-dim-primary">
                          {wM} × {lM} m
                        </span>
                        <span className="era-dim-secondary">
                          {wFt}' × {lFt}'
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Floor plan */}
            {unit.floor_plan_image && (
              <div className="era-floor-plan">
                <div className="era-floor-plan-section-label">Floor Plan</div>
                <img src={getFullImageUrl(unit.floor_plan_image)} alt="Floor Plan" />
              </div>
            )}
          </>
        )}

        {infoTab === "benefits" && (
          <div className="era-benefits">
            {unit.description && (
              <div className="era-benefits-text">{unit.description}</div>
            )}
            {hasAmenities && (
              <div className="era-tags">
                {unit.amenities.map((a, i) => (
                  <span key={i} className="era-tag">
                    {a}
                  </span>
                ))}
              </div>
            )}
          </div>
        )}
      </Reveal>

      {/* ── Payment Plans — inline, part of the same continuous scroll ──
           No longer a separate header tab. Only rendered when the unit
           actually has plans; otherwise this section is skipped entirely
           and the page flows straight from Info/Benefits to amenities. */}
      {unit.payment_plans?.length > 0 && PaymentPlansContent && (
        <Reveal>
          <div className="era-payment-section" id="payment-plans-section">
            <div className="era-content-tabs" style={{ borderBottom: "1px solid var(--card-border)" }}>
              <div className="era-content-tab active" style={{ cursor: "default" }}>
                Payment Plans
              </div>
            </div>
            <div style={{ padding: "0 56px 44px" }}>
              <PaymentPlansContent
                plans={unit.payment_plans || []}
                fmtPrice={fmtPrice}
                currency={currency}
                unitPrice={unit.offer_price || unit.actual_price}
                feeBreakdown={feeBreakdown}
                sym={sym}
              />
            </div>
          </div>
        </Reveal>
      )}

      {/* ── Full-bleed amenity showcase sections ──
           Only rendered for amenities that have a dedicated image
           (unit.amenity_showcases, if your API provides one) — falls
           back to nothing if you don't have per-amenity imagery yet. */}
      {unit.amenity_showcases?.map((a, i) => (
        <Reveal key={i}>
          <div className="era-amenities-section">
            {i % 2 === 0 ? (
              <>
                <img
                  className="era-amenity-image"
                  src={getFullImageUrl(a.image)}
                  alt={a.title}
                />
                <div>
                  <div className="era-amenity-title">{a.title}</div>
                  <div className="era-amenity-desc">{a.description}</div>
                </div>
              </>
            ) : (
              <>
                <div>
                  <div className="era-amenity-title">{a.title}</div>
                  <div className="era-amenity-desc">{a.description}</div>
                </div>
                <img
                  className="era-amenity-image"
                  src={getFullImageUrl(a.image)}
                  alt={a.title}
                />
              </>
            )}
          </div>
        </Reveal>
      ))}
    </>
  );
};

/* ═════════════════════════════════════════════════════════════
   PaymentPlansContent - with proper tax display
   (Unchanged logic — now rendered inline by EraUnitDetails instead
   of behind a separate header tab.)
═════════════════════════════════════════════════════════════ */
const PaymentPlansContent = ({
  plans,
  fmtPrice,
  currency,
  unitPrice,
  feeBreakdown,
  sym = "₹",
}) => {
  const [activePlan, setActivePlan] = useState(0);
  if (!plans?.length)
    return (
      <div className="up-section">
        <div
          className="up-section-body"
          style={{ textAlign: "center", padding: "40px 20px" }}
        >
          <div style={{ fontSize: 40, marginBottom: 12 }}>💳</div>
          <div
            style={{
              fontSize: 15,
              fontWeight: 600,
              color: "var(--text-muted)",
            }}
          >
            No payment plans available
          </div>
        </div>
      </div>
    );

  const basePrice =
    parseFloat(String(unitPrice || "0").replace(/[^0-9.]/g, "")) || 0;
  const calcAmtLabel = (pct) =>
    basePrice > 0 ? fmtExact((basePrice * parseFloat(pct)) / 100, sym) : null;
  const plan = plans[activePlan];
  const totalPct = plan.milestones.reduce(
    (s, m) => s + (parseFloat(m.percentage) || 0),
    0,
  );

  const calculateMilestoneTotal = (milestone) => {
    if (!feeBreakdown || !milestone.percentage) {
      return null;
    }
    const pct = parseFloat(milestone.percentage) / 100;
    const base = (feeBreakdown.unit_price || basePrice) * pct;
    const tax = (feeBreakdown.tax_amount || 0) * pct;
    const fees =
      ((feeBreakdown.processing_fee || 0) +
        (feeBreakdown.stamp_duty || 0) +
        (feeBreakdown.registration_fee || 0) +
        (feeBreakdown.maintenance_charge || 0) +
        (feeBreakdown.custom_fee1 || 0) +
        (feeBreakdown.custom_fee2 || 0)) *
      pct;
    return {
      base,
      tax,
      fees,
      total: base + tax + fees,
    };
  };

  return (
    <div className="up-plans-wrap">
      {plans.length > 1 && (
        <div className="up-plan-tabs">
          {plans.map((p, i) => (
            <button
              key={p.id}
              className={`up-plan-tab${i === activePlan ? " active" : ""}`}
              onClick={() => setActivePlan(i)}
            >
              {p.name}
            </button>
          ))}
        </div>
      )}

      {/* Grand total banner */}
      {feeBreakdown?.tax_enabled && feeBreakdown?.total_amount > 0 && (
        <div className="grand-total-banner" style={{ marginBottom: 16 }}>
          <div className="gtb-row">
            <span className="gtb-label">Unit {fmtExact(basePrice, sym)}</span>
            <span className="gtb-val">
              {fmtExact(feeBreakdown.unit_price || basePrice, sym)}
            </span>
          </div>
          {(feeBreakdown.processing_fee || 0) > 0 && (
            <div className="gtb-row">
              <span className="gtb-label">
                {feeBreakdown.fee_labels?.processing || "Processing Fee"}
              </span>
              <span className="gtb-val">
                {fmtExact(feeBreakdown.processing_fee, sym)}
              </span>
            </div>
          )}
          {(feeBreakdown.stamp_duty || 0) > 0 && (
            <div className="gtb-row">
              <span className="gtb-label">
                {feeBreakdown.fee_labels?.stamp_duty || "Stamp Duty"}
              </span>
              <span className="gtb-val">
                {fmtExact(feeBreakdown.stamp_duty, sym)}
              </span>
            </div>
          )}
          {(feeBreakdown.registration_fee || 0) > 0 && (
            <div className="gtb-row">
              <span className="gtb-label">
                {feeBreakdown.fee_labels?.registration || "Registration Fee"}
              </span>
              <span className="gtb-val">
                {fmtExact(feeBreakdown.registration_fee, sym)}
              </span>
            </div>
          )}
          {(feeBreakdown.maintenance_charge || 0) > 0 && (
            <div className="gtb-row">
              <span className="gtb-label">
                {feeBreakdown.fee_labels?.maintenance || "Maintenance"}
              </span>
              <span className="gtb-val">
                {fmtExact(feeBreakdown.maintenance_charge, sym)}
              </span>
            </div>
          )}
          {(feeBreakdown.custom_fee1 || 0) > 0 && (
            <div className="gtb-row">
              <span className="gtb-label">
                {feeBreakdown.fee_labels?.custom1 || "Custom Fee 1"}
              </span>
              <span className="gtb-val">
                {fmtExact(feeBreakdown.custom_fee1, sym)}
              </span>
            </div>
          )}
          {(feeBreakdown.custom_fee2 || 0) > 0 && (
            <div className="gtb-row">
              <span className="gtb-label">
                {feeBreakdown.fee_labels?.custom2 || "Custom Fee 2"}
              </span>
              <span className="gtb-val">
                {fmtExact(feeBreakdown.custom_fee2, sym)}
              </span>
            </div>
          )}
          {feeBreakdown.tax_amount > 0 && (
            <div className="gtb-row" style={{ color: "#b45309" }}>
              <span>
                {feeBreakdown.tax_label || "Tax"} ({feeBreakdown.tax_rate}%
                {feeBreakdown.tax_system
                  ? ` · ${feeBreakdown.tax_system.toUpperCase()}`
                  : ""}
                )
              </span>
              <span style={{ fontWeight: 700 }}>
                {fmtExact(feeBreakdown.tax_amount, sym)}
              </span>
            </div>
          )}
          <div
            className="gtb-row"
            style={{
              borderTop: "1px solid #fde68a",
              paddingTop: 5,
              marginTop: 3,
            }}
          >
            <span className="gtb-total-label">
              Grand Total (incl. tax & fees)
            </span>
            <span className="gtb-total-val">
              {fmtExact(feeBreakdown.total_amount, sym)}
            </span>
          </div>
        </div>
      )}

      <div className="ms-card">
        <div className="ms-header">
          <div>
            <div
              style={{
                fontFamily: "var(--font-heading)",
                fontSize: 17,
                fontWeight: 700,
                color: "var(--text-dark)",
              }}
            >
              {plan.name}
            </div>
            {plan.description && (
              <div
                style={{
                  fontSize: 13,
                  color: "var(--text-muted)",
                  marginTop: 2,
                }}
              >
                {plan.description}
              </div>
            )}
          </div>
          {totalPct === 100 && (
            <span
              style={{
                padding: "3px 12px",
                // borderRadius: 20,
                background: "#f0fdf4",
                border: "1px solid #bbf7d0",
                color: "#16a34a",
                fontSize: 12,
                fontWeight: 700,
              }}
            >
              ✓ 100%
            </span>
          )}
        </div>

        {plan.milestones.map((m, i) => {
          const c = TYPE_COLORS[m.type] || TYPE_COLORS.custom;
          const icon = TYPE_ICONS[m.type] || "⭐";
          const displayAmt = m.calculated_amount
            ? fmtExact(m.calculated_amount, sym)
            : m.percentage
              ? calcAmtLabel(m.percentage)
              : m.fixed_amount
                ? fmtExact(m.fixed_amount, sym)
                : null;

          const milestoneTotals = calculateMilestoneTotal(m);
          const msTaxData =
            feeBreakdown && m.percentage
              ? computeMilestoneAmounts(m.percentage, feeBreakdown)
              : null;

          return (
            <div key={m.id || i} className="ms-row">
              <div
                className="ms-num"
                style={{ borderColor: c.border, color: c.color }}
              >
                {i + 1}
              </div>
              <div className="ms-body">
                <div
                  className="ms-type-chip"
                  style={{ background: c.bg, color: c.color }}
                >
                  {icon} {m.type_label || m.type?.replace(/_/g, " ")}
                </div>
                <div className="ms-label">{m.label}</div>
                {(m.due_date || m.due_after_days) && (
                  <div className="ms-due">
                    📅{" "}
                    {m.due_date
                      ? `Due by ${m.due_date}`
                      : `Due ${m.due_after_days} days after booking`}
                  </div>
                )}
                {m.note && <div className="ms-note">{m.note}</div>}

                {feeBreakdown && m.percentage && (
                  <div
                    style={{
                      marginTop: 6,
                      padding: "8px 12px",
                      background: "#fef9ee",
                      border: "1px solid #fde68a",
                      //borderRadius: 6,
                      fontSize: 12,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: 2,
                      }}
                    >
                      <span style={{ color: "var(--text-muted)" }}>
                        Base amount
                      </span>
                      <span>{fmtExact(milestoneTotals?.base || 0, sym)}</span>
                    </div>
                    {(milestoneTotals?.fees || 0) > 0 && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: 2,
                        }}
                      >
                        <span style={{ color: "var(--text-muted)" }}>Fees</span>
                        <span>{fmtExact(milestoneTotals?.fees || 0, sym)}</span>
                      </div>
                    )}
                    {(milestoneTotals?.tax || 0) > 0 && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: 2,
                          color: "#b45309",
                        }}
                      >
                        <span>
                          {feeBreakdown.tax_label || "Tax"} (
                          {feeBreakdown.tax_rate}%)
                        </span>
                        <span style={{ fontWeight: 600 }}>
                          {fmtExact(milestoneTotals?.tax || 0, sym)}
                        </span>
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        borderTop: "1px solid #fde68a",
                        paddingTop: 4,
                        marginTop: 4,
                        fontWeight: 700,
                        color: "var(--primary-color)",
                      }}
                    >
                      <span>Total incl. tax & fees</span>
                      <span>{fmtExact(milestoneTotals?.total || 0, sym)}</span>
                    </div>
                  </div>
                )}
              </div>
              <div className="ms-amounts">
                {m.percentage > 0 && (
                  <div className="ms-pct">{m.percentage}%</div>
                )}
                {displayAmt && (
                  <div
                    className="ms-amt"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    ≈ {displayAmt}
                    {msTaxData && (msTaxData.tax > 0 || msTaxData.fees > 0) && (
                      <TaxBreakdownBadge
                        milestonePercent={m.percentage}
                        feeBreakdown={feeBreakdown}
                        sym={sym}
                      />
                    )}
                  </div>
                )}
                {milestoneTotals && milestoneTotals.total > 0 && (
                  <div
                    style={{
                      fontSize: 13,
                      fontWeight: 700,
                      color: "var(--primary-color)",
                      marginTop: 2,
                    }}
                  >
                    Total: {fmtExact(milestoneTotals.total, sym)}
                  </div>
                )}
              </div>
            </div>
          );
        })}

        <div className="ms-footer">
          <span
            style={{
              fontSize: 13,
              color: "var(--text-muted)",
              fontWeight: 600,
            }}
          >
            Total payment mapped
          </span>
          <div style={{ textAlign: "right" }}>
            <span
              style={{
                fontSize: 18,
                fontWeight: 800,
                color:
                  totalPct === 100
                    ? "#16a34a"
                    : totalPct > 100
                      ? "#dc2626"
                      : "var(--primary-color)",
              }}
            >
              {totalPct.toFixed(0)}%{totalPct === 100 ? " ✓" : ""}
            </span>
            {feeBreakdown?.total_amount > 0 && (
              <div style={{ fontSize: 11, color: "#b45309", marginTop: 2 }}>
                Grand Total: {fmtExact(feeBreakdown.total_amount, sym)} (incl.
                all taxes &amp; fees)
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        style={{
          textAlign: "center",
          fontSize: 12,
          color: "var(--text-muted)",
          marginTop: 10,
        }}
      >
        Amounts shown are estimates. Final figures confirmed at booking.
      </div>
    </div>
  );
};

/* ═════════════════════════════════════════════════════════════
   BOOKING STEP COMPONENTS
═════════════════════════════════════════════════════════════ */

const BrokerInactiveScreen = ({ onClose }) => (
  <div className="broker-inactive">
    <div className="broker-inactive-icon">🔒</div>
    <div className="broker-inactive-title">Account Inactive</div>
    <p
      style={{
        color: "var(--text-muted)",
        fontSize: 13,
        lineHeight: 1.7,
        marginBottom: 20,
      }}
    >
      Your account is currently{" "}
      <strong style={{ color: "#dc2626" }}>inactive</strong>. Please contact the
      admin to activate your account.
    </p>
    <div
      style={{
        background: "#fff5f5",
        border: "1.5px solid #fecaca",
       // borderRadius: 10,
        padding: "12px 16px",
        marginBottom: 20,
        fontSize: 12,
        color: "#dc2626",
        textAlign: "left",
      }}
    >
      <div style={{ fontWeight: 700, marginBottom: 4 }}>What to do next:</div>
      <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.8 }}>
        <li>Contact your project administrator</li>
        <li>Ask them to activate your account</li>
        <li>You can book once your status is active</li>
      </ul>
    </div>
    <button
      onClick={onClose}
      className="book-btn"
      style={{
        background: "var(--page-bg)",
        color: "var(--text-muted)",
        border: "1.5px solid var(--card-border)",
      }}
    >
      Close
    </button>
  </div>
);

const StepDetails = ({ user, onBook, onLogout, isAvail }) => (
  <div>
    {user ? (
      <div className="logged-in-card">
        <div>
          <div className="logged-in-label">✓ Logged in as</div>
          <div className="logged-in-name">{user.name}</div>
          <div
            style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 2 }}
          >
            {user.email}
          </div>
        </div>
        <button className="logout-btn" onClick={onLogout}>
          Logout
        </button>
      </div>
    ) : (
      <p
        style={{
          color: "var(--text-muted)",
          fontSize: 13,
          lineHeight: 1.6,
          marginBottom: 16,
        }}
      >
        To book this unit, please log in or create an account. Both email and
        phone will be verified.
      </p>
    )}
    {isAvail !== false && (
      <button className="book-btn" onClick={onBook}>
        {user ? "Continue to Booking →" : "Login / Register to Book →"}
      </button>
    )}
  </div>
);

const StepLogin = ({ form, setForm, onLogin, onSwitch, loading, error }) => (
  <div>
    <div
      style={{
        color: "var(--text-dark)",
        fontWeight: 700,
        fontSize: 15,
        marginBottom: 16,
      }}
    >
      Login to your account
    </div>
    {error && <div className="error-box">⚠️ {error}</div>}
    <input
      className="sidebar-input"
      type="email"
      placeholder="Email address"
      value={form.email}
      onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
    />
    <input
      className="sidebar-input"
      type="password"
      placeholder="Password"
      value={form.password}
      onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
      onKeyDown={(e) => e.key === "Enter" && onLogin()}
      style={{ marginBottom: 16 }}
    />
    <button
      className="book-btn"
      onClick={onLogin}
      disabled={loading || !form.email || !form.password}
    >
      {loading ? "Logging in…" : "Login →"}
    </button>
    {onSwitch && (
      <p
        style={{
          textAlign: "center",
          marginTop: 14,
          color: "var(--text-muted)",
          fontSize: 13,
        }}
      >
        Don't have an account?{" "}
        <button className="auth-link" onClick={onSwitch}>
          Register
        </button>
      </p>
    )}
  </div>
);

const StepRegister = ({
  form,
  setForm,
  onRegister,
  onSwitch,
  loading,
  error,
}) => {
  const [showPass, setShowPass] = useState(false);
  const strength = !form.password
    ? 0
    : [
        form.password.length >= 8,
        /[A-Z]/.test(form.password),
        /[0-9]/.test(form.password),
        /[^A-Za-z0-9]/.test(form.password),
      ].filter(Boolean).length;
  const strengthColor = ["#ef4444", "#f59e0b", "#f59e0b", "#16a34a", "#16a34a"][
    strength
  ];
  return (
    <div>
      <div
        style={{
          color: "var(--text-dark)",
          fontWeight: 700,
          fontSize: 15,
          marginBottom: 4,
        }}
      >
        Create an account
      </div>
      <div
        style={{ color: "var(--text-muted)", fontSize: 12, marginBottom: 14 }}
      >
        We'll verify your email and phone number. A Company Admin will need to
        approve your account before you can book on behalf of a client.
      </div>
      {error && <div className="error-box">⚠️ {error}</div>}
      <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
        {[
          { v: "broker", label: "🤝 Broker" },
          { v: "sales", label: "📈 Sales" },
        ].map(({ v, label }) => (
          <button
            key={v}
            type="button"
            onClick={() => setForm((f) => ({ ...f, role: v }))}
            style={{
              flex: 1,
              padding: 8,
              //borderRadius: 8,
              cursor: "pointer",
              fontSize: 13,
              border: `1.5px solid ${form.role === v ? "var(--primary-color)" : "var(--card-border)"}`,
              background: form.role === v ? "var(--page-bg)" : "transparent",
              color:
                form.role === v ? "var(--primary-color)" : "var(--text-muted)",
              fontWeight: form.role === v ? 700 : 400,
              fontFamily: "var(--font-body)",
            }}
          >
            {label}
          </button>
        ))}
      </div>
      <input
        className="sidebar-input"
        type="text"
        placeholder="Full Name *"
        value={form.name}
        onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
      />
      {(form.role === "broker" || form.role === "sales") && (
        <input
          className="sidebar-input"
          type="text"
          placeholder={
            form.role === "sales"
              ? "Sales Team / Department (optional)"
              : "Company / Agency Name"
          }
          value={form.broker_company}
          onChange={(e) =>
            setForm((f) => ({ ...f, broker_company: e.target.value }))
          }
        />
      )}
      <input
        className="sidebar-input"
        type="email"
        placeholder="Email Address *"
        value={form.email}
        onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
      />
      <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
        <CountryCodePicker
          value={form.country_code}
          onChange={(v) => setForm((f) => ({ ...f, country_code: v }))}
        />
        <input
          style={{
            flex: 1,
            padding: "10px 12px",
            background: "var(--page-bg)",
            border: "1.5px solid var(--card-border)",
            //borderRadius: 8,
            color: "var(--text-dark)",
            fontSize: 13,
            fontFamily: "var(--font-body)",
            outline: "none",
          }}
          type="tel"
          placeholder="Phone number *"
          value={form.phone}
          onChange={(e) =>
            setForm((f) => ({ ...f, phone: e.target.value.replace(/\D/g, "") }))
          }
        />
      </div>
      <div style={{ position: "relative", marginBottom: 4 }}>
        <input
          style={{
            width: "100%",
            padding: "10px 40px 10px 12px",
            background: "var(--page-bg)",
            border: "1.5px solid var(--card-border)",
            //borderRadius: 8,
            color: "var(--text-dark)",
            fontSize: 13,
            boxSizing: "border-box",
            fontFamily: "var(--font-body)",
            outline: "none",
          }}
          type={showPass ? "text" : "password"}
          placeholder="Password (min 8 chars) *"
          value={form.password}
          onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
        />
        <button
          type="button"
          onClick={() => setShowPass((s) => !s)}
          style={{
            position: "absolute",
            right: 10,
            top: "50%",
            transform: "translateY(-50%)",
            background: "none",
            border: "none",
            color: "var(--text-muted)",
            cursor: "pointer",
            fontSize: 14,
          }}
        >
          {showPass ? "🙈" : "👁"}
        </button>
      </div>
      {form.password && (
        <div style={{ marginBottom: 12 }}>
          <div className="pw-strength">
            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="pw-bar"
                style={{
                  background:
                    i <= strength ? strengthColor : "var(--card-border)",
                }}
              />
            ))}
          </div>
          <div style={{ fontSize: 11, color: strengthColor }}>
            {["", "Weak", "Fair", "Good", "Strong"][strength]}
          </div>
        </div>
      )}
      <button
        className="book-btn"
        style={{ marginTop: 6 }}
        onClick={onRegister}
        disabled={
          loading ||
          !form.name ||
          !form.email ||
          !form.phone ||
          !form.password ||
          form.password.length < 8
        }
      >
        {loading ? "Creating account…" : "Register & Verify →"}
      </button>
      <p
        style={{
          textAlign: "center",
          marginTop: 14,
          color: "var(--text-muted)",
          fontSize: 13,
        }}
      >
        Already have an account?{" "}
        <button className="auth-link" onClick={onSwitch}>
          Login
        </button>
      </p>
    </div>
  );
};

const StepOtp = ({ type, onVerify, onResend, loading, error, setError }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];
  const isEmail = type === "email";
  const handleKey = (i, e) => {
    if (e.key === "Backspace") {
      if (otp[i]) {
        const n = [...otp];
        n[i] = "";
        setOtp(n);
      } else if (i > 0) refs[i - 1].current?.focus();
    }
  };
  const handleChange = (i, val) => {
    const digit = val.replace(/\D/g, "").slice(-1),
      n = [...otp];
    n[i] = digit;
    setOtp(n);
    if (digit && i < 5) refs[i + 1].current?.focus();
    if (digit && i === 5) {
      const full = [...n].join("");
      if (full.length === 6) {
        setError("");
        onVerify(full);
      }
    }
  };
  const handlePaste = (e) => {
    const p = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (p.length === 6) {
      setOtp(p.split(""));
      refs[5].current?.focus();
      setError("");
      onVerify(p);
    }
  };
  const fullOtp = otp.join("");
  return (
    <div>
      <div style={{ textAlign: "center", marginBottom: 20 }}>
        <div style={{ fontSize: 36, marginBottom: 8 }}>
          {isEmail ? "📧" : "📱"}
        </div>
        <div
          style={{ color: "var(--text-dark)", fontWeight: 700, fontSize: 15 }}
        >
          Verify your {isEmail ? "email" : "phone"}
        </div>
        <div style={{ color: "var(--text-muted)", fontSize: 12, marginTop: 6 }}>
          Enter the 6-digit code sent to your {isEmail ? "email" : "phone"}.
        </div>
      </div>
      {error && (
        <div
          style={{
            padding: "8px 12px",
            //borderRadius: 8,
            marginBottom: 12,
            fontSize: 12,
            background: error.startsWith("✓") ? "#f0fdf4" : "#fff5f5",
            border: `1px solid ${error.startsWith("✓") ? "#bbf7d0" : "#fecaca"}`,
            color: error.startsWith("✓") ? "#16a34a" : "#dc2626",
          }}
        >
          {error}
        </div>
      )}
      <div className="otp-grid" onPaste={handlePaste}>
        {otp.map((digit, i) => (
          <input
            key={i}
            ref={refs[i]}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={digit}
            onChange={(e) => handleChange(i, e.target.value)}
            onKeyDown={(e) => handleKey(i, e)}
            className={`otp-cell${digit ? " filled" : ""}`}
          />
        ))}
      </div>
      <button
        className="book-btn"
        onClick={() => {
          if (fullOtp.length === 6) onVerify(fullOtp);
        }}
        disabled={loading || fullOtp.length < 6}
      >
        {loading ? "Verifying…" : "Verify Code →"}
      </button>
      <div style={{ textAlign: "center", marginTop: 16 }}>
        <span style={{ color: "var(--text-muted)", fontSize: 13 }}>
          Didn't receive the code?{" "}
        </span>
        <button
          className="auth-link"
          onClick={() => {
            setOtp(["", "", "", "", "", ""]);
            onResend();
          }}
          disabled={loading}
        >
          Resend
        </button>
      </div>
    </div>
  );
};

const StepPlanSelect = ({
  plans,
  selected,
  onSelect,
  fmtPrice,
  unitPrice,
  onNext,
  onBack,
  existingBookingId,
  feeBreakdown,
  sym = "₹",
}) => {
  const [expanded, setExpanded] = useState(null);
  const price = parseFloat(String(unitPrice || "0").replace(/,/g, "")) || 0;
  const calcAmtLabel = (pct) =>
    price > 0 ? fmtExact((price * parseFloat(pct)) / 100, sym) : null;

  return (
    <div>
      <div
        style={{
          color: "var(--text-dark)",
          fontWeight: 700,
          fontSize: 15,
          marginBottom: 4,
        }}
      >
        Choose a Payment Plan
      </div>
      <div
        style={{ color: "var(--text-muted)", fontSize: 12, marginBottom: 14 }}
      >
        Full plan details are shown above — pick one to continue.
      </div>

      {feeBreakdown?.tax_enabled && feeBreakdown?.total_amount > 0 && (
        <div className="grand-total-banner" style={{ marginBottom: 14 }}>
          <div className="gtb-row">
            <span className="gtb-label">Unit Price</span>
            <span className="gtb-val">
              {fmtExact(feeBreakdown.unit_price || price, sym)}
            </span>
          </div>
          {feeBreakdown.tax_amount > 0 && (
            <div className="gtb-row">
              <span style={{ color: "#b45309" }}>
                {feeBreakdown.tax_label || "Tax"} ({feeBreakdown.tax_rate}%)
              </span>
              <span style={{ color: "#b45309", fontWeight: 700 }}>
                {fmtExact(feeBreakdown.tax_amount, sym)}
              </span>
            </div>
          )}
          <div
            className="gtb-row"
            style={{
              borderTop: "1px solid #fde68a",
              paddingTop: 5,
              marginTop: 3,
            }}
          >
            <span className="gtb-total-label">Grand Total</span>
            <span className="gtb-total-val">
              {fmtExact(feeBreakdown.total_amount, sym)}
            </span>
          </div>
        </div>
      )}

      {/* Full payment option */}
      <div
        className={`plan-option${selected === null ? " selected" : ""}`}
        onClick={() => onSelect(null)}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div>
            <div
              style={{
                color: "var(--text-dark)",
                fontWeight: 600,
                fontSize: 13,
              }}
            >
              Full Payment
            </div>
            <div
              style={{ color: "var(--text-muted)", fontSize: 11, marginTop: 2 }}
            >
              Pay{" "}
              {feeBreakdown?.total_amount
                ? `${fmtExact(feeBreakdown.total_amount, sym)} (incl. taxes)`
                : "the full amount"}{" "}
              upfront
            </div>
          </div>
          <div
            className={`plan-radio${selected === null ? " selected" : ""}`}
          />
        </div>
      </div>

      {plans.map((plan) => {
        const isSelected = selected === plan.id,
          isExpanded = expanded === plan.id;
        const totalPct = plan.milestones.reduce(
          (s, m) => s + (parseFloat(m.percentage) || 0),
          0,
        );
        return (
          <div key={plan.id} style={{ marginBottom: 8 }}>
            <div
              className={`plan-option${isSelected ? " selected" : ""}`}
            //   style={{ borderRadius: isExpanded ? "8px 8px 0 0" : 8 }}
              onClick={() => {
                onSelect(plan.id);
                setExpanded(isExpanded ? null : plan.id);
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  gap: 10,
                }}
              >
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      color: "var(--text-dark)",
                      fontWeight: 700,
                      fontSize: 13,
                    }}
                  >
                    {plan.name}
                  </div>
                  {plan.description && (
                    <div
                      style={{
                        color: "var(--text-muted)",
                        fontSize: 11,
                        marginTop: 2,
                      }}
                    >
                      {plan.description}
                    </div>
                  )}
                  {!isExpanded && (
                    <div
                      style={{
                        marginTop: 6,
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 4,
                      }}
                    >
                      {plan.milestones.slice(0, 2).map((m, i) => (
                        <span
                          key={i}
                          style={{
                            fontSize: 10,
                            padding: "2px 8px",
                           // borderRadius: 8,
                            background: "var(--page-bg)",
                            color: "var(--primary-color)",
                            fontWeight: 600,
                            border: "1px solid var(--card-border)",
                          }}
                        >
                          {m.label}
                          {m.percentage ? ` · ${m.percentage}%` : ""}
                        </span>
                      ))}
                      {plan.milestones.length > 2 && (
                        <span
                          style={{ fontSize: 10, color: "var(--text-muted)" }}
                        >
                          +{plan.milestones.length - 2} more
                        </span>
                      )}
                    </div>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    gap: 6,
                    flexShrink: 0,
                  }}
                >
                  <div
                    className={`plan-radio${isSelected ? " selected" : ""}`}
                  />
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      setExpanded(isExpanded ? null : plan.id);
                    }}
                    style={{
                      background: "none",
                      border: "none",
                      color: "var(--text-muted)",
                      fontSize: 11,
                      cursor: "pointer",
                      padding: 0,
                      fontFamily: "var(--font-body)",
                    }}
                  >
                    {isExpanded ? "▲ Less" : "▼ Details"}
                  </button>
                </div>
              </div>
            </div>

            {isExpanded && (
              <div
                style={{
                  background: "var(--page-bg)",
                 // borderRadius: "0 0 8px 8px",
                  border: "1.5px solid var(--primary-color)44",
                  borderTop: "none",
                }}
              >
                {plan.milestones.map((m, i) => {
                  const c = TYPE_COLORS[m.type] || TYPE_COLORS.custom;
                  const icon = TYPE_ICONS[m.type] || "⭐";
                  const amt = m.calculated_amount
                    ? fmtExact(m.calculated_amount, sym)
                    : m.percentage
                      ? calcAmtLabel(m.percentage)
                      : null;
                  return (
                    <div
                      key={i}
                      style={{
                        padding: "10px 14px",
                        borderBottom:
                          i < plan.milestones.length - 1
                            ? "1px solid var(--card-border)"
                            : "none",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 8,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            flex: 1,
                          }}
                        >
                          <span style={{ fontSize: 16 }}>{icon}</span>
                          <div>
                            <span
                              style={{
                                fontSize: 10,
                                padding: "1px 7px",
                                //borderRadius: 8,
                                background: c.bg,
                                color: c.color,
                                fontWeight: 700,
                              }}
                            >
                              {m.type_label}
                            </span>
                            <span
                              style={{
                                color: "var(--text-dark)",
                                fontSize: 12,
                                fontWeight: 600,
                                marginLeft: 6,
                              }}
                            >
                              {m.label}
                            </span>
                          </div>
                        </div>
                        <div style={{ textAlign: "right" }}>
                          {m.percentage > 0 && (
                            <div
                              style={{
                                color: "var(--primary-color)",
                                fontWeight: 800,
                                fontSize: 15,
                              }}
                            >
                              {m.percentage}%
                            </div>
                          )}
                          {amt && (
                            <div
                              style={{
                                color: "var(--text-muted)",
                                fontSize: 11,
                              }}
                            >
                              ≈ {amt}
                            </div>
                          )}
                        </div>
                      </div>
                      {feeBreakdown && m.percentage && (
                        <MilestoneTaxRow
                          milestone={m}
                          feeBreakdown={feeBreakdown}
                        />
                      )}
                    </div>
                  );
                })}
                <div
                  style={{
                    padding: "8px 14px",
                    display: "flex",
                    justifyContent: "space-between",
                    borderTop: "1px solid var(--card-border)",
                    background: "var(--card-bg)",
                  }}
                >
                  <span style={{ color: "var(--text-muted)", fontSize: 12 }}>
                    Total
                  </span>
                  <div style={{ textAlign: "right" }}>
                    <span
                      style={{
                        color:
                          totalPct === 100 ? "#16a34a" : "var(--primary-color)",
                        fontWeight: 700,
                        fontSize: 13,
                      }}
                    >
                      {totalPct.toFixed(0)}%{totalPct === 100 ? " ✓" : ""}
                    </span>
                    {feeBreakdown?.total_amount > 0 && (
                      <div
                        style={{ fontSize: 10, color: "#b45309", marginTop: 2 }}
                      >
                        = {fmtExact(feeBreakdown.total_amount, sym)} incl. taxes
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      })}

      <button className="book-btn" onClick={onNext} style={{ marginTop: 12 }}>
        {existingBookingId ? "Update Plan & Pay →" : "Continue →"}
      </button>
      <button
        type="button"
        onClick={onBack}
        style={{
          display: "block",
          width: "100%",
          marginTop: 8,
          background: "none",
          border: "1.5px solid var(--card-border)",
         // borderRadius: 8,
          color: "var(--text-muted)",
          padding: 10,
          cursor: "pointer",
          fontSize: 13,
          fontFamily: "var(--font-body)",
        }}
      >
        ← Back
      </button>
    </div>
  );
};

const StepBookingForm = ({
  user,
  form,
  setForm,
  onSubmit,
  loading,
  error,
  selectedPlan,
  plans,
  onBack,
  unit,
  existingBookingId,
  feeBreakdown,
  sym = "₹",
}) => {
  const plan = plans.find((p) => p.id === selectedPlan);
  const isAgent = user?.role === "broker" || user?.role === "sales";
  const price =
    parseFloat(
      (unit?.offer_price || unit?.actual_price || "")
        .toString()
        .replace(/[^0-9.]/g, ""),
    ) || 0;
  const commissionRate = parseFloat(user?.commission_rate || 2);
  const commissionAmt =
    price > 0 ? ((price * commissionRate) / 100).toFixed(2) : null;
  const canSubmit = isAgent
    ? form.name && form.phone && form.client_name && form.client_phone
    : form.name && form.phone;

  return (
    <div>
      <div
        style={{
          color: "var(--text-dark)",
          fontWeight: 700,
          fontSize: 15,
          marginBottom: 4,
        }}
      >
        {existingBookingId ? "Update Payment Plan" : "Confirm Booking"}
      </div>
      <div
        style={{ color: "var(--text-muted)", fontSize: 12, marginBottom: 12 }}
      >
        {existingBookingId ? (
          <span>
            Updating plan for booking{" "}
            <span style={{ color: "var(--primary-color)" }}>
              #{existingBookingId}
            </span>
          </span>
        ) : isAgent ? (
          <>
            Booking as {user?.role === "sales" ? "sales" : "broker"}{" "}
            <span style={{ color: "var(--primary-color)" }}>{user?.name}</span>
          </>
        ) : (
          <>
            Booking as{" "}
            <span style={{ color: "var(--primary-color)" }}>{user?.name}</span>
          </>
        )}
      </div>

      {plan && (
        <div
          style={{
            background: "var(--page-bg)",
            border: "1.5px solid var(--card-border)",
            //borderRadius: 8,
            padding: "10px 12px",
            marginBottom: 14,
            fontSize: 12,
          }}
        >
          <div
            style={{
              color: "var(--primary-color)",
              fontWeight: 700,
              marginBottom: 2,
            }}
          >
            💳 {plan.name}
          </div>
          <div style={{ color: "var(--text-muted)" }}>
            Selected payment plan
          </div>
          <button
            type="button"
            onClick={onBack}
            style={{
              background: "none",
              border: "none",
              color: "var(--text-muted)",
              fontSize: 11,
              padding: 0,
              marginTop: 4,
              cursor: "pointer",
              textDecoration: "underline",
              fontFamily: "var(--font-body)",
            }}
          >
            Change plan
          </button>
        </div>
      )}

      <BookingSummaryTaxCard
        feeBreakdown={feeBreakdown}
        selectedPlan={selectedPlan}
        plans={plans}
        unit={unit}
        sym={sym}
      />

      {error && <div className="error-box">⚠️ {error}</div>}

      {isAgent ? (
        <>
          {commissionAmt && (
            <div className="commission-box">
              <div className="commission-label">Your Commission</div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div className="commission-amt">
                  {fmtExact(commissionAmt, sym)}
                </div>
                <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
                  {commissionRate}% of price
                </div>
              </div>
            </div>
          )}
          <div
            style={{
              fontSize: 11,
              color: "var(--text-muted)",
              marginBottom: 8,
              textTransform: "uppercase",
              fontWeight: 600,
              letterSpacing: "0.8px",
            }}
          >
            Your Contact Info
          </div>
          <input
            className="sidebar-input"
            type="text"
            placeholder="Your Name *"
            value={form.name}
            onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
          />
          <input
            className="sidebar-input"
            type="tel"
            placeholder="Your Phone *"
            value={form.phone}
            onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
          />
          <div
            style={{
              fontSize: 11,
              color: "var(--text-muted)",
              marginBottom: 8,
              marginTop: 8,
              textTransform: "uppercase",
              fontWeight: 600,
              letterSpacing: "0.8px",
            }}
          >
            Client Details
          </div>
          <input
            className="sidebar-input"
            type="text"
            placeholder="Client Full Name *"
            value={form.client_name}
            onChange={(e) =>
              setForm((f) => ({ ...f, client_name: e.target.value }))
            }
          />
          <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
            <CountryCodePicker
              value={form.client_country_code}
              onChange={(v) =>
                setForm((f) => ({ ...f, client_country_code: v }))
              }
            />
            <input
              style={{
                flex: 1,
                padding: "10px 12px",
                background: "var(--page-bg)",
                border: "1.5px solid var(--card-border)",
               // borderRadius: 8,
                color: "var(--text-dark)",
                fontSize: 13,
                fontFamily: "var(--font-body)",
                outline: "none",
              }}
              type="tel"
              placeholder="Client Phone *"
              value={form.client_phone}
              onChange={(e) =>
                setForm((f) => ({
                  ...f,
                  client_phone: e.target.value.replace(/\D/g, ""),
                }))
              }
            />
          </div>
          <input
            className="sidebar-input"
            type="email"
            placeholder="Client Email (optional)"
            value={form.client_email}
            onChange={(e) =>
              setForm((f) => ({ ...f, client_email: e.target.value }))
            }
          />
          <textarea
            className="sidebar-input"
            placeholder="Notes (optional)"
            rows={2}
            value={form.notes}
            onChange={(e) => setForm((f) => ({ ...f, notes: e.target.value }))}
            style={{ resize: "none", marginBottom: 16 }}
          />
        </>
      ) : (
        <>
          <input
            className="sidebar-input"
            type="text"
            placeholder="Your Name *"
            value={form.name}
            onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
          />
          <input
            className="sidebar-input"
            type="tel"
            placeholder="Phone Number *"
            value={form.phone}
            onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
          />
          <textarea
            className="sidebar-input"
            placeholder="Message / Notes (optional)"
            rows={3}
            value={form.notes}
            onChange={(e) => setForm((f) => ({ ...f, notes: e.target.value }))}
            style={{ resize: "none", marginBottom: 16 }}
          />
        </>
      )}

      <button
        className="book-btn"
        onClick={onSubmit}
        disabled={loading || !canSubmit}
      >
        {loading
          ? "Submitting…"
          : existingBookingId
            ? "✓ Update Plan & Proceed to Payment"
            : isAgent
              ? "✓ Submit Booking for Client"
              : "✓ Confirm Booking"}
      </button>
      <button
        type="button"
        onClick={onBack}
        style={{
          display: "block",
          width: "100%",
          marginTop: 8,
          background: "none",
          border: "1.5px solid var(--card-border)",
         // borderRadius: 8,
          color: "var(--text-muted)",
          padding: 10,
          cursor: "pointer",
          fontSize: 13,
          fontFamily: "var(--font-body)",
        }}
      >
        ← Back
      </button>
    </div>
  );
};

const BookingDone = ({ unit, onClose }) => (
  <div className="booking-done">
    <div className="booking-done-emoji">🎉</div>
    <div className="booking-done-title">Booking Received!</div>
    <div className="booking-done-text">
      Your enquiry for Unit {unit.plot_number} has been submitted.
      <br />
      Our team will contact you shortly.
    </div>
    <button className="book-btn" onClick={onClose}>
      Close
    </button>
  </div>
);

/* ═════════════════════════════════════════════════════════════
   CountryCodePicker
═════════════════════════════════════════════════════════════ */
const COUNTRY_CODES = [
  { code: "+91", flag: "🇮🇳", name: "India" },
  { code: "+971", flag: "🇦🇪", name: "UAE" },
  { code: "+966", flag: "🇸🇦", name: "Saudi Arabia" },
  { code: "+974", flag: "🇶🇦", name: "Qatar" },
  { code: "+965", flag: "🇰🇼", name: "Kuwait" },
  { code: "+973", flag: "🇧🇭", name: "Bahrain" },
  { code: "+968", flag: "🇴🇲", name: "Oman" },
  { code: "+1", flag: "🇺🇸", name: "USA / Canada" },
  { code: "+44", flag: "🇬🇧", name: "UK" },
  { code: "+61", flag: "🇦🇺", name: "Australia" },
  { code: "+65", flag: "🇸🇬", name: "Singapore" },
  { code: "+60", flag: "🇲🇾", name: "Malaysia" },
  { code: "+86", flag: "🇨🇳", name: "China" },
  { code: "+81", flag: "🇯🇵", name: "Japan" },
  { code: "+49", flag: "🇩🇪", name: "Germany" },
  { code: "+33", flag: "🇫🇷", name: "France" },
  { code: "+39", flag: "🇮🇹", name: "Italy" },
  { code: "+34", flag: "🇪🇸", name: "Spain" },
  { code: "+7", flag: "🇷🇺", name: "Russia" },
  { code: "+55", flag: "🇧🇷", name: "Brazil" },
  { code: "+92", flag: "🇵🇰", name: "Pakistan" },
  { code: "+880", flag: "🇧🇩", name: "Bangladesh" },
  { code: "+94", flag: "🇱🇰", name: "Sri Lanka" },
  { code: "+977", flag: "🇳🇵", name: "Nepal" },
  { code: "+20", flag: "🇪🇬", name: "Egypt" },
  { code: "+234", flag: "🇳🇬", name: "Nigeria" },
  { code: "+27", flag: "🇿🇦", name: "South Africa" },
  { code: "+254", flag: "🇰🇪", name: "Kenya" },
  { code: "+62", flag: "🇮🇩", name: "Indonesia" },
  { code: "+63", flag: "🇵🇭", name: "Philippines" },
  { code: "+66", flag: "🇹🇭", name: "Thailand" },
  { code: "+84", flag: "🇻🇳", name: "Vietnam" },
  { code: "+82", flag: "🇰🇷", name: "South Korea" },
  { code: "+90", flag: "🇹🇷", name: "Turkey" },
  { code: "+98", flag: "🇮🇷", name: "Iran" },
  { code: "+964", flag: "🇮🇶", name: "Iraq" },
  { code: "+961", flag: "🇱🇧", name: "Lebanon" },
  { code: "+962", flag: "🇯🇴", name: "Jordan" },
];

const CountryCodePicker = ({ value, onChange }) => {
  const [open, setOpen] = useState(false),
    [search, setSearch] = useState("");
  const selected =
    COUNTRY_CODES.find((c) => c.code === value) || COUNTRY_CODES[0];
  const filtered = search.trim()
    ? COUNTRY_CODES.filter(
        (c) =>
          c.name.toLowerCase().includes(search.toLowerCase()) ||
          c.code.includes(search),
      )
    : COUNTRY_CODES;
  return (
    <div style={{ position: "relative" }}>
      <button
        type="button"
        onClick={() => {
          setOpen((o) => !o);
          setSearch("");
        }}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          padding: 10,
          background: "var(--page-bg)",
          border: "1.5px solid var(--card-border)",
          //borderRadius: 8,
          color: "var(--text-dark)",
          cursor: "pointer",
          fontSize: 13,
          whiteSpace: "nowrap",
          minWidth: 82,
          fontFamily: "var(--font-body)",
        }}
      >
        <span style={{ fontSize: 16 }}>{selected.flag}</span>
        <span>{selected.code}</span>
        <span style={{ fontSize: 10, opacity: 0.5 }}>▼</span>
      </button>
      {open && (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 4px)",
            left: 0,
            zIndex: 999,
            background: "var(--card-bg)",
            border: "1px solid var(--card-border)",
            //borderRadius: 10,
            overflow: "hidden",
            minWidth: 220,
            boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          }}
        >
          <div
            style={{
              padding: "8px 10px",
              borderBottom: "1px solid var(--card-border)",
            }}
          >
            <input
              autoFocus
              type="text"
              placeholder="Search country…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                width: "100%",
                padding: "7px 10px",
                background: "var(--page-bg)",
                border: "1px solid var(--card-border)",
               // borderRadius: 6,
                color: "var(--text-dark)",
                fontSize: 12,
                outline: "none",
                boxSizing: "border-box",
                fontFamily: "var(--font-body)",
              }}
            />
          </div>
          <div style={{ maxHeight: 240, overflowY: "auto" }}>
            {filtered.map((c) => (
              <div
                key={c.code + c.name}
                onClick={() => {
                  onChange(c.code);
                  setOpen(false);
                  setSearch("");
                }}
                style={{
                  padding: "9px 14px",
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  cursor: "pointer",
                  fontSize: 13,
                  background:
                    c.code === value ? "var(--page-bg)" : "transparent",
                  color:
                    c.code === value
                      ? "var(--primary-color)"
                      : "var(--text-dark)",
                  fontWeight: c.code === value ? 700 : 400,
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.background = "var(--page-bg)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.background =
                    c.code === value ? "var(--page-bg)" : "transparent")
                }
              >
                <span style={{ fontSize: 16, flexShrink: 0 }}>{c.flag}</span>
                <span
                  style={{
                    flex: 1,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {c.name}
                </span>
                <span style={{ opacity: 0.45, fontSize: 12, flexShrink: 0 }}>
                  {c.code}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

/* ═════════════════════════════════════════════════════════════
   MAIN COMPONENT
═════════════════════════════════════════════════════════════ */
const UnitPage = () => {
  const { tenant, plotId } = useParams();
  const navigate = useNavigate();
  const { settings, isLoaded: settingsLoaded } = useSettings();

  const containerRef = useRef(null);
  const viewerRef = useRef(null);
  const markersRef = useRef(null);
  const overlayRef = useRef(null);
  const labelRef = useRef(null);
  const allMarkerIdsRef = useRef([]);

  const [unit, setUnit] = useState(null);
  const [hotspots, setHotspots] = useState(null);
  const [fetchError, setFetchError] = useState(null);
  const [isFetching, setIsFetching] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadProgress, setLoadProgress] = useState(0);
  const [activeTab, setActiveTab] = useState("details");
  const [galIdx, setGalIdx] = useState(0);

  // Booking sidebar state
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [bookingStep, setBookingStep] = useState("details");
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loginForm, setLoginForm] = useState({ email: "", password: "" });
  const [registerForm, setRegisterForm] = useState({
    name: "",
    email: "",
    country_code: "+91",
    phone: "",
    password: "",
    role: "broker",
    broker_company: "",
  });
  const [bookingForm, setBookingForm] = useState({
    name: "",
    phone: "",
    notes: "",
    client_name: "",
    client_phone: "",
    client_email: "",
    client_country_code: "+91",
  });
  const [authLoading, setAuthLoading] = useState(false);
  const [authError, setAuthError] = useState("");
  const [bookingDone, setBookingDone] = useState(false);
  const [pendingUserId, setPendingUserId] = useState(null);
  const [existingBookingId, setExistingBookingId] = useState(null);
  const [currency, setCurrency] = useState("₹");
  const [feeBreakdown, setFeeBreakdown] = useState(null);

  // Login modal (shared by wishlist + book-now-when-logged-out flows)
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [authIntent, setAuthIntent] = useState(null); // null | "wishlist" | "book"
  const [modalStep, setModalStep] = useState("login");
  const [modalPendingUserId, setModalPendingUserId] = useState(null);
  const [modalAuthError, setModalAuthError] = useState("");

  // ── Auth — via AuthContext, tenant-scoped (see components/AuthContext.jsx).
  const { user, login, register, verifyEmail, verifyPhone, resendOtp, signOut } =
    useAuth();
  const { wishedIds, toggle: toggleWish } = useWishlist(tenant, user?.token);
  const { showToast } = useToast();

  // ── Helper: build image URL with tenant ──────────────────────────────────
  const getFullImageUrl = useCallback(
    (path) => {
      if (!path) return null;
      if (path.startsWith("http://") || path.startsWith("https://")) {
        return path;
      }
      const baseUrl = settings?.img_url || process.env.REACT_APP_IMG_URL || "";
      const cleanPath = path.startsWith("/") ? path.substring(1) : path;
      return baseUrl.endsWith("/")
        ? `${baseUrl}${cleanPath}`
        : `${baseUrl}/${cleanPath}`;
    },
    [settings],
  );

  const wishlistWithToken = useCallback(
    (freshToken, pid, plotNumber) => {
      apiJson(tenant, `/wishlist/toggle`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${freshToken}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ plot_id: Number(pid) }),
      })
        .then((d) => {
          showToast(
            d.wishlisted
              ? `❤️ Added to Wishlist — Unit ${plotNumber}`
              : `🤍 Removed from Wishlist — Unit ${plotNumber}`,
            d.wishlisted ? "wishlist_add" : "wishlist_remove",
            2800,
          );
        })
        .catch(() => {});
    },
    [tenant, showToast],
  );

  // ── Fetch unit + hotspots + currency ──────────────────────
  useEffect(() => {
    if (!tenant || !plotId) {
      setFetchError("No tenant or plot ID provided");
      setIsFetching(false);
      return;
    }

    const fetchAll = async () => {
      try {
        const [unitData, hsData, currData] = await Promise.all([
          apiJson(tenant, `/unit/${plotId}`),
          apiJson(tenant, `/hotspots?plot_id=${plotId}`),
          apiJson(tenant, `/currency`),
        ]);

        setUnit(unitData);
        setHotspots(hsData || []);
        setCurrency(
          currData?.symbol ||
            currData?.currency ||
            currData?.data?.symbol ||
            currData?.data?.currency ||
            "₹",
        );
      } catch (err) {
        console.error("Fetch error:", err);
        setFetchError(err.message);
      } finally {
        setIsFetching(false);
      }
    };
    fetchAll();
  }, [tenant, plotId]);

  // ── Fee preview ────────────────────────────────────────────
  useEffect(() => {
    if (!unit?.actual_price && !unit?.offer_price) return;
    if (!tenant) return;

    const price = unit.offer_price || unit.actual_price;
    apiJson(tenant, `/payment/fee-preview?price=${encodeURIComponent(price)}`, {
      headers: {
        Accept: "application/json",
        ...(user?.token ? { Authorization: `Bearer ${user.token}` } : {}),
      },
    })
      .then((d) => {
        if (d) setFeeBreakdown(d.fee_breakdown || d);
      })
      .catch(() => {});
  }, [tenant, unit, user?.token]);

  // ── Panorama viewer ────────────────────────────────────────
  const destroyViewer = useCallback(() => {
    if (!viewerRef.current) return;
    try {
      viewerRef.current._cleanup?.();
    } catch (e) {}
    try {
      if (
        containerRef.current?.isConnected &&
        containerRef.current?.hasChildNodes()
      )
        viewerRef.current.destroy();
    } catch (e) {}
    viewerRef.current = null;
    markersRef.current = null;
  }, []);

  const buildMarkers = useCallback((unitData, hsData) => {
    const markers = [];
    hsData.forEach((hs) => {
      if (!hs.yaw || !hs.pitch) return;
      if (hs.hotspot_type === "gallery") {
        markers.push({
          id: `hs-gallery-${hs.id}`,
          position: {
            yaw: toRad(parseFloat(hs.yaw)),
            pitch: toRad(parseFloat(hs.pitch)),
          },
          html: `<div class="hs-marker hs-gallery">🖼 ${hs.title || hs.label}</div>`,
          size: { width: 170, height: 42 },
          data: {
            type: "gallery",
            galleryIndex: hs.gallery_index ?? 0,
            name: hs.title || hs.label,
            yawRad: toRad(parseFloat(hs.yaw)),
            pitchRad: toRad(parseFloat(hs.pitch)),
          },
        });
      } else {
        const room = unitData.rooms?.find(
          (r) =>
            r.id === hs.room_panorama_id ||
            r.room_label === (hs.title || hs.label),
        );
        markers.push({
          id: `hs-room-${hs.id}`,
          position: {
            yaw: toRad(parseFloat(hs.yaw)),
            pitch: toRad(parseFloat(hs.pitch)),
          },
          html: `<div class="hs-marker hs-room">🚪 ${hs.title || hs.label}</div>`,
          size: { width: 160, height: 42 },
          data: {
            type: "room",
            roomId: room?.id || hs.room_panorama_id,
            name: hs.title || hs.label,
            yawRad: toRad(parseFloat(hs.yaw)),
            pitchRad: toRad(parseFloat(hs.pitch)),
          },
        });
      }
    });
    if (markers.length === 0 && unitData.rooms?.length > 0) {
      unitData.rooms.forEach((room, idx) => {
        const yaw = (idx / unitData.rooms.length) * 360 - 180;
        markers.push({
          id: `fallback-room-${room.id}`,
          position: { yaw: toRad(yaw), pitch: toRad(-10) },
          html: `<div class="hs-marker hs-room">🚪 ${room.room_label}</div>`,
          size: { width: 160, height: 42 },
          data: {
            type: "room",
            roomId: room.id,
            name: room.room_label,
            yawRad: toRad(yaw),
            pitchRad: toRad(-10),
          },
        });
      });
    }
    return markers;
  }, []);

  useEffect(() => {
    if (
      !unit?.panorama_url ||
      !hotspots ||
      !containerRef.current ||
      activeTab !== "panorama"
    )
      return;

    destroyViewer();
    setIsLoaded(false);
    setLoadProgress(0);

    let current = 0;
    const interval = setInterval(() => {
      current += Math.random() * 10;
      if (current >= 90) {
        current = 90;
        clearInterval(interval);
      }
      setLoadProgress(Math.round(current));
    }, 180);

    const fullPanoramaUrl = getFullImageUrl(unit.panorama_url);
    if (!fullPanoramaUrl) {
      setFetchError("Failed to construct panorama URL");
      return;
    }

    const psvMarkers = buildMarkers(unit, hotspots);
    allMarkerIdsRef.current = psvMarkers.map((m) => m.id);

    const initTimer = setTimeout(() => {
      if (!containerRef.current) return;
      try {
        viewerRef.current = new Viewer({
          container: containerRef.current,
          panorama: fullPanoramaUrl,
          defaultZoomLvl: 50,
          mousewheelCtrlKey: false,
          loadingImg: null,
          loadingTxt: "",
          useXmpData: false,
          plugins: [[MarkersPlugin, { markers: psvMarkers }]],
        });
      } catch (e) {
        console.error("PSV init error:", e);
        return;
      }

      const handleResize = () => {
        try {
          viewerRef.current?.autoSize();
        } catch (e) {}
      };
      window.addEventListener("resize", handleResize);
      document.addEventListener("fullscreenchange", handleResize);
      document.addEventListener("webkitfullscreenchange", handleResize);

      markersRef.current = viewerRef.current.getPlugin(MarkersPlugin);
      viewerRef.current.addEventListener("ready", () => {
        clearInterval(interval);
        setLoadProgress(100);
        setTimeout(() => setIsLoaded(true), 400);

        let angle = 0,
          isInteracting = false,
          resumeTimer = null;
        const swing = () => {
          if (!isInteracting) {
            angle += 0.0015;
            try {
              viewerRef.current?.rotate({
                yaw: Math.sin(angle) * 0.06,
                pitch: 0,
              });
            } catch (e) {}
          }
          if (viewerRef.current)
            viewerRef.current._rafId = requestAnimationFrame(swing);
        };
        viewerRef.current._rafId = requestAnimationFrame(swing);

        const onStart = () => {
          isInteracting = true;
          clearTimeout(resumeTimer);
        };
        const onEnd = () => {
          resumeTimer = setTimeout(() => {
            isInteracting = false;
          }, 2500);
        };
        const el = containerRef.current;
        if (el) {
          el.addEventListener("mousedown", onStart, { passive: true });
          el.addEventListener("mouseup", onEnd, { passive: true });
          el.addEventListener("touchstart", onStart, { passive: true });
          el.addEventListener("touchend", onEnd, { passive: true });
        }
        viewerRef.current._cleanup = () => {
          if (viewerRef.current?._rafId)
            cancelAnimationFrame(viewerRef.current._rafId);
          clearTimeout(resumeTimer);
          window.removeEventListener("resize", handleResize);
          document.removeEventListener("fullscreenchange", handleResize);
          document.removeEventListener("webkitfullscreenchange", handleResize);
          if (el) {
            el.removeEventListener("mousedown", onStart);
            el.removeEventListener("mouseup", onEnd);
            el.removeEventListener("touchstart", onStart);
            el.removeEventListener("touchend", onEnd);
          }
        };
      });

      // Handle error event
      viewerRef.current.addEventListener("error", (e) => {
        console.error("PSV viewer error:", e);
      });

      markersRef.current?.addEventListener("select-marker", ({ marker }) => {
        const { type, roomId, galleryIndex, name, yawRad, pitchRad } =
          marker.data;
        allMarkerIdsRef.current.forEach((id) => {
          try {
            markersRef.current?.updateMarker({ id, opacity: 0 });
          } catch (e) {}
        });
        if (labelRef.current) {
          labelRef.current.textContent = name;
          labelRef.current.style.opacity = "1";
        }
        viewerRef.current
          ?.animate({ yaw: yawRad, pitch: pitchRad, zoom: 60, speed: "4rpm" })
          .then(() =>
            viewerRef.current?.animate({
              yaw: yawRad,
              pitch: pitchRad,
              zoom: 100,
              speed: "20rpm",
            }),
          )
          .then(() => {
            if (overlayRef.current) {
              overlayRef.current.style.transition = "opacity 0.4s ease-in";
              overlayRef.current.style.opacity = "1";
            }
            setTimeout(() => {
              if (type === "gallery")
                navigate(`/${tenant}/unit/${plotId}/gallery/${galleryIndex}`);
              else navigate(`/${tenant}/unit/${plotId}/room/${roomId}`);
            }, 450);
          });
      });
    }, 50);

    return () => {
      clearInterval(interval);
      clearTimeout(initTimer);
      destroyViewer();
    };
  }, [
    unit,
    hotspots,
    activeTab,
    tenant,
    plotId,
    getFullImageUrl,
    buildMarkers,
    destroyViewer,
    navigate,
  ]);

  useEffect(() => {
    if (!overlayRef.current) return;
    overlayRef.current.style.opacity = "1";
    overlayRef.current.style.transition = "none";
    const t = setTimeout(() => {
      overlayRef.current.style.transition = "opacity 0.7s ease-out";
      overlayRef.current.style.opacity = "0";
    }, 50);
    return () => clearTimeout(t);
  }, []);

  // ── Auth handlers (sidebar-embedded login/register/otp) ────
  const handleLogin = async () => {
    setAuthLoading(true);
    setAuthError("");
    try {
      const data = await login(loginForm);

      if (data.step === "verify_email") {
        setPendingUserId(data.user_id);
        setBookingStep("verify_email");
        setAuthLoading(false);
        return;
      }
      if (data.step === "verify_phone") {
        setPendingUserId(data.user_id);
        setBookingStep("verify_phone");
        setAuthLoading(false);
        return;
      }

      setBookingForm((f) => ({
        ...f,
        name: data.user.name || "",
        phone: (data.user.country_code || "") + (data.user.phone || ""),
      }));
      afterAuth();
    } catch (err) {
      setAuthError(err.message);
    }
    setAuthLoading(false);
  };

  const handleRegister = async () => {
    setAuthLoading(true);
    setAuthError("");
    try {
      const data = await register(registerForm);

      setPendingUserId(data.user_id);
      setBookingStep("verify_email");
      setAuthError("");
    } catch (err) {
      setAuthError(err.message);
    }
    setAuthLoading(false);
  };

  const handleVerifyEmail = async (otp) => {
    setAuthLoading(true);
    setAuthError("");
    try {
      const data = await verifyEmail(pendingUserId, otp);

      setPendingUserId(data.user_id);
      setBookingStep("verify_phone");
      setAuthError("");
    } catch (err) {
      setAuthError(err.message);
    }
    setAuthLoading(false);
  };

  const handleVerifyPhone = async (otp) => {
    setAuthLoading(true);
    setAuthError("");
    try {
      const data = await verifyPhone(pendingUserId, otp);

      setBookingForm((f) => ({
        ...f,
        name: data.user.name || "",
        phone: (data.user.country_code || "") + (data.user.phone || ""),
      }));
      afterAuth();
    } catch (err) {
      setAuthError(err.message);
    }
    setAuthLoading(false);
  };

  const handleResendOtp = async (type) => {
    if (!pendingUserId) return;
    setAuthLoading(true);
    setAuthError("");
    try {
      const data = await resendOtp(pendingUserId, type);
      setAuthError("✓ " + data.message);
    } catch (err) {
      setAuthError(err.message);
    }
    setAuthLoading(false);
  };

  // ── Modal auth handlers (login/register/otp inside the popup modal) ──
  const handleModalLogin = async () => {
    setAuthLoading(true);
    setModalAuthError("");
    try {
      const data = await login(loginForm);

      if (data.step === "verify_email") {
        setModalPendingUserId(data.user_id);
        setModalStep("verify_email");
        setAuthLoading(false);
        return;
      }
      if (data.step === "verify_phone") {
        setModalPendingUserId(data.user_id);
        setModalStep("verify_phone");
        setAuthLoading(false);
        return;
      }

      setLoginModalOpen(false);

      if (authIntent === "wishlist") {
        wishlistWithToken(data.user.token, plotId, unit?.plot_number);
      } else if (authIntent === "book") {
        setBookingForm((f) => ({
          ...f,
          name: data.user.name || "",
          phone: (data.user.country_code || "") + (data.user.phone || ""),
        }));
        openBooking(data.user);
      }
      setAuthIntent(null);
    } catch (err) {
      setModalAuthError(err.message);
    }
    setAuthLoading(false);
  };

  const handleModalRegister = async () => {
    setAuthLoading(true);
    setModalAuthError("");
    try {
      const data = await register(registerForm);

      setModalPendingUserId(data.user_id);
      setModalStep("verify_email");
      setModalAuthError("");
    } catch (err) {
      setModalAuthError(err.message);
    }
    setAuthLoading(false);
  };

  const handleModalVerifyEmail = async (otp) => {
    setAuthLoading(true);
    setModalAuthError("");
    try {
      const data = await verifyEmail(modalPendingUserId, otp);

      setModalPendingUserId(data.user_id);
      setModalStep("verify_phone");
      setModalAuthError("");
    } catch (err) {
      setModalAuthError(err.message);
    }
    setAuthLoading(false);
  };

  const handleModalVerifyPhone = async (otp) => {
    setAuthLoading(true);
    setModalAuthError("");
    try {
      const data = await verifyPhone(modalPendingUserId, otp);

      setLoginModalOpen(false);

      if (authIntent === "wishlist") {
        wishlistWithToken(data.user.token, plotId, unit?.plot_number);
      } else if (authIntent === "book") {
        setBookingForm((f) => ({
          ...f,
          name: data.user.name || "",
          phone: (data.user.country_code || "") + (data.user.phone || ""),
        }));
        openBooking(data.user);
      }
      setAuthIntent(null);
    } catch (err) {
      setModalAuthError(err.message);
    }
    setAuthLoading(false);
  };

  const handleModalResendOtp = async (type) => {
    if (!modalPendingUserId) return;
    setAuthLoading(true);
    setModalAuthError("");
    try {
      const data = await resendOtp(modalPendingUserId, type);
      setModalAuthError("✓ " + data.message);
    } catch (err) {
      setModalAuthError(err.message);
    }
    setAuthLoading(false);
  };

  const closeModal = () => {
    setLoginModalOpen(false);
    setAuthIntent(null);
    setModalStep("login");
    setModalAuthError("");
  };

  // ── Booking submit ─────────────────────────────────────────
  const handleBooking = async () => {
    setAuthLoading(true);
    setAuthError("");
    const isAgent = user?.role === "broker" || user?.role === "sales";
    if (isAgent && user?.status && user.status !== "active") {
      setAuthError(
        "Your account is currently inactive. Please contact the admin to activate your account before booking.",
      );
      setAuthLoading(false);
      return;
    }
    try {
      if (existingBookingId) {
        const data = await apiJson(
          tenant,
          `/bookings/${existingBookingId}/plan`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${user?.token}`,
            },
            body: JSON.stringify({ payment_plan_id: selectedPlan }),
          },
        );

        if (data.booking?.fee_breakdown)
          setFeeBreakdown(data.booking.fee_breakdown);
        setTimeout(
          () => navigate(`/${tenant}/payment/${existingBookingId}`),
          400,
        );
        return;
      }

      const payload = {
        plot_id: plotId,
        plot_number: unit.plot_number,
        plot_type: unit.plot_type,
        block: unit.block,
        section: unit.section,
        direction: unit.direction,
        area: unit.plot_size ? String(unit.plot_size) : "",
        price: unit.offer_price
          ? String(unit.offer_price)
          : String(unit.actual_price || ""),
        project_id: unit.project_id,
        block_id: unit.block_id,
        name: bookingForm.name,
        phone: bookingForm.phone,
        notes: bookingForm.notes,
        payment_plan_id: selectedPlan,
        client_name: isAgent ? bookingForm.client_name : undefined,
        client_phone: isAgent
          ? bookingForm.client_country_code + bookingForm.client_phone
          : undefined,
        client_email: isAgent ? bookingForm.client_email : undefined,
      };

      const data = await apiJson(tenant, `/bookings`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(payload),
      });

      if (data.booking?.fee_breakdown)
        setFeeBreakdown(data.booking.fee_breakdown);

      const bookingId = data.booking?.id;
      if (bookingId) {
        showToast(
          `🎉 Booking confirmed! Redirecting to payment…`,
          "success",
          2500,
        );
        setTimeout(() => navigate(`/${tenant}/payment/${bookingId}`), 400);
      } else {
        setBookingDone(true);
        showToast(
          `✅ Booking received! We'll contact you shortly.`,
          "success",
          4000,
        );
      }
    } catch (err) {
      setAuthError(err.message);
    }
    setAuthLoading(false);
  };

  const handleBack = () => {
    if (overlayRef.current) {
      overlayRef.current.style.transition = "opacity 0.4s ease-in";
      overlayRef.current.style.opacity = "1";
    }
    const dest = unit?.block_id
      ? `/${tenant}/floor/${unit.block_id}`
      : unit?.floor_id
        ? `/${tenant}/floor/${unit.floor_id}`
        : null;
    setTimeout(() => (dest ? navigate(dest) : navigate(`/${tenant}`)), 450);
  };

  const switchToGallery = () => {
    destroyViewer();
    setActiveTab("gallery");
    setIsLoaded(false);
  };
  const switchToPanorama = () => setActiveTab("panorama");
  const switchToDetails = () => {
    destroyViewer();
    setActiveTab("details");
  };

  // Payment plans are now inline within the Details view rather than a
  // separate tab — this switches to Details (if not already there) and
  // smooth-scrolls down to the plans section. The short delay covers the
  // case where we're switching away from the panorama tab, so the
  // section has actually mounted into the DOM before we try to scroll.
  const scrollToPaymentPlans = () => {
    destroyViewer();
    setActiveTab("details");
    setTimeout(() => {
      document
        .getElementById("payment-plans-section")
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 80);
  };

  const hasPlans = (unit?.payment_plans?.length || 0) > 0;
  const afterAuth = () => setBookingStep(hasPlans ? "plan" : "form");

  // Accepts an optional user override so it can run immediately after a
  // fresh login/registration (before AuthContext's `user` re-renders).
  const openBooking = async (authedUser = user) => {
    setSidebarOpen(true);
    setBookingDone(false);
    setAuthError("");
    if (authedUser) {
      if (
        (authedUser.role === "broker" || authedUser.role === "sales") &&
        authedUser.status &&
        authedUser.status !== "active"
      ) {
        setBookingStep("broker_inactive");
        return;
      }
      try {
        const data = await apiJson(tenant, `/bookings`, {
          headers: {
            Authorization: `Bearer ${authedUser.token}`,
            Accept: "application/json",
          },
        });

        const bookings = Array.isArray(data) ? data : data.data || [];
        const existing = bookings.find(
          (b) =>
            String(b.plot_id) === String(plotId) &&
            b.booking_status !== "cancelled",
        );
        if (existing) {
          setExistingBookingId(existing.id);
          setSelectedPlan(existing.payment_plan_id || null);
          try {
            const d = await apiJson(tenant, `/bookings/${existing.id}`, {
              headers: {
                Authorization: `Bearer ${authedUser.token}`,
                Accept: "application/json",
              },
            });
            if (d?.booking?.fee_breakdown)
              setFeeBreakdown(d.booking.fee_breakdown);
          } catch (e) {}

          if (existing.booking_status === "confirmed") {
            setBookingDone(true);
            setBookingStep("details");
            return;
          }
          setBookingStep(hasPlans ? "plan" : "form");
          return;
        }
      } catch (e) {}
      setExistingBookingId(null);
      setBookingStep(hasPlans ? "plan" : "form");
    } else {
      setExistingBookingId(null);
      setBookingStep("details");
    }
  };

  const logout = () => {
    signOut();
    setBookingStep("details");
    setSelectedPlan(null);
    setExistingBookingId(null);
  };

  useEffect(() => {
    if (user)
      setBookingForm((f) => ({
        ...f,
        name: f.name || user.name || "",
        phone: f.phone || (user.country_code || "") + (user.phone || ""),
      }));
  }, [user?.id]);

  // ── Helpers ────────────────────────────────────────────────
  const fmtPrice = (val) =>
    val ? `${currency} ${Number(val).toLocaleString("en-IN")}` : null;
  const getStatusColor = (s) => {
    const v = s?.toLowerCase();
    return v === "available"
      ? "#16a34a"
      : v === "pre-booked"
        ? "#d97706"
        : "#dc2626";
  };

  // ── Guards ─────────────────────────────────────────────────
  if (isFetching || !settingsLoaded)
    return (
      <div className="unit-loading-screen">
        <div style={{ fontSize: 48 }}>🏠</div>
        <div
          style={{ color: "var(--text-dark)", fontSize: 16, fontWeight: 600 }}
        >
          {!settingsLoaded ? "Loading settings..." : "Loading unit…"}
        </div>
        <div className="loading-bar-track">
          <div className="loading-bar-fill" />
        </div>
      </div>
    );
  if (fetchError || !unit)
    return (
      <div className="unit-loading-screen">
        <div style={{ fontSize: 48 }}>⚠️</div>
        <h2 style={{ color: "var(--text-dark)" }}>Unit Unavailable</h2>
        <p style={{ color: "var(--text-muted)" }}>
          {fetchError || "Unit not found."}
        </p>
        <button
          onClick={() => navigate(`/${tenant}`)}
          style={{
            padding: "10px 24px",
            background: "var(--primary-color)",
            color: "#fff",
            border: "none",
           // borderRadius: 8,
            cursor: "pointer",
            fontWeight: 700,
          }}
        >
          ← Go Back
        </button>
      </div>
    );

  const gallery = unit.gallery_images || [];
  const hasPano = !!unit.panorama_url;
  const hasGal = gallery.length > 0;
  const hasRooms = unit.rooms?.length > 0;
  const isAvail = unit.status?.toLowerCase() === "available";
  const statusColor = getStatusColor(unit.status);
  const isWished =
    wishedIds instanceof Set ? wishedIds.has(Number(plotId)) : false;
  const sym = feeBreakdown?.currency_symbol || currency;

  // ── Theme — colors & fonts pulled from the tenant's own backend
  // settings instead of the hardcoded ERA defaults, so each tenant's
  // branding actually applies. Falls back to the CSS :root defaults
  // in UnitPage.css whenever a given setting isn't present.
  const themeVars = {
    ...(settings?.primary_color && { "--primary-color": settings.primary_color }),
    ...(settings?.primary_hover_color && { "--primary-hover": settings.primary_hover_color }),
    ...(settings?.page_bg_color && { "--page-bg": settings.page_bg_color }),
    ...(settings?.card_bg_color && { "--card-bg": settings.card_bg_color }),
    ...(settings?.card_border_color && { "--card-border": settings.card_border_color }),
    ...(settings?.text_dark_color && { "--text-dark": settings.text_dark_color }),
    ...(settings?.text_muted_color && { "--text-muted": settings.text_muted_color }),
    ...(settings?.header_bg_color && { "--header-bg": settings.header_bg_color }),
    ...(settings?.font_heading && { "--font-heading": settings.font_heading }),
    ...(settings?.font_body && { "--font-body": settings.font_body }),
  };

  return (
    <div className="unit-page" style={themeVars}>
      {/* ── Auth modal (wishlist + book-now-when-logged-out) ── */}
      {loginModalOpen && (
        <>
          <div className="up-modal-backdrop" onClick={closeModal} />
          <div className="up-modal">
            <div className="up-modal-head">
              <div className="up-modal-title">
                {modalStep === "verify_email"
                  ? "📧 Verify Email"
                  : modalStep === "verify_phone"
                    ? "📱 Verify Phone"
                    : authIntent === "book"
                      ? "🏠 Login to Book"
                      : authIntent === "wishlist"
                        ? "❤️ Save to Wishlist"
                        : "👤 Login to your account"}
              </div>
              <button className="up-modal-close" onClick={closeModal}>
                ×
              </button>
            </div>
            {modalStep === "verify_email" ? (
              <StepOtp
                key="modal-otp-email"
                type="email"
                onVerify={handleModalVerifyEmail}
                onResend={() => handleModalResendOtp("email")}
                loading={authLoading}
                error={modalAuthError}
                setError={setModalAuthError}
              />
            ) : modalStep === "verify_phone" ? (
              <StepOtp
                key="modal-otp-phone"
                type="phone"
                onVerify={handleModalVerifyPhone}
                onResend={() => handleModalResendOtp("phone")}
                loading={authLoading}
                error={modalAuthError}
                setError={setModalAuthError}
              />
            ) : (
              <>
                <div className="up-modal-tabs">
                  {["login", "register"].map((tab) => (
                    <button
                      key={tab}
                      className={`up-modal-tab${modalStep === tab ? " active" : ""}`}
                      onClick={() => {
                        setModalStep(tab);
                        setModalAuthError("");
                      }}
                    >
                      {tab === "login" ? "Log In" : "Register"}
                    </button>
                  ))}
                </div>
                <p
                  style={{
                    color: "var(--text-muted)",
                    fontSize: 13,
                    marginBottom: 16,
                    lineHeight: 1.6,
                  }}
                >
                  {authIntent === "book"
                    ? modalStep === "login"
                      ? "Log in to continue booking this unit."
                      : "Create an account to book this unit."
                    : authIntent === "wishlist"
                      ? modalStep === "login"
                        ? "Log in to save this unit to your wishlist."
                        : "Create an account to save this unit."
                      : modalStep === "login"
                        ? "Log in to access your account."
                        : "Create an account to get started."}
                </p>
                {modalStep === "login" ? (
                  <StepLogin
                    form={loginForm}
                    setForm={setLoginForm}
                    onLogin={handleModalLogin}
                    onSwitch={() => {
                      setModalStep("register");
                      setModalAuthError("");
                    }}
                    loading={authLoading}
                    error={modalAuthError}
                  />
                ) : (
                  <StepRegister
                    form={registerForm}
                    setForm={setRegisterForm}
                    onRegister={handleModalRegister}
                    onSwitch={() => {
                      setModalStep("login");
                      setModalAuthError("");
                    }}
                    loading={authLoading}
                    error={modalAuthError}
                  />
                )}
              </>
            )}
          </div>
        </>
      )}

      {/* ── Vertical nav rail — replaces the old horizontal header.
           Same handlers as before (handleBack, switchToDetails,
           switchToPanorama, switchToGallery, openBooking, wishlist
           toggle, dashboard/login navigation) — only the layout moved. ── */}
      <div className="unit-nav-rail">
        <button className="rail-back-btn" onClick={handleBack} title="Back to floor">
          ←
        </button>

        <div
          className="rail-status-dot"
          style={{ background: statusColor }}
          title={unit.status}
        />

        <div className="rail-nav">
          <button
            className={`rail-nav-btn${activeTab === "details" ? " active" : ""}`}
            onClick={switchToDetails}
            title="Details"
          >
            <span className="rail-icon">📋</span>
            <span className="rail-label">Info</span>
          </button>
          {hasPano && (
            <button
              className={`rail-nav-btn${activeTab === "panorama" ? " active" : ""}`}
              onClick={switchToPanorama}
              title="360° View"
            >
              <span className="rail-icon">🌐</span>
              <span className="rail-label">360°</span>
            </button>
          )}
          {hasGal && (
            <button
              className={`rail-nav-btn${activeTab === "gallery" ? " active" : ""}`}
              onClick={switchToGallery}
              title={`Gallery (${gallery.length})`}
            >
              <span className="rail-icon">🖼</span>
              <span className="rail-label">Gallery</span>
            </button>
          )}
          {hasPlans && (
            <button
              className="rail-nav-btn"
              onClick={scrollToPaymentPlans}
              title="Payment Plans"
            >
              <span className="rail-icon">💳</span>
              <span className="rail-label">Plans</span>
            </button>
          )}
        </div>

        <div className="rail-spacer" />

        {isAvail && (
          <button
            className="rail-book-btn"
            onClick={() => {
              if (user) {
                openBooking();
              } else {
                setAuthIntent("book");
                setModalStep("login");
                setModalAuthError("");
                setLoginModalOpen(true);
              }
            }}
            title="Book Now"
          >
            <span className="rail-icon">✦</span>
            <span className="rail-label">Book</span>
          </button>
        )}

        {unit && (
          <button
            className={`rail-action-btn${isWished ? " wished" : ""}`}
            onClick={() => {
              if (!user?.token) {
                setAuthIntent("wishlist");
                setModalStep("login");
                setModalAuthError("");
                setLoginModalOpen(true);
              } else {
                const willAdd = !isWished;
                toggleWish(Number(plotId))
                  .then(() => {
                    showToast(
                      willAdd
                        ? `❤️ Added to Wishlist — Unit ${unit.plot_number}`
                        : `🤍 Removed from Wishlist — Unit ${unit.plot_number}`,
                      willAdd ? "wishlist_add" : "wishlist_remove",
                      2800,
                    );
                  })
                  .catch(() => {
                    showToast(
                      "Failed to update wishlist. Please try again.",
                      "error",
                      3000,
                    );
                  });
              }
            }}
            title={isWished ? "Remove from Wishlist" : "Save to Wishlist"}
          >
            {isWished ? "❤️" : "🤍"}
          </button>
        )}

        {user ? (
          <button
            className="rail-avatar"
            onClick={() => navigate(`/${tenant}/dashboard`)}
            title={`${user.name} — My Dashboard`}
          >
            {user.name?.[0]?.toUpperCase()}
          </button>
        ) : (
          <button
            className="rail-action-btn"
            onClick={() => {
              setAuthIntent(null);
              setModalStep("login");
              setModalAuthError("");
              setLoginModalOpen(true);
            }}
            title="Login"
          >
            👤
          </button>
        )}
      </div>

      {/* ── Main wrapper — everything to the right of the rail ── */}
      <div className="unit-main-wrapper">
        <div className="unit-content-area">
        {/* Full-screen panorama */}
        {activeTab === "panorama" && (
          <div className="unit-fullview">
            <div ref={containerRef} className="psv-container-div" />
            <div className={`pano-loader${isLoaded ? " gone" : ""}`}>
              <div className="pano-loader-card">
                <div className="pano-loader-emoji">🏠</div>
                <div className="pano-loader-percent">{loadProgress}%</div>
                <div className="pano-loader-bar-track">
                  <div
                    className="pano-loader-bar-fill"
                    style={{ width: `${loadProgress}%` }}
                  />
                </div>
                <div className="pano-loader-text">
                  {loadProgress < 40
                    ? "Preparing panorama..."
                    : loadProgress < 80
                      ? "Loading image data..."
                      : loadProgress < 100
                        ? "Almost ready..."
                        : "✓ Ready"}
                </div>
              </div>
            </div>
            {isLoaded && hasRooms && (
              <div className="room-nav-strip">
                <span className="room-nav-label">Rooms</span>
                {unit.rooms.map((room) => (
                  <button
                    key={room.id}
                    className="room-thumb-btn"
                    onClick={() =>
                      navigate(`/${tenant}/unit/${plotId}/room/${room.id}`)
                    }
                  >
                    {room.thumb_url ? (
                      <img
                        src={getFullImageUrl(room.thumb_url)}
                        alt={room.room_label}
                      />
                    ) : (
                      <div className="room-thumb-placeholder">🚪</div>
                    )}
                    <span>{room.room_label}</span>
                  </button>
                ))}
              </div>
            )}
            <div ref={labelRef} className="marker-label" />
          </div>
        )}

        {/* Two-column layout for details / gallery — sidebar on the
            left (booking widget), main content flows on the right
            as one continuous page (see .unit-detail-layout CSS
            `order` swap). */}
        {activeTab !== "panorama" && (
          <div className="unit-detail-layout">
            {/* ── MAIN CONTENT (renders on the right via CSS order) ── */}
            <div className="unit-detail-left">
              {activeTab === "details" && (
                <EraUnitDetails
                  unit={unit}
                  fmtPrice={fmtPrice}
                  statusColor={statusColor}
                  currency={currency}
                  sym={sym}
                  feeBreakdown={feeBreakdown}
                  getFullImageUrl={getFullImageUrl}
                  gallery={gallery}
                  hasPano={hasPano}
                  plotId={plotId}
                  tenant={tenant}
                  navigate={navigate}
                  galIdx={galIdx}
                  setGalIdx={setGalIdx}
                  onOpenPano={switchToPanorama}
                  PaymentPlansContent={PaymentPlansContent}
                />
              )}

              {activeTab === "gallery" && hasGal && (
                <>
                  <EraGallery
                    gallery={gallery}
                    hasPano={hasPano}
                    plotId={plotId}
                    tenant={tenant}
                    navigate={navigate}
                    galIdx={galIdx}
                    setGalIdx={setGalIdx}
                    onOpenPano={switchToPanorama}
                  />
                  <div style={{ padding: "0 56px 44px" }}>
                    <div className="era-floor-plan-section-label">
                      All Photos ({gallery.length})
                    </div>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fill, minmax(200px, 1fr))",
                        gap: 10,
                      }}
                    >
                      {gallery.map((img, i) => {
                        const imgUrl = img;
                        return imgUrl ? (
                          <img
                            key={i}
                            src={imgUrl}
                            alt={`Gallery ${i + 1}`}
                            onClick={() => {
                              setGalIdx(i);
                              navigate(
                                `/${tenant}/unit/${plotId}/gallery/${i}`,
                              );
                            }}
                            style={{
                              width: "100%",
                              aspectRatio: "4/3",
                              objectFit: "cover",
                              cursor: "pointer",
                              border: `2px solid ${i === galIdx ? "var(--primary-color)" : "transparent"}`,
                              transition: "all 0.2s",
                            }}
                          />
                        ) : null;
                      })}
                    </div>
                  </div>
                </>
              )}
            </div>

            {/* ── SIDEBAR — booking widget (renders on the left via CSS order) ── */}
            <div
              className={`unit-detail-right${sidebarOpen ? " sidebar-open" : ""}`}
            >
              <div className="right-panel-header">
                <div className="right-panel-price">
                  {unit.offer_price
                    ? fmtPrice(unit.offer_price)
                    : fmtPrice(unit.actual_price)}
                </div>
                {unit.offer_price && (
                  <div className="right-panel-price-orig">
                    {fmtPrice(unit.actual_price)}
                  </div>
                )}
                {feeBreakdown?.tax_enabled &&
                  feeBreakdown?.total_amount > 0 && (
                    <div
                      style={{
                        fontSize: 12,
                        color: "#b45309",
                        fontWeight: 600,
                        marginTop: 3,
                      }}
                    >
                      Grand Total: {fmtExact(feeBreakdown.total_amount, sym)}{" "}
                      (incl. tax)
                    </div>
                  )}
                <div className="right-panel-title">Unit {unit.plot_number}</div>
                <div className="right-panel-sub">
                  {unit.plot_type}
                  {unit.plot_size ? ` · ${unit.plot_size} sqft` : ""}
                  {unit.direction ? ` · ${unit.direction}` : ""}
                </div>
                <div
                  style={{
                    marginTop: 8,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 5,
                    padding: "3px 12px",
                   // borderRadius: 20,
                    fontSize: 12,
                    fontWeight: 700,
                    background: statusColor + "18",
                    color: statusColor,
                    border: `1px solid ${statusColor}44`,
                  }}
                >
                  ● {unit.status}
                </div>
              </div>

              {/* Quick stat pills */}
              <div style={{ padding: "14px 32px 0" }}>
                <div className="rp-stats">
                  {unit.bedrooms != null && (
                    <div className="rp-stat">
                      <span className="rp-stat-icon">🛏</span>
                      <div className="rp-stat-val">{unit.bedrooms}</div>
                      <div className="rp-stat-lbl">Beds</div>
                    </div>
                  )}
                  {unit.bathrooms != null && (
                    <div className="rp-stat">
                      <span className="rp-stat-icon">🚿</span>
                      <div className="rp-stat-val">{unit.bathrooms}</div>
                      <div className="rp-stat-lbl">Baths</div>
                    </div>
                  )}
                  {unit.plot_size && (
                    <div className="rp-stat">
                      <span className="rp-stat-icon">📐</span>
                      <div className="rp-stat-val">{unit.plot_size}</div>
                      <div className="rp-stat-lbl">sqft</div>
                    </div>
                  )}
                  {!unit.bedrooms && !unit.bathrooms && !unit.plot_size && (
                    <>
                      <div className="rp-stat">
                        <span className="rp-stat-icon">🏢</span>
                        <div className="rp-stat-val">
                          {unit.plot_type || "—"}
                        </div>
                        <div className="rp-stat-lbl">Type</div>
                      </div>
                      <div className="rp-stat">
                        <span className="rp-stat-icon">🧭</span>
                        <div className="rp-stat-val">
                          {unit.direction || "—"}
                        </div>
                        <div className="rp-stat-lbl">Facing</div>
                      </div>
                      <div className="rp-stat">
                        <span className="rp-stat-icon">🚪</span>
                        <div className="rp-stat-val">
                          {unit.rooms?.length || 0}
                        </div>
                        <div className="rp-stat-lbl">Rooms</div>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="right-panel-scroll">
                {bookingStep === "broker_inactive" ? (
                  <BrokerInactiveScreen onClose={() => setSidebarOpen(false)} />
                ) : bookingDone ? (
                  <BookingDone
                    unit={unit}
                    onClose={() => setSidebarOpen(false)}
                  />
                ) : bookingStep === "details" ? (
                  <StepDetails
                    user={user}
                    onBook={() =>
                      user
                        ? hasPlans
                          ? setBookingStep("plan")
                          : setBookingStep("form")
                        : setBookingStep("login")
                    }
                    onLogout={logout}
                    isAvail={isAvail}
                  />
                ) : bookingStep === "login" ? (
                  <StepLogin
                    form={loginForm}
                    setForm={setLoginForm}
                    onLogin={handleLogin}
                    onSwitch={() => {
                      setBookingStep("register");
                      setAuthError("");
                    }}
                    loading={authLoading}
                    error={authError}
                  />
                ) : bookingStep === "register" ? (
                  <StepRegister
                    form={registerForm}
                    setForm={setRegisterForm}
                    onRegister={handleRegister}
                    onSwitch={() => {
                      setBookingStep("login");
                      setAuthError("");
                    }}
                    loading={authLoading}
                    error={authError}
                  />
                ) : bookingStep === "verify_email" ? (
                  <StepOtp
                    key="otp-email"
                    type="email"
                    onVerify={handleVerifyEmail}
                    onResend={() => handleResendOtp("email")}
                    loading={authLoading}
                    error={authError}
                    setError={setAuthError}
                  />
                ) : bookingStep === "verify_phone" ? (
                  <StepOtp
                    key="otp-phone"
                    type="phone"
                    onVerify={handleVerifyPhone}
                    onResend={() => handleResendOtp("phone")}
                    loading={authLoading}
                    error={authError}
                    setError={setAuthError}
                  />
                ) : bookingStep === "plan" ? (
                  <StepPlanSelect
                    plans={unit.payment_plans || []}
                    selected={selectedPlan}
                    onSelect={setSelectedPlan}
                    fmtPrice={fmtPrice}
                    unitPrice={unit.actual_price}
                    onNext={() => setBookingStep("form")}
                    onBack={() => setBookingStep("details")}
                    existingBookingId={existingBookingId}
                    feeBreakdown={feeBreakdown}
                    sym={sym}
                  />
                ) : bookingStep === "form" ? (
                  <StepBookingForm
                    user={user}
                    form={bookingForm}
                    setForm={setBookingForm}
                    onSubmit={handleBooking}
                    loading={authLoading}
                    error={authError}
                    selectedPlan={selectedPlan}
                    plans={unit.payment_plans || []}
                    onBack={() =>
                      hasPlans
                        ? setBookingStep("plan")
                        : setBookingStep("details")
                    }
                    unit={unit}
                    existingBookingId={existingBookingId}
                    feeBreakdown={feeBreakdown}
                    sym={sym}
                  />
                ) : null}
              </div>
            </div>
          </div>
        )}
        </div>
      </div>
    </div>
  );
};

export default UnitPage;
